/* eslint-disable quotes */
export const translation2 = {
  en: {
    appWidget: 'Install Gumb on your device',
    featurePopups: {
      appointmentSchedule: {
        innerHtml:
          "<h3>New feature: Download your appointment schedule as an Excel or CSV file. </h3><p>We have completely redesigned the statistics page, and you can export your entire schedule now. The new report called 'Appointment schedule' gives you an overview of facts and figures of your events.</p><p>We are already working on another report called 'Member figures' which will be related to user performance. </p><p>The diary report is now available in the web app for all users.</p>",
        buttonOk: 'LATER',
        buttonRedirect: 'SEE NOW',
      },
      preferecePopup: {
        title: '2 New Features',
        first: {
          title: 'Set All to "Going":',
          subtitle:
            'Set the default response for new or existing events - for all participants at once!',
          link: '',
        },
        second: {
          title: 'Default Event Settings:',
          subtitle: 'Define how new events should look.',
          link: 'Instructions',
        },
      },
      appleCalendar: {
        title: 'CONNECT YOUR APPLE (iCal) CALENDAR&nbsp;🍏',
        message:
          'We did it! After a lot of hard work, Gumb now enables direct calendar connection in the WEB version for seamless synchronization. Stay tuned for the iOS/Smartphone release&nbsp;coming&nbsp;soon!',
        extraMessage: 'Open the step-by-step guide',
        redirectText: 'here',
        okButton: 'Connect Now',
        cancelButton: 'Not Now',
      },
      calendar: {
        innerhtml:
          "<h3>We did it!</h3> <p> <b>GOOGLE CALENDAR connections</b> are now available! </p> <br/> <p> Events from Gumb - Each community individually selectable, can now be automatically added to your calendar.  </p> <div class='images-container'> <img src='https://gumb-cdn-prod.s3.eu-central-1.amazonaws.com/featurePopups/calendar-1.png' alt='calendar-1' /> <img src='https://gumb-cdn-prod.s3.eu-central-1.amazonaws.com/featurePopups/calendar-2.png' alt='calendar-2' /></div> <p> This tutorial explains everything you need to know: <br/><a target='_blank' rel='noopener noreferrer' href='https://gumb.app/en/support/connect-gumb-with-google-calender/'>→&nbsp; Click here for full instructions </a> </p> <p>Quick guide:</p> <ol> <li>Connect and important: check the box!</li> <li>Select community</li> <li>Wait a few minutes and reload the page.</li> </ol> <p> Connect your Google Calendar to save time and make the most of each day. </p>",
        buttonOk: 'NOTHING FOR ME',
        buttonRedirect: 'CONNECT NOW',
      },
      notifications: {
        title: 'How should members be notified?',
        firstRow: 'We added: Mobile Push Messages & Notification Settings.',
        secondRow:
          'Customize now the notification settings that admins manage, for the entire community:',
        thirdRow: 'All you need to do is:',
        listFirstRow: 'Go to Community Settings → Notifications.',
        listSecondRow:
          'Enable/disable the options in each category → to customize everything perfectly for you. (→ Read tutorial <0>here</0>)',
        lastRow:
          'Tell now your members to enable push or email settings in their own Gumb profile.',
        buttonLater: 'Later',
        buttonSettings: 'Go to settings now',
      },
      pushNotifications: {
        title: '📢 Next-Level Communication: Push Notifications',
        message:
          'Admins and group leaders can now create push notifications to send you important information directly to your smartphone.\n\nWhat you can do with push notifications:\n\n• <b>Share important information instantly</b> (e.g., schedule changes, emergencies)\n• <b>Reach individuals or entire teams</b> (personalized communication)\n• <b>Save messages as templates to save time</b> (efficient communication)',
        extraMessage: 'Stay up-to-date and never miss any news again!',
        cancelButton: 'View later',
        okButton: 'Try now',
        newMessageOne:
          'Admins and group leaders can now communicate directly with individuals or entire teams to send you important information directly to your smartphone.\n\n',
        redirectLink: 'Create custom push notifications',
        newMessageTwo:
          ', select recipients, and even save your messages as templates for later use.',
      },
      importEvent: {
        title: 'Upload/Import Events ',
        subText:
          "No more manual entry! Easily import your events with a CSV or Excel file. Whether it's 30 or 300 events - it's quick and can even be undone if there are mistakes.",
        cancelButton: 'View later',
        okButton: 'Try now',
        secondText: 'Find step-by-step instructions',
      },
      mail: {
        title: 'New function: MAIL MODE',
        firstRow:
          'The integrated e-mail function simplifies and speeds up team communication.  Urgently need to send an e-mail to everyone? But only to members who answered "Yes" at the appointment? → Now possible with just a few clicks!',
        secondRow:
          'The mail mode is now available in the web app for admins and group leaders. It will be further expanded in the coming time.',
        thirdRow: 'Read more: <0>https://gumb.app/support/mailmodus/</0>',
        buttonLater: 'LATER',
        buttonMail: 'VIEW NOW',
      },
      eventPdf: {
        title: 'New feature: Download event as PDF',
        firstRow: 'Save time now and print the event details with one click!',
        secondRow:
          'Shortly before upcoming events, or even for past ones, all event details including all response statistics can be exported to PDF.',
        thirdRow: 'Requirement scheduler: You have admin rights',
        fourthRow: 'Requirement group planner: You are the group leader',
        fifthRow: 'The feature is now available in the web app.',
      },
    },
    menu: {
      homePage: 'HOMEPAGE',
      subscriptions: 'Subscriptions',
      groupScheduler: 'SCHEDULER',
      documentation: 'DOCUMENTS',
      chats: 'CHAT',
    },
    badges: {},
    dayOfWeek: {
      day1: 'MON',
      day2: 'TUE',
      day3: 'WED',
      day4: 'THU',
      day5: 'FRI',
      day6: 'SAT',
      day0: 'SUN',
    },
    status: {
      taskInactive: '= Not activated',
      notActivated: '= Not activated',
      awaitingReply: '= Awaiting',
      taskInactiveDesc: 'This task is deactivated - members can’t see it.',
      notActivatedDesc:
        'This person is not activated for the event - they won’t see it (white cell).',
      awaitingReplyDesc:
        'The event is visible, but no response has been given yet.',
      notActivatedAction:
        'Click on the event → Edit → Participants → check the box → Save',
      taskInactiveAction:
        'Click on the event → Edit → Tasks → check the box → Save',
      awaitingReplyAction: 'Tap the cell → Choose a response → Save',
    },
    email: {
      sender: 'Sender',
      recipients: 'Recipients',
      otherRecipients: 'Other recipients (separate with comma)',
      subject: 'Subject',
      message: 'Message',
      attachCommunityDocs: 'Attach community documents',
      plusTooltip: 'Write new email',
      emailSentSuccessfuly:
        'Email sent. Note: This was a no-reply email, the recipient can’t reply directly, but your sender address is visible.',
      emailSent: {
        title_one: '📤 Email sent to {{count}} recipient',
        title_other: '📤 Email sent to {{count}} recipients',
        message: 'If someone replies, the message goes straight to your inbox.',
      },
      sendCopy: 'Send a copy to me',
      maxAttachmentsSize: 'Maximum total attachment size: 15 MB',
      changeEmail: {
        title: 'Confirmation email sent',
        message:
          "We've sent you an email with a confirmation link for your new address. Please check your inbox and click the link to confirm your changes. If you don’t receive the email within a few minutes, check your spam folder. If you need help, feel free to contact us.",
      },
    },
    pushNotification: {
      header: 'Push Notification',
      filterByRecipient: 'Select Recipients',
      filterByResponse: 'Select Recipient by Response',
      pushMessage: 'Create Push',
      saveAsTemplate: 'Save Template',
      sendCopy: 'Send me a copy',
      allowMember: 'Allow member to member',
      pasteUrl: '🌐 Event or external link?',
      plusTooltip: 'Create new push notification',
      toasterText:
        '🆕 New Feature: You can now add an external link, like any website 🌐 (URL), to push notifications!\nDirect recipients straight to the website.',
      templates: 'Templates',
      title: 'Title',
      lastUsed: 'Last Used',
      noTemplates: 'Saved templates appear here',
      template: 'Template',
      sendConfirmHeader: 'Review Before Sending',
      totalRecipients: 'RECIPIENTS',
      redirectLink: 'TO LINK',
      successTitle: 'Push Sent!',
      successMessage:
        'Your message was sent to <b>{{totalRecipients}}</b> recipients.',
      selectEventFirst: 'Please select an event first',
      templateLimitTitle: 'Template Limit Reached',
      templateLimitInfo:
        "Save up to 8 of your messages as templates to reuse them later. We've already added 3 templates for inspiration - feel free to edit or delete them.",
      templateLimitMessage:
        'You have reached the maximum number of templates. Please delete one to create a new one.',
      urlInfo:
        'You can add links to any website (except Gumb) here. This could be a link to a product page, a news article, or anything else you find relevant. Simply paste the full URL (including https://).',
      urlInfoOne:
        'You can add any external website (URL) here to direct your recipients straight to it. If you choose an event above, the app will insert the event link, and clicking the push notification will open the event directly in Gumb.',
      urlInfoTwo:
        'Coming Soon: Add any external link (except Gumb) to your pushes! Link to websites, news, and more. Stay&nbsp;tuned!',
      urlTooltip:
        'You can create a push notification with or without linking to an event. Want to share your event link? Simply select an event above to automatically copy it here.',
    },
    common: {
      logoutTooltip: 'Log out',
      ctrl: 'Toggle totals',
      nextDay: '+1d',
      createdAt: 'Created At',
      updatedAt: 'Last Updated At',
      onlyAdmin: 'Only admins can use this feature.',
      download: 'Download',
      attachFile: 'Attach File',
      new: 'New',
      unseen: 'Unseen',
      more: 'More',
      less: 'Less',
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
      overallScheduler: 'Scheduler',
      selectEvent: 'Select event (optional)',
      displayEventsFrom: 'Display events from',
      modalExit: 'Are you sure you want to exit without saving your data?',
      all: 'All',
      tooltipEdit: 'Edit',
      tooltipDelete: 'Remove',
      overview: 'Overview',
      cancel: 'Cancel',
      removeLogo: 'Are you sure you want to delete this?',
      noTasks: 'No tasks yet',
      noUsers: 'No users yet',
      noOptions: 'No options',
      role: 'Roles',
      admin: 'Admins',
      member: 'Members',
      group_lead: 'Group Leaders',
      email: 'Email',
      groups: 'Groups',
      logoutHeader: 'Logout?',
      logoutMessage: 'You will be redirected to the login screen.',
      deleteHeader: 'Are you sure you want to delete user?',
      logout: 'Logout',
      delete: 'Delete',
      tablePlaceholder: 'No members to show yet',
      contentPlaceholder: 'No content to show yet',
      create: 'Create',
      copy: 'Copy',
      visible: 'Visible',
      saveChanges: 'Save changes',
      newField: 'New field',
      fieldName: 'Field name',
      addField: 'Add field',
      notifications: 'Notifications',
      participants: 'Participants',
      tasks: 'Tasks',
      documentation: 'Documents',
      description: 'Description',
      facebook: 'Facebook',
      twitter: 'X',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      youtube: 'YouTube',
      startDate: 'Start date',
      startTime: 'Start time',
      startDateTime: 'Start date/time',
      endDateTime: 'End date/time',
      endDate: 'End date',
      endTime: 'End time',
      icon: 'Icon',
      sendMessage: 'Send message',
      aboutMe: 'About Me',
      selectAll: 'Select all',
      approve: 'Approve',
      reject: 'Reject',
      backToGumb: 'Back to Gumb',
      edit: 'Edit',
      addComment: 'Add comment',
      answer: 'Save',
      ok: 'Ok',
      withoutGroup: 'Without group',
      copyLink: 'COPY LINK',
      copied: 'Copied',
      sendInviteLink: 'Send invite link',
      apply: 'Apply',
      from: 'From',
      to: 'To',
      enable: 'Enable',
      search: 'Search',
      color: 'Color',
      columns: 'Show columns',
      hiddenColumns: 'Hidden columns',
      noResultsFound: 'No earlier events available',
      sorryNoResults:
        "We're sorry you couldn't find what you were looking for. Please try another way.",
      tutorial: 'Tutorial',
      next: 'Next',
      back: 'Back',
      step: 'Step',
      createSuccess: {
        title: 'Created',
        message: 'Your option has been successfully created.',
      },
      editSuccess: {
        title: 'Edited',
        message: 'Your changes have been saved.',
      },
      deleteSuccess: {
        title: 'Deleted',
        message: 'The option has been successfully removed.',
      },
      toolTipText: {
        grid3x3: 'Matrix: Assign members to communities',
        faq: 'Help: Guides, Contact, More.',
        communityPlusIcon: 'Create new community',
        logoGumb:
          'Mystery in the making: Discover later what this button conceals!',
        memberArrowIcon: 'Go to member overview',
        memberPlusIcon: 'Add new member',
        eventType: 'Create event type',
        responses: 'Create answer option',
        task: 'Create task',
        schedulerPlusIcon: 'Create event or group',
      },
      shareEventTitle: 'Share event link via:',
      copyEventLink: 'Or copy the link:',
    },
    auth: {
      signInWith: 'Sign in with',
      continueAs: 'Continue as',
      create: 'Create free account',
      signUp: 'Sign up',
      signIn: 'Sign in',
      welcome: 'Welcome!',
      createAccount: 'Create free',
      forgotPassword: 'Forgot password?',
      resetPassword: 'Reset password',
      resetPasswordTooltip:
        'If you reset the password, the member will receive an email with instructions to set a new password. For accounts created with Facebook, Google, or Apple, Gumb can’t reset the password. The member can still sign in using the respective social media icon.',
      resetPasswordModalTitle: 'Password reset initiated',
      resetPasswordModalText:
        'The member now gets an email to set a new password. For Facebook, Google or Apple accounts, they can still log in as usual with the icon.',
      resetPasswordErrorModalTitle: 'Password reset not possible',
      resetPasswordErrorModalText:
        'Note: This member uses Facebook, Google, or Apple to log in. Gumb can’t reset the password. If the member forgot the password, they must reset it directly with the provider. Logging in via the social icon still works. Please inform the member.',
      terms: {
        '0': 'I agree to the ',
        '1': 'Terms',
        '2': ' and ',
        '3': 'Privacy Policy',
      },
      termsAcknowledgement:
        'By continuing, you acknowledge that you understand and agree to the <0>Terms & Conditions</0> and <1>Privacy Policy</1>.',
      home: 'Home',
      confirmed: 'Email successfully confirmed',
      verifying: 'Verifying email...',
      recovery: 'Password recovery',
      send: 'Send',
      codeSended:
        'Verification link has been sent to your email. Please check and confirm. Pay attention to the spam folder.',
      signUpSuccess:
        'Registered successfully. Please check email to confirm registration',
      inviteSent:
        'Registered successfully. Please check email to confirm registration',
      inviteSentTitle: 'Invitation sent successfully',
      inviteSentText:
        'Top! The member was added successfully and the invitation with a temporary password was sent (check spam folder if needed). The member can now log in and set a new password. Reload this page to update the member list. You and your admins can now edit the group, role, or the member’s profile.',
      reset: 'Reset',
      yourEmail: '{{value}} is already your email address',
      existEmail: '{{value}} already in use',
      labels: {
        email: 'Email',
        currentEmail: 'Current email',
        newEmail: 'New email',
        password: 'Password',
        oldPassword: 'Old password',
        newPassword: 'New password',
        confirmPassword: 'Confirm password',
      },
      accountExists:
        'We already have an account with this email address at Gumb. If this email belongs to you, click forgot password and check your inbox and spam folder.',
      codeExpired:
        'This was an expired link. After you enter your email here, we will email you with a new link to complete your account verification.',
      userNotConfirmed:
        'You still need to verify your account. We have sent you an email with a confirmation link. If you did not receive an email, please check the spam folder in your mailbox. ',
      invalidCredentials: 'Incorrect username or password',
      userNotFound:
        'This email is either not registered yet or linked to Google, Apple, or Facebook. Don’t change your social media password in Gumb - just log in using the matching social media icon.',
      socialLoginDetected: {
        title: 'Social login detected',
        message:
          'This email seems to be linked to Google, Apple, or Facebook. The password is managed there, not by Gumb. To log in, just click the matching social media icon.',
      },
    },
    profile: {
      editSuccess: 'Changes saved',
      settings: 'Settings',
      editProfile: 'Edit profile',
      selectImage: 'Select image',
      myProfile: 'My profile',
      profileEditBtn: 'ADD YOUR INFO: ADDRESS, SOCIALS & MORE',
      basicInformation: 'Basic info',
      contactInformation: 'Contact info',
      addressInformation: 'Address info',
      myCommunities: 'My communities',
      myAppointments: 'My Appointments',
      myChat: 'MY CHATS',
      freeText1: 'Free Text 1',
      freeText2: 'Free Text 2',
      subscription: 'Subscription',
      userProfile: 'User profile',
      tellUsAboutYourself: 'About me',
      firstName: 'First name',
      lastName: 'Last name',
      profileName: 'Username',
      person: 'Person',
      role: 'User Role',
      email: 'Email',
      dateOfBirth: 'Date of birth',
      privatePhoneNumber: 'Phone (Home)',
      officePhoneNumber: 'Phone (Work)',
      mobilePhoneNumber: 'Phone (Mobile)',
      street: 'Street',
      region: 'Region',
      postalCode: 'Postal code',
      city: 'City',
      country: 'Country',
      about: 'About',
      linkChangeEmail: '(Change email)',
    },
    profileCommunities: {
      empty: {
        title: 'No communities visible yet',
        description:
          'Once you create your own communities or join others,<brPure />they will appear here.',
      },
      heading: 'My Communities',
      titleOwner: 'Community owner',
      titleMember: 'Member',
      popupLeave: {
        title: 'Sure you want to leave the community?',
        button: 'Leave',
      },
      leaveCommunity: {
        title: 'Sure you want to leave the community?',
        message:
          'Leaving only this community. Your account stays, and you can join others anytime.',
        okButton: 'Yes, Leave',
        cancelButton: 'Cancel',
      },
      table: {
        labelCommunity: 'Community',
        labelOwner: 'Owner',
        labelGroups: 'Groups',
        labelMembers: 'Members',
      },
    },
    profileSettings: {
      title: 'Profile settings',
      notification: 'Notification',
      notificationsPlaceholder: 'No notifications yet',
      changePassword: 'Change password',
      changeEmail: 'Email',
      saveNewEmail: 'Save new email',
      language: 'Language',
      timeFormat: 'Time format',
      permissions: 'Permissions',
      allowedToEdit: 'Admins are allowed to edit my profile',
      other: 'Other',
      pushNotification: 'Push notification',
      receiveByEmail: 'Receive notifications by email',
      receivePush: 'Receive mobile push notifications',
      receiveInApp: 'Receive in-app notifications',
      terms: 'Terms and Conditions',
      protectionRegulation: 'Privacy Policy',
      deleteAccount: 'Delete account',
      logout: 'Logout',
      deleteProfileHeader: 'Sure you want to delete your account?',
      notifications: {
        now: 'Now',
        hours: '{{value}} h ago',
        minutes: '{{value}} mins ago',
        minute: '1 min ago',
      },
    },
    calendarConnection: {
      googleCalendar: 'Google Calendar',
      outlookCalendar: 'Outlook Calendar',
      pageTitle: 'Calendar connection',
      connectTitle: 'Connect your calendar\nto sync events automatically',
      connectDescription:
        'Gumb adds events for you - they show up automatically in your calendar.',
      appleCalendar: 'Apple Calendar',
      appleConnectionSteps: {
        headerOne:
          'Add Gumb events to your calendar (Apple or Outlook) using an iCal URL - in 4 steps.',
        demoLinks: 'Quick demo',
        demoLinksApple: 'Apple',
        demoLinksAppleHere: 'here',
        demoLinksDetailed: 'Detailed guide',
        demoLinksDetailedApple: 'Apple',
        demoLinksDetailedHere: 'here',
        demoLinksOutlook: 'Outlook',
        demoLinksOutlookHere: 'here',
        stepOne: 'In your calendar app, open',
        stepOneSubscribeBold: 'Subscribe to Calendar',
        stepOneApplePrefix: 'Apple',
        stepOneAppleSuffix: 'File → New Calendar Subscription',
        stepOneOutlookPrefix: 'Outlook',
        stepOneOutlookSuffix:
          'Add calendar → From Internet / Subscribe from web',
        stepTwo: "Copy your community's iCal link below and paste it",
        stepThree: 'Name the calendar and optionally choose a color',
        stepFour:
          'Adjust storage (iCloud, Mac, Outlook) & refresh settings, confirm',
      },
      appleConnectionPopup: {
        title: 'How to connect?',
        stepOne: 'Copy the community link',
        stepTwo:
          'In your Apple Calendar, under "Calendar", choose "File" > "New Calendar Subscription".',
        stepThree:
          'Enter the Community’s iCal Link copied, then click "Subscribe".',
        stepFour:
          'Name the calendar, choose a color, set preferences like location (iCloud or Mac) or auto-refresh, and click "OK".',
      },
      appleDisconnectPopup: {
        title: 'Confirm Disconnection',
        message:
          'Clicking "Yes, disconnect now" will remove all Gumb events from your calendar(s). Please manually delete the calendar(s) afterwards, as it/they will otherwise remain visible.\n\n<b>To fully unsubscribe:</b>\n\n• <b>On macOS</b>: Open Calendar, right-click the calendar > "Unsubscribe".\n• <b>On iOS</b>: Go to "Calendars", tap the "Info" button next to the calendar > "Delete Calendar".',
        okButton: 'Yes, disconnect now',
      },
      appleUncheckBoxPopup: {
        title: 'Confirm Disconnection',
        message:
          'Clicking "Yes, disconnect now" will remove all Gumb events from your calendar. Please manually delete the calendar afterwards, as it will otherwise remain visible.\n\n<b>To fully unsubscribe:</b>\n\n• <b>On macOS</b>: Open Calendar, right-click the calendar > "Unsubscribe".\n• <b>On iOS</b>: Go to "Calendars", tap the "Info" button next to the calendar > "Delete Calendar".',
        okButton: 'Yes, disconnect now',
      },
      connectWithApple: 'Connect Apple & Outlook (iCal)',
      cantSeeICal: "Can't see the iCal link? Just tick the checkbox.",
      syncTip:
        'Only the events from the selected community will be synchronized with your calendar.',
      connect: 'Connect',
      connected: 'Connected',
      disconnect: 'Disconnect',
      disconnectSuccess: 'Disconnected successfully',
      selectCommunities: 'Communities selection',
      selectCommunitiesDescription:
        'Only the events from the selected community will be synchronized with your calendar.',
      authSuccessTitle: 'Successfully connected',
      authSuccessMessage:
        'Your communities will now automatically synchronize. Wait a moment and then refresh the Google Calendar page to complete the initial synchronization.',
      authSuccessTitleTwo: 'Select your community now',
      authSuccessMessageTwo: 'Tap the checkmark and "Save Changes" to confirm.',
      syncSuccess:
        'Successfully updated!\nFrom now on, everything will be synchronized automatically. You can change the selection of communities at any time.',
      syncSuccessTitle: 'Almost Done!',
      syncSuccessMessage:
        "We're linking your community to your Google Calendar. It'll just take 2-3 minutes. Refresh your Google Calendar page to see updates.",
      disconnectConfirmTitle: 'Are you sure?',
      disconnectConfirmDescription:
        'All the events will be removed from your calendar if you disconnect.',
      disconnectConfirm: {
        title: 'Disconnect Now?',
        message:
          "Disconnecting will remove all events from your Google Calendar. Don't worry, you can reconnect Gumb for a new synchronization later at any time.",
        cancelButton: 'Cancel',
        okButton: 'Yes, Disconnect',
      },
      noCommunities:
        'There are no communities to select.\nWait until an admin adds you.',
      checkboxWarning: 'ATTENTION: The check mark must be set!',
    },
    community: {
      noMembersEmptyState: {
        title: 'No members signed up yet',
        description: 'Once members sign up, they will appear here.',
      },
      plusIconSubText: 'Plan an event or set up recurring events.',
      selectAllCommunityAdmins: 'All admins',
      selectAllGroupAdmins: 'All group leaders',
      createSuccess: 'Community was successfully created',
      createFailure: 'Please try creating your community again in a moment.',
      deleteSuccess: 'Community was successfully deleted',
      leaveSuccess: 'You have successfully left the community',
      descriptionTitle: 'About community',
      descriptionPlaceholder: 'Here you can describe your community',
      online: 'Online',
      updateCommunity: 'Update Community',
      members: 'Members',
      createCommunity: 'Create community',
      communityName: 'Community name',
      category: 'Category',
      aboutCommunity: 'About community',
      selectLogo: 'Select logo',
      selectLogoTip: 'jpg, jpeg, png (5MB)',
      chooseCover: 'Choose cover',
      chooseCoverTip: 'jpg, jpeg, png (20MB)',
      website: 'Website',
      partnership: 'Partnership',
      deleteCommunity: 'Delete community',
      deleteHeader: 'Are you sure you want to remove this user from group?',
      addMembers: 'Add members',
      invitationLink: 'Invitation link',
      communityRole: 'Community role',
      joinCommunity: 'Join community',
      namePlaceholder: "{{value}}'s team",
      requestSent: 'Membership request successfully sent',
      requestSentButton: 'Membership request sent',
      limitExceededHeader:
        'Your community limit is reached. To create more, upgrade your plan in Profile > Subscription.',
      limitExceededMessage:
        'Contact your community owner. Only they can manage and update the subscription.',
      limitExceededMessageOwner:
        'Please go to Profile > Subscription to manage your plan and upgrade if needed.',
      updateFailure: 'Community update failure',
      buttonAddEvent: 'Add Event',
      userBlockedTitle: 'Blocked',
      userBlockedText:
        'Seems like someone blocked you on this community. Admins can block or deblock members.',
      createOverLimitTitle: 'Maximum communities reached',
      createOverLimitText:
        "Start your free trial or choose a plan under 'Change Plan' to organize your own community.",
      notInvitedTitle: 'No permission',
      notInvitedText:
        'You may not have permission to access this event. Admins and group leaders can add you to the event.',
      noRequestsTitle: 'No pending requests yet.',
      noRequestsText:
        'When people submit requests for your community, they will be displayed here for you to review.',
      invitationCodeExpired:
        'The invitation link has expired. You can now send a join request, which admins will decide whether to accept or reject.',
      communityNotFound: 'Community not found',
      communityPopup: {
        title: 'Create Event or Group',
        subTitleOne:
          'Plan events in the central SCHEDULER. Use groups to divide members into teams.',
        createEvent: {
          infoText:
            "Schedule events for all or specific groups/members in the SCHEDULER. Visible in scheduler, 'My Events', and groups.",
          btntitle: 'Create Event',
          linkText: 'Tutorial',
        },
        createGroup: {
          infoText:
            'Groups have their own planners, with events visible only to group members. Manage member roles effectively',
          btntitle: 'Create Group',
          linkText: 'here',
        },
        chatTitle: 'Chat Options',
        chatSubTitle: 'Start a 1:1 chat or create a chat room for groups.',
        oneToOne: {
          infoText:
            "Click the chat icon next to a member's name or their profile picture to send a message.",
          btntitle: 'Go to Member List',
          linkText: 'here',
        },
        createChatGroup: {
          infoText:
            'Create a private chat room for selected members, teams, or groups. Only admins can create these rooms.',
          btntitle: 'Create Chat Room',
          linkText: 'here',
        },
      },
      exportStatistics: 'Export Statistics',
      exportStatisticsTooltip: 'Export the statistics to a CSV file',
    },
    communitySettings: {
      noSearchResults: {
        title: 'No results found',
        description:
          'No matches for {{searchResult}}. Try a different search term.',
      },
      clearSearch: 'Clear search',
      noMatrixData: {
        title: 'No communities visible yet',
        description:
          'Once an owner creates communities and makes you an admin, you can assign members here.',
      },
      matrixDescription:
        'One-click assign/remove members to your communities - saves instantly.<brPure />Ideal for season & team changes and multiple assignments.',
      admin: 'Admin',
      tooltip: 'Go to the matrix view: assign/remove members to communities.',
      matrix: 'Matrix',
      member: 'Member',
      blocked: 'Blocked user',
      owner: 'Owner',
      group_lead: 'Group Leader',
      group_admin: 'Group Admin',
      chat_admin: 'Chat Admin',
      community_admin: 'Community Admin',
      editRoleSuccess: 'Role was successfully changed',
      deleteUserSuccess: 'User was successfully deleted from community',
      removeUser: {
        title: 'Are you sure about removing this user?',
        message:
          'When you remove this user, they will be removed from your community but will retain their user account and can still participate in other communities.',
        cancelButton: 'Cancel',
        okButton: 'Yes, Remove',
      },
      removeUserSuccess: {
        title: 'User Removed',
        message: 'The user has been successfully removed from your community.',
      },
      editSuccess: 'Changes have been successfully updated',
      title: 'Community settings',
      backToSubscriptionsDetails: 'Back to subscription details',
      tabs: {
        general: 'General preferences',
        eventTypes: 'Event Types',
        subscriptions: 'Subscriptions',
        responses: 'Response Options',
        roles: 'Members',
        chats: 'Chats',
        requests: 'Requests',
        other: 'Other',
        tasks: 'Tasks',
      },
      addMember: 'Add Member',
      exportMembers: 'Export',
      exportMembersTooltip: 'Export the member list to a CSV file',
      deleteCommunityHeader: 'Really delete?',
      deleteCommunityMessage:
        'All your data will be permanently deleted. No recovery possible.',
      defaultEventList: [
        '🤝🏻🏻 Meetup 🤝🏻🏻',
        '📅 Event 📅',
        '📋 Meeting 📋',
        '📝 Board Meeting 📝',
        '🚌 Trip 🚌',
        '🛠️ Workshop 🛠️',
        '⏰ Duty / Shift ⏰',
        '🏢 Company Event 🏢',
        '🏃 Training 🏃',
        '🏆 Tournament 🏆',
        '🎶 Rehearsal 🎶',
        '🔴 CANCELLED 🔴',
        'ℹ️ INFO ℹ️',
        '📊 SURVEY 📊',
      ],
      defaultResponsesTypes: [
        'I’ll join ✅',
        'I won’t attend ❌',
        'Not sure yet 🟨',
      ],
      defaultTasks: ["Who's driving?", 'Who brings the drinks?'],
      selectUsers: {
        title: 'Select Users',
        message:
          'Please mark users with a checkbox to approve or decline membership requests.',
      },
      memberExists: 'Member already exists',
      mailSent:
        'Invite sent! Valid for 24 hours. The new member clicks “Join now” and logs in with the temporary password - and they’re instantly part of your community. Admins can resend the invite anytime.',
      userNotFound:
        'No profile found. Enter first and last name to create a new profile and send the invite.',
      disableAddMemberTooltip:
        'Member limit reached. Ask the community owner to upgrade the plan to add more members.',
      notifyByFields: 'Send notification when these fields are changed',
      notifyByReplies: 'Do you want to send notifications to invitees?',
      remindBefore: 'Remind before',
      addReminder: '+ Add reminder (2 max.)',
      notificationsTypes: [
        'Event created',
        'Event updated',
        'Event deleted',
        'Event reminder',
      ],
      notificationsClasses: ['In-App', 'Email', 'Push'],
      notificationPopupHeader: 'Send notifications to invitees?',
      notificationPopupMessageLabel: 'Add optional message',
      notificationPopupNotify: 'Send',
      notificationPopupDoNotNotify: "Don't send",
      notificationPopupBack: 'Back to editing',
      ownerTooltip:
        '👑 Owner\n\nThe owner created this community.\n\nThere is always only one - with full rights: manages the subscription and can delete the community.\n\nTransfer possible - please contact support.',
      emailTooltip:
        "📧 Email\n\nThis is the user's login email.\nOnly the user can change it.\n\nTip: Know a new member's email? → Add user",
      roleTooltip:
        '🛠️ Role\n\nAdmin:\nFull access on community level - sees & manages everything.\n➜ Click the field to make a user an admin\n\nGroup Leader:\nManages events & responses in one group.\n➜ Open group → Members → Drag up',
      groupsTooltip:
        '👥 Groups\n\nShows the groups this member belongs to.\n➜ Click the field to assign groups.\n\nNew members see all scheduler events.\nGroup events become visible only after group assignment.',
    },
    communityInvitation: {
      subjectFirst: 'You have been invited to join the community',
      subjectSecond: '',
      body: 'Please follow the link below to join the community',
      invitationSuccess:
        'Approved! Member added to your list. Check role and group under Community Settings → Members.',
      invitationFailure: 'Error - your plan limit is probably reached.',
      membersInvitation: {
        title: 'Invite members',
        description:
          'You have several ways to add new members. More info: <0>"Add a new user"</0>.',
        showMore: 'Show more',
        showLess: 'Show less',
        codeInvitation: {
          title: 'The fastest and easiest way',
          button: 'Copy invitation link',
          updateLink: 'Renew link',
          generateLink: 'Generate link now',
          howItWorks: 'How it works',
          goodToKnow: 'Good to know',
          howItWorksText:
            'Members click on "Create free account" using the link selected above. When Gumb sends an email, members only need to confirm their email address to gain direct access.',
          goodToKnowText:
            'This is super-quick, but please note that once the account verification is complete, people with this link will be able to access your events immediately. Hence, you can renew the above link whenever you like.',
        },
        linkInvitation: {
          title: 'Via Link:',
          button: 'Copy community link',
          howItWorks: 'How it works:',
          adminFlow: 'Admins review requests:',
          howItWorksText:
            '<0>Copy and share the link.</0><0>Members with a Gumb account click “Join”.</0><0>If someone doesn’t have an account, they need to sign up first, then click the link again to send you their request.</0>',
          adminFlowText:
            'You’ll find all new requests in the “Requests” tab. Admins can approve or decline them there. Open requests are marked with the gear icon.',
        },
        addMember: {
          title: 'Invite or pre-register via email address',
          button: 'ADD USER',
          selfSignUp: 'Member registers themselves:',
          preRegister: 'Pre-register a person:',
          selfSignUpText:
            'Anyone can sign up for Gumb for free and send you their email address. If you enter it here, the member is automatically added and can see all events.',
          preRegisterText:
            'Create a new member directly using their email address. The account is set up instantly - the member receives an invite with a temporary password and can log in right away. The password can be changed later.',
        },
      },
    },
    group: {
      deleteEventSuccess: 'Event was successfully deleted',
      createSuccess: 'Group was successfully created',
      deleteSuccess: 'Group was successfully deleted',
      addMembersSuccess: 'Members successfully added. Check your members list.',
      addMembersSuccessWithMessage: {
        title: 'Member added!',
        message:
          'Your member list has been successfully updated. Manage roles and group assignments. You can also add or change user details.',
      },
      deleteUserSuccess: 'Successfully deleted user from group',
      addParticipants: 'Add Members',
      createGroup: 'Create Group',
      deleteGroup: 'Delete Group',
      groupName: 'Group Name',
      changeGroupNameSuccess: 'Group Name Successfully Changed.',
      groups: 'Groups',
      inviteMembers: 'Invite members',
      tabs: {
        schedule: 'Schedule',
        members: 'Members',
        chat: 'Chat',
        documentation: 'Documents',
        statistic: 'Export & Statistics',
        import: 'Import',
      },
      limitExceededHeader:
        'Your community limit is reached. To create more, upgrade your plan in Profile > Subscription.',
      limitExceededMessage:
        'Contact your community owner. Only they can manage and update the subscription.',
      limitExceededMessageOwner:
        'Please go to Profile > Subscription to manage your plan and upgrade if needed.',
      groupRole: 'Group role',
      addGroup: 'Add Group',
    },
    chat: {
      noRead: 'Not yet read',
      noActiveCommunity: "You don't have an active community yet.",
      lastAdmin:
        'A chat room needs at least one admin or group leader. Make sure at least one person always has this role.',
      read: {
        now: '{{name}} read just now',
        hours: '{{name}} read {{value}}h ago',
        minutes: '{{name}} read {{value}} mins ago',
        minute: '{{name}} read 1 min ago',
        dateTime: '{{name}} read on {{value}} at {{time}}',
      },
      update: {
        btn: 'SAVE',
        success: 'Member list has been updated',
        successUpdate: 'Chat group updated successfully',
      },
      modal: {
        btn: 'Manage',
        about: 'About',
        editRoom: 'Edit Chat Room',
        delete: 'Delete Chat Room',
        editMember: 'Edit Members',
        onlyChatAdmin: 'Only chat room admins can do this.',
      },
      details: {
        title: 'Chat Room Details',
        secondTitle: 'INFORMATION',
        name: 'Chat group name',
      },
      delete: {
        success: 'Chat room has been deleted',
      },
      create: {
        title: 'Create Chat Room',
        name: 'Chat Room Name',
        description: 'Group Description (optional)',
        btnNext: 'NEXT',
        success: 'Chat room created',
      },
      popover: {
        title: 'Unknown user',
        message: 'User no longer in in this community or group',
      },
      new: 'New',
      chat: 'Chat',
      plusTooltip: 'Create a new chat or group chat',
      op1: 'Files & Videos',
      op2: 'Photos',
      files: 'Files',
      inputPlaceHolder: 'Type a message',
      searchHover: 'Search or start a new chat',
      emptyStatus: {
        noChatSelected: {
          firstLine: 'Select a conversation to view the chat,',
          secondLine: 'or click here to start a',
          LinkText: 'NEW CHAT',
        },
        noChatUser: 'No chats yet?',
        noChatSubText: 'Start a 1:1 chat or wait for your admin to add you.',
        noUnseenUser: "Don't have any unseen chat",
        sendFirstMessage: 'Write your first message to {{recipient}}.',
      },
      infoPopup: {
        title: 'Limit Exceeded',
        message: 'You can upload a maximum of 20 files at a time.',
      },
    },
    statistics: {
      tableType: 'Choose a report',
      eventReplies: 'Responses & Tasks',
      eventTypes: 'Event type',
      appointmentSchedule: 'Appointment schedule',
      memberFigures: 'Presence check',
      charts: {
        eventTypesByMonth: 'Number of events by type',
        eventReplies: 'Reactions to response options',
        memberPresence: 'Number of reactions per response',
      },
      loadingStatistics: 'Loading...',
      memberFiguresExportSuccess: {
        title: 'Report is being generated!',
        message:
          'We’re creating your attendance report. With lots of data, this might take a few minutes. For security reasons, the report will be sent to your email. Please check your inbox. Thanks for your patience!',
      },
    },
    filters: {
      clickToSelect: 'To filter, click here',
      showFilters: 'Show filters',
      dateRange: 'Select date range',
      filterBy: 'Filter By',
      dateRanges: {
        yearToDate: 'Year-to-date',
        lastDays: 'Last {{number}} days',
        lastYear: 'Last year',
        yesterday: 'Yesterday',
        today: 'Today',
        tomorrow: 'Tomorrow',
        nextDays: 'Next {{number}} days',
        thisWeek: 'This week',
        thisMonth: 'This month',
        thisYear: 'This year',
        allTime: 'All time',
        specificDateRange: 'Specific date range',
      },
      downloadXlsxOrCsv: 'Download here: Excel or CSV',
    },
    bulkUploadEvents: {
      toastText:
        '🆕  The new appointment import feature is now available for each group!  🎉',
      moduleTitle: 'Import',
      step1: 'Step 1',
      step2: 'Step 2',
      step3: 'Step 3',
      step4: 'Step 4',
      stepOne: {
        stepTitle: 'Prepare Data Import',
        stepDescription: 'Download Excel Template',
        componentTitle: 'Download Excel Template',
        componentDescription:
          'Fill in the template with your event data, or use your own Excel file.',
        p1: 'Fill in the template with your event data.',
        p2: 'Column headers must remain in English.',
        p3: 'Examples in each column show you the correct format.',
        p4: 'New event types are added automatically.',
        p5: '<b>Important</b>: If you use your own file, the following column titles must be copied exactly as shown in English (case sensitive):',
        p6: 'Examples in each column of the template show you the correct format.',
        p7: 'New event types are added automatically',
        eventTypes: 'GO TO EVENT TYPES',
        template: 'Download Template',
        nextStepButton: 'Continue',
        copy: 'Copy All',
      },
      stepTwo: {
        stepTitle: 'Upload File',
        stepDescription: 'Upload CSV File',
        componentTitle: 'UPLOAD CSV FILE',
        componentDescription:
          'Save the Excel file as <b><u>CSV</u></b> and upload it here.',
        p1: "We'll check the format and show you a preview.",
        uploadButton: 'Choose File',
        maximumFileSize: 'Maximum file size: 1MB',
      },
      stepThree: {
        stepTitle: 'Confirm Data',
        stepDescription: 'Preview of your first event.',
        componentTitle: 'Confirm Data',
        componentDescription:
          'Review the sample and adjust the activated members.\nThe selected members apply to all events.',
        nextStepButton: 'CONFIRM AND UPLOAD',
      },
      stepFour: {
        stepTitle: 'Successfully Uploaded!',
        stepDescription:
          'Uploading events was a success. See them in the scheduler.',
        componentTitle: 'Successfully Uploaded!',
        componentDescription: '<b>{{count}}</b> events have been imported.',
        secondTitle: 'Good to Know',
        secondSubTitle: 'You can undo the import or upload a new list.',
        goToScheduler: 'Go to Scheduler',
        undoImport: 'Undo Import',
        uploadNewList: 'Upload New List',
      },
      errors: {
        eventNameErrorTitle: 'Event Name Error',
        eventNameErrorMessage:
          'Event name missing on row <b><u>{{row}}</u></b>.',
        eventTypeErrorTitle: 'Event Type Error',
        eventTypeErrorMessage:
          'Event type missing on row <b><u>{{row}}</u></b>.',
        timeErrorTitle: 'Time Error',
        timeErrorMessage:
          'Start or end time missing on row <b><u>{{row}}</u></b>.',
        dateErrorTitle: 'Date Error',
        dateErrorMessage: 'Date missing on row <b><u>{{row}}</u></b>.',
        locationErrorTitle: 'Location Error',
        locationErrorMessage:
          'Event location missing on row <b><u>{{row}}</u></b>.',
        invalidDateOrTimeTitle: 'Invalid Date or Time',
        invalidDateOrTimeMessage:
          'Please re-check date and time format on row <b><u>{{row}}</u></b> (e.g., use HH:MM for time).',
      },
      commentRequired: {
        title: 'Comment needed',
        message: 'Please enter a short comment.',
      },
      deletePopupTitle: 'Delete Event List?',
      deletePopupMessage:
        'This action will permanently delete your last uploaded event list. Are you sure?',
      deleteSuccessTitle: 'Deletion Successful!',
      deleteSuccessMessage:
        'Your last uploaded event list was deleted successfully.',
      successMessage:
        'Validation Successful. Proceed to the next step to see a preview.',
      restartProcessTitle: 'Upload New Event List',
      restartProcessMessage:
        'You can upload a new event list at any time. Please note that previously uploaded events will still be visible in the scheduler. If you want to replace the old list, delete it first or undo the last import.',
      restartProcessOkButton: 'UPLOAD NEW LIST',
      exportDataSample: {
        event_name: 'Zurich Street Parade',
        event_type_name: 'Performance',
        event_location: 'Bahnhofstrasse 5, 8001 Zurich',
        event_description: 'Open-air festival with international bands and DJs',
      },
    },
    event: {
      noParticipants: {
        title: 'No Participants yet.',
        description:
          'Once a member is added to the event, they will appear here.',
      },
      noParticipantsSearchResults: {
        title: 'No results found',
        description: 'Try using a different search term.',
      },
      noDocuments: {
        title: 'No files yet',
        description: 'Files will appear here once they are uploaded.',
      },
      noTasks: {
        title: 'No tasks yet',
        description:
          'Tasks will appear here once they are created or activated by an admin.',
      },
      noSearchResults: {
        title: 'No results found',
        description: 'Try using a different search term.',
      },
      event: 'Event',
      createdAt: 'Creation date',
      editEvent: 'Edit Event',
      createEvent: 'Create event',
      updateEvent: 'Update event',
      eventName: 'Event name',
      eventType: 'Event type',
      eventTypeDeleted: 'Deleted event type',
      eventDetails: 'Event details',
      eventOrganizer: 'Event organizer',
      eventOrganizerShort: 'Organizer',
      location: 'Location',
      eventTypeEdit: 'Event type edit',
      eventTypeName: 'Event type name',
      eventTypeCreate: 'Create event type',
      responseRequired: 'Response required',
      responseName: 'Response name',
      responsesEdit: 'Response edit',
      responsesCreate: 'Create response',
      repeatAnEvent: 'Repeat an event',
      repeatWithInterval: 'Repeat with interval',
      allDay: 'All day',
      registrationDeadline: 'Registration deadline',
      commentRequired: 'Comment required',
      editTask: 'Edit task',
      createTask: 'Create task',
      eventTaskName: 'Task name',
      icon: 'Icon',
      isMemberComing: 'Your response?',
      recurringEvent: 'Recurring event',
      allEvents: 'All events',
      thisEventOnly: 'This event only',
      createEventSuccess: 'Event was successfully created',
      updateEventSuccess: 'Event was successfully updated',
      createEventReplySuccess: 'Response successfully saved',
      updateEventReplySuccess: 'Response successfully updated',
      addGuests: 'Additional guests?',
      eventOperations: {
        eventOnly: 'This event',
        eventAndFollowUp: 'This and following events',
        all: 'All events',
        deleteText: 'Delete recurring event',
        editText: 'Edit recurring event',
        editReplyText: 'Your answer applies to',
        confirm: 'OK',
      },
      dfRes: 'Set default response for all',
      dfResInfo:
        'This sets the default response for all event participants. Any existing individual responses will be overwritten.',
      title: 'Warning',
      responseToast:
        'If you delete the default response without saving a new one, all previous reactions and comments will be deleted.',
      setPreferences: 'Set Preferences',
      setEventDefaults: 'Set Event Defaults',
      preferencesText:
        'Define default settings for new events of this type, including the default response for members',
      responseSubTitle: 'Require comment (optional)',
      requestComment:
        'Enable this option so members must add a comment when choosing this answer (e.g. “No, without me” to request a reason).',
      registeredUsers: 'Responses',
      guests: 'Guests',
      nomination: 'Nomination',
      nominated: "You're nominated",
      havePenalty: 'You received a penalty',
      penalty: 'Penalty',
      invitees: 'Invitees',
      awaiting: 'Awaiting',
      minutes: 'Minutes',
      hours: 'Hours',
      days: 'Days',
      weeks: 'Weeks',
      weekDay: 'Weekday',
      duration: 'Duration',
      months: 'Months',
      years: 'Years',
      viewAppointment: 'View Event',
      myResponse: 'My Response',
      noEvents: {
        title: 'No events visible yet',
        description: 'Once an admin adds you, your events will appear here.',
      },
      shareEvent:
        'Share event - Click the icon to copy the event and paste it anywhere (email, WhatsApp, etc.)',
      shareEventOption: 'Share event link',
      exportPDFOption: 'Export to PDF',
      deadlineExpired:
        'The signup deadline has probably passed or the event is already over.',
      totalInvitees: 'Total invitees',
      responsesReceived: 'Responses received',
      additionalGuests: 'Additional guests',
      noPermissionToGiveReply: "You don't have permission to change this",
      responsesPercentage: 'Responses percentage',
      acceptedTasks: 'Accepted tasks',
      acceptedTasksByUser: 'Tasks by user',
      givenComments: 'Given comments',
      givenCommentsByUser: 'Given comments by user',
      optionalMessage: 'Click here to see the news.',
    },
    task: {
      createTask: 'Create task',
      taskName: 'Task name',
      noTasks: 'No tasks',
    },
    groupSettings: {
      title: 'Group settings',
      tabs: {
        general: 'General',
        eventTypes: 'Event types',
        responses: 'Responses',
        membersManagement: 'Member administration',
        other: 'More',
      },
      deleteGroupHeader: 'Really delete?',
      deleteGroupMessage:
        'All your data will be permanently deleted. Recovery is not possible.',
    },
    documentation: {
      title: 'Documents',
      generalDocumentation: 'General documents',
      uploadedFiles: 'Uploaded files',
      chooseFile: 'Choose file',
      tipMessage: 'Maximum upload file size: 50 MB',
      overview: '{{value}} GB of {{capacity}} GB used',
      uploadSuccess: 'Document was successfully uploaded',
      deleteSuccess: 'Document was successfully deleted',
      attachFiles: 'Attach files',
      limitExceededHeader: 'You have reached the storage limit for documents.',
      sort: {
        label: 'Sort by',
        nameAsc: 'Name (A-Z)',
        nameDesc: 'Name (Z-A)',
        dateOldest: 'Date (Oldest first)',
        dateNewest: 'Date (Newest first)',
      },
    },
    subscriptions: {
      title: 'Subscriptions',
      subscription: 'Subscription',
      yearly: 'Yearly',
      monthly: 'Monthly',
      adBlocker: {
        header: 'Disable Ad Blocker',
        body: 'Disable your ad blocker (icon next to the URL) to see local prices. Reload the page.',
      },
      freeTitle: '2 months free trial',
      freeDescription: 'Start your free 2-month trial now.',
      freeText1: 'Open up to <strong>30</strong> communities',
      freeText2: 'Full access to all features',
      freeText3: 'No credit card required - sign up and start immediately',
      freeText4: 'No automatic renewal',
      freeText5: 'No ads',
      subscribe: 'SUBSCRIBE',
      seeDetails: 'SEE DETAILS',
      buildCustom: 'Custom',
      month: 'month',
      year: 'year',
      community: 'Community Hub',
      communities: 'Community Hubs',
      scheduler: '<strong>1</strong> Central Event Scheduler',
      schedulers: 'Each with <strong>1</strong> Central Event Scheduler',
      group: 'Team/Department Group Planners',
      capacity: 'Member Capacity',
      chatEnabled: 'Chat included',
      chatExcluded: 'Chat Functionality Not Included',
      maxStorage: 'GB storage',
      classic: 'Classic',
      classicPlus: 'Classic+',
      popular: 'POPULAR',
      textInnerTop:
        'Pick the right plan for your team. Organize into up to {{groups}} groups and manage {{members}} members. Update or cancel anytime.',
      textInnerBottom:
        "Your subscription is an ongoing contract. Benefit: It auto-renews annually/monthly. We'll send an email reminder. Pay with credit card (MasterCard, Visa) or PayPal.",
      chatsExcluded: 'Chats excluded',
      current: 'CURRENT',
      pay: 'PAY',
      usingBlocker: 'Please disable ad blocker and reload the page',
      failedToSubscribe:
        "Payment failed. Either the security check didn't pass or your card might expire soon. Please use another card or try again.",
      usedGroups: 'Used groups',
      usedMembers: 'Used members',
      usedCommunity: 'Used communities',
      usedStorage: 'Used storage',
      orderSummary: 'Order summary',
      tax: 'TAX',
      total: 'Total',
      periodEnds: 'Paid period ends',
      cancelSubscription: 'CANCEL MY SUBSCRIPTION',
      paypalLink: 'BILLING HISTORY',
      paymentApproved: 'Payment approved',
      paymentError: 'Payment error',
      limitExceededHeader: "You've reached the member limit.",
      limitExceededMessage:
        'Contact your community owner. Only they can manage and update the subscription.',
      limitExceededMessageOwner: 'Choose a plan to create a community.',
      inactiveSubscriptionHeader: 'Payment approval pending',
      inactiveSubscriptionMessage:
        "Sorry, you can't continue this action. You may have to first complete the payment process.",
      subscriptionNotPaid: 'No active plan',
      contactAdmin: 'Please, contact the Admin.',
      free: 'Free account',
      requireSubscription:
        'Gumb is free for members of active communities. Create your own community and start your free trial now or change to a suitable plan under "Change Plan".',
      requireSubscriptionMember:
        'No valid subscription was detected. You don\'t have to do anything here yourself. The community owner on the other hand can check in his profile under "Subscription" if the license for this community is activated or extended.',
      billingAttention: {
        viewSubscription: 'Manage subscription',
        dismiss: 'Dismiss',
        past_due: {
          title: "We couldn't process your last payment",
          body: 'Please update your payment method to keep your subscription active.',
          cta: 'Update payment method',
        },
        unpaid: {
          title: 'Your account has an unpaid balance',
          body: 'Update your billing details to restore access to your workspace.',
          cta: 'Update billing',
        },
        overdue_invoice: {
          title: 'You have an overdue invoice',
          body: 'Pay your outstanding invoice to keep your subscription active.',
          cta: 'Pay invoice',
        },
      },
      cancelConfirmation: 'Are you sure you want to cancel your subscription?',
      unsubscribe: 'Cancel',
      cancelled:
        'Cancellation confirmed. A confirmation of cancellation has just been sent to your email. You will continue to have access to all features until the paid settlement date.',
      renewSubscriptionText:
        'Thank you!\n\nYour previous subscription will be renewed, if you activate it now',
      activate: 'Activate now',
      activated:
        "Your subscription is active! Welcome to Gumb: we're thrilled you're now professionally planning and organizing with us. A confirmation is in your email. All features are immediately available to your team.",
      approved:
        'Preparing your subscription... Please wait a moment (up to 45 seconds). Do not refresh or close this browser window during this time.',
      trial: 'Free trial',
      trialActivated:
        'Your trial has started. You and your admins can now begin planning, inviting members, and managing settings.',
      cancelledTitle: 'Cancelled',
      startTrial: 'Start free trial',
      startTrialHeader: 'Looooong Testing!',
      startTrialText:
        ':tada: Try Gumb free for 2 months - no credit card, no automatic renewal. Nothing happens when the trial ends.',
      subscriptionExpired:
        "This community currently doesn't have an active subscription.To add new users, the subscription needs to be renewed.For questions: support@gumb.app",
      startTrialPopupButton: 'Test for Free',
      paymentMethods: 'Credit card or Paypal',
      checkout: {
        pageTitle: 'Checkout',
        breadcrumbCheckout: 'Checkout - {{plan}}',
        stepPlanSelected: 'Plan selected',
        stepOrderSummary: 'Order summary',
        stepConfirmation: 'Confirmation',
        completeOrder: 'Complete your order',
        planInfoSub: '{{billing}} · {{count}} {{teams}}',
        planLineAnnual: '{{plan}} (annual)',
        planLineMonthly: '{{plan}} (monthly)',
        planLineSubtextAnnual:
          '{{currency}}{{price}}/year · {{days}} days remaining',
        planLineSubtextMonthly:
          '{{currency}}{{price}}/month · {{days}} days remaining',
        daysRemainingSubtext: '{{days}} days remaining',
        annualSavingLine: 'Annual billing savings',
        totalDueToday: 'Total due today',
        renewsOn: 'Renews {{date}}',
        chargedToday: 'Charged today:',
        activationInfo:
          "After payment is approved, your plan activates and you'll get a confirmation email. You can cancel anytime from subscription settings.",
        activationInfoStripe:
          'Your plan activates immediately after payment. Renews annually on the same date - cancel anytime.',
        activationInfoStripeMonthly:
          'Your plan activates immediately after payment. Renews monthly on the same date - cancel anytime.',
        includedTitle: "What's included",
        included1: 'Shared main calendar',
        included2: 'Real-time attendance',
        included3: 'Team chat & DMs',
        included4: 'Push notifications',
        included5: 'Member roles & permissions',
        included6: 'File storage & docs',
        included7: 'iOS, Android & web',
        included8: 'Analytics & CSV export',
        trustSecure: 'Secure checkout with PayPal',
        trustSecureStripe: 'Secure checkout via Stripe',
        trustCancel: 'Cancel anytime',
        trustCancelDetailed: 'Cancel anytime, no penalty',
        trustSSL: '256-bit SSL encryption',
        stripeProcessedNote: 'Secure payment processed by',
        completePurchase: 'Complete purchase',
        paymentMethodLegend: 'Payment method',
        payDirectTitle: 'Pay now',
        payDirectDesc: 'Charged today.',
        payInvoiceTitle: 'Invoice',
        payInvoiceDesc: 'Invoice by email.',
        invoiceHeadline: 'Pay by invoice',
        invoiceSubline:
          'Yearly plan · Stripe invoice · pay on the hosted invoice page',
        invoicePanelBody:
          'We create a yearly subscription and email a Stripe hosted invoice. Payer contacts below are saved for your records; Stripe uses your profile email as bill to.',
        requestInvoice: 'Request invoice',
        toBeInvoiced: 'To be invoiced',
        invoicePageNote:
          'Your subscription starts immediately, regardless of payment',
        chf: {
          title: 'Billing details',
          subtitle:
            'You will receive a QR-Bill by email. Payment term 30 days.',
          name: 'Organization or name',
          address: 'Address',
          vatNumber: 'VAT number',
          billingEmail: 'Billing email',
          optional: 'optional',
          recipientsHint:
            'All recipients receive the same invoice. Leave empty to use {{email}}.',
          total: 'Total',
          submit: 'Request invoice',
          activationNote:
            'Your subscription starts immediately, regardless of payment',
          invalidEmail: 'Enter a valid email address',
          maxRecipients: 'Maximum 5 recipients',
        },
        invoiceTrust1: 'Invoice sent to your billing email',
        invoiceTrust2: 'Pay by bank transfer with the reference provided',
        invoiceTrust3:
          'Your app is active right away - pay the invoice when it suits you',
        priceSaveVsMonthly: '2 months free vs. monthly',
        planDetails: 'Plan details',
        badgeNew: 'New subscription',
        planNotInCatalog:
          'This plan isn’t available on the checkout catalog yet, or the link is outdated. Go back to Change plan and open checkout again from there.',
        backToChangePlan: 'Back to Plans',
        invoiceYearlyOnly:
          'Invoice billing is available for annual subscriptions only. Choose yearly billing on Change plan, then return to checkout.',
        invoicePayerEmailsLabel: 'Payer / finance emails',
        invoicePayerEmailsHint:
          'We store these contacts for your records. Stripe sends the invoice to your profile email (bill to).',
        invoiceBillToProfile: 'Bill to: {{email}}',
        invoiceEmailPlaceholder: 'finance@company.com',
        invoiceAddEmail: '+ Add another email',
        invoiceRemoveEmail: 'Remove email',
        invoiceSubmit: 'Create Invoice',
        invoiceSubmitting: 'Creating invoice…',
        invoiceInvalidEmails: 'Enter at least one valid email address.',
        invoiceSubmitError:
          'Could not create the invoice. Try again or contact support.',
        stripeCheckoutError: "We couldn't start checkout. Please try again.",
        invoiceSuccessTitle: 'Invoice created - complete payment when ready',
        invoiceAmount: 'Amount: {{amount}}',
        invoiceOpenHosted: 'Open Stripe invoice & pay',
        invoiceHostedPending:
          'Your subscription is pending payment. Check your email for the invoice link, or open Subscription in your profile shortly.',
        invoiceReturnBreadcrumb: 'Confirmation',
        invoiceReturnSuccessTitle: "You're all set!",
        invoiceReturnSuccessSub:
          "Your {{plan}} is active now. Pay the Stripe invoice when you're ready - no need to wait for payment to use the app.",
        invoiceReturnSuccessDetailsHeading: "What's been activated",
        invoiceReturnSuccessBulletPlan:
          '{{plan}} - your subscription limits and billing are applied.',
        invoiceReturnSuccessBulletActive:
          'Premium features are available right away on web and mobile.',
        invoiceReturnSuccessBulletInvoice:
          'A Stripe invoice was created - open it below or check your billing email.',
        invoiceReturnSeeInvoice: 'See invoice',
        invoiceReturnSeeInvoicePending: 'Invoice link pending',
        invoiceReturnGoSubscription: 'Go to subscription',
        stripeReturnBreadcrumbSuccess: 'Confirmation',
        stripeReturnBreadcrumbFailure: 'Checkout cancelled',
        stripeReturnSuccessTitle: "You're all set!",
        stripeReturnSuccessSub:
          'Your {{plan}} is now active. You can start using all features immediately - no waiting, no setup delay.',
        stripeReturnPlanFallback: 'plan',
        stripeReturnSuccessDetailsHeading: "What's been activated",
        stripeReturnSuccessBulletPlan:
          '{{plan}} - your subscription limits and billing are now applied.',
        stripeReturnSuccessBulletActive:
          'Premium features are available right away on web and mobile.',
        stripeReturnSuccessBulletEmail:
          "We'll send a receipt to your billing email when payment is confirmed.",
        stripeReturnSuccessBulletGuarantee:
          '30-day money-back guarantee applies to your subscription.',
        stripeReturnSessionRef: 'Checkout reference: {{id}}',
        stripeReturnGoHome: 'Go to home',
        stripeReturnViewSubscription: 'View subscription',
        stripeReturnFailureTitle: 'Payment not completed',
        stripeReturnFailureSub:
          "You weren't charged. You can open checkout again anytime from Change plan.",
        stripeReturnFailureDetailsHeading: 'What happened',
        stripeReturnFailureBullet1:
          'Checkout was cancelled or closed before payment finished.',
        stripeReturnFailureBullet2: 'Your subscription was not changed.',
        stripeReturnTryAgain: 'Back to plans',
        stripeReturnBackSubscription: 'View subscription',
        onboardingStripeReturnPlanFallback: 'onboarding add-on',
        onboardingStripeReturnSuccessTitle: 'Onboarding purchase complete',
        onboardingStripeReturnSuccessSub:
          'Your one-time {{plan}} purchase is confirmed.',
        onboardingStripeReturnSuccessDetailsHeading: 'What you purchased',
        onboardingStripeReturnSuccessBulletPlan:
          '{{plan}} - one-time onboarding. Your subscription plan and billing cycle are unchanged.',
        onboardingStripeReturnSuccessBulletEmail:
          "We'll send a receipt to your billing email when payment is confirmed.",
        onboardingStripeReturnSuccessBulletNext:
          "We'll follow up with next steps for your onboarding.",
        onboardingStripeReturnSuccessBulletGuarantee:
          '30-day money-back guarantee applies to this onboarding purchase.',
        onboardingStripeReturnBookSession: 'Schedule onboarding session',
        onboardingStripeReturnFailureSub:
          "You weren't charged. You can open onboarding checkout again from Change plan.",
        onboardingStripeReturnFailureBullet2:
          'Your subscription and paid onboarding extras were not changed.',
      },
      subscriptionsPopup: {
        title: 'No active plan',
        subtitle: '<b>{{ownerName}}</b> is the owner and can choose a plan. 🙌🏻',
        firstBox: {
          title: 'Choose a plan to restore full access for everyone.',
          btnText: 'Choose plan',
        },
        secondBox: {
          title:
            'Should someone else take over? We can transfer ownership to another member.',
          btnText: 'Request ownership',
          contactMessage:
            'I would like to request an ownership transfer for "{{communityName}}" ({{communityId}}). Current owner: {{currentOwner}}. My email: {{email}}.',
        },
      },
      profile: {
        legacy: {
          heading: 'Subscription Details',
          titleMembership: 'Membership',
          titlePayment: 'Payment',
          buttonCancel: 'Cancel membership',
          details: {
            linkChangePlan: 'Change plan',
            infoTrial:
              "Your trial is running. After it ends, you won’t be charged. If you want to keep using Gumb, choose a plan under 'Change plan'.",
            infoTrialNew:
              "Your trial is running. After it ends on {{expireDate}}, you won’t be charged. If you want to keep using Gumb, choose a plan under 'Change plan'.",
            linkShowCommunities: 'Show my communities',
            linkHistory: 'Billing history',
            linkChangePayment: 'Change payment method',
            currentPlan: 'Current plan:',
            communitiesInUse: 'Communities in use:',
            groupsInUse: 'Groups in use:',
            membersInUse: 'Members in use:',
            storageInUse: 'Storage in use:',
            paymentCycle: 'Payment cycle:',
            paymentMethod: 'Payment method:',
          },
          billing: {
            paymentInfoNote:
              'You can add payment details securely when you subscribe. Billing is handled by Stripe with encryption.',
            securePayments: 'Secure payments',
            renewalNote: 'Renews {{date}} · {{cycle}}',
            choosePlanTrial: 'Choose your plan',
            cancelTrial: 'Cancel trial',
            cancelTrialConfirm:
              'End your free trial? You can subscribe again anytime from the plans page.',
            trustStripeNote:
              'Payments securely processed - manage billing for invoices & receipts',
          },
        },
        page: {
          title: 'Subscription & Billing',
        },
        confirming: {
          onboardingTitle: 'Almost there',
          onboardingHint:
            "We're syncing your payment with your account. This usually takes just a moment.",
          subscriptionTitle: 'Almost there',
          subscriptionHint:
            "We're activating your subscription. This usually takes just a moment.",
        },
        labels: {
          paymentCycleMonth: 'Monthly',
          paymentCycleYear: 'Yearly',
          validUntil: 'Still valid until:',
          nextPayment: 'Next payment:',
          infoCancelled:
            'Your subscription is cancelled and won’t renew. You can use the app until the next billing date. You can renew anytime.',
          subscriptionEndedOn: 'Subscription ended:',
          trialEndedOn: 'Trial ended:',
          accessUntil: 'Access until:',
          nextInvoice: 'Next invoice:',
          lastPlan: 'Last plan',
          invoiceBillingCyclePrimary: 'Annual · Custom pricing',
        },
        hero: {
          title: 'Start your 2-month free trial',
          subtitle: 'Full access to all features - no credit card required.',
          seeIncluded: "See what's included",
        },
        freeAccount: {
          subtitle: "You haven't started a trial or subscription yet.",
          badge: 'Free account',
          noActivePlan: 'No active plan',
          trialUnlockBlurb:
            'Start your free 2-month trial to unlock full access - including multiple Communities, group schedulers, member management, and more.',
          trialNoteFooter:
            '2-month free trial - nothing charged automatically afterwards.',
          comparePlans: 'Compare plans',
        },
        plan: {
          title: 'Current Plan',
          subtitleTrial: 'Test Gumb comfortably during your trial.',
          subtitleActive: 'Your plan is active and renews automatically.',
          subtitleNonRenewal:
            'Full access until {{date}}. The subscription will not renew automatically.',
          subtitleStripeEnded:
            'Paid subscription ended on {{date}}. You can subscribe again from Change plan.',
          subtitleFullyCancelled:
            'Your {{plan}} subscription ended on {{date}}.',
          subtitleTrialExpired: 'Your trial ended on {{date}}.',
          badgeTrial: 'Free trial',
          badgeTrialExpired: 'Trial expired',
          badgeCancelled: 'Cancelled',
          badgeEnded: 'Ended',
          badgeActive: 'Active',
          endsOnNote:
            'Ends {{date}}. Nothing is charged automatically afterwards.',
          footnoteStripeEnded:
            'Ended on {{date}}. There will be no further charges.',
          footnoteFullyCancelled: 'Cancelled on {{date}}. No further charges.',
          footnoteTrialExpired: 'Trial ended {{date}}. Nothing was charged.',
          footnoteRenewalCancelled:
            'No renewal after {{date}}. You keep full access until then · {{price}}{{period}} (last plan while active) · {{billingMethod}}',
          footnoteRenewalPayment:
            'Renews {{date}} · {{price}}{{period}} {{billingMethod}}',
          paymentMethodChargedGeneric: 'your payment method on file',
          paymentMethodChargedTo: 'charged to {{chargedTo}}',
          paymentMethodBilledByInvoice: 'billed by invoice',
          featureCommunities: 'Up to {{count}} Communities',
          featureSchedulers: 'Up to {{count}} group schedulers',
          featureMembers: 'Up to {{count}} members',
          featureStorage: '{{count}} GB storage',
          paidProFeatureExtras: [
            'Real-time attendance tracking',
            'Team chat, DMs & push notifications',
          ],
        },
        statusBanner: {
          trialTitle: 'Free trial active',
          trialBody:
            'Your trial runs until {{date}}. Gumb is free until then - nothing is charged automatically afterwards.',
          stripeEndedRich:
            'This Stripe subscription has ended. There will be no further charges.',
          fullyCancelledTitle: 'Cancelled',
          fullyCancelledRich:
            'Your subscription has been cancelled. Access ended on {{date}}. Subscribe again anytime.',
          trialExpiredTitle: 'Trial expired',
          trialExpiredRich:
            'Your trial ended on {{date}}. Choose a plan to keep full access.',
          activeLabel: '{{plan}} · Active',
          nonRenewalRich:
            'Active until {{date}} - will not renew. No further charges after that date · {{price}}{{period}}',
          renewalRich:
            'Your subscription renews on {{date}} · {{price}}{{period}}',
          frequencyAnnual: 'Annual',
          frequencyMonthly: 'Monthly',
        },
        payment: {
          title: 'Payment',
          methodLabel: 'Payment method',
          invoiceMethodTitle: 'Invoice (annual)',
          sentToBilling: 'Bill to {{email}}',
          sentToBillingLabel: 'Bill to',
          cycleLabel: 'Billing cycle',
          accountManagerLabel: 'Account manager',
          lastInvoiceLabel: 'Last invoice',
          lastInvoiceUnavailable: '-',
          lastInvoiceHintInvoice: 'Official invoice PDF',
          lastInvoiceHint: 'Invoice for this payment',
          downloadInvoice: 'Download PDF',
          methodOnFile: 'Card on file',
          noPaymentYet: 'No payment needed yet',
          cardExpiresShort: 'Expires {{month}} / {{year}}',
          noActiveSubscription: 'No active subscription',
          manageBilling: 'Manage billing',
          manageBillingHint: 'Opens the secure Stripe billing portal',
          viewInvoices: 'View Invoices',
          switchToInvoice: 'Switch to invoice payments',
          switchToCard: 'Switch to card payments',
          switchToInvoiceTitle: 'Switch to invoice payments?',
          switchToInvoiceBody: 'Invoices will be sent to your billing email.',
          switchToInvoiceBodyBold: "Your card won't be charged automatically.",
          switchToInvoiceConfirm: 'Switch to invoices',
          switchToCardTitle: 'Switch to card payments?',
          switchToCardBody: 'Your saved card will be charged automatically.',
          switchToCardBodyBold:
            "Invoices won't be emailed for future payments.",
          switchToCardConfirm: 'Switch to card payments',
          switchBillingReviewSubtitle:
            'Review the change below before confirming.',
          switchBillingChangeSummaryLabel: 'What changes',
          switchBillingTimingLabel: 'When it applies',
          switchBillingStep1Label: 'Review change',
          switchBillingStep2Label: 'Add card',
          switchBillingStepIndicator:
            'Step {{current}} of {{total}} · {{label}}',
          switchBillingProcessing: 'Updating payment method…',
          switchBillingRedirecting: 'Redirecting…',
          switchBillingFromLabel: 'Current',
          switchBillingToLabel: 'New',
          switchBillingInvoiceLabel: 'Invoice',
          switchBillingCardLabel: 'Card',
          switchBillingNextCycleNote:
            "Starts with your next billing cycle.\nYour current subscription period won't change.",
          switchBillingAddCardTitle: 'Add a payment card',
          switchBillingAddCardSubtitle:
            'One last step to finish switching to card payments.',
          switchBillingAddCardPendingLabel: 'Card required',
          switchBillingAddCardPendingText:
            "A payment card is required to complete this switch.\nYour billing method won't change until you add one.",
          switchBillingAddCardNextLabel: 'What happens next',
          switchBillingAddCardNextText:
            'Continue to add your payment card on next page.',
          switchBillingAddCardSecureNote:
            'Your card details are encrypted and handled securely.',
          switchBillingAddCardGo: 'Add payment card',
          switchBillingAddCardStepDone: 'Change confirmed',
          switchBillingAddCardStepNext: 'Add your card',
          switchBillingSuccess: 'Payment method updated.',
          switchBillingErrorGeneric:
            "We couldn't update your payment method. Please try again.",
          switchBillingNoPaymentMethod:
            'Add a payment method before you can switch.',
          switchBillingNoPaymentMethodLink: '<link>Manage billing</link>',
          choosePaymentTitle: 'Choose a payment method',
          choosePaymentSubtitle: 'How would you like to continue?',
          choosePaymentInvoiceBody:
            "We'll send invoices to your billing email. Nothing is charged automatically.",
          choosePaymentCardBody:
            "Pay automatically with a card. You'll add your card on the next page.",
          choosePaymentConfirm: 'Continue',
          choosePaymentConfirmInvoice: 'Use invoice',
          choosePaymentConfirmCard: 'Add your card',
          choosePaymentRedirecting: 'Taking you to add your card…',
          choosePaymentCardOpened: 'Finish adding your card in the new tab.',
          choosePaymentErrorNoUrl:
            "We couldn't open the next page. Please try again.",
          editRecipients: 'Edit recipients',
          editRecipientsTitle: 'Invoice recipients',
          editRecipientsSubtitle:
            'All recipients receive the same invoice. Leave empty to use your account email.',
          editRecipientsSave: 'Save',
          editRecipientsSaving: 'Saving…',
          editRecipientsError:
            "We couldn't update your invoice recipients. Please try again.",
        },
        invoiceHistory: {
          title: 'Billing history',
          subtitle: 'Past invoices and receipts for your subscription.',
          colInvoice: 'Invoice',
          colIssued: 'Issue date',
          colDue: 'Due date',
          colAmount: 'Amount',
          colStatus: 'Status',
          colDownload: 'Download',
          statusOpen: 'Unpaid',
          statusPaid: 'Paid',
          statusVoid: 'Voided',
          downloadInvoice: 'Invoice',
          downloadReceipt: 'Receipt',
          invoiceFallback: 'Invoice {{id}}',
          issuedOn: 'Issued {{date}}',
          dueOn: 'Due {{date}}',
          noDueDate: '—',
          empty:
            "You don't have any invoices yet. They'll show up here after your first billing cycle.",
          loadError:
            "We couldn't load your billing history. Refresh the page or try again in a few minutes.",
          paginationLabel: 'Billing history pages',
          showingRange: 'Showing {{from}} to {{to}} out of {{total}} invoices',
          previousPage: 'Previous page',
          nextPage: 'Next page',
        },
        usage: {
          title: 'Current Usage',
          lockedHint: 'Start a trial to activate your plan limits',
          lockedHintResubscribe: 'Resubscribe to restore your plan limits.',
          lockedHintTrialExpired: 'Choose a plan to restore your plan limits.',
          members: 'Members',
          atLimitMembers: 'Limit reached',
          spotsRemaining: '{{count}} spots remaining',
          communities: 'Communities',
          atLimitCommunities: 'Limit reached',
          communitiesRemaining: '{{count}} community spots remaining',
          schedulers: 'Group schedulers',
          atLimitSchedulers: 'Limit reached',
          schedulersRemaining: '{{count}} schedulers remaining',
          storage: 'Storage',
          atLimitStorage: 'Limit reached - delete files or upgrade',
          storageRemaining: '{{count}} GB remaining',
          upgradeNudgeTitle: "You've reached your Communities / Teams limit.",
          planLimitNudgeTitle: "You've reached a plan limit.",
          upgradeNudgeBody:
            'Upgrade to Premium to add more teams, increase member capacity, and unlock automations & analytics.',
          planLimitNudgeBody:
            'Upgrade your plan to increase limits for members, communities, group schedulers, and storage. Compare plans and switch anytime.',
          upgradeCta: 'Upgrade',
        },
        actions: {
          choosePlan: 'Choose Plan',
          changePlan: 'Change plan',
          comparePlansMenu: 'Compare plans',
          cancelSubscription: 'Cancel subscription',
          dontCancelSubscription: "Don't cancel subscription",
          restartMembership: 'Restart Membership',
          subscribeAgain: 'Subscribe again',
        },
        trust: {
          poweredBy: 'Payments securely processed by',
        },
      },
    },
    terms: {
      title: 'Gumb Terms & Conditions',
    },
    errors: {
      cantSendMessageToYourself: 'You cannot send a message to yourself.',
      downloadFail: 'Download error, try again.',
      required: 'Field is required',
      email: 'Please enter a valid email address',
      invalidEmail:
        'Oops! Please enter a valid email. Check for typos and try again.',
      integer: 'Must be an integer',
      confirmPassword: "Passwords don't match. Please try again",
      NotAuthorizedException: 'Incorrect username or password.',
      invalidCode: 'That code was invalid. Please try again.',
      errorToast: 'Error: {{message}}',
      invalidRequest: 'Invalid request',
      passwordChanged: 'Password changed',
      password:
        'Password should contain at least 8 characters, letters\n in upper and lower cases and digits',
      termsError: 'Please accept terms and conditions',
      min: 'Minimum {{value}} characters',
      max: 'Maximum {{value}} characters',
      startDate: "Date can't be earlier than {{value}}",
      endDate: 'Date can not be earlier than start date',
      fileSize: 'File size is too large',
      fileSizeCustom: 'File too large: Maximum size is {{size}} MB.',
      customFileSize: 'File too large: Max {{size}}. Remove it and try again.',
      unsupportedFormat: 'Unsupported file format',
      postalCode: 'Minimum 4 digits',
      sorry: 'Sorry',
      text404: 'Looks like the page you are looking for is not available :(',
      url: 'Must be valid url',
      text500: 'Something went wrong :(',
      onlyForGroupAndAdmin: 'Feature for admins and group leaders only',
      onlyForAdmin: 'Feature for admins only',
      communityAccessDenied:
        'You no longer have access to this community or it doesn’t exist.',
    },
    eventTypes: {
      createSuccess: 'Event type created',
      editSuccess: 'Changes saved',
      deleteSuccess: 'Event type deleted',
    },
    eventTasks: {
      createSuccess: 'Task created',
      editSuccess: 'Changes saved',
      deleteSuccess: 'Task deleted',
    },
    eventResponses: {
      createSuccess: 'Response created',
      editSuccess: 'Changes saved',
      deleteSuccess: 'Response deleted',
    },
    tips: {
      registrationDeadline:
        'The deadline ends at the event’s set start time. Members can RSVP until then. After that, only admins & group leaders can make changes.',
      eventType: 'The admin can add new event types in the community settings.',
    },
    frequencies: {
      doNotRepeat: 'Does not repeat',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      yearly: 'Annually',
      everyWorkingDay: 'Every weekday (Monday to Friday)',
      other: 'Custom…',
    },
  },
  de: {
    appWidget: 'Installiere Gumb auf deinem Gerät',
    featurePopups: {
      appointmentSchedule: {
        innerHtml:
          '<h3>Neue Funktion: Terminkalender als Excel- oder CSV-Datei herunterladen! </h3><p>Jetzt kannst du eure gesamte Terminliste exportieren und wir haben die Statistik-Seite komplett überarbeitet! Der neue Bericht namens ‚Terminkalender‘ gibt dir einen Überblick über Zahlen und Fakten eurer Veranstaltungen. </p><p>Wir arbeiten bereits an einem weiteren Bericht namens ‚Mitgliederzahlen‘, der sich auf die Nutzerperformanz beziehen wird. </p><p>Der Terminkalender-Bericht steht ab sofort in der Web-App für alle Nutzer zur Verfügung.</p>',
        buttonOk: 'SPÄTER',
        buttonRedirect: 'JETZT ANSEHEN',
      },
      appleCalendar: {
        title: 'VERBINDE DEINEN APPLE (iCal) KALENDER&nbsp;🍏',
        message:
          'Wir haben es geschafft! Nach harter Arbeit ermöglicht Gumb nun die direkte Kalenderverbindung in der WEB-Version für eine nahtlose Synchronisation.\nDas iOS/Smartphone-Release folgt&nbsp;auch&nbsp;bald.',
        extraMessage: 'die Schritt-für-Schritt-Anleitung öffnen.',
        redirectText: 'Hier',
        okButton: 'Jetzt verbinden',
        cancelButton: 'Jetzt nicht',
      },
      preferecePopup: {
        title: '2 neue Funktionen',
        first: {
          title: 'Alle gleichzeitig auf Grün:',
          subtitle:
            'Lege die Standardantwort für neue oder bestehende Termine fest - für alle Teilnehmer auf einmal!',
          link: '',
        },
        second: {
          title: 'Termin-Standardwerte:',
          subtitle:
            'Definiere bei den Ereignistypen, wie neue Termine standardmässig aussehen sollen.',
          link: 'Anleitung',
        },
      },
      calendar: {
        innerhtml:
          "<h3>Wir haben es geschafft!</h3> <p> Die <b>GOOGLE KALENDER-Anbindung</b> ist da! </p> <br/> <p> Termine aus Gumb - Jede Gemeinschaft individuell wählbar, können nun automatisch in deinen Kalender übernommen werden. </p> <div class='images-container'> <img src='https://gumb-cdn-prod.s3.eu-central-1.amazonaws.com/featurePopups/calendar-1.png' alt='calendar-1' /> <img src='https://gumb-cdn-prod.s3.eu-central-1.amazonaws.com/featurePopups/calendar-2.png' alt='calendar-2' /></div> <p> Alles, was du tun musst, wird dir in dieser Anleitung erklärt: <br/><a target='_blank' rel='noopener noreferrer' href='https://gumb.app/de/support/gumb-mit-google-kalender-verbinden/'>→&nbsp; Vollständige Anleitung lesen </a> </p> <p>Kurzanleitung:</p> <ol> <li>Verbinden und wichtig: Häkchen setzen!</li> <li>Gemeinschaft auswählen</li> <li>Ein paar Minuten warten und Seite neu laden</li> </ol> <p> Verbinde deinen Google-Kalender, um Zeit zu sparen und das Beste aus jedem Tag zu machen. </p>",
        buttonOk: 'NICHTS FÜR MICH',
        buttonRedirect: 'JETZT VERBINDEN',
      },
      notifications: {
        title: 'Wie sollen die Mitglieder benachrichtigt werden?',
        firstRow:
          'Hinzugefügt haben wir: Mobile-Push-Nachrichten  & Benachrichtigungseinstellungen.',
        secondRow:
          'Die Benachrichtigungseinstellungen, die Admins verwalten, für die gesamte Community jetzt passgenau einstellen:',
        thirdRow: 'Alles, was du dafür tun musst, ist:',
        listFirstRow:
          'Gehe zu den Community-Einstellungen → Benachrichtigungen.',
        listSecondRow:
          'Aktiviere/Deaktiviere die Optionen in jeder Kategorie, → um alles für euch perfekt anzupassen. (→ Anleitung <0>hier</0> lesen)',
        lastRow:
          'Teile euren Mitgliedern mit, jetzt in ihrem eigenen Gumb-Profil die Einstellungen für Push oder E-Mail zu aktivieren.',
        buttonLater: 'Später',
        buttonSettings: 'Jetzt zu den Einstellungen gehen',
      },
      pushNotifications: {
        title: '📢 Next-Level-Kommunikation: Push-Nachrichten',
        message:
          'Admins und Gruppenleiter können jetzt Push-Nachrichten erstellen, um euch wichtige Infos direkt auf euer Smartphone zu senden.\n\nDas könnt ihr mit Push-Nachrichten:\n\n• <b>Wichtige Infos sofort teilen</b> (z.B. Terminänderungen, Notfälle)\n• <b>Einzelne Personen oder ganze Teams erreichen</b> (personalisierte Kommunikation)\n• <b>Nachrichten als Vorlagen speichern, um Zeit zu sparen</b> (effiziente Kommunikation)',
        extraMessage:
          'Bleibt immer auf dem Laufenden und verpasst keine Neuigkeiten mehr!',
        cancelButton: 'Später ansehen',
        okButton: 'Jetzt testen',
        newMessageOne:
          'Admins und Gruppenleiter können jetzt direkt mit einzelnen Personen oder ganzen Teams kommunizieren, um euch wichtige Infos direkt auf euer Smartphone zu&nbsp;senden.\n\n',
        redirectLink: 'Erstelle individuelle Push-Nachrichten',
        newMessageTwo:
          ', wähle die Empfänger aus und speichere deine Nachrichten sogar als Vorlagen für die spätere&nbsp;Verwendung.',
      },
      importEvent: {
        title: 'Termine hochladen/importieren ',
        subText:
          'Vorbei sind die Zeiten des manuellen Eintippens! Importiert eure Termine jetzt ganz einfach per CSV- oder Excel-Datei. Egal ob 30 oder 300 Termine - es geht schnell und kann bei Fehlern sogar rückgängig gemacht werden.',
        cancelButton: 'Später ansehen',
        okButton: 'Jetzt testen',
        secondText: ' findest du eine Schritt-für-Schritt-Anleitung.',
      },
      mail: {
        title: 'Neue Funktion: MAILMODUS',
        firstRow:
          'Die integrierte E-Mail Funktion vereinfacht und beschleunigt die Kommunikation im Team.  Dringend ein E-Mail an alle versenden? Aber nur an Mitglieder, die beim Termin mit "Ja" geantwortet haben? → Jetzt mit wenigen Klicks möglich!',
        secondRow:
          'Der Mailmodus steht ab sofort in der Web-App für Admins und Gruppenleiter:innen zur Verfügung. Er wird in der kommenden Zeit weiter ausgebaut.',
        thirdRow: 'Mehr dazu: <0>https://gumb.app/support/mailmodus/</0>',
        buttonLater: 'Später',
        buttonMail: 'Jetzt ansehen',
      },
      eventPdf: {
        title: 'Neue Funktion: Termin als PDF herunterladen',
        firstRow:
          'Jetzt Zeit sparen und die Termindetails per Klick ausdrucken!',
        secondRow:
          'Kurz vor anstehenden Veranstaltungen, oder auch für vergangene, können alle Termindetails inklusive aller Antwortstatistiken auf PDF exportiert werden.',
        thirdRow: 'Voraussetzung Terminplaner: Du hast Adminrechte',
        fourthRow: 'Voraussetzung Gruppenplaner: Du bist Gruppenleiter',
        fifthRow: 'Die Funktion steht ab sofort in der Web-App zur Verfügung.',
      },
    },
    menu: {
      homePage: 'STARTSEITE',
      subscriptions: 'Abos',
      groupScheduler: 'TERMINPLANER',
      documentation: 'DOKUMENTE',
      chats: 'CHAT',
    },
    status: {
      taskInactive: '= Nicht aktiviert',
      notActivated: '= Nicht aktiviert',
      awaitingReply: '= Ausstehend',
      taskInactiveDesc:
        'Diese Aufgabe ist deaktiviert - Mitglieder sehen sie nicht.',
      notActivatedDesc:
        'Diese Person ist für den Termin nicht aktiviert - sie sieht ihn nicht (weisses Feld).',
      awaitingReplyDesc:
        'Der Termin ist sichtbar, aber es wurde noch nicht geantwortet.',
      notActivatedAction:
        'Termin anklicken → Bearbeiten → Teilnehmer → Häkchen setzen → Speichern',
      taskInactiveAction:
        'Termin anklicken → Bearbeiten → Aufgaben → Häkchen setzen → Speichern',
      awaitingReplyAction: 'Zelle antippen → Antwort wählen → Speichern',
    },
    dayOfWeek: {
      day1: 'MO',
      day2: 'DI',
      day3: 'MI',
      day4: 'DO',
      day5: 'FR',
      day6: 'SA',
      day0: 'SO',
    },
    email: {
      sender: 'Absender',
      recipients: 'Empfänger',
      otherRecipients: 'Weitere Empfänger (mit Komma trennen)',
      subject: 'Betreff',
      message: 'Nachricht',
      attachCommunityDocs: 'Gemeinschaftsdokumente anhängen',
      plusTooltip: 'Neue E-Mail schreiben',
      emailSentSuccessfuly:
        'E-Mail gesendet. Beachte: Das war eine No-Reply-E-Mail, auf die der Empfänger nicht direkt antworten kann, deine Absenderadresse wird aber angezeigt.',
      emailSent: {
        title_one: '📤 E-Mail gesendet an {{count}} Empfänger',
        title_other: '📤 E-Mail gesendet an {{count}} Empfänger',
        message:
          'Wenn jemand antwortet, landet die Nachricht direkt in deinem Postfach.',
      },
      sendCopy: 'Sende eine Kopie an mich',
      maxAttachmentsSize: 'Anhänge insgesamt max. 15 MB',
      changeEmail: {
        title: 'Bestätigungs-E-Mail gesendet',
        message:
          'Wir haben dir eine E-Mail mit einem Bestätigungslink für deine neue Adresse gesendet. Bitte prüfe dein Postfach und klicke auf den Link, um die Änderung zu bestätigen. Schau auch im Spam-Ordner nach. Bei Fragen helfen wir dir gerne weiter.',
      },
    },
    pushNotification: {
      header: 'Push-Nachricht',
      filterByRecipient: 'Empfänger auswählen',
      filterByResponse: 'Empfänger nach Antwort auswählen',
      pushMessage: 'Push erstellen',
      saveAsTemplate: 'Als Vorlage speichern',
      sendCopy: 'Mir auch senden',
      pasteUrl: '🌐 Ereignis- oder externer Link?',
      plusTooltip: 'Neue Push-Nachricht erstellen',
      toasterText:
        '🆕 Neue Funktion: Jetzt kannst du einen externen Link, also eine beliebige Webseite 🌐 (URL), in Push-Nachrichten einfügen!\n Leite Empfänger direkt zur Webseite weiter.',
      templates: 'Vorlagen',
      title: 'Titel',
      lastUsed: 'Zuletzt verwendet',
      noTemplates: 'Gespeicherte Vorlagen werden hier angezeigt',
      template: 'Vorlage',
      sendConfirmHeader: 'Vor dem Senden überprüfen',
      totalRecipients: 'EMPFÄNGER',
      redirectLink: 'ZUM LINK',
      successTitle: 'Push versendet!',
      successMessage:
        'Deine Nachricht wurde an <b>{{totalRecipients}}</b> Empfänger gesendet.',
      selectEventFirst: 'Wähle zuerst ein Ereignis aus',
      templateLimitTitle: 'Vorlagen-Limit erreicht',
      templateLimitInfo:
        'Speichere bis zu 8 deiner Nachrichten als Vorlage, um sie später wiederzuverwenden. 3 Ideenvorlagen haben wir dir schon hinzugefügt - bearbeite oder lösche sie nach Belieben.',
      templateLimitMessage:
        'Du hast die maximale Anzahl an Vorlagen erreicht. Bitte lösche eine Vorlage, um eine neue zu speichern.',
      urlInfo:
        'Hier kannst du Links zu beliebigen Websites hinzufügen. Zum Beispiel zu einer Produktseite, einem Artikel oder etwas, das für euch wichtig ist. Gib einfach die komplette URL (inkl. https://) ein.',
      urlInfoOne:
        'Hier kannst du jede externe Website (URL) einfügen, damit deine Empfänger direkt dorthin gelangen. Wählst du oben ein Ereignis aus, fügt die App automatisch den Termin-Link ein und beim Klick auf die Push-Nachricht öffnet sich das Ereignis direkt in Gumb.',
      urlInfoTwo:
        'Funktion noch in Entwicklung: Füge beliebige externe Links (ausser Gumb) zu deinen Push-Nachrichten hinzu! Verlinke auf Websites, Nachrichten&nbsp;und&nbsp;mehr.',
      urlTooltip:
        'Du kannst eine Push-Nachricht mit oder ohne Verlinkung zu einem Event erstellen. Möchtest du deinen Event-Link teilen? Wähle einfach ein Event oben aus, um ihn automatisch hier zu kopieren.',
    },
    common: {
      noResultsFound: 'Keine älteren Termine verfügbar',
      logoutTooltip: 'Abmelden',
      ctrl: 'Gesamtzahlen ein-/ausblenden',
      nextDay: '+1T',
      createdAt: 'Erstellt am',
      updatedAt: 'Aktualisiert am',
      onlyAdmin: 'Nur Admins können diese Funktion nutzen.',
      download: 'Herunterladen',
      attachFile: 'Datei anhängen',
      new: 'Neu',
      unseen: 'Ungesehen',
      more: 'Mehr',
      less: 'Weniger',
      sunday: 'Sonntag',
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      january: 'Januar',
      february: 'Februar',
      march: 'März',
      april: 'April',
      may: 'Mai',
      june: 'Juni',
      july: 'Juli',
      august: 'August',
      september: 'September',
      october: 'Oktober',
      november: 'November',
      december: 'Dezember',
      overallScheduler: 'Terminplaner',
      selectEvent: 'Ereignis auswählen (optional)',
      displayEventsFrom: 'Ereignisse anzeigen aus',
      modalExit:
        'Möchtest du den Vorgang wirklich beenden, ohne deine Daten zu speichern?',
      all: 'Alle',
      tooltipEdit: 'Bearbeiten',
      tooltipDelete: 'Entfernen',
      overview: 'Übersicht',
      cancel: 'Abbrechen',
      removeLogo: 'Bist du sicher, dass du das löschen willst?',
      noTasks: 'Noch keine Aufgaben',
      noUsers: 'Noch keine Nutzer',
      noOptions: 'Keine Optionen',
      role: 'Rollen',
      admin: 'Admins',
      member: 'Mitglieder',
      group_lead: 'Gruppenleiter',
      email: 'E-Mail',
      groups: 'Gruppen',
      logoutHeader: 'Ausloggen?',
      logoutMessage: 'Du wirst zum Anmeldebildschirm zurückgeleitet.',
      deleteHeader: 'Sicher, Mitglied soll gelöscht werden?',
      logout: 'Ausloggen',
      delete: 'Löschen',
      tablePlaceholder: 'Noch keine Mitglieder zum Anzeigen',
      contentPlaceholder: 'Noch kein Inhalt zum Anzeigen',
      create: 'Erstellen',
      copy: 'Kopieren',
      visible: 'Sichtbar',
      saveChanges: 'Änderungen speichern',
      newField: 'Neues Feld',
      fieldName: 'Feld-Name',
      addField: 'Feld hinzufügen',
      notifications: 'Benachrichtigungen',
      participants: 'Teilnehmer',
      tasks: 'Aufgaben',
      documentation: 'Dokumente',
      description: 'Beschreibung',
      facebook: 'Facebook',
      twitter: 'X',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      youtube: 'YouTube',
      startDate: 'Startdatum',
      startTime: 'Startzeit',
      startDateTime: 'Startdatum/Startzeit',
      endDateTime: 'Enddatum/Endzeit',
      endDate: 'Enddatum',
      endTime: 'Endzeit',
      icon: 'Symbol',
      sendMessage: 'Nachricht senden',
      aboutMe: 'Über mich',
      selectAll: 'Alle auswählen',
      approve: 'Genehmigen',
      reject: 'Ablehnen',
      backToGumb: 'Zurück zu Gumb',
      edit: 'Bearbeiten',
      addComment: 'Kommentar hinzufügen',
      answer: 'Speichern',
      ok: 'Ok',
      withoutGroup: 'Ohne Gruppe',
      copyLink: 'Link kopieren',
      copied: 'Kopiert',
      sendInviteLink: 'Einladungslink senden',
      apply: 'Anwenden',
      from: 'Von',
      to: 'Bis',
      enable: 'Aktiviert',
      search: 'Suchen',
      color: 'Farbe',
      columns: 'Eingeblendete Spalten',
      hiddenColumns: 'Ausgeblendete Spalten',
      sorryNoResults:
        'Es tut uns leid, dass wir nicht finden konnten, was du suchst. Bitte probiere eine andere Methode.',
      tutorial: 'Anleitung',
      next: 'Weiter',
      back: 'Zurück',
      step: 'Schritt',
      createSuccess: {
        title: 'Erstellt',
        message: 'Deine Option wurde erfolgreich erstellt.',
      },
      editSuccess: {
        title: 'Aktualisiert',
        message: 'Deine Änderungen wurden gespeichert.',
      },
      deleteSuccess: {
        title: 'Gelöscht',
        message: 'Die Option wurde erfolgreich entfernt.',
      },
      toolTipText: {
        grid3x3: 'Matrix: Mitglieder zu Communities zuordnen',
        faq: 'Hilfe: Anleitungen, Kontakt, mehr.',
        communityPlusIcon: 'Neue Gemeinschaft erstellen',
        logoGumb:
          'Geheimnis in Planung: Entdeckt später, was dieser Button verbirgt!',
        memberPlusIcon: 'Neues Mitglied hinzufügen',
        memberArrowIcon: 'Zur Mitgliederübersicht',
        eventType: 'Ereignistyp erstellen',
        responses: 'Antwortoption erstellen',
        task: 'Aufgabe erstellen',
        schedulerPlusIcon: 'Ereignis oder Gruppe erstellen',
      },
      shareEventTitle: 'Ereignis-Link teilen über:',
      copyEventLink: 'Oder Link kopieren:',
    },
    auth: {
      signInWith: 'Anmelden mit',
      continueAs: 'Weiter als',
      create: 'Kostenloses Konto erstellen',
      signUp: 'Registrieren',
      signIn: 'Einloggen',
      welcome: 'Willkommen!',
      createAccount: 'Kostenloses Konto erstellen',
      forgotPassword: 'Passwort vergessen?',
      resetPassword: 'Passwort zurücksetzen',
      resetPasswordTooltip:
        'Wenn du das Passwort zurücksetzt, bekommt das Mitglied eine E-Mail mit Anweisungen für ein neues Passwort. Für Konten, die über Facebook, Google oder Apple erstellt wurden, kann Gumb das Passwort nicht zurücksetzen. Das Mitglied kann sich aber weiterhin über das entsprechende Social-Media-Icon einloggen.',
      resetPasswordModalTitle: 'Passwort-Zurücksetzung gestartet',
      resetPasswordModalText:
        'Das Mitglied bekommt jetzt eine E-Mail zum Zurücksetzen des Passworts. Für Facebook, Google oder Apple kann es sich einfach wie gewohnt mit dem Icon einloggen.',
      resetPasswordErrorModalTitle: 'Passwort-Rücksetzung nicht möglich',
      resetPasswordErrorModalText:
        'Hinweis: Dieses Mitglied nutzt Facebook, Google oder Apple zum Einloggen. Gumb kann das Passwort nicht zurücksetzen. Falls das Mitglied das Passwort vergessen hat, muss es dies direkt beim Anbieter zurücksetzen. Das Einloggen per Social-Icon funktioniert weiterhin. Bitte informiere das Mitglied.',
      terms: {
        '0': 'Ich bin einverstanden mit: ',
        '1': 'Bedingungen',
        '2': ' und  ',
        '3': 'Datenschutzerklärung',
      },
      termsAcknowledgement:
        'By continuing, you acknowledge that you understand and agree to the <0>Terms & Conditions</0> and <1>Privacy Policy</1>.',
      home: 'Startseite',
      confirmed: 'E-Mail erfolgreich bestätigt',
      verifying: 'E-Mail bestätigen...',
      recovery: 'Passwort-Wiederherstellung',
      send: 'Senden',
      codeSended:
        'Bestätigungslink wurde an deine E-Mail gesendet. Bitte prüfen und bestätigen. Schau auch im Spam-Ordner nach.',
      signUpSuccess:
        'Registrierung erfolgreich. Bitte prüfe jetzt dein E-Mail-Postfach, um die Registrierung zu bestätigen.',
      inviteSentTitle: 'Einladung erfolgreich versandt',
      inviteSentText:
        'Top! Du hast das Mitglied erfolgreich erfasst und die Einladung mit temporärem Passwort wurde versendet (Spamordner ggf. prüfen). Das Mitglied kann sich jetzt einloggen und das Passwort anpassen. Lade die Seite neu, um die Mitgliederliste zu aktualisieren. Du und deine Admins könnt jetzt Gruppe, Rolle oder das Mitgliedprofil bearbeiten.',
      reset: 'Zurücksetzen',
      yourEmail: '{{value}} ist bereits deine E-Mail-Adresse',
      existEmail: '{{value}} ist bereits vorhanden',
      labels: {
        email: 'E-Mail',
        currentEmail: 'Aktuelle E-Mail',
        newEmail: 'Neue E-Mail',
        password: 'Passwort',
        oldPassword: 'Altes Passwort',
        newPassword: 'Neues Passwort',
        confirmPassword: 'Passwort bestätigen',
      },
      accountExists:
        'Diese E-Mail-Adresse wird bereits für ein Gumb-Konto verwendet. Wenn diese E-Mail dir gehört, klicke auf Passwort vergessen und prüfe deinen Posteingang und Spamordner.',
      codeExpired:
        'Dieser Link ist abgelaufen. Gib hier deine E-Mail ein, dann senden wir dir einen neuen Link zur Kontoverifizierung.',
      userNotConfirmed:
        'Du musst dein Konto noch verifizieren. Dazu haben wir dir eine E-Mail mit einem Bestätigungslink geschickt. Wenn du keine E-Mail bekommen hast, schaue bitte auch in deinem Spam-Ordner nach.',
      invalidCredentials: 'Falscher Benutzername oder falsches Passwort',
      userNotFound:
        'Diese E-Mail ist entweder noch nicht registriert oder mit Google, Apple oder Facebook verknüpft. Ändere das Social-Media-Passwort nicht in Gumb, sondern logge dich einfach mit dem passenden Social-Media-Icon ein.',
      socialLoginDetected: {
        title: 'Social Login erkannt',
        message:
          'Diese E-Mail scheint mit Google, Apple oder Facebook verknüpft zu sein. Das Passwort wird dort verwaltet, nicht bei Gumb. Zum Einloggen kannst du aber einfach aufs entsprechende Social-Media-Symbol klicken.',
      },
    },
    profile: {
      editSuccess: 'Änderungen gespeichert',
      settings: 'Einstellungen',
      editProfile: 'Profil bearbeiten',
      selectImage: 'Bild auswählen',
      myProfile: 'Mein Profil',
      profileEditBtn: 'GIB DEINE INFOS EIN: ADRESSE, SOCIALS & MEHR',
      basicInformation: 'Grundinfos',
      contactInformation: 'Kontaktdaten',
      addressInformation: 'Adressdaten',
      myCommunities: 'Meine Gemeinschaften',
      myChat: 'MEINE CHATS',
      freeText1: 'Freitext 1',
      freeText2: 'Freitext 2',
      myAppointments: 'Meine Termine',
      subscription: 'Abo',
      userProfile: 'Benutzerprofil',
      tellUsAboutYourself: 'Über mich',
      firstName: 'Vorname',
      lastName: 'Nachname',
      profileName: 'Benutzername',
      person: 'Person',
      role: 'Rolle',
      email: 'E-Mail',
      dateOfBirth: 'Geburtsdatum',
      privatePhoneNumber: 'Tel (Privat)',
      officePhoneNumber: 'Tel (Arbeit)',
      mobilePhoneNumber: 'Tel (Mobil)',
      street: 'Strasse',
      region: 'Region',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      country: 'Land',
      about: 'Über mich',
      linkChangeEmail: '(E-Mail ändern)',
    },
    profileCommunities: {
      empty: {
        title: 'Noch keine Communities sichtbar',
        description:
          'Sobald du eigene Communities erstellst oder Mitglied wirst,<brPure />erscheinen sie hier.',
      },
      popupLeave: {
        title: 'Sicher, Gemeinschaft wirklich verlassen?',
        button: 'Verlassen',
      },
      leaveCommunity: {
        title: 'Sicher, Gemeinschaft wirklich verlassen?',
        message:
          'Du verlässt nur diese Community. Dein Konto bleibt, du kannst anderen jederzeit beitreten.',
        okButton: 'Ja, Verlassen',
        cancelButton: 'Abbrechen',
      },
    },
    profileSettings: {
      title: 'Profil Einstellungen',
      notification: 'Benachrichtigungen',
      notificationsPlaceholder: 'Du hast noch keine Benachrichtigungen',
      changePassword: 'Passwort ändern',
      changeEmail: 'E-Mail',
      saveNewEmail: 'Neue E-Mail speichern',
      language: 'Sprache',
      timeFormat: 'Zeitformat',
      permissions: 'Berechtigungen',
      allowedToEdit: 'Admins dürfen mein Profil bearbeiten',
      other: 'Andere',
      pushNotification: 'Push-Benachrichtigungen',
      receiveByEmail: 'Benachrichtigungen per E-Mail erhalten',
      receivePush: 'Mobile Push-Benachrichtigungen empfangen',
      receiveInApp: 'In-App-Benachrichtigungen empfangen',
      terms: 'Allgemeine Geschäftsbedingungen (AGB)',
      protectionRegulation: 'Datenschutzerklärung',
      deleteAccount: 'Konto löschen',
      logout: 'Ausloggen',
      deleteProfileHeader: 'Sicher, dein Konto löschen?',
      notifications: {
        now: 'Jetzt',
        hours: 'Vor {{value}} std',
        minutes: 'Vor {{value}} min',
        minute: 'Vor 1 Minute',
      },
    },
    calendarConnection: {
      googleCalendar: 'Google Kalender',
      outlookCalendar: 'Outlook Kalender',
      pageTitle: 'Kalenderverbindung',
      connectTitle:
        'Kalender verbinden\nund Termine automatisch synchronisieren',
      connectDescription:
        'Gumb erstellt Termine für dich - sie erscheinen automatisch in deinem Kalender.',
      appleCalendar: 'Apple Kalender',
      appleConnectionSteps: {
        headerOne:
          'Integriere Gumb-Ereignisse in deinen Kalender (Apple oder Outlook) mit einer URL (iCal) - in 4 Schritten.',
        demoLinks: 'Schnelle Demo',
        demoLinksApple: 'Apple',
        demoLinksAppleHere: 'hier',
        demoLinksDetailed: 'Detaillierte Anleitung',
        demoLinksDetailedApple: 'Apple',
        demoLinksDetailedHere: 'hier',
        demoLinksOutlook: 'Outlook',
        demoLinksOutlookHere: 'hier',
        stepOne: 'In deinem Kalender-Programm öffnen',
        stepOneSubscribeBold: 'Kalender abonnieren',
        stepOneApplePrefix: 'Apple',
        stepOneAppleSuffix: 'Ablage → Neues Kalenderabonnement',
        stepOneOutlookPrefix: 'Outlook',
        stepOneOutlookSuffix:
          'Kalender hinzufügen → Aus dem Internet / Abonnierter Kalender',
        stepTwo: 'iCal-Link deiner Community unten kopieren und einfügen',
        stepThree: 'Namen vergeben und optional Farbe wählen',
        stepFour:
          'Speicherort (iCloud, Mac, Outlook) & Aktualisierung anpassen, bestätigen',
      },
      appleConnectionPopup: {
        title: 'Wie verbinden?',
        stepOne: 'Den Community-Link kopieren',
        stepTwo:
          'Im Apple-Kalender unter „Kalender“ auf „Ablage“ > „Neues Kalenderabonnement“ gehen.',
        stepThree:
          'Den kopierten iCal-Link der Community eingeben und auf „Abonnieren“ klicken.',
        stepFour:
          'Kalender benennen, Farbe wählen, Einstellungen wie Speicherort (iCloud oder Mac) oder Automatik-Aktualisierung festlegen und „OK“ drücken.',
      },
      appleDisconnectPopup: {
        title: 'Trennung Bestätigen',
        message:
          'Wenn du auf „Ja, jetzt trennen“ klickst, werden alle Gumb-Events aus deinem/n Kalender/n entfernt. Bitte lösche den/die Kalender anschliessend manuell, da er/sie sonst sichtbar bleibt/bleiben.\n\n<b>Um dich vollständig abzumelden:</b>\n\n• <b>Auf macOS</b>: Kalender öffnen, mit Rechtsklick auf den Kalender > „Abo kündigen“.\n• <b>Auf iOS</b>: Gehe zu „Kalender“, tippe auf das „Info“-Symbol neben dem Kalender > „Kalender löschen“.',
        okButton: 'Ja, jetzt trennen',
      },
      appleUncheckBoxPopup: {
        title: 'Trennung Bestätigen',
        message:
          'Wenn du auf „Ja, jetzt trennen“ klickst, werden alle Gumb-Events aus deinem Kalender entfernt. Bitte lösche den Kalender anschliessend manuell, da er sonst sichtbar bleibt.\n\n<b>Um dich vollständig abzumelden:</b>\n\n• <b>Auf macOS</b>: Kalender öffnen, mit Rechtsklick auf den Kalender > „Abo kündigen“.\n• <b>Auf iOS</b>: Gehe zu „Kalender“, tippe auf das „Info“-Symbol neben dem Kalender > „Kalender löschen“.',
        okButton: 'Ja, jetzt trennen',
      },
      connectWithApple: 'Apple & Outlook (iCal) verbinden',
      cantSeeICal:
        'Siehst du den iCal-Link nicht? Markiere einfach das Kästchen.',
      syncTip:
        'Nur die Termine der ausgewählten Gemeinschaft werden mit deinem Kalender synchronisiert.',
      connect: 'Verbinden',
      connected: 'Verbunden',
      disconnect: 'Trennen',
      disconnectSuccess: 'Verbindung erfolgreich getrennt',
      selectCommunities: 'Auswahl der Gemeinschaften',
      selectCommunitiesDescription:
        'Nur die Termine der ausgewählten Gemeinschaft werden mit deinem Kalender synchronisiert.',
      authSuccessTitle: 'Erfolgreich autorisiert',
      authSuccessMessage:
        'Eure Termine werden jetzt automatisch synchronisiert. Kurz warten, dann Google Kalender-Seite neu laden.',
      authSuccessTitleTwo: 'Wähle jetzt deine Community',
      authSuccessMessageTwo:
        'Tippe auf das Häkchen und dann auf "Änderungen speichern" zum Bestätigen.',
      syncSuccess:
        'Aktualisiert!\nAlles wird jetzt automatisch synchronisiert. Du kannst die Auswahl der Gemeinschaften jederzeit ändern.',
      syncSuccessTitle: 'Gleich fertig!',
      syncSuccessMessage:
        'Wir verbinden deine Community mit deinem Google Kalender. Das dauert nur 2-3 Minuten. Aktualisiere deine Google Kalender-Seite, um die Updates zu sehen.',
      disconnectConfirmTitle: 'Bist du sicher?',
      disconnectConfirmDescription:
        'Alle Termine werden aus deinem Kalender entfernt, wenn du die Verbindung trennst.',
      disconnectConfirm: {
        title: 'Jetzt trennen?',
        message:
          'Durch die Trennung werden alle Termine aus deinem Google Kalender gelöscht. Keine Sorge, du kannst jedoch Gumb für eine neue Synchronisierung später jederzeit erneut verbinden.',
        cancelButton: 'Abbrechen',
        okButton: 'Ja, Trennen',
      },
      noCommunities:
        'Es gibt keine Gemeinschaften zum Auswählen.\nWarte, bis ein Administrator dich hinzufügt.',
      checkboxWarning: 'ACHTUNG: Das Häkchen muss gesetzt sein!',
    },
    community: {
      noMembersEmptyState: {
        title: 'Noch keine Mitglieder eingetragen',
        description: 'Sobald sich Mitglieder eintragen, erscheinen sie hier.',
      },
      plusIconSubText: 'Plane ein Ereignis oder erstelle Terminserien.',
      selectAllCommunityAdmins: 'Alle Admins',
      selectAllGroupAdmins: 'Alle Gruppenleiter:innen',
      createSuccess: 'Gemeinschaft wurde erfolgreich erstellt',
      createFailure:
        'Bitte versuche in einem Moment erneut, deine Gemeinschaft zu erstellen.',
      deleteSuccess: 'Gemeinschaft wurde erfolgreich gelöscht',
      leaveSuccess: 'Du hast die Gemeinschaft erfolgreich verlassen',
      descriptionTitle: 'Über die Gemeinschaft',
      descriptionPlaceholder: 'Hier kannst du deine Gemeinschaft beschreiben',
      online: 'Online',
      updateCommunity: 'Community aktualisieren',
      members: 'Mitglieder',
      createCommunity: 'Gemeinschaft erstellen',
      communityName: 'Name der Gemeinschaft',
      category: 'Kategorie',
      aboutCommunity: 'Über die Gemeinschaft',
      selectLogo: 'Logo auswählen',
      selectLogoTip: 'jpg, jpeg, png (5MB)',
      chooseCover: 'Cover auswählen',
      chooseCoverTip: 'jpg, jpeg, png (20MB)',
      website: 'Webseite',
      partnership: 'Partnerschaft',
      deleteCommunity: 'Gemeinschaft löschen',
      deleteHeader:
        'Sicher, dass du diesen Benutzer aus der Gruppe entfernen möchtest?',
      addMembers: 'Mitglieder hinzufügen',
      invitationLink: 'Einladungslink',
      communityRole: 'Rolle',
      joinCommunity: 'Gemeinschaft beitreten',
      namePlaceholder: "{{value}}'s team",
      requestSent: 'Beitrittsanfrage erfolgreich gesendet',
      requestSentButton: 'Beitrittsanfrage gesendet',
      limitExceededHeader:
        'Dein Abo-Limit für Communities ist erreicht. Möchtest du mehr erstellen, ist ein Upgrade im Profil > Abo nötig.',
      limitExceededMessage:
        'Bitte wende dich an den Besitzer eurer Gemeinschaft. Nur er/sie verwaltet das Abo und kann es aktualisieren.',
      limitExceededMessageOwner:
        'Bitte gehe in deinem Profil zu Abo, um euer Abo zu verwalten und bei Bedarf ein Upgrade durchzuführen.',
      updateFailure: 'Fehler beim Aktualisieren',
      buttonAddEvent: 'Ereignis hinzufügen',
      userBlockedTitle: 'Blockiert',
      userBlockedText:
        'Es scheint, als hätte dich jemand in dieser Community blockiert. Admins können Mitglieder sperren oder entsperren.',
      createOverLimitTitle: 'Maximale Anzahl an Gemeinschaften erreicht',
      createOverLimitText:
        "Starte jetzt eure kostenlose Testphase oder wähle unter 'Abo ändern' ein Abo, um deine eigene Gemeinschaft zu organisieren.",
      notInvitedTitle: 'Keine Berechtigung',
      notInvitedText:
        'Es scheint, dass du keinen Zugriff auf diesen Termin hast. Admins oder Gruppenleiter können dich hinzufügen.',
      noRequestsTitle: 'Noch keine Anfragen zur Überprüfung.',
      noRequestsText:
        'Wenn Personen Anfragen für eure Gemeinschaft einreichen, werden sie dir hier zur Überprüfung angezeigt.',
      invitationCodeExpired:
        'Das ist ein abgelaufener Einladungslink. Du kannst aber jetzt eine Beitrittsanfrage senden, die Admins annehmen oder ablehnen können.',
      communityNotFound: 'Gemeinschaft nicht gefunden',
      communityPopup: {
        title: 'Ereignis oder Gruppe erstellen',
        subTitleOne:
          'Plane Ereignisse im zentralen TERMINPLANER. Nutze Gruppen, um Mitglieder in Teams aufzuteilen.',
        chatTitle: 'Chat-Optionen',
        chatSubTitle:
          'Starte einen 1:1-Chat oder erstelle einen Chatraum für Gruppen.',
        oneToOne: {
          infoText:
            'Klicke auf das Chat-Symbol neben dem Namen eines Mitglieds oder auf sein Profilbild, um eine Nachricht zu senden.',
          btntitle: 'Zur Mitgliederübersicht',
          linkText: 'Tutorial',
        },
        createChatGroup: {
          infoText:
            'Erstelle einen privaten Chatraum für ausgewählte Mitglieder, Teams oder Gruppen. Nur Admins können diese Räume einrichten.',
          btntitle: 'Chatraum erstellen',
          inkText: 'hier',
        },
        createEvent: {
          infoText:
            "Plane Ereignisse für alle oder spezifische Gruppen/Mitglieder im TERMINPLANER. Sichtbar im Terminplaner, unter 'Meine Termine' und in Gruppen.",
          btntitle: 'Ereignis erstellen',
          linkText: 'Tutorial',
        },
        createGroup: {
          infoText:
            'Gruppen haben ihre eigenen Planer, mit Ereignissen, die nur für Gruppenmitglieder sichtbar sind. Verwalte Mitgliederrollen effektiv',
          btntitle: 'Gruppe erstellen',
          linkText: 'hier',
        },
      },
      exportStatistics: 'Export von Statistiken',
      exportStatisticsTooltip:
        'Exportieren Sie die Statistiken in eine CSV-Datei',
    },
    communitySettings: {
      noSearchResults: {
        title: 'Keine Treffer gefunden',
        description:
          'Zu {{searchResult}} gibt es keine Ergebnisse. Versuch es mit einem anderen Suchbegriff.',
      },
      clearSearch: 'Suche zurücksetzen',
      noMatrixData: {
        title: 'Noch keine Communities sichtbar',
        description:
          'Sobald ein Besitzer Communities erstellt und dich zum Admin macht, kannst du hier Mitglieder zuordnen.',
      },
      matrixDescription:
        'Per Klick Mitglieder euren Communities zuordnen/entfernen - speichert sofort.<brPure />Ideal für Saison- & Teamwechsel sowie Mehrfachzuordnungen.',
      matrix: 'Matrix',
      tooltip:
        'Zur Matrixansicht: Mitglieder zu Communities zuordnen/entfernen.',
      admin: 'Admin',
      member: 'Mitglied',
      blocked: 'Geblockter Nutzer',
      owner: 'Besitzer:in',
      group_lead: 'Gruppenleiter:in',
      group_admin: 'Gruppenadministrator:in',
      chat_admin: 'Chat-Admin',
      community_admin: 'Community-Administrator:in',
      editRoleSuccess: 'Rolle wurde erfolgreich geändert',
      deleteUserSuccess: 'Benutzer:in wurde erfolgreich aus Community gelöscht',
      removeUser: {
        title: 'Bist du sicher, diesen Benutzer zu entfernen?',
        message:
          'Wenn du diesen Benutzer entfernst, wird er aus deiner Community entfernt, behält jedoch sein Benutzerkonto und kann weiterhin in anderen Communities aktiv sein.',
        cancelButton: 'Abbrechen',
        okButton: 'Ja, entfernen',
      },
      removeUserSuccess: {
        title: 'Benutzer entfernt',
        message:
          'Der Benutzer wurde erfolgreich aus deiner Community entfernt.',
      },
      editSuccess: 'Änderungen wurden erfolgreich aktualisiert',
      title: 'Gemeinschafts-Einstellungen',
      backToSubscriptionsDetails: 'Zurück zu den Abonnementdetails',
      tabs: {
        general: 'Voreinstellungen',
        eventTypes: 'Ereignistypen',
        subscriptions: 'Abonnements',
        responses: 'Antwortmöglichkeiten',
        roles: 'Mitglieder',
        requests: 'Anfragen',
        other: 'Sonstige',
        tasks: 'Aufgaben',
      },
      addMember: 'Benutzer:in hinzufügen',
      exportMembers: 'Export',
      exportMembersTooltip: 'Mitgliederliste exportieren in eine CSV-Datei',
      deleteCommunityHeader: 'Wirklich löschen?',
      deleteCommunityMessage:
        'Alle eure Daten werden unwiderruflich gelöscht. Keine Wiederherstellung möglich.',
      defaultEventList: [
        '🤝🏻🏻 Treffen 🤝🏻🏻',
        '📅 Veranstaltung 📅',
        '📋 Besprechung 📋',
        '📝 Vorstandssitzung 📝',
        '🚌 Ausflug 🚌',
        '🛠️ Workshop 🛠️',
        '⏰ Einsatz / Schicht ⏰',
        '🏢 Firmenevent 🏢',
        '🏃 Training 🏃',
        '🏆 Turnier 🏆',
        '🎶 Probe 🎶',
        '🔴 ABGESAGT 🔴',
        'ℹ️ Info ℹ️',
        '📊 UMFRAGE 📊',
      ],
      defaultResponsesTypes: [
        'Ich bin dabei ✅',
        'Ich kann nicht kommen ❌',
        'Noch nicht sicher 🟨',
      ],
      defaultTasks: ['Wer fährt?', 'Wer bringt die Getränke?'],
      selectUsers: {
        title: 'Nutzer auswählen',
        message:
          'Bitte markiere die Nutzer mit einem Häkchen, um Beitrittsanfragen zu genehmigen oder abzulehnen.',
      },
      memberExists: 'Mitglied existiert bereits',
      mailSent:
        'Einladung verschickt! Sie ist 24 Stunden gültig. Das neue Mitglied klickt auf „Jetzt beitreten“ und loggt sich mit dem temporären Passwort ein - schon ist es Teil deiner Community. Admins können die Einladung jederzeit neu senden.',
      userNotFound:
        'Kein Profil gefunden. Trag Vor- und Nachname ein, um ein neues Profil zu erstellen und die Einladung zu verschicken.',
      disableAddMemberTooltip:
        'Mitgliederlimit erreicht. Bitte Community-Besitzer um ein Abo-Upgrade, um mehr Mitglieder hinzuzufügen.',
      notifyByFields:
        'Benachrichtigung versenden, wenn diese Felder geändert werden',
      notifyByReplies: 'Benachrichtige, wenn Eingeladene so antworten',
      remindBefore: 'Vorher erinnern',
      addReminder: '+ Erinnerung hinzufügen (max. 2)',
      notificationsTypes: [
        'Neuer Termin',
        'Termin wurde aktualisiert',
        'Termin wurde gelöscht',
        'Terminerinnerung',
      ],
      notificationsClasses: ['In-App', 'E-mail', 'Push'],
      notificationPopupHeader: 'Benachrichtigungen an Eingeladene senden?',
      notificationPopupMessageLabel: 'Optionale Nachricht hinzufügen',
      notificationPopupNotify: 'Senden',
      notificationPopupDoNotNotify: 'Nicht senden',
      notificationPopupBack: 'Zurück zum Bearbeiten',
      ownerTooltip:
        '👑 Besitzer\n\nDer Besitzer hat diese Gemeinschaft erstellt.\n\nEs gibt immer nur einen - mit den höchsten Rechten: Er verwaltet das Abo und kann die Gemeinschaft löschen.\n\nEin Wechsel ist möglich - kontaktiere dazu bitte den Support.',
      emailTooltip:
        '📧 E-Mail\n\nDas ist die Login-E-Mail des Nutzers.\nNur er selbst kann sie ändern.\n\nTipp: Du kennst die E-Mail eines neuen Mitglieds? → Benutzer hinzufügen',
      roleTooltip:
        '🛠️ Rolle\n\nAdmin:\nHat alle Rechte auf Gemeinschaftsebene - sieht & verwaltet alles.\n➜ Klicke auf das Feld, um ein Mitglied zum Admin zu machen\n\nGruppenleiter:\nVerwaltet Termine & Antworten in einer Gruppe.\n➜ Gruppe öffnen → Mitglieder → hochziehen',
      groupsTooltip:
        '👥 Gruppen\n\nZeigt, in welchen Gruppen das Mitglied ist.\n➜ Klicke auf das Feld, um Gruppen zuzuweisen.\n\nNeue Mitglieder sehen alle Termine im Terminplaner.\nGruppentermine werden erst sichtbar, wenn sie einer Gruppe zugeteilt sind.',
    },
    communityInvitation: {
      subjectFirst: 'Sie wurden in die Community',
      subjectSecond: 'eingeladen',
      body: 'Bitte folgen Sie dem Link unten, um der Community beizutreten',
      invitationSuccess:
        'Genehmigt! Das Mitglied ist jetzt in eurer Liste. Rolle und Gruppe findest du unter Community-Einstellungen → Mitglieder.',
      invitationFailure: 'Fehler - wahrscheinlich ist euer Abo-Limit erreicht.',
      membersInvitation: {
        title: 'Mitglieder einladen',
        description:
          'Du hast mehrere Möglichkeiten, neue Mitglieder hinzuzufügen. Mehr Infos: <0>"Neuen Benutzer hinzufügen"</0>.',
        showMore: 'Mehr anzeigen',
        showLess: 'Weniger anzeigen',
        codeInvitation: {
          title: 'Der schnellste und einfachste Weg',
          button: 'Einladungslink kopieren',
          updateLink: 'Link erneuern',
          generateLink: 'Jetzt Link generieren',
          howItWorks: 'So funktioniert’s',
          goodToKnow: 'Gut zu wissen',
          howItWorksText:
            'Mitglieder klicken auf "Kostenloses Konto erstellen" mit dem oben ausgewählten Link. Wenn Gumb eine E-Mail sendet, müssen die Mitglieder nur ihre E-Mail-Adresse bestätigen, um direkten Zugang zu erhalten.',
          goodToKnowText:
            'Das geht superschnell, aber beachte bitte, dass Personen mit diesem Link sofort auf eure Termine zugreifen können, sobald die Kontoverifizierung abgeschlossen ist. Deshalb kannst du den oben genannten Link jederzeit erneuern.',
        },
        linkInvitation: {
          title: 'Per Link:',
          button: 'Gemeinschafts-Link kopieren',
          howItWorks: 'So geht’s:',
          adminFlow: 'Admins prüfen Anfragen:',
          howItWorksText:
            '<0>Link kopieren und teilen.</0><0>Mitglieder mit Gumb-Konto klicken auf „Beitreten“.</0><0>Wer noch kein Konto hat, registriert sich kurz, klickt dann erneut auf den Link und schickt euch die Anfrage.</0>',
          adminFlowText:
            'Alle neuen Anfragen siehst du im Tab „Anfragen“. Admins können sie dort annehmen oder ablehnen. Offene Anfragen erkennst du am Zahnrad-Symbol.',
        },
        addMember: {
          title: 'Per E-Mail-Adresse einladen oder vorregistrieren',
          button: 'BENUTZER HINZUFÜGEN',
          selfSignUp: 'Mitglied registriert sich selbst:',
          preRegister: 'Person vorerfassen:',
          selfSignUpText:
            'Alle können sich kostenlos bei Gumb anmelden und dir ihre E-Mail-Adresse schicken. Wenn du die Adresse hier einträgst, wird das Mitglied automatisch hinzugefügt und sieht alle Termine.',
          preRegisterText:
            'Lege ein neues Mitglied direkt mit seiner E-Mail-Adresse an. Das Konto wird sofort erstellt, das Mitglied erhält eine Einladung mit temporärem Passwort und kann sich direkt einloggen. Das Passwort kann später geändert werden.',
        },
      },
    },
    group: {
      deleteEventSuccess: 'Ereignis wurde erfolgreich gelöscht',
      createSuccess: 'Gruppe wurde erfolgreich erstellt',
      deleteSuccess: 'Gruppe wurde erfolgreich gelöscht',
      addMembersSuccess:
        'Mitglied erfolgreich hinzugefügt. Prüfe deine Mitgliederliste.',
      addMembersSuccessWithMessage: {
        title: 'Mitglied hinzugefügt!',
        message:
          'Eure Mitgliederliste wurde erfolgreich aktualisiert. Verwalte jetzt Rolle und Gruppenzuweisung. Du kannst auch die Personalien des Nutzers ergänzen oder ändern.',
      },
      deleteUserSuccess: 'Der Nutzer wurde erfolgreich aus Gruppe entfernt',
      addParticipants: 'Mitglieder hinzufügen',
      createGroup: 'Gruppe erstellen',
      deleteGroup: 'Gruppe löschen',
      groupName: 'Gruppename',
      changeGroupNameSuccess: 'Gruppenname erfolgreich geändert.',
      groups: 'Gruppen',
      inviteMembers: 'Mitglieder einladen',
      tabs: {
        schedule: 'Terminplan',
        members: 'Mitglieder',
        chat: 'Unterhaltung',
        documentation: 'Dokumente',
        statistic: 'Export & Statistiken',
        import: 'Import',
      },
      limitExceededHeader:
        'Dein Abo-Limit für Communities ist erreicht. Möchtest du mehr erstellen, ist ein Upgrade im Profil > Abo nötig.',
      limitExceededMessage:
        'Bitte wende dich an den Besitzer eurer Gemeinschaft. Nur er/sie verwaltet das Abo und kann es aktualisieren.',
      limitExceededMessageOwner:
        'Bitte gehe in deinem Profil zu Abo, um euer Abo zu verwalten und bei Bedarf ein Upgrade durchzuführen.',
      groupRole: 'Gruppen Rolle',
      addGroup: 'Gruppe hinzufügen',
    },
    chat: {
      read: {
        now: '{{name}} gelesen gerade eben',
        hours: '{{name}} gelesen vor {{value}}h',
        minutes: '{{name}} gelesen vor {{value}} Min.',
        minute: '{{name}} gelesen vor 1 Min.',
        day: '{{name}} gelesen am {{value}}',
        dateTime: '{{name}} gelesen am {{value}} um {{time}}',
      },
      noRead: 'Noch nicht gelesen',
      noActiveCommunity: 'Du hast noch keine aktive Community.',
      lastAdmin:
        'Ein Chatraum braucht mindestens einen Admin oder Gruppenleiter. Stelle sicher, dass immer mindestens eine Person diese Rolle hat.',
      update: {
        successUpdate: 'Chatraum erfolgreich aktualisiert',
        success: 'Mitgliederliste wurde aktualisiert',
        btn: 'SPEICHERN',
      },
      modal: {
        btn: 'Verwalten',
        about: 'Info',
        editRoom: 'Chatraum bearbeiten',
        delete: 'Chatraum löschen',
        editMember: 'Mitglieder bearbeiten',
        onlyChatAdmin: 'Nur Chatraum-Admins können das tun.',
      },
      details: {
        title: 'Chatraum Details',
        secondTitle: 'INFORMATIONEN',
        name: 'Chatraumname',
      },
      delete: {
        success: 'Chatraum wurde gelöscht',
      },
      create: {
        title: 'Chatraum erstellen',
        name: 'Chatraumname',
        description: 'Gruppenbeschreibung (optional)',
        success: 'Chatraum wurde erstellt',
        btnNext: 'WEITER',
      },
      new: 'Neuer',
      chat: 'Chat',
      popover: {
        title: 'Unbekannter Nutzer',
        message: 'Nicht mehr in dieser Community oder Gruppe',
      },
      inputPlaceHolder: 'Nachricht eingeben',
      op1: 'Dateien & Videos',
      op2: 'Fotos',
      files: 'Dateien',
      searchHover: 'Suchen oder neuen Chat beginnen',
      plusTooltip: 'Neuen Chat oder Gruppenchat erstellen',
      emptyStatus: {
        noChatSelected: {
          firstLine: 'Wähle eine Unterhaltung aus, um den Chat anzuzeigen,',
          secondLine: 'oder starte hier einen',
          LinkText: 'NEUEN CHAT',
        },
        noChatUser: 'Noch keine Chats?',
        noChatSubText:
          'Starte einen 1:1-Chat oder warte, bis dein Admin dich hinzufügt.',
        noUnseenUser: "Don't have any unseen chat",
        sendFirstMessage: 'Schreib deine erste Nachricht an {{recipient}}.',
      },
      infoPopup: {
        title: 'Limit überschritten',
        message: 'Du kannst maximal 20 Dateien auf einmal hochladen.',
      },
    },
    statistics: {
      tableType: 'Wähle einen Bericht',
      eventReplies: 'Antworten & Aufgaben',
      eventTypes: 'Ereignisart',
      appointmentSchedule: 'Terminkalender',
      memberFigures: 'Anwesenheitskontrolle',
      charts: {
        eventTypesByMonth: 'Anzahl der Termine nach Typ',
        eventReplies: 'Reaktionen auf Antwortmöglichkeiten',
        memberPresence: 'Anzahl der Reaktionen pro Antwort',
      },
      loadingStatistics: 'Wird geladen...',
      memberFiguresExportSuccess: {
        title: 'Bericht wird erstellt!',
        message:
          'Dein Anwesenheitsbericht wird erstellt. Wegen der vielen Daten kann es ein paar Minuten dauern. Aus Sicherheitsgründen bekommst du den Bericht per E-Mail. Bitte prüfe deinen Posteingang. Danke für deine Geduld!',
      },
    },
    filters: {
      clickToSelect: 'Klicke hier, um zu filtern',
      showFilters: 'Filter anzeigen',
      dateRange: 'Datumsbereich auswählen',
      filterBy: 'Filtern nach',
      dateRanges: {
        yearToDate: 'Bisheriges Jahr',
        lastDays: 'Letzte {{number}} Tage',
        lastYear: 'Letztes Jahr',
        yesterday: 'Gestern',
        today: 'Heute',
        tomorrow: 'Morgen',
        nextDays: 'Nächste {{number}} Tage',
        thisWeek: 'Diese Woche',
        thisMonth: 'In diesem Monat',
        thisYear: 'In diesem Jahr',
        allTime: 'Alle Zeiten',
        specificDateRange: 'Spezifischer Datumsbereich',
      },
      downloadXlsxOrCsv: 'Hier herunterladen: Excel oder CSV',
    },
    bulkUploadEvents: {
      toastText:
        '🆕  Die neue Terminimport-Funktion ist jetzt für jede Gruppe verfügbar!  🎉',
      moduleTitle: 'Import',
      step1: 'Schritt 1',
      step2: 'Schritt 2',
      step3: 'Schritt 3',
      step4: 'Schritt 4',
      stepOne: {
        stepTitle: 'Datenimport vorbereiten',
        stepDescription: 'Excel-Vorlage herunterladen',
        componentTitle: 'Excel-Vorlage herunterladen',
        componentDescription:
          'Füll die Vorlage mit deinen Ereignisdaten aus oder verwende deine eigene Excel-Datei.',
        p1: 'Fülle die Vorlage mit deinen Ereignisdaten aus.',
        p2: 'Spaltentitel müssen in Englisch bleiben.',
        p3: 'Beispiele in jeder Spalte zeigen dir das richtige Format.',
        p4: 'Neue Ereignistypen werden automatisch hinzugefügt.',
        p5: '<b>Wichtig</b>: Wenn du deine eigene Datei verwendest, müssen die folgenden Spaltentitel exakt so in Englisch (Gross-/Kleinschreibung beachten) kopiert und übernommen werden:',
        p6: 'Beispiele in jeder Spalte der Vorlage zeigen dir das richtige Format.',
        p7: 'Neue Ereignistypen werden automatisch hinzugefügt.',
        eventTypes: 'ZU DEN EREIGNISTYPEN',
        template: 'VORLAGE HERUNTERLADEN',
        nextStepButton: 'WEITER',
        copy: 'Jetzt alle kopieren',
      },
      stepTwo: {
        stepTitle: 'DATEI HOCHLADEN',
        stepDescription: 'CSV DATEI HOCHLADEN',
        componentTitle: 'CSV DATEI HOCHLADEN',
        componentDescription:
          'Speichere die Excel-Datei als <b><u>CSV</u></b> und lade sie hier hoch.',
        p1: 'Wir prüfen das Format und zeigen dir eine Vorschau.',
        uploadButton: 'Datei auswählen',
        maximumFileSize: 'Maximale Dateigrösse: 1MB',
      },
      stepThree: {
        stepTitle: 'Daten bestätigen',
        stepDescription: 'Vorschau deines ersten Ereignisses.',
        componentTitle: 'Daten bestätigen',
        componentDescription:
          'Überprüfe das Beispiel und passe die aktivierten Mitglieder an.\nDie ausgewählten Mitglieder gelten für alle Ereignisse.',
        nextStepButton: 'BESTÄTIGEN & HOCHLADEN',
      },
      stepFour: {
        stepTitle: 'Erfolgreich hochgeladen!',
        stepDescription:
          'Das Hochladen der Ereignisse war erfolgreich. Du findest sie im Terminplaner.',
        componentTitle: 'Erfolgreich hochgeladen!',
        componentDescription: '<b>{{count}}</b> Termine wurden importiert.',
        secondTitle: 'Gut zu wissen',
        secondSubTitle:
          'Du kannst den Import rückgängig machen oder eine neue Liste hochladen.',
        goToScheduler: 'ZUM TERMINPLANER',
        undoImport: 'IMPORT RÜCKGÄNGIG MACHEN',
        uploadNewList: 'NEUE LISTE HOCHLADEN',
      },
      errors: {
        eventNameErrorTitle: 'Ereignisname fehlt',
        eventNameErrorMessage:
          'Fehlender Ereignisname in Zeile <b><u>{{row}}</u></b>.',
        eventTypeErrorTitle: 'Ereignistyp fehlt',
        eventTypeErrorMessage:
          'Fehlender Ereignistyp in Zeile <b><u>{{row}}</u></b>.',
        timeErrorTitle: 'Zeitangabe fehlt',
        timeErrorMessage:
          'Start- oder Endzeit fehlt in Zeile <b><u>{{row}}</u></b>.',
        dateErrorTitle: 'Datum fehlt',
        dateErrorMessage: 'Fehlendes Datum in Zeile <b><u>{{row}}</u></b>.',
        locationErrorTitle: 'Ort fehlt',
        locationErrorMessage: 'Fehlender Ort in Zeile <b><u>{{row}}</u></b>.',
        invalidDateOrTimeTitle: 'Ungültiges Datum oder ungültige Uhrzeit',
        invalidDateOrTimeMessage:
          'Bitte überprüfe das Datums- und Zeitformat in Zeile <b><u>{{row}}</u></b> (z. B. HH:MM für die Uhrzeit).',
      },
      commentRequired: {
        title: 'Kommentar nötig',
        message: 'Bitte gib einen kurzen Kommentar dazu ein.',
      },
      deletePopupTitle: 'Terminliste löschen?',
      deletePopupMessage:
        'Diese Aktion löscht deine zuletzt hochgeladene Terminliste unwiderruflich. Bist du sicher?',
      deleteSuccessTitle: 'Erfolgreich gelöscht!',
      deleteSuccessMessage:
        'Deine zuletzt hochgeladene Terminliste wurde erfolgreich gelöscht.',
      successMessage:
        'Überprüfung erfolgreich. Gehe zum nächsten Schritt, um eine Vorschau zu sehen.',
      restartProcessTitle: 'Neue Terminliste hochladen',
      restartProcessMessage:
        'Du kannst jederzeit eine neue Terminliste hochladen. Beachte bitte, dass bereits hochgeladene Termine weiterhin im Terminplaner sichtbar bleiben. Wenn du die alte Liste ersetzen möchtest, lösche sie vorher oder mache den letzten Import rückgängig.',
      restartProcessOkButton: 'NEUE LISTE HOCHLADEN',
      exportDataSample: {
        event_name: 'Zürich Street Parade',
        event_type_name: 'Auftritt',
        event_location: 'Bahnhofstrasse 5, 8001 Zürich',
        event_description:
          'Open-Air-Festival mit internationalen Bands und DJs',
      },
    },
    event: {
      noParticipants: {
        title: 'Noch keine Teilnehmer.',
        description:
          'Sobald ein Mitglied zum Event hinzugefügt wird, erscheint es hier.',
      },
      noParticipantsSearchResults: {
        title: 'Keine Ergebnisse gefunden',
        description: 'Versuch es mit einem anderen Suchbegriff.',
      },
      noDocuments: {
        title: 'Noch keine Dateien',
        description: 'Dateien erscheinen hier, sobald sie hochgeladen werden.',
      },
      noTasks: {
        title: 'Noch keine Aufgaben',
        description:
          'Aufgaben erscheinen hier, sobald sie von einem Admin erstellt oder aktiviert werden.',
      },
      noSearchResults: {
        title: 'Keine Ergebnisse gefunden',
        description: 'Versuch es mit einem anderen Suchbegriff.',
      },
      event: 'Ereignis',
      createdAt: 'Erstellungsdatum',
      editEvent: 'Ereignis bearbeiten',
      createEvent: 'Ereignis erstellen',
      updateEvent: 'Ereignis aktualisieren',
      eventName: 'Ereignisname',
      eventType: 'Ereignistyp',
      eventDetails: 'Ereignisdetails',
      eventTypeDeleted: 'Gelöschte Ereignistypen',
      eventOrganizer: 'Organisator:in',
      eventOrganizerShort: 'Organisator:in',
      location: 'Ort',
      eventTypeEdit: 'Ereignistyp bearbeiten',
      eventTypeName: 'Name des Ereignistyps',
      eventTypeCreate: 'Veranstaltungstyp erstellen',
      responseRequired: 'Antwort erforderlich',
      responseName: 'Name der Antwort',
      responsesEdit: 'Antwort bearbeiten',
      responsesCreate: 'Antwort erstellen',
      repeatAnEvent: 'Ereignis wiederholen',
      repeatWithInterval: 'Wiederholung mit Intervall',
      allDay: 'Ganztags',
      registrationDeadline: 'Anmeldefrist',
      commentRequired: 'Kommentar erforderlich',
      editTask: 'Aufgabe bearbeiten',
      createTask: 'Aufgabe erstellen',
      eventTaskName: 'Name der Aufgabe',
      icon: 'Symbol',
      isMemberComing: 'Deine Antwort?',
      recurringEvent: 'Wiederkehrendes Ereignis',
      allEvents: 'Alle Ereignisse',
      thisEventOnly: 'Nur dieses Ereignis',
      createEventSuccess: 'Ereignis wurde erfolgreich erstellt',
      updateEventSuccess: 'Ereignis wurde erfolgreich aktualisiert',
      createEventReplySuccess: 'Antwort erfolgreich gespeichert',
      updateEventReplySuccess: 'Antwort erfolgreich aktualisiert',
      addGuests: 'Zusätzliche Gäste?',
      eventOperations: {
        eventOnly: 'Dieser Termin',
        eventAndFollowUp: 'Dieser und alle folgenden Termine',
        all: 'Alle Termine',
        deleteText: 'Wiederkehrenden Termin löschen',
        editText: 'Wiederkehrenden Termin bearbeiten',
        editReplyText: 'Deine Antwort gilt für',
        confirm: 'OK',
      },
      dfRes: 'Standardreaktion für alle',
      dfResInfo:
        'Hiermit wird die Standardantwort für alle Teilnehmer des Termins gesetzt. Bereits gegebene individuelle Antworten werden überschrieben.',
      title: 'Achtung',
      responseToast:
        'Wenn du die Standard-Antwort löschst, ohne eine neue zu speichern, werden alle bisherigen Reaktionen und Kommentare gelöscht.',
      setPreferences: 'Voreinstellungen festlegen',
      setEventDefaults: 'Standardwerte festlegen',
      preferencesText:
        'Definiere Voreinstellungen für neue Termine dieses Typs, inkl. Standardantwort für Mitglieder',
      responseSubTitle: 'Kommentar anfordern (optional)',
      requestComment:
        'Aktiviere diese Option, damit Mitglieder bei dieser Antwort einen Kommentar abgeben müssen (z. B. bei „Nein, ohne mich“, um den Grund zu erfragen).',
      registeredUsers: 'Eingeladene Personen',
      guests: 'Gäste',
      nomination: 'Aufgebot',
      nominated: 'Du bist nominiert',
      havePenalty: 'Du hast einen Penalty bekommen',
      penalty: 'Penalty',
      invitees: 'Eingeladene Personen',
      awaiting: 'Ausstehend',
      minutes: 'Minuten',
      hours: 'Stunden',
      days: 'Tage',
      weeks: 'Wochen',
      weekDay: 'Wochentag',
      duration: 'Dauer',
      months: 'Monate',
      years: 'Jahre',
      viewAppointment: 'Event anzeigen',
      myResponse: 'Meine Antwort',
      noEvents: {
        title: 'Noch keine Termine sichtbar',
        description:
          'Sobald dich ein Admin hinzufügt, erscheinen hier deine Termine.',
      },
      shareEvent:
        'Termin teilen - Klick auf das Symbol, um den Termin zu kopieren und überall einzufügen (E-Mail, WhatsApp usw.).',
      shareEventOption: 'Terminlink teilen',
      exportPDFOption: 'Als PDF exportieren',
      deadlineExpired:
        'Die Anmeldefrist ist vermutlich abgelaufen oder das Ereignis ist schon vorbei.',
      totalInvitees: 'Eingeladene insgesamt',
      responsesReceived: 'Erhaltene Antworten',
      additionalGuests: 'Zusätzliche Gäste',
      noPermissionToGiveReply: 'Du hast nicht die Rechte, dies zu ändern',
      responsesPercentage: 'Prozentsatz der Antworten',
      acceptedTasks: 'Angenommene Aufgaben',
      acceptedTasksByUser: 'Aufgaben nach Benutzer',
      givenComments: 'Gegebene Kommentare',
      givenCommentsByUser: 'Erteilte Kommentare durch Benutzer',
      optionalMessage: 'Klick hier, um die Nachrichten zu sehen.',
    },
    task: {
      createTask: 'Aufgabe erstellen',
      taskName: 'Name der Aufgabe',
      noTasks: 'Keine Aufgaben',
    },
    groupSettings: {
      title: 'Gruppen-Einstellungen',
      tabs: {
        general: 'Allgemein',
        eventTypes: 'Ereignistypen',
        responses: 'Antworten',
        membersManagement: 'Mitglieder-Verwaltung',
        other: 'Weitere',
      },
      deleteGroupHeader: 'Wirklich löschen?',
      deleteGroupMessage:
        'Alle eure Daten werden unwiderruflich gelöscht. Keine Wiederherstellung möglich.',
    },
    documentation: {
      title: 'Dokumente',
      generalDocumentation: 'Allgemeine Dokumente',
      uploadedFiles: 'Hochgeladene Dateien',
      chooseFile: 'Datei auswählen',
      tipMessage: 'Maximale Upload-Dateigrösse: 50 MB',
      overview: '{{value}} GB von {{capacity}} GB benutzt',
      uploadSuccess: 'Dokument wurde erfolgreich hochgeladen',
      deleteSuccess: 'Dokument wurde erfolgreich gelöscht',
      attachFiles: 'Dateien anhängen',
      limitExceededHeader:
        'Ihr habt das Speicherlimit für die Dokumente erreicht.',
      sort: {
        label: 'Sortieren nach',
        nameAsc: 'Name (A-Z)',
        nameDesc: 'Name (Z-A)',
        dateOldest: 'Datum (Älteste zuerst)',
        dateNewest: 'Datum (Neueste zuerst)',
      },
    },
    subscriptions: {
      title: 'Abonnements',
      subscription: 'Abonnement',
      yearly: 'Jährlich',
      adBlocker: {
        header: 'Ad-Blocker deaktivieren',
        body: 'Deaktiviere deinen Ad-Blocker (Symbol neben der URL), um lokale Preise zu sehen. Seite neu laden.',
      },
      monthly: 'Monatlich',
      freeTitle: '2 Monate kostenlos testen',
      freeDescription: 'Starte jetzt eure kostenlose 2-monatige Testphase.',
      freeText1: 'Bis zu <strong>30</strong> Gemeinschaften eröffnen',
      freeText2: 'Vollzugriff auf alle Funktionen',
      freeText3: 'Keine Kreditkarte benötigt - einfach anmelden',
      freeText4: 'Keine automatische Verlängerung',
      freeText5: 'Keine Werbung',
      subscribe: 'ABONNIEREN',
      seeDetails: 'DETAILS ANSEHEN',
      buildCustom: 'Custom',
      month: 'Monat',
      year: 'Jahr',
      community: 'Gemeinschaft',
      communities: 'Gemeinschaften',
      maxStorage: 'GB Speicher',
      scheduler: '<strong>1</strong> zentraler Terminplaner',
      schedulers: 'Jede mit einem zentralen Terminplaner',
      classic: 'Classic',
      group: 'Team-/Abteilungs-Gruppenplaner',
      capacity: 'Mitglieder',
      classicPlus: 'Classic+',
      popular: 'BELIEBT',
      textInnerTop:
        'Wähle das passende Abo für euch. Organisiert euer Team in bis zu {{groups}} Gruppen und verwaltet bis zu {{members}} Mitglieder. Jederzeit kündbar oder aktualisierbar.',
      textInnerBottom:
        'Dein Abo ist ein unbefristeter Vertrag. Vorteil: Es verlängert sich jährlich/monatlich automatisch. Wir erinnern dich per E-Mail. Zahle mit Kreditkarte (MasterCard, Visa) oder PayPal.',
      chatsExcluded: 'Ohne Chat-Funktion',
      current: 'AKTUELL',
      pay: 'BEZAHLEN',
      usingBlocker: 'Bitte deaktiviere den Werbeblocker und lade die Seite neu',
      failedToSubscribe:
        'Zahlung fehlgeschlagen. Entweder wurde die Sicherheitsprüfung nicht bestanden oder vermutlich läuft die Kreditkarte bald ab. Verwende eine andere oder probiere es nochmals.',
      usedGroups: 'Verwendete Gruppen',
      usedMembers: 'Verwendete Mitglieder',
      usedCommunity: 'Verwendete Gemeinschaften',
      usedStorage: 'Genutzter Speicherplatz',
      orderSummary: 'Zusammenfassung des Auftrags',
      tax: 'STEUERN',
      total: 'Gesamt',
      periodEnds: 'Bezahlte Periode endet',
      cancelSubscription: 'ABO KÜNDIGEN',
      paypalLink: 'ZAHLUNGSÜBERSICHT',
      chatEnabled: 'Mit Chat',
      chatExcluded: 'Kein Chat',
      paymentApproved: 'Zahlung genehmigt',
      paymentError: 'Zahlungsfehler',
      limitExceededHeader: 'Du hast das Mitgliederlimit erreicht.',
      limitExceededMessage:
        'Bitte wende dich an den Besitzer eurer Gemeinschaft. Nur er/sie verwaltet das Abo und kann es aktualisieren.',
      limitExceededMessageOwner:
        'Wählt einen Plan, um eine Gemeinschaft zu erstellen.',
      inactiveSubscriptionHeader: 'Zahlungsgenehmigung ausstehend',
      inactiveSubscriptionMessage:
        'Entschuldigung, Du kannst diese Aktion nicht fortsetzen. Du musst zuerst den Zahlungsvorgang abschliessen.',
      subscriptionNotPaid: 'Kein aktiver Plan',
      contactAdmin: 'Bitte kontaktiere den Admin.',
      free: 'Gratiskonto',
      requireSubscription:
        'Gumb ist kostenlos für Mitglieder aktiver Communities. Erstelle deine eigene Community und starte jetzt deine Testphase oder ändere dein Abo unter "Abo ändern".',
      requireSubscriptionMember:
        'Es wurde kein gültiges Abo gefunden. Keine Sorge, du musst nichts tun. Der Gemeinschafts-Besitzer sollte jedoch prüfen, ob die Lizenz für diese Gemeinschaft in seinem Abo-Bereich aktiviert oder erneuert wird.',
      cancelConfirmation:
        'Bist du sicher, dass du dein Abonnement kündigen willst?',
      unsubscribe: 'Kündigen',
      cancelled:
        'Kündigung bestätigt. Eine Bestätigung der Kündigung wurde soeben an deine E-Mail versendet. Bis zum bezahlten Abrechnungstag haben alle weiterhin Zugriff auf alle Funktionen.',
      renewSubscriptionText:
        'Vielen Dank!\n\nDein bisheriges Abonnement wird verlängert, wenn du es jetzt aktivierst',
      activate: 'Jetzt aktivieren',
      activated:
        'Dein Abo wurde aktiviert! Wir freuen uns sehr, dass ihr ab jetzt mit Gumb professionell plant und organisiert! Eine Bestätigung ist unterwegs zu deiner E-Mail. Alle Funktionen stehen euch sofort zur Verfügung.',
      approved:
        'Wir bereiten dein Abo vor... Bitte warte einen Moment (bis zu 45 Sekunden). Bitte aktualisiere oder schliesse das Browserfenster nicht währenddessen.',
      trial: 'Kostenlose Probezeit',
      cancelledTitle: 'Gekündigt',
      trialActivated:
        'Eure Testphase hat begonnen. Du und deine Admins können jetzt mit der Planung beginnen, Mitglieder einladen und die Einstellungen verwalten.',
      startTrial: 'Gratis testen',
      startTrialHeader: 'Laaaaaaange testen!',
      startTrialText:
        ':tada: 2 Monate kostenlos testen - keine Kreditkarte, keine automatische Verlängerung. Danach entscheidest du.',
      subscriptionExpired:
        'Diese Community hat derzeit kein aktives Abo. Um neue Nutzer hinzuzufügen, muss das Abo erneuert werden. Bei Fragen: support@gumb.app',
      startTrialPopupButton: 'Kostenlos testen',
      paymentMethods: 'Kreditkarte oder Paypal',
      checkout: {
        pageTitle: 'Checkout',
        breadcrumbCheckout: 'Checkout - {{plan}}',
        stepPlanSelected: 'Plan ausgewählt',
        stepOrderSummary: 'Bestellübersicht',
        stepConfirmation: 'Bestätigung',
        completeOrder: 'Bestellung abschliessen',
        planInfoSub: '{{billing}} · {{count}} {{teams}}',
        planLineAnnual: '{{plan}} (jährlich)',
        planLineMonthly: '{{plan}} (monatlich)',
        planLineSubtextAnnual:
          '{{currency}}{{price}}/Jahr · {{days}} Tage verbleibend',
        planLineSubtextMonthly:
          '{{currency}}{{price}}/Monat · {{days}} Tage verbleibend',
        daysRemainingSubtext: '{{days}} Tage verbleibend',
        annualSavingLine: 'Ersparnis bei Jahreszahlung',
        totalDueToday: 'Heute fällig',
        renewsOn: 'Verlängert sich am {{date}}',
        chargedToday: 'Heute belastet:',
        activationInfo:
          'Sobald die Zahlung bestätigt ist, wird dein Tarif aktiviert und du erhältst eine Bestätigungs-E-Mail. Du kannst jederzeit in den Abo-Einstellungen kündigen.',
        activationInfoStripe:
          'Dein Tarif wird direkt nach der Zahlung aktiviert. Verlängert sich jährlich am selben Datum - jederzeit kündbar.',
        activationInfoStripeMonthly:
          'Dein Tarif wird direkt nach der Zahlung aktiviert. Verlängert sich monatlich am selben Datum - jederzeit kündbar.',
        includedTitle: 'Enthalten',
        included1: 'Geteilter Hauptkalender',
        included2: 'Anwesenheit in Echtzeit',
        included3: 'Team-Chat & Direktnachrichten',
        included4: 'Push-Benachrichtigungen',
        included5: 'Mitgliederrollen & Berechtigungen',
        included6: 'Dateispeicher & Dokumente',
        included7: 'iOS, Android & Web',
        included8: 'Analysen & CSV-Export',
        trustSecure: 'Sicherer Checkout mit PayPal',
        trustSecureStripe: 'Sicherer Checkout mit Stripe',
        trustCancel: 'Jederzeit kündbar',
        trustCancelDetailed: 'Jederzeit kündbar, ohne Strafgebühr',
        trustSSL: '256-Bit-SSL-Verschlüsselung',
        stripeProcessedNote: 'Sichere Zahlung über',
        completePurchase: 'Kauf abschliessen',
        paymentMethodLegend: 'Zahlungsmethode',
        payDirectTitle: 'Jetzt zahlen',
        payDirectDesc: 'Heute belastet.',
        payInvoiceTitle: 'Rechnung',
        payInvoiceDesc: 'Rechnung per E-Mail.',
        invoiceHeadline: 'Per Rechnung zahlen',
        invoiceSubline:
          'Banküberweisung · PDF-Rechnung an deine Rechnungs-E-Mail',
        invoicePanelBody:
          'Wir senden dir eine Rechnung mit Zahlungsdaten und Referenz. Dein Abo wird aktiviert, sobald die Zahlung eingeht (in der Regel 1-3 Werktage nach Überweisung).',
        requestInvoice: 'Rechnung anfordern',
        toBeInvoiced: 'Wird in Rechnung gestellt',
        invoicePageNote:
          'Euer Abo startet sofort, unabhängig vom Zahlungseingang',
        chf: {
          title: 'Rechnungsdetails',
          subtitle:
            'Ihr erhaltet eine QR-Rechnung per E-Mail. Zahlungsfrist 30 Tage.',
          name: 'Organisation oder Name',
          address: 'Adresse',
          vatNumber: 'MwSt-Nummer',
          billingEmail: 'Rechnungs-E-Mail',
          optional: 'optional',
          recipientsHint:
            'Alle Empfänger erhalten dieselbe Rechnung. Leer lassen, um {{email}} zu verwenden.',
          total: 'Total',
          submit: 'Rechnung anfordern',
          activationNote:
            'Euer Abo startet sofort, unabhängig vom Zahlungseingang',
          invalidEmail: 'Gib eine gültige E-Mail-Adresse ein',
          maxRecipients: 'Maximal 5 Empfänger',
        },
        invoiceTrust1: 'Rechnung an deine Rechnungs-E-Mail gesendet',
        invoiceTrust2:
          'Per Banküberweisung mit der angegebenen Referenz zahlen',
        invoiceTrust3:
          'Deine App ist sofort aktiv - bezahle die Rechnung, wenn es dir passt',
        priceSaveVsMonthly: '2 Monate gratis gegenüber monatlich',
        planDetails: 'Tarifdetails',
        badgeNew: 'Neues Abonnement',
        planNotInCatalog:
          'Dieser Tarif ist im Checkout-Katalog noch nicht verfügbar oder der Link ist veraltet. Gehe zurück zu „Tarif ändern“ und starte den Checkout dort erneut.',
        backToChangePlan: 'Zurück zu den Tarifen',
        invoiceYearlyOnly:
          'Rechnungszahlung ist nur für Jahresabos verfügbar. Wähle unter „Tarif ändern“ die jährliche Abrechnung und kehre dann zum Checkout zurück.',
        invoicePayerEmailsLabel: 'Zahler-/Finanz-E-Mails',
        invoicePayerEmailsHint:
          'Wir speichern diese Kontakte für deine Unterlagen. Stripe sendet die Rechnung an deine Profil-E-Mail (Rechnungsempfänger).',
        invoiceBillToProfile: 'Rechnung an: {{email}}',
        invoiceEmailPlaceholder: 'finance@company.com',
        invoiceAddEmail: '+ Weitere E-Mail hinzufügen',
        invoiceRemoveEmail: 'E-Mail entfernen',
        invoiceSubmit: 'Rechnung erstellen',
        invoiceSubmitting: 'Rechnung wird erstellt…',
        invoiceInvalidEmails: 'Gib mindestens eine gültige E-Mail-Adresse ein.',
        invoiceSubmitError:
          'Rechnung konnte nicht erstellt werden. Bitte erneut versuchen oder Support kontaktieren.',
        stripeCheckoutError:
          'Checkout konnte nicht gestartet werden. Bitte versuche es erneut.',
        invoiceSuccessTitle:
          'Rechnung erstellt - Zahlung abschliessen, wenn du bereit bist',
        invoiceAmount: 'Betrag: {{amount}}',
        invoiceOpenHosted: 'Stripe-Rechnung öffnen & zahlen',
        invoiceHostedPending:
          'Dein Abonnement wartet auf Zahlung. Prüfe deine E-Mail auf den Rechnungslink oder öffne in Kürze „Abonnement“ in deinem Profil.',
        invoiceReturnBreadcrumb: 'Bestätigung',
        invoiceReturnSuccessTitle: 'Geschafft!',
        invoiceReturnSuccessSub:
          'Dein {{plan}} ist jetzt aktiv. Bezahle die Stripe-Rechnung, wenn du bereit bist - du musst nicht auf die Zahlung warten, um die App zu nutzen.',
        invoiceReturnSuccessDetailsHeading: 'Was aktiviert wurde',
        invoiceReturnSuccessBulletPlan:
          '{{plan}} - deine Abo-Limits und Abrechnung sind angewendet.',
        invoiceReturnSuccessBulletActive:
          'Premium-Funktionen sind sofort in Web und App verfügbar.',
        invoiceReturnSuccessBulletInvoice:
          'Eine Stripe-Rechnung wurde erstellt - öffne sie unten oder prüfe deine Rechnungs-E-Mail.',
        invoiceReturnSeeInvoice: 'Rechnung ansehen',
        invoiceReturnSeeInvoicePending: 'Rechnungslink ausstehend',
        invoiceReturnGoSubscription: 'Zum Abonnement',
        stripeReturnBreadcrumbSuccess: 'Bestätigung',
        stripeReturnBreadcrumbFailure: 'Checkout abgebrochen',
        stripeReturnSuccessTitle: 'Geschafft!',
        stripeReturnSuccessSub:
          'Dein {{plan}} ist jetzt aktiv. Du kannst alle Funktionen sofort nutzen - ohne Wartezeit.',
        stripeReturnPlanFallback: 'Tarif',
        stripeReturnSuccessDetailsHeading: 'Was aktiviert wurde',
        stripeReturnSuccessBulletPlan:
          '{{plan}} - dein Abo, Limits und Abrechnung sind jetzt aktiv.',
        stripeReturnSuccessBulletActive:
          'Premium-Funktionen sind sofort in Web und App verfügbar.',
        stripeReturnSuccessBulletEmail:
          'Wir senden dir eine Quittung an deine Rechnungs-E-Mail, sobald die Zahlung bestätigt ist.',
        stripeReturnSuccessBulletGuarantee:
          '30-Tage-Geld-zurück-Garantie gilt für dein Abonnement.',
        stripeReturnSessionRef: 'Checkout-Referenz: {{id}}',
        stripeReturnGoHome: 'Zur Startseite',
        stripeReturnViewSubscription: 'Abo anzeigen',
        stripeReturnFailureTitle: 'Zahlung nicht abgeschlossen',
        stripeReturnFailureSub:
          'Es wurde nichts berechnet. Du kannst den Checkout jederzeit unter „Tarif ändern“ erneut starten.',
        stripeReturnFailureDetailsHeading: 'Was passiert ist',
        stripeReturnFailureBullet1:
          'Der Checkout wurde abgebrochen oder vor Abschluss der Zahlung geschlossen.',
        stripeReturnFailureBullet2: 'Dein Abonnement wurde nicht geändert.',
        stripeReturnTryAgain: 'Zurück zu den Plänen',
        stripeReturnBackSubscription: 'Abo anzeigen',
      },
      subscriptionsPopup: {
        title: 'Kein aktiver Plan',
        subtitle:
          '<b>{{ownerName}}</b> ist Besitzer und kann einen Plan wählen. 🙌🏻',
        firstBox: {
          title:
            'Wählt einen Plan, um allen wieder den vollen Zugriff zu geben.',
          btnText: 'Plan wählen',
        },
        secondBox: {
          title:
            'Soll jemand anders übernehmen? Wir übertragen die Gemeinschaft an ein anderes Mitglied.',
          btnText: 'Übernahme anfragen',
          contactMessage:
            'Ich möchte die Übernahme der Gemeinschaft "{{communityName}}" ({{communityId}}) anfragen. Aktueller Besitzer: {{currentOwner}}. Meine E-Mail: {{email}}.',
        },
      },
      profile: {
        legacy: {
          heading: 'Abodetails',
          titleMembership: 'Mitgliedschaft',
          titlePayment: 'Zahlung',
          buttonCancel: 'Mitgliedschaft kündigen',
          details: {
            linkChangePlan: 'Abo ändern',
            infoTrial:
              'Eure Testphase läuft gerade. Nach Ablauf wird dir selbstverständlich nichts berechnet. Wenn ihr Gumb weiterhin nutzen möchtet, wähle unter „Abo ändern“ euer passendes Abo.',
            infoTrialNew:
              'Eure Testphase läuft gerade. Nach Ablauf am {{expireDate}} wird dir selbstverständlich nichts berechnet. Wenn ihr Gumb weiterhin nutzen möchtet, wählt unter „Abo ändern“ euer passendes Abo.',
            linkShowCommunities: 'Meine Gemeinschaften anzeigen',
            linkHistory: 'Abrechnungsverlauf (Beleg per PayPal-E-Mail)',
            linkChangePayment: 'Ändern der Zahlungsmethode',
            currentPlan: 'Aktuelles Abo:',
            communitiesInUse: 'Genutzte Gemeinschaften:',
            groupsInUse: 'Genutzte Gruppen:',
            membersInUse: 'Genutzte Mitglieder:',
            storageInUse: 'Genutzter Speicherplatz:',
            paymentCycle: 'Zahlungszyklus:',
            paymentMethod: 'Zahlungsmethode:',
          },
          billing: {
            paymentInfoNote:
              'Du kannst Zahlungsdaten sicher hinzufügen, wenn du abonnierst. Die Abrechnung läuft über Stripe mit Verschlüsselung.',
            securePayments: 'Sichere Zahlungen',
            renewalNote: 'Verlängert sich {{date}} · {{cycle}}',
            choosePlanTrial: 'Wähle deinen Plan',
            cancelTrial: 'Testphase beenden',
            cancelTrialConfirm:
              'Kostenlose Testphase beenden? Du kannst dich jederzeit wieder von der Planseite aus anmelden.',
            trustStripeNote:
              'Zahlungen sicher verarbeitet - Abrechnung für Rechnungen & Belege verwalten',
          },
        },
        page: {
          title: 'Abonnement & Abrechnung',
        },
        confirming: {
          onboardingTitle: 'Almost there',
          onboardingHint:
            "We're syncing your payment with your account. This usually takes just a moment.",
          subscriptionTitle: 'Almost there',
          subscriptionHint:
            "We're activating your subscription. This usually takes just a moment.",
        },
        labels: {
          paymentCycleMonth: 'Monatlich',
          paymentCycleYear: 'Jährlich',
          validUntil: 'Noch gültig bis:',
          nextPayment: 'Nächste Zahlung:',
          infoCancelled:
            'Dein Abo ist gekündigt und wird nicht verlängert. Ihr könnt die App bis zum nächsten Rechnungsdatum weiter nutzen. Du kannst das Abo jederzeit erneuern.',
          subscriptionEndedOn: 'Abonnement beendet:',
          trialEndedOn: 'Probezeit beendet:',
          accessUntil: 'Zugang bis:',
          nextInvoice: 'Next invoice:',
          lastPlan: 'Letzter Plan',
          invoiceBillingCyclePrimary: 'Annual · Custom pricing',
        },
        hero: {
          title: '2 Monate gratis testen',
          subtitle: 'Alle Funktionen. Keine Kreditkarte.',
          seeIncluded: 'Sieh, was enthalten ist',
        },
        freeAccount: {
          subtitle: 'Du hast noch keine Testphase oder kein Abo gestartet.',
          badge: 'Kostenloses Konto',
          noActivePlan: 'Kein aktiver Plan',
          trialUnlockBlurb:
            'Starte deine kostenlose 2-monatige Testphase für vollen Zugang - inkl. mehrerer Gemeinschaften, Gruppenplaner, Mitgliederverwaltung und mehr.',
          trialNoteFooter:
            '2-monatige kostenlose Testphase - danach keine automatische Abbuchung.',
          comparePlans: 'Pläne vergleichen',
        },
        plan: {
          title: 'Aktueller Plan',
          subtitleTrial: 'Teste Gumb in Ruhe während deiner Testphase.',
          subtitleActive:
            'Dein Plan ist aktiv und verlängert sich automatisch.',
          subtitleNonRenewal:
            'Voller Zugang bis {{date}}. Das Abo verlängert sich nicht automatisch.',
          subtitleStripeEnded:
            'Bezahltes Abo beendet am {{date}}. Du kannst dich jederzeit unter „Abo ändern“ erneut anmelden.',
          subtitleFullyCancelled: 'Dein {{plan}}-Abo endete am {{date}}.',
          subtitleTrialExpired: 'Eure Probezeit ist am {{date}} abgelaufen.',
          badgeTrial: 'Kostenlose Testphase',
          badgeTrialExpired: 'Probezeit abgelaufen',
          badgeCancelled: 'Gekündigt',
          badgeEnded: 'Beendet',
          badgeActive: 'Aktiv',
          endsOnNote: 'Endet am {{date}}. Danach keine automatische Abbuchung.',
          footnoteStripeEnded:
            'Beendet am {{date}}. Keine weiteren Abbuchungen.',
          footnoteFullyCancelled:
            'Gekündigt am {{date}}. Keine weiteren Abbuchungen.',
          footnoteTrialExpired:
            'Probezeit am {{date}} beendet. Es wurde nichts belastet.',
          footnoteRenewalCancelled:
            'Keine Verlängerung nach {{date}}. Voller Zugang bis dahin · {{price}}{{period}} (letzter Plan) · {{billingMethod}}',
          footnoteRenewalPayment:
            'Verlängert sich {{date}} · {{price}}{{period}} {{billingMethod}}',
          paymentMethodChargedGeneric: 'deine hinterlegte Zahlungsmethode',
          paymentMethodChargedTo: 'abgerechnet an {{chargedTo}}',
          paymentMethodBilledByInvoice: 'abgerechnet per Rechnung',
          featureCommunities: 'Bis zu {{count}} Gemeinschaften',
          featureSchedulers: 'Bis zu {{count}} Gruppenplaner',
          featureMembers: 'Bis zu {{count}} Mitgliedern',
          featureStorage: '{{count}} GB Speicher',
          paidProFeatureExtras: [
            'Echtzeit-Anwesenheitserfassung',
            'Team-Chat, Direktnachrichten & Push-Benachrichtigungen',
          ],
        },
        statusBanner: {
          trialTitle: 'Kostenlose Testphase aktiv',
          trialBody:
            'Deine Testphase läuft bis {{date}}. Gumb ist bis dahin kostenlos - danach wird nichts automatisch berechnet.',
          stripeEndedRich:
            'Dieses Stripe-Abo ist beendet. Es fallen keine weiteren Kosten an.',
          fullyCancelledTitle: 'Gekündigt',
          fullyCancelledRich:
            'Dein Abo wurde gekündigt. Der Zugang endete am {{date}}. Du kannst jederzeit erneut abonnieren.',
          trialExpiredTitle: 'Probezeit abgelaufen',
          trialExpiredRich:
            'Eure Probezeit ist am {{date}} abgelaufen. Wählt einen Plan, um den vollen Zugriff zu behalten.',
          activeLabel: '{{plan}} · Aktiv',
          nonRenewalRich:
            'Aktiv bis {{date}} - verlängert sich nicht. Danach keine weiteren Abbuchungen · {{price}}{{period}}',
          renewalRich:
            'Dein Abo verlängert sich am {{date}} · {{price}}{{period}}',
          frequencyAnnual: 'Jährlich',
          frequencyMonthly: 'Monatlich',
        },
        payment: {
          title: 'Zahlung',
          methodLabel: 'Zahlungsmethode',
          invoiceMethodTitle: 'Invoice (annual)',
          sentToBilling: 'Rechnung an {{email}}',
          sentToBillingLabel: 'Rechnung an',
          cycleLabel: 'Abrechnungszyklus',
          accountManagerLabel: 'Account manager',
          lastInvoiceLabel: 'Letzte Rechnung',
          lastInvoiceUnavailable: '-',
          lastInvoiceHintInvoice: 'Offizielle Rechnung als PDF',
          lastInvoiceHint: 'Rechnung für diese Zahlung',
          downloadInvoice: 'PDF herunterladen',
          methodOnFile: 'Karte hinterlegt',
          noPaymentYet: 'Noch keine Zahlung nötig',
          cardExpiresShort: 'Läuft ab {{month}} / {{year}}',
          noActiveSubscription: 'Kein aktives Abonnement',
          manageBilling: 'Abrechnung verwalten',
          manageBillingHint: 'Öffnet das sichere Stripe-Abrechnungsportal',
          viewInvoices: 'Rechnungen anzeigen',
          switchToInvoice: 'Auf Rechnungszahlung wechseln',
          switchToCard: 'Auf Kartenzahlung wechseln',
          switchToInvoiceTitle: 'Auf Rechnungszahlung wechseln?',
          switchToInvoiceBody:
            'Rechnungen werden an deine Rechnungs-E-Mail gesendet.',
          switchToInvoiceBodyBold:
            'Deine Karte wird nicht mehr automatisch belastet.',
          switchToInvoiceConfirm: 'Zu Rechnungen wechseln',
          switchToCardTitle: 'Auf Kartenzahlung wechseln?',
          switchToCardBody:
            'Deine hinterlegte Karte wird automatisch belastet.',
          switchToCardBodyBold:
            'Für künftige Zahlungen werden keine Rechnungen per E-Mail versendet.',
          switchToCardConfirm: 'Auf Kartenzahlung wechseln',
          switchBillingReviewSubtitle:
            'Prüfe die Änderung unten, bevor du bestätigst.',
          switchBillingChangeSummaryLabel: 'Was sich ändert',
          switchBillingTimingLabel: 'Wann es gilt',
          switchBillingStep1Label: 'Änderung prüfen',
          switchBillingStep2Label: 'Karte hinzufügen',
          switchBillingStepIndicator:
            'Schritt {{current}} von {{total}} · {{label}}',
          switchBillingProcessing: 'Zahlungsmethode wird aktualisiert…',
          switchBillingRedirecting: 'Weiterleitung…',
          switchBillingFromLabel: 'Aktuell',
          switchBillingToLabel: 'Neu',
          switchBillingInvoiceLabel: 'Rechnung',
          switchBillingCardLabel: 'Karte',
          switchBillingNextCycleNote:
            'Gilt ab deinem nächsten Abrechnungszeitraum.\nDein aktueller Abo-Zeitraum bleibt unverändert.',
          switchBillingAddCardTitle: 'Zahlungskarte hinzufügen',
          switchBillingAddCardSubtitle:
            'Noch ein Schritt, um auf Kartenzahlung umzustellen.',
          switchBillingAddCardPendingLabel: 'Karte erforderlich',
          switchBillingAddCardPendingText:
            'Zum Abschluss des Wechsels wird eine Zahlungskarte benötigt.\nDeine Zahlungsmethode ändert sich erst, wenn du eine Karte hinzufügst.',
          switchBillingAddCardNextLabel: 'Wie es weitergeht',
          switchBillingAddCardNextText:
            'Weiter zur nächsten Seite, um deine Zahlungskarte hinzuzufügen.',
          switchBillingAddCardSecureNote:
            'Deine Kartendaten werden verschlüsselt und sicher verarbeitet.',
          switchBillingAddCardGo: 'Zahlungskarte hinzufügen',
          switchBillingAddCardStepDone: 'Änderung bestätigt',
          switchBillingAddCardStepNext: 'Karte hinzufügen',
          switchBillingSuccess: 'Zahlungsmethode aktualisiert.',
          switchBillingErrorGeneric:
            'Deine Zahlungsmethode konnte nicht aktualisiert werden. Bitte versuche es erneut.',
          switchBillingNoPaymentMethod:
            'Füge zuerst eine Zahlungsmethode hinzu, bevor du wechseln kannst.',
          switchBillingNoPaymentMethodLink: '<link>Abrechnung verwalten</link>',
          choosePaymentTitle: 'Zahlungsmethode wählen',
          choosePaymentSubtitle: 'Wie möchtest du fortfahren?',
          choosePaymentInvoiceBody:
            'Wir senden Rechnungen an deine Rechnungs-E-Mail. Es wird nichts automatisch abgebucht.',
          choosePaymentCardBody:
            'Bezahle automatisch per Karte. Du hinterlegst sie auf der nächsten Seite.',
          choosePaymentConfirm: 'Weiter',
          choosePaymentConfirmInvoice: 'Rechnung wählen',
          choosePaymentConfirmCard: 'Karte hinterlegen',
          choosePaymentRedirecting: 'Du wirst weitergeleitet…',
          choosePaymentCardOpened:
            'Schließe die Karteneingabe im neuen Tab ab.',
          choosePaymentErrorNoUrl:
            'Die nächste Seite konnte nicht geöffnet werden. Bitte versuche es erneut.',
          editRecipients: 'Empfänger bearbeiten',
          editRecipientsTitle: 'Rechnungsempfänger',
          editRecipientsSubtitle:
            'Alle Empfänger erhalten dieselbe Rechnung. Leer lassen, um die E-Mail-Adresse deines Kontos zu verwenden.',
          editRecipientsSave: 'Speichern',
          editRecipientsSaving: 'Wird gespeichert…',
          editRecipientsError:
            'Die Rechnungsempfänger konnten nicht aktualisiert werden. Bitte versuche es erneut.',
        },
        invoiceHistory: {
          title: 'Abrechnungsverlauf',
          subtitle: 'Frühere Rechnungen und Belege für dein Abo.',
          colInvoice: 'Rechnung',
          colIssued: 'Rechnungsdatum',
          colDue: 'Fällig am',
          colAmount: 'Betrag',
          colStatus: 'Status',
          colDownload: 'Download',
          statusOpen: 'Unbezahlt',
          statusPaid: 'Bezahlt',
          statusVoid: 'Storniert',
          downloadInvoice: 'Rechnung',
          downloadReceipt: 'Beleg',
          invoiceFallback: 'Rechnung {{id}}',
          issuedOn: 'Ausgestellt am {{date}}',
          dueOn: 'Fällig am {{date}}',
          noDueDate: '—',
          empty:
            'Noch keine Rechnungen vorhanden. Sie erscheinen hier nach deinem ersten Abrechnungszeitraum.',
          loadError:
            'Der Abrechnungsverlauf konnte nicht geladen werden. Aktualisiere die Seite oder versuche es in ein paar Minuten erneut.',
          paginationLabel: 'Seiten im Abrechnungsverlauf',
          showingRange: '{{from}}–{{to}} von {{total}} Rechnungen',
          previousPage: 'Vorherige Seite',
          nextPage: 'Nächste Seite',
        },
        usage: {
          title: 'Aktuelle Nutzung',
          lockedHint:
            'Starte eine Testphase, um deine Planlimits zu aktivieren',
          lockedHintResubscribe:
            'Abonniere erneut, um deine Planlimits wiederherzustellen.',
          lockedHintTrialExpired:
            'Wählt einen Plan, um eure Limiten wiederherzustellen.',
          members: 'Mitglieder',
          atLimitMembers: 'Limit erreicht',
          spotsRemaining: '{{count}} Plätze übrig',
          communities: 'Gemeinschaften',
          atLimitCommunities: 'Limit erreicht',
          communitiesRemaining: '{{count}} Gemeinschafts-Plätze übrig',
          schedulers: 'Gruppenplaner',
          atLimitSchedulers: 'Limit erreicht',
          schedulersRemaining: '{{count}} Planer übrig',
          storage: 'Speicher',
          atLimitStorage: 'Limit erreicht - Dateien löschen oder upgraden',
          storageRemaining: '{{count}} GB übrig',
          upgradeNudgeTitle: 'Du hast dein Gemeinschafts-/Team-Limit erreicht.',
          planLimitNudgeTitle: 'Du hast ein Planlimit erreicht.',
          upgradeNudgeBody:
            'Upgrade auf Premium für mehr Teams, höhere Mitgliederzahl und Automatisierungen & Analysen.',
          planLimitNudgeBody:
            'Upgrade deinen Plan für höhere Limits bei Mitgliedern, Gemeinschaften, Gruppenplanern und Speicher. Pläne vergleichen und jederzeit wechseln.',
          upgradeCta: 'Upgrade',
        },
        actions: {
          choosePlan: 'Plan wählen',
          changePlan: 'Plan ändern',
          comparePlansMenu: 'Pläne vergleichen',
          cancelSubscription: 'Abo kündigen',
          dontCancelSubscription: 'Kündigung zurücknehmen',
          restartMembership: 'Mitgliedschaft neu starten',
          subscribeAgain: 'Erneut abonnieren',
        },
        trust: {
          poweredBy: 'Zahlungen werden sicher von Stripe verarbeitet',
        },
      },
    },
    terms: {
      title: 'Allgemeine Geschäftsbedingungen',
    },
    errors: {
      cantSendMessageToYourself: 'Du kannst dir selbst keine Nachricht senden.',
      downloadFail: 'Download-Fehler, bitte versuche es erneut.',
      required: 'Dieses Feld ist erforderlich',
      email: 'Bitte gib eine gültige E-Mail ein',
      invalidEmail:
        'Ups! Bitte gib eine gültige E-Mail-Adresse ein. Überprüfe auf Tippfehler und versuche es erneut.',
      integer: 'Muss eine ganze Zahl sein',
      confirmPassword:
        'Passwörter stimmen nicht überein. Bitte versuche es erneut',
      NotAuthorizedException: 'Falscher Benutzername oder Passwort.',
      invalidCode: 'Dieser Code ist ungültig. Bitte versuche es erneut.',
      errorToast: 'Error: {{message}}',
      invalidRequest: 'Ungültige Anfrage',
      passwordChanged: 'Passwort geändert',
      password:
        'Das Passwort sollte mindestens 8 Zeichen lang sein, Buchstaben in Gross- und Kleinschreibung, Ziffern und Sonderzeichen enthalten',
      termsError: 'Bitte akzeptiere die Bedingungen',
      min: 'Mindestens {{value}} Zeichen',
      max: 'Maximal {{value}} Zeichen',
      startDate: 'Das Datum darf nicht vor dem {{value}} liegen',
      endDate: 'Das Datum kann nicht vor dem Startdatum liegen',
      fileSize: 'Die Datei ist zu gross',
      fileSizeCustom: 'Datei zu gross: Maximale Grösse ist {{size}} MB.',
      customFileSize:
        'Datei zu gross: Max {{size}}. Entferne sie und versuche es erneut.',
      unsupportedFormat: 'Dieses Dateiformat wird nicht unterstützt',
      postalCode: 'Mindestens 4 Ziffern',
      sorry: 'Entschuldigung',
      text404: 'Sieht aus, als ob die gesuchte Seite nicht verfügbar ist :(',
      url: 'Muss eine gültige URL sein.',
      text500: 'Da ist etwas schief gelaufen :(',
      onlyForGroupAndAdmin: 'Funktion nur für Admins und Gruppenleiter',
      onlyForAdmin: 'Funktion nur für Admins',
      communityAccessDenied:
        'Du hast keinen Zugriff mehr auf diese Community oder sie existiert nicht.',
    },
    eventTypes: {
      createSuccess: 'Ereignistyp erstellt',
      editSuccess: 'Änderungen gespeichert',
      deleteSuccess: 'Ereignistyp gelöscht',
    },
    eventTasks: {
      createSuccess: 'Aufgabe erstellt',
      editSuccess: 'Änderungen gespeichert',
      deleteSuccess: 'Aufgabe gelöscht',
    },
    eventResponses: {
      createSuccess: 'Antwort erstellt',
      editSuccess: 'Änderungen gespeichert',
      deleteSuccess: 'Antwort gelöscht',
    },
    tips: {
      registrationDeadline:
        'Die Frist endet zur eingestellten Startzeit des Events. Bis dahin können Mitglieder zu- oder absagen. Danach nur noch Admins & Gruppenleiter.',
      eventType:
        'Der Admin kann in den Gemeinschaftseinstellungen neue Ereignistypen hinzufügen.',
    },
    frequencies: {
      doNotRepeat: 'Einmalig',
      daily: 'Täglich',
      weekly: 'Wöchentlich',
      monthly: 'Monatlich',
      yearly: 'Jährlich',
      everyWorkingDay: 'Jeden Montag bis Freitag',
      other: 'Benutzerdefiniert…',
    },
  },
  es: {
    appWidget: 'Instala Gumb en tu dispositivo',
    featurePopups: {
      appointmentSchedule: {
        innerHtml:
          "<h3>New feature: Download your appointment schedule as an Excel or CSV file. </h3><p>We have completely redesigned the statistics page, and you can export your entire schedule now. The new report called 'Appointment schedule' gives you an overview of facts and figures of your events.</p><p>We are already working on another report called 'Member figures' which will be related to user performance. </p><p>The diary report is now available in the web app for all users.</p>",
        buttonOk: 'LATER',
        buttonRedirect: 'SEE NOW',
      },
      preferecePopup: {
        title: '2 New Features',
        first: {
          title: 'Set All to "Going":',
          subtitle:
            'Set the default response for new or existing events - for all participants at once!',
          link: '',
        },
        second: {
          title: 'Default Event Settings:',
          subtitle: 'Define how new events should look.',
          link: 'Instructions',
        },
      },
      appleCalendar: {
        title: 'CONECTA TU CALENDARIO (iCal)&nbsp;🍏',
        message:
          '¡Lo logramos! Después de mucho trabajo, Gumb ahora habilita la conexión directa del calendario en la versión WEB para una sincronización perfecta. ¡Estén atentos para el lanzamiento de la versión para iOS/Smartphone&nbsp;muy&nbsp;pronto!',
        extraMessage: 'Abre la guía paso a paso',
        redirectText: 'aquí',
        okButton: 'Conectar ahora',
        cancelButton: 'No ahora',
      },
      calendar: {
        innerhtml:
          "<h3>Lo hemos conseguido.</h3> <p> ¡La conexión de GOOGLE CALENDAR está aquí! </p> <br/> <p> Eventos de Gumb - Cada comunidad seleccionable individualmente, ahora puede ser transferida automáticamente a su calendario. </p> <div class='images-container'> <img src='https://gumb-cdn-prod.s3.eu-central-1.amazonaws.com/featurePopups/calendar-1.png' alt='calendar-1' /> <img src='https://gumb-cdn-prod.s3.eu-central-1.amazonaws.com/featurePopups/calendar-2.png' alt='calendar-2' /></div> <p> En esta guía se explica todo lo que hay que hacer: <br/><a target='_blank' rel='noopener noreferrer' href='https://gumb.app/en/support/connect-gumb-with-google-calender/'>→&nbsp; Leer las instrucciones completas </a> </p> <p>Guía rápida:</p> <ol> <li>Conectar e importante: ¡marcar la casilla!</li> <li>Seleccionar la comunidad</li> <li>Espere unos minutos y recargue la página</li> </ol> <p> Conecta tu Google Calendar para ahorrar tiempo y aprovechar al máximo cada día. </p>",
        buttonOk: 'NADA PARA MÍ',
        buttonRedirect: 'CONECTAR AHORA',
      },
      notifications: {
        title: '¿Cómo se debe notificar a los miembros?',
        firstRow:
          'Hemos añadido: Configuración de mensajes y notificaciones push para móviles.',
        secondRow:
          'La configuración de las notificaciones que gestionan los administradores puede ahora personalizarse para toda la comunidad:',
        thirdRow: 'Todo lo que tienes que hacer es:',
        listFirstRow: 'Vaya a Configuración de la comunidad → Notificaciones.',
        listSecondRow:
          'Activa/desactiva las opciones de cada categoría → para personalizar todo a la perfección para ti. (→ Lea las instrucciones <0>aquí</0>)',
        lastRow:
          'Dígales a sus miembros que habiliten la configuración de push o correo electrónico en su propio perfil de Gumb ahora. ',
        buttonLater: 'Más tarde',
        buttonSettings: 'Ir a la configuración ahora',
      },
      pushNotifications: {
        title: '📢 Comunicación de siguiente nivel: Notificaciones Push',
        message:
          'Los administradores y líderes de grupo ahora pueden crear notificaciones push para enviarte información importante directamente a tu smartphone.\n\nQué puedes hacer con las notificaciones push:\n\n• <b>Compartir información importante al instante</b> (por ejemplo, cambios de horario, emergencias)\n• <b>Llegar a personas individuales o equipos completos</b> (comunicación personalizada)\n• <b>Guardar mensajes como plantillas para ahorrar tiempo</b> (comunicación eficiente)',
        extraMessage:
          '¡Mantente siempre informado y no te pierdas ninguna novedad!',
        cancelButton: 'Ver más tarde',
        okButton: 'Probar ahora',
        newMessageOne:
          'Los administradores y los líderes de grupo ahora pueden comunicarse directamente con personas individuales o equipos completos para enviarle información importante directamente a su teléfono inteligente.\n\n',
        redirectLink: 'Cree notificaciones push personalizadas',
        newMessageTwo:
          ', seleccione destinatarios e incluso guarde sus mensajes como plantillas para usarlos más tarde.',
      },
      importEvent: {
        title: 'Upload/Import Events ',
        subText:
          "No more manual entry! Easily import your events with a CSV or Excel file. Whether it's 30 or 300 events - it's quick and can even be undone if there are mistakes.",
        cancelButton: 'View later',
        okButton: 'Try now',
        secondText: 'Find step-by-step instructions',
      },
      mail: {
        title: 'Nueva función: MODO CORREO',
        firstRow:
          'La función de correo electrónico integrada simplifica y agiliza la comunicación del equipo.  ¿Necesita enviar urgentemente un correo electrónico a todo el mundo? ¿Pero sólo a los miembros que han respondido "Sí" a la cita? → ¡Ahora es posible con solo unos pocos clics!',
        secondRow:
          'El modo de correo está ahora disponible en la aplicación web para los administradores y líderes de grupo. Se ampliará aún más en el próximo periodo.',
        thirdRow: 'Más información: <0>https://gumb.app/support/mailmodus/</0>',
        buttonLater: 'VER MÁS TARDE',
        buttonMail: 'AHORA',
      },
      eventPdf: {
        title: 'Nueva función: Descargar la cita como PDF',
        firstRow:
          'Ahorre tiempo ahora e imprima los detalles del evento con un solo clic.',
        secondRow:
          'Poco antes de los próximos eventos, o incluso para eventos pasados, se pueden exportar a PDF todos los detalles del evento, incluyendo todas las estadísticas de respuesta.',
        thirdRow:
          'Requisito del planificador de citas: tiene derechos de administrador',
        fourthRow:
          'Requisito de la planificación del grupo: Usted es un líder de grupo',
        fifthRow: 'La función ya está disponible en la aplicación web.',
      },
    },
    menu: {
      homePage: 'INICIO',
      subscriptions: 'Suscripciónes',
      groupScheduler: 'CALENDARIO',
      documentation: 'DOCUMENTOS',
      chats: 'CHAT',
    },
    dayOfWeek: {
      day1: 'L',
      day2: 'M',
      day3: 'X',
      day4: 'J',
      day5: 'V',
      day6: 'S',
      day0: 'D',
    },
    status: {
      taskInactive: '= No activada',
      notActivated: '= No activado',
      awaitingReply: '= En espera',
      taskInactiveDesc: 'Esta tarea está desactivada - los miembros no la ven.',
      notActivatedDesc:
        'Esta persona no está activada para el evento - no lo ve (celda blanca).',
      awaitingReplyDesc: 'El evento es visible, pero aún no se ha respondido.',
      notActivatedAction:
        'Haz clic en el evento → Editar → Participantes → marcar la casilla → Guardar',
      taskInactiveAction:
        'Haz clic en el evento → Editar → Tareas → marcar la casilla → Guardar',
      awaitingReplyAction: 'Pulsa la celda → Elige una respuesta → Guardar',
    },
    email: {
      sender: 'Remitente',
      recipients: 'Destinatarios',
      otherRecipients: 'Otros destinatarios (separar con coma)',
      subject: 'Asunto',
      message: 'Mensaje',
      attachCommunityDocs: 'Adjuntar documentos comunitarios',
      plusTooltip: 'Escribir nuevo correo electrónico',
      emailSentSuccessfuly:
        'Correo enviado. Atención: era un correo no-reply, el destinatario no puede responder directamente, pero tu dirección de remitente es visible.',
      emailSent: {
        title_one: '📤 Email enviado a {{count}} destinatario',
        title_other: '📤 Email enviado a {{count}} destinatarios',
        message:
          'Si alguien responde, el mensaje llega directamente a tu bandeja de entrada.',
      },
      sendCopy: 'Envíenme una copia',
      maxAttachmentsSize: 'Tamaño total de adjuntos máx. 15 MB',
      changeEmail: {
        title: 'Correo de confirmación enviado',
        message:
          'Te hemos enviado un correo con un enlace de confirmación para tu nueva dirección. Revisa tu bandeja de entrada y haz clic en el enlace para confirmar el cambio. Si no recibes el correo en unos minutos, revisa la carpeta de spam. Si tienes dudas, estamos aquí para ayudarte.',
      },
    },
    pushNotification: {
      header: 'Notificaciones Push',
      filterByRecipient: 'Seleccionar destinatarios',
      filterByResponse: 'Seleccionar destinatarios por respuesta',
      pushMessage: 'Crear push',
      saveAsTemplate: 'Guardar como plantilla',
      sendCopy: 'Enviarme una copia',
      pasteUrl: '🌐 Enlace a evento o externo?',
      plusTooltip: 'Crear nueva notificación push',
      toasterText:
        '🆕 Nueva función: ¡Ahora puedes agregar un enlace externo, como cualquier sitio web 🌐 (URL), a las notificaciones push!\nDirige a los destinatarios directamente al sitio web.',
      templates: 'Plantillas',
      title: 'Título',
      lastUsed: 'ZÚltimo uso',
      noTemplates: 'Las plantillas guardadas aparecen aquí',
      template: 'Plantilla',
      sendConfirmHeader: 'Revisar antes de enviar',
      totalRecipients: 'DESTINATARIOS',
      redirectLink: 'AL ENLACE',
      successTitle: '¡Notificación enviada!',
      successMessage:
        'Tu mensaje ha sido enviado a <b>{{totalRecipients}}</b> destinatarios!',
      selectEventFirst: 'Por favor, selecciona un evento primero',
      templateLimitTitle: 'Límite de plantillas alcanzado',
      templateLimitInfo:
        'Guarda hasta 8 de tus mensajes como plantillas para reutilizarlos más tarde. Ya hemos añadido 3 plantillas para inspirarte: siéntete libre de editarlas o borrarlas.',
      templateLimitMessage:
        'Has alcanzado el número máximo de plantillas. Por favor, elimina una para crear una nueva.',
      urlInfo:
        'Aquí puedes añadir enlaces a cualquier web, por ejemplo una página de producto, un artículo o cualquier cosa importante para vosotros. Solo introduce la URL completa (incluido https://).',
      urlInfoOne:
        'Aquí puedes añadir cualquier sitio web externo (URL) para que tus destinatarios accedan directamente. Si seleccionas un evento arriba, la app añade el enlace del evento y la notificación push abre el evento directamente en Gumb.',
      urlInfoTwo:
        'Próximamente: ¡Agrega cualquier enlace externo (excepto Gumb) a tus notificaciones push! Enlaza a sitios web, noticias y más. ¡Mantente&nbsp;atento!',
      urlTooltip:
        'Puedes crear una notificación push con o sin enlace a un evento. ¿Quieres compartir el enlace de tu evento? Simplemente selecciona un evento arriba para copiarlo automáticamente aquí.',
    },
    common: {
      noResultsFound: 'No hay eventos anteriores disponibles',
      logoutTooltip: 'Cerrar sesión',
      ctrl: 'Mostrar/ocultar totales',
      nextDay: '+1d',
      createdAt: 'Créé le',
      updatedAt: 'Mis à jour le',
      onlyAdmin: 'Solo los administradores pueden usar esta función.',
      download: 'Descargar',
      attachFile: 'Adjuntar archivo',
      new: 'Nuevo',
      unseen: 'No vistos',
      more: 'Más',
      less: 'Menos',
      sunday: 'Domingo',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      may: 'Mayo',
      june: 'Junio',
      july: 'Julio',
      august: 'Agosto',
      september: 'Septiembre',
      october: 'Octubre',
      november: 'Noviembre',
      december: 'Diciembre',
      overallScheduler: 'Planificador',
      selectEvent: 'Seleccionar evento (opcional)',
      displayEventsFrom: 'Mostrar eventos de',
      modalExit: 'Ertu viss um að þú viljir hætta án þess að vista gögnin þín?',
      all: 'Todo',
      tooltipEdit: 'Editar miembro',
      tooltipDelete: 'Quitar miembro',
      overview: 'Información general',
      cancel: 'Cancelar',
      removeLogo: '¿Está seguro que quiere borrar esto?',
      noTasks: 'Aún no hay tareas',
      noUsers: 'Aún no hay usuarios',
      noOptions: 'Sin opciones',
      role: 'Roles',
      admin: 'Administradores',
      member: 'Miembros',
      group_lead: 'Líderes de grupo',
      email: 'Email',
      groups: 'Grupos',
      logoutHeader: '¿Cerrar sesión?',
      logoutMessage: 'Serás redirigido a la pantalla de inicio de sesión.',
      deleteHeader: '¿Está seguro de que quiere eliminar el usuario?',
      logout: 'Cerrar sesión',
      delete: 'Borrar',
      tablePlaceholder: 'Aún no hay miembros para mostrar',
      contentPlaceholder: 'Aún no hay contenido para mostrar',
      create: 'Crear',
      copy: 'Copiar',
      visible: 'Visible',
      saveChanges: 'Guardar cambios',
      newField: 'Campo nuevo',
      fieldName: 'Nombre de campo',
      addField: 'Añadir campo',
      notifications: 'Notificaciones',
      participants: 'Participantes',
      tasks: 'Tareas',
      documentation: 'Documentos',
      description: 'Descripción',
      facebook: 'Facebook',
      twitter: 'X',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      youtube: 'YouTube',
      startDate: 'Fecha de inicio',
      startTime: 'Hora de inicio',
      startDateTime: 'Fecha/hora de inicio',
      endDateTime: 'Fecha/hora de finalización',
      endDate: 'Fecha de terminación',
      endTime: 'Hora de terminación',
      icon: 'Ícono',
      sendMessage: 'Enviar un mensaje',
      aboutMe: 'Sobre Mí',
      selectAll: 'Seleccionar todo',
      approve: 'Aprobar',
      reject: 'Rechazar',
      backToGumb: 'Volver a Gumb',
      edit: 'Editar',
      addComment: 'Añadir un comentario',
      answer: 'Guardar',
      ok: 'Ok',
      withoutGroup: 'Sin grupo',
      copyLink: 'Copiar link',
      copied: 'Copiado',
      sendInviteLink: 'Enviar enlace de invitación',
      apply: 'Aplique',
      from: 'De',
      to: 'A',
      enable: 'Activar',
      search: 'Buscar en',
      color: 'Color',
      columns: 'Columnas difuminadas',
      hiddenColumns: 'Columnas ocultas',
      sorryNoResults:
        'Lamentamos que no haya encontrado lo que buscaba. Por favor, inténtelo de otra manera.',
      tutorial: 'Guía',
      next: 'Siguiente',
      back: 'Atrás',
      step: 'Paso',
      createSuccess: {
        title: 'Creada',
        message: 'Tu opción ha sido creada exitosamente.',
      },
      editSuccess: {
        title: 'Editada',
        message: 'Tus cambios han sido guardados.',
      },
      deleteSuccess: {
        title: 'Eliminada',
        message: 'La opción ha sido eliminada exitosamente.',
      },
      toolTipText: {
        grid3x3: 'Matriz: asignar miembros a las comunidades',
        faq: 'Ayuda: Guías, Contacto, Más.',
        communityPlusIcon: 'Crear nueva comunidad',
        logoGumb:
          'Misterio en desarrollo: ¡Descubran más tarde lo que este botón esconde!',
        memberArrowIcon: 'Ir al resumen de miembros',
        memberPlusIcon: 'Añadir nuevo miembro',
        eventType: 'Crear tipo de evento',
        responses: 'Crear opción de respuesta',
        task: 'Crear tarea',
        schedulerPlusIcon: 'Crear evento o grupo',
      },
      shareEventTitle: 'Compartir enlace del evento vía:',
      copyEventLink: 'O copia el enlace:',
    },
    auth: {
      signInWith: 'Iniciar sesión con',
      continueAs: 'Continuar como',
      create: 'Crear cuenta gratuita',
      signUp: 'Registrarse',
      signIn: 'Iniciar sesión',
      welcome: '¡Bienvenido!',
      createAccount: 'Crear una cuenta gratis',
      forgotPassword: '¿Olvidó su contraseña?',
      resetPassword: 'Restablecer la contraseña',
      resetPasswordTooltip:
        'Si restableces la contraseña, el miembro recibirá un correo con instrucciones para crear una nueva. Para cuentas creadas con Facebook, Google o Apple, Gumb no puede restablecer la contraseña. El miembro puede seguir iniciando sesión usando el icono de la red social correspondiente.',
      resetPasswordModalTitle: 'Restablecimiento de contraseña iniciado',
      resetPasswordModalText:
        'El miembro recibe ahora un correo para crear una nueva contraseña. Para Facebook, Google o Apple, puede iniciar sesión como siempre con el icono.',
      resetPasswordErrorModalTitle: 'No es posible restablecer la contraseña',
      resetPasswordErrorModalText:
        'Atención: Este miembro usa Facebook, Google o Apple para iniciar sesión. Gumb no puede restablecer la contraseña. Si el miembro olvidó la contraseña, debe restablecerla directamente con el proveedor. Iniciar sesión con el icono social sigue funcionando. Por favor, informa al miembro.',
      terms: {
        '0': 'Estoy de acuerdo con ',
        '1': 'las Condiciones',
        '2': ' y ',
        '3': 'Política de Privacidad',
      },
      termsAcknowledgement:
        'By continuing, you acknowledge that you understand and agree to the <0>Terms & Conditions</0> and <1>Privacy Policy</1>.',
      home: 'Pagina Principal',
      confirmed: 'Email confirmado exitosamente',
      verifying: 'verificación del email...',
      recovery: 'Recuperación de contraseña',
      send: 'Enviar',
      codeSended:
        'Se ha enviado un enlace de verificación a tu correo. Por favor, revisa y confirma. Revisa también la carpeta de spam.',
      signUpSuccess:
        'Registrado exitosamente. Por favor compruebe su correo electrónico para confirmar la registración',
      inviteSentTitle: 'Invitación enviada con éxito',
      inviteSentText:
        '¡Perfecto! Miembro registrado y la invitación con contraseña temporal fue enviada (revisa spam si es necesario). El miembro puede iniciar sesión y cambiar la contraseña. Recarga la página para actualizar la lista de miembros. Ahora tú y tus admins podéis editar grupo, rol o el perfil del miembro.',
      reset: 'Restablecer',
      yourEmail: '{{value}} ya es su dirección de email',
      existEmail: '{{value}} ya existe',
      labels: {
        email: 'Email',
        currentEmail: 'Correo electrónico actual',
        newEmail: 'Nuevo email',
        password: 'Contraseña',
        oldPassword: 'Contraseña anterior',
        newPassword: 'Contraseña nueva',
        confirmPassword: 'Confirmar contraseña',
      },
      accountExists:
        'Esta dirección de correo electrónico ya está en uso para una cuenta de Gumb. Si este correo electrónico es el suyo, haga clic en Olvidé mi contraseña y compruebe su bandeja de entrada y su carpeta de correo no deseado.',
      codeExpired:
        'Este era un enlace caducado. Después de introducir su correo electrónico aquí, le enviaremos un nuevo enlace para completar la verificación de su cuenta.',
      userNotConfirmed:
        'Todavía tiene que verificar su cuenta. Le hemos enviado un correo electrónico con un enlace de confirmación. Si no ha recibido un correo electrónico, compruebe la carpeta de correo no deseado de su buzón. ',
      invalidCredentials: 'Nombre de usuario o contraseña incorrectos',
      userNotFound:
        'Este correo aún no está registrado o está vinculado a Google, Apple o Facebook. No cambies la contraseña de la red social en Gumb; solo inicia sesión con el icono correspondiente.',
      socialLoginDetected: {
        title: 'Inicio de sesión social detectado',
        message:
          'Este correo parece estar vinculado a Google, Apple o Facebook. La contraseña se gestiona allí, no en Gumb. Para iniciar sesión, haz clic en el icono de la red social correspondiente.',
      },
    },
    profile: {
      editSuccess: 'Cambios guardados',
      settings: 'Configuraciones',
      editProfile: 'Editar perfíl',
      selectImage: 'Seleccionar imagen',
      myProfile: 'Mí perfíl',
      profileEditBtn: 'AÑADE TU INFO: DIRECCIÓN, REDES Y MÁS',
      basicInformation: 'Info básica',
      contactInformation: 'Contacto',
      addressInformation: 'Dirección',
      myCommunities: 'Mis comunidades',
      myChat: 'MIS CHATS',
      freeText1: 'Texto Libre 1',
      freeText2: 'Texto Libre 2',
      myAppointments: 'Mis citas',
      subscription: 'Suscripción',
      userProfile: 'Perfíl de usuario',
      tellUsAboutYourself: 'Sobre mí',
      firstName: 'Nombre',
      lastName: 'Apellido',
      profileName: 'Nombre de usuario',
      person: 'Persona',
      role: 'Role de usuario',
      email: 'Email',
      dateOfBirth: 'Fecha de Nacimiento',
      privatePhoneNumber: 'Tel (Privado)',
      officePhoneNumber: 'Tel (Trabajo)',
      mobilePhoneNumber: 'Tel (Móvil)',
      street: 'Calle',
      region: 'Región',
      postalCode: 'Código Postal',
      city: 'Ciudad',
      country: 'País',
      about: 'About',
      linkChangeEmail: '(Cambiar E-Mail)',
    },
    profileCommunities: {
      empty: {
        title: 'Ninguna comunidad visible',
        description:
          'Cuando crees tus propias comunidades o te unas a otras,<brPure />aparecerán aquí.',
      },
      popupLeave: {
        title: '¿Seguro que quieres salir de la comunidad?',
        button: 'Salir',
      },
      leaveCommunity: {
        title: '¿Seguro que quieres salir de la comunidad?',
        message:
          'Solo sales de esta comunidad. Tu cuenta sigue y puedes unirte a otras cuando quieras.',
        okButton: 'Sí, Abandonar',
        cancelButton: 'Cancelar',
      },
    },
    profileSettings: {
      title: 'Configuraciones del perfíl',
      notification: 'Notificación',
      notificationsPlaceholder: 'Aún no tienes notificaciones',
      changePassword: 'Cambiar contraseña',
      changeEmail: 'Email',
      saveNewEmail: 'Guardar el nuevo email',
      language: 'Lengua',
      timeFormat: 'Formato de tiempo',
      permissions: 'Autorizaciones',
      allowedToEdit: 'Los administradores pueden editar mi perfil',
      other: 'Otro',
      pushNotification: 'Notificación Push',
      receiveByEmail: 'Recibir notificaciones por correo electrónico',
      receivePush: 'Recibir notificaciones push en el móvil',
      receiveInApp: 'Recibir notificaciones in-app',
      terms: 'Condiciones generales',
      protectionRegulation: 'Política de privacidad',
      deleteAccount: 'Borrar la cuenta',
      logout: 'Cerrar la sesión',
      deleteProfileHeader: '¿Seguro que quieres borrar tu cuenta?',
      notifications: {
        now: 'Ahora',
        hours: '{hace {value}} h',
        minutes: '{hace {value}} mins',
        minute: 'hace 1 min',
      },
    },
    calendarConnection: {
      outlookCalendar: 'Outlook Calendar',
      googleCalendar: 'Google Calendar',
      pageTitle: 'Conexión con el calendario',
      connectTitle:
        'Conecta tu calendario\ny sincroniza eventos automáticamente',
      connectDescription:
        'Gumb crea eventos por ti: aparecen automáticamente en tu calendario.',
      appleCalendar: 'Calendario de Apple',
      appleConnectionSteps: {
        headerOne:
          'Agrega eventos de Gumb a tu calendario (Apple u Outlook) con una URL iCal - en 4 pasos.',
        demoLinks: 'Demostración rápida',
        demoLinksApple: 'Apple',
        demoLinksAppleHere: 'aquí',
        demoLinksDetailed: 'Guía detallada',
        demoLinksDetailedApple: 'Apple',
        demoLinksDetailedHere: 'aquí',
        demoLinksOutlook: 'Outlook',
        demoLinksOutlookHere: 'aquí',
        stepOne: 'En tu app de calendario, abrir',
        stepOneSubscribeBold: 'Suscribirse a un calendario',
        stepOneApplePrefix: 'Apple',
        stepOneAppleSuffix: 'Archivo → Nueva suscripción de calendario',
        stepOneOutlookPrefix: 'Outlook',
        stepOneOutlookSuffix:
          'Agregar calendario → Desde Internet / Calendario suscrito',
        stepTwo: 'Copiar el enlace iCal de tu comunidad y pegarlo',
        stepThree: 'Asignar nombre y, opcionalmente, un color',
        stepFour:
          'Ajustar ubicación (iCloud, Mac, Outlook) y frecuencia de actualización, confirmar',
      },
      appleConnectionPopup: {
        title: '¿Cómo conectar?',
        stepOne: 'Copiar el enlace de la comunidad',
        stepTwo:
          'En tu Calendario de Apple, bajo "Calendario", elige "Archivo" > "Nueva suscripción a calendario".',
        stepThree:
          'Ingresa el enlace iCal de la Comunidad copiado, luego haz clic en "Suscribirse".',
        stepFour:
          'Nombra el calendario, selecciona un color, ajusta preferencias como ubicación (iCloud o Mac) o actualización automática y haz clic en "Aceptar".',
      },
      appleDisconnectPopup: {
        title: 'Confirmar Desconexión',
        message:
          'Al pulsar "Sí, desconectar ahora", se eliminarán todos los eventos de Gumb de tu(s) calendario(s). Por favor, elimina manualmente el/los calendario(s) después, ya que de lo contrario seguirá/seguirán siendo visible(s).\n\n<b>Para darte de baja completamente:</b>\n\n• <b>En macOS</b>: Abre Calendario, haz clic derecho en el calendario > "Darse de baja".\n• <b>En iOS</b>: Ve a "Calendarios", toca el botón "Info" al lado del calendario > "Eliminar Calendario".',
        okButton: 'Sí, desconectar ahora',
      },
      appleUncheckBoxPopup: {
        title: 'Confirmar Desconexión',
        message:
          'Al hacer clic en "Sí, desconectar ahora", se eliminarán todos los eventos de Gumb de tu calendario. Por favor, elimina manualmente el calendario después, ya que de lo contrario seguirá visible.\n\n<b>Para darte de baja completamente:</b>\n\n• <b>En macOS</b>: Abre Calendario, haz clic derecho en el calendario > "Darse de baja".\n• <b>En iOS</b>: Ve a "Calendarios", toca el botón "Info" al lado del calendario > "Eliminar Calendario".',
        okButton: 'Sí, desconectar ahora',
      },
      connectWithApple: 'Conectar Apple y Outlook (iCal)',
      cantSeeICal: '¿No ves el enlace iCal? Solo marca la casilla.',
      syncTip:
        'Sólo los eventos de la comunidad seleccionada se sincronizarán con su calendario.',
      connect: 'Conectar',
      connected: 'Asociados',
      disconnect: 'Desconectar',
      disconnectSuccess: 'Desconectado con éxito',
      selectCommunities: 'Selección de comunidades',
      selectCommunitiesDescription:
        'Sólo los eventos de la comunidad seleccionada se sincronizarán con su calendario.',
      authSuccessTitle: 'Conexión exitosa',
      authSuccessMessage:
        'Tus eventos se están sincronizando automáticamente. Espera un momento y recarga la página de Google Calendar para completar la primera sincronización.',
      authSuccessTitleTwo: '¡Selecciona tu comunidad ahora',
      authSuccessMessageTwo:
        'Toca la marca de verificación y pulsa "Guardar cambios" para confirmar.',
      syncSuccess:
        '¡Actualizado!\nSincronización automática activa. Gestiona tus comunidades cuando quieras.',
      syncSuccessTitle: '¡Casi listo!',
      syncSuccessMessage:
        'Estamos sincronizando tu comunidad con tu Google Calendar. Solo tomará 2-3 minutos. Actualiza tu página de Google Calendar para ver las actualizaciones.',
      disconnectConfirmTitle: '¿Estás seguro?',
      disconnectConfirmDescription:
        'Si te desconectas, todos los eventos serán eliminados de tu calendario.',
      disconnectConfirm: {
        title: '¿Desconectar ahora?',
        message:
          'La desconexión eliminará todos los eventos de tu Google Calendar. No te preocupes, puedes volver a conectar Gumb para una nueva sincronización en cualquier momento.',
        cancelButton: 'Cancelar',
        okButton: 'Sí, Desconectar',
      },
      noCommunities:
        'No hay comunidades para seleccionar.\nEspera a que un administrador te añada.',
      checkboxWarning: 'ATENCIÓN: ¡La garrapata debe estar ajustada!',
    },
    community: {
      noMembersEmptyState: {
        title: 'Ningún miembro inscrito',
        description: 'Cuando los miembros se inscriban, aparecerán aquí.',
      },
      plusIconSubText: 'Planea un evento o establece series de eventos.',
      selectAllCommunityAdmins: 'Todos los administradores',
      selectAllGroupAdmins: 'Todos los jefes de grupo',
      createSuccess: 'La comunidad fué creada exitosamente',
      createFailure:
        'Inténtalo de nuevo en un momento para crear tu comunidad.',
      deleteSuccess: 'La comunidad fué borrada exitosamente',
      leaveSuccess: 'Has abandonado con éxito la comunidad',
      descriptionTitle: 'Sobre la comunidad',
      descriptionPlaceholder: 'Aquí se puede describir su comunidad',
      online: 'En linea',
      updateCommunity: 'Actualizar comunidad',
      members: 'Miembros',
      createCommunity: 'Crear la comunidad',
      communityName: 'Nombre de la comunidad',
      category: 'Categoría',
      aboutCommunity: 'Sobre la comunidad',
      selectLogo: 'Seleccionar logo',
      selectLogoTip: 'jpg, jpeg, png (5MB)',
      chooseCover: 'Seleccionar cover',
      chooseCoverTip: 'jpg, jpeg, png (20MB)',
      website: 'Sitio web',
      partnership: 'Colaboración',
      deleteCommunity: 'Borrar la comunidad',
      deleteHeader:
        '¿Estás seguro de que quieres eliminar a este usuario del grupo?',
      addMembers: 'Añadir miembros',
      invitationLink: 'Enlace de invitación',
      communityRole: 'Role de la comunidad',
      joinCommunity: 'Unirse a la comunidad',
      namePlaceholder: '{Equipo de {value}}',
      requestSent: 'Solicitud de afiliación enviada con éxito',
      requestSentButton: 'Solicitud de afiliación enviada',
      limitExceededHeader:
        'Has alcanzado el límite de comunidades de tu plan. Para crear más, mejora tu plan en Perfil > Suscripción.',
      limitExceededMessage:
        'Contacta al propietario de tu comunidad. Solo él/ella puede administrar y actualizar la suscripción.',
      limitExceededMessageOwner:
        'Por favor, ve a Perfil > Suscripción para gestionar tu plan y actualizarlo si es necesario.',
      updateFailure: 'No se pudo actualizar la comunidad',
      buttonAddEvent: 'Añadir evento',
      userBlockedTitle: 'Bloqueado',
      userBlockedText:
        'Parece que alguien te ha bloqueado en esta comunidad. Los administradores pueden bloquear o desbancar a los miembros.',
      createOverLimitTitle: 'Límite de comunidades alcanzado',
      createOverLimitText:
        "Inicia tu prueba gratuita o elige un plan en 'Cambiar plan' para organizar tu propia comunidad.",
      notInvitedTitle: 'Sin permiso',
      notInvitedText:
        'Es posible que no tengas permiso para acceder a este evento. Los administradores y jefes de grupo pueden añadirte al evento.',
      noRequestsTitle: 'Aún no hay solicitudes pendientes.',
      noRequestsText:
        'Cuando la gente envíe solicitudes para su comunidad, se mostrarán aquí para que usted las revise.',
      invitationCodeExpired:
        'Este es un enlace de invitación caducado. Pero ahora puedes enviar una solicitud de adhesión, que los administradores pueden aceptar o rechazar.',
      communityNotFound: 'Comunidad no encontrada',
      communityPopup: {
        title: 'Crear Evento o Grupo',
        subTitleOne:
          'Planifica eventos en el PROGRAMADOR central. Usa grupos para dividir a los miembros en equipos.',
        createEvent: {
          infoText:
            "Programa eventos para todos o grupos/miembros específicos en el PROGRAMADOR. Visible en el programador, en 'Mis Eventos' y en los grupos.",
          btntitle: 'Crear Evento',
          linkText: 'Tutorial',
        },
        createGroup: {
          infoText:
            'Los grupos tienen sus propios planificadores, con eventos visibles solo para los miembros del grupo. Gestiona los roles de los miembros eficazmente',
          btntitle: 'Crear Grupo',
          linkText: 'aquí',
        },
        chatTitle: 'Opciones de chat',
        chatSubTitle: 'Inicia un chat 1:1 o crea una sala de chat para grupos.',
        oneToOne: {
          infoText:
            'Haz clic en el ícono de chat junto al nombre de un miembro o en su foto de perfil para enviarle un mensaje.',
          btntitle: 'Ver lista de miembros',
          linkText: 'Tutorial',
        },
        createChatGroup: {
          infoText:
            'Crea una sala de chat privada para miembros, equipos o grupos seleccionados. Solo los administradores pueden crear estas salas.',
          btntitle: 'Crear sala de chat',
          linkText: 'aquí',
        },
      },
      exportStatistics: 'Exportación de estadísticas',
      exportStatisticsTooltip: 'Exportar las estadísticas a un archivo CSV',
    },
    communitySettings: {
      noMatrixData: {
        title: 'Ninguna comunidad visible',
        description:
          'Cuando un propietario cree comunidades y te haga administrador, podrás asignar miembros aquí.',
      },
      noSearchResults: {
        title: 'Ningún resultado',
        description:
          'No hay resultados para {{searchResult}}. Intenta con otro término de búsqueda.',
      },
      clearSearch: 'Borrar búsqueda',
      matrix: 'Matriz',
      matrixDescription:
        'Asigna/retira miembros a tus comunidades con un clic - se guarda al instante.<brPure />Ideal para cambios de temporada y de equipo y para asignaciones múltiples.',
      tooltip:
        'Ir a la vista Matriz: asignar/retirar miembros en las comunidades.',
      admin: 'Administrador',
      member: 'Miembro',
      blocked: 'Usuario bloqueado',
      owner: 'Propietario',
      group_lead: 'Lider de grupo',
      group_admin: 'Administrador de grupo',
      chat_admin: 'Admin de chat',
      community_admin: 'Administrador de la comunidad',
      editRoleSuccess: 'Role fué cambiado exitosamente changed',
      deleteUserSuccess:
        'El usuario ha sido eliminado con éxito de la comunidad',
      removeUser: {
        title: '¿Estás seguro de eliminar a este usuario?',
        message:
          'Cuando elimines a este usuario, será eliminado de tu comunidad, pero mantendrá su cuenta de usuario y podrá seguir participando en otras comunidades.',
        cancelButton: 'Cancelar',
        okButton: 'Sí, Eliminar',
      },
      removeUserSuccess: {
        title: 'Usuario eliminado',
        message: 'El usuario ha sido eliminado con éxito de tu comunidad.',
      },
      editSuccess: 'Los cambios se han actualizado con éxito',
      title: 'Configuraciones de la comunidad',
      backToSubscriptionsDetails: 'Volver a los detalles de la suscripción',
      tabs: {
        general: 'Preferencias generales',
        eventTypes: 'Tipos de evento',
        subscriptions: 'Suscripciones',
        responses: 'Opciones de respuesta',
        roles: 'Miembros',
        requests: 'Solicitudes',
        other: 'Otro',
        tasks: 'Tareas',
      },
      addMember: 'Añadir miembro',
      exportMembers: 'Exportar',
      exportMembersTooltip: 'Exportar la lista de miembros a un archivo CSV',
      deleteCommunityHeader: '¿Realmente eliminar?',
      deleteCommunityMessage:
        'Todos vuestros datos se borrarán permanentemente. No se pueden recuperar.',
      defaultEventList: [
        '🤝🏻🏻 Encuentro 🤝🏻🏻',
        '📅 Evento 📅',
        '📋 Reunión 📋',
        '📝 Reunión de junta 📝',
        '🚌 Excursión 🚌',
        '🛠️ Taller 🛠️',
        '⏰ Turno ⏰',
        '🏢 Evento de empresa 🏢',
        '🏃 Entrenamiento 🏃',
        '🏆 Torneo 🏆',
        '🎶 Ensayo 🎶',
        '🔴 CANCELADO 🔴',
        'ℹ️ Info ℹ️',
        '📊 ENCUESTA 📊',
      ],
      defaultResponsesTypes: [
        'Me uno ✅',
        'No podré asistir ❌',
        'Aún no estoy seguro 🟨',
      ],
      defaultTasks: ['¿Quién conduce?', '¿Quién trae las bebidas?'],
      selectUsers: {
        title: 'Seleccionar Usuarios',
        message:
          'Marca a los usuarios con una casilla para aprobar o rechazar las solicitudes de membresía.',
      },
      memberExists: 'El miembro ya existe',
      mailSent:
        '¡Invitación enviada! Válida durante 24 horas. El nuevo miembro hace clic en “Unirse ahora” e inicia sesión con la contraseña temporal: así ya forma parte de tu comunidad. Los admins pueden reenviar la invitación en cualquier momento.',
      userNotFound:
        'No se encontró perfil. Escribe nombre y apellido para crear un nuevo perfil y enviar la invitación.',
      disableAddMemberTooltip:
        'Límite de miembros alcanzado. Pide al propietario de la comunidad que actualice el plan para agregar más miembros.',
      notifyByFields: 'Enviar notificación cuando estos campos se cambien',
      notifyByReplies: '¿Quieres enviar notificaciones a los invitados?',
      remindBefore: 'Recordar antes',
      addReminder: '+ Añadir recordatorio (2 máx.)',
      notificationsTypes: [
        'Evento creado',
        'Evento actualizado',
        'Evento eliminado',
        'Recordatorio de evento',
      ],
      notificationsClasses: ['In-App', 'E-mail', 'Push'],
      notificationPopupHeader: '¿Notificar a los invitados?',
      notificationPopupMessageLabel: 'Añadir mensaje opcional',
      notificationPopupNotify: 'Enviar',
      notificationPopupDoNotNotify: 'No enviar',
      notificationPopupBack: 'Volver a la edición',
      ownerTooltip:
        '👑 Propietario\n\nEl propietario creó esta comunidad.\n\nSiempre hay solo uno - con todos los derechos: gestiona la suscripción y puede eliminar la comunidad.\n\nCambio posible - contacta con soporte.',
      emailTooltip:
        '📧 Correo electrónico\n\nCorreo de acceso del usuario.\nSolo el usuario puede modificarlo.\n\nConsejo: ¿Conoces el correo de un nuevo miembro? → Añadir usuario',
      roleTooltip:
        '🛠️ Rol\n\nAdmin:\nAcceso total en toda la comunidad - ve y gestiona todo.\n➜ Haz clic para hacer admin a un miembro\n\nLíder de grupo:\nGestiona eventos y respuestas dentro de un grupo.\n➜ Abre el grupo → Miembros → Arrastra hacia arriba',
      groupsTooltip:
        '👥 Grupos\n\nMuestra a qué grupos pertenece el miembro.\n➜ Haz clic para asignar grupos.\n\nLos nuevos miembros ven todos los eventos generales.\nLos eventos de grupo solo son visibles tras asignación.',
    },
    communityInvitation: {
      subjectSecond: '',
      body: 'Por favor, siga el siguiente enlace para unirse a la comunidad',
      invitationSuccess:
        '¡Aprobado! Miembro añadido a la lista. Revisa rol y grupo en Configuración de la comunidad → Miembros.',
      invitationFailure:
        'Error: probablemente ya alcanzaste el límite de tu plan.',
      membersInvitation: {
        title: 'Invitar miembros',
        description:
          'Tienes varias opciones para agregar nuevos miembros. Más información: <0>"Añadir un nuevo usuario"</0>.',
        showMore: 'Mostrar más',
        showLess: 'Mostrar menos',
        codeInvitation: {
          title: 'La forma más rápida y sencilla',
          button: 'Copiar enlace de invitación',
          updateLink: 'Generar enlace ahora',
          generateLink: 'Generate link now',
          howItWorks: 'Cómo funciona',
          goodToKnow: 'Es bueno saberlo',
          howItWorksText:
            'Los miembros hacen clic en "Crear cuenta gratuita" utilizando el enlace seleccionado anteriormente. Cuando Gumb envía un correo electrónico, los miembros sólo tienen que confirmar su dirección de correo electrónico para obtener acceso directo.',
          goodToKnowText:
            'Esto es súper rápido, pero tenga en cuenta que una vez que la verificación de la cuenta esté completa, las personas con este enlace podrán acceder a sus eventos inmediatamente. Por lo tanto, puedes renovar el enlace anterior cuando quieras.',
        },
        linkInvitation: {
          title: 'Por enlace:',
          button: 'Copiar enlace de la comunidad',
          howItWorks: 'Cómo funciona:',
          adminFlow: 'Los admins revisan las solicitudes:',
          howItWorksText:
            '<0>Copia y comparte el enlace.</0><0>Los miembros con cuenta de Gumb hacen clic en “Unirse”.</0><0>Si alguien no tiene cuenta, debe registrarse primero, luego volver a hacer clic en el enlace para enviarte la solicitud.</0>',
          adminFlowText:
            'Todas las nuevas solicitudes aparecen en la pestaña “Solicitudes”. Los admins pueden aceptarlas o rechazarlas allí. Las solicitudes abiertas se marcan con el icono de engranaje.',
        },
        addMember: {
          title: 'Invitar o preregistrar por dirección de correo electrónico',
          button: 'AÑADIR USUARIO',
          selfSignUp: 'El miembro se registra solo:',
          preRegister: 'Preregistrar persona:',
          selfSignUpText:
            'Cualquiera puede registrarse gratis en Gumb y enviarte su dirección de correo electrónico. Si la ingresas aquí, el miembro se añade automáticamente y ve todos los eventos.',
          preRegisterText:
            'Crea un nuevo miembro directamente con su correo electrónico. La cuenta se crea al instante, el miembro recibe una invitación con contraseña temporal y puede iniciar sesión de inmediato. La contraseña puede cambiarse más tarde.',
        },
      },
    },
    group: {
      deleteEventSuccess: 'El evento se ha eliminado con éxito',
      createSuccess: 'Grupo fue creado exitosamente',
      deleteSuccess: 'Grupo fue borrado exitosamente',
      addMembersSuccess: 'Participantes fueron añadidos exitosamente',
      addMembersSuccessWithMessage: {
        title: 'Miembro añadido!',
        message:
          'Tu lista de miembros ha sido actualizada exitosamente. Gestiona roles y asignaciones a grupos. También puedes añadir o cambiar los detalles del usuario.',
      },
      deleteUserSuccess: 'Se ha eliminado con éxito el usuario del grupo',
      addParticipants: 'Añadir miembros',
      createGroup: 'Crear grupo',
      deleteGroup: 'Borrar grupo',
      groupName: 'Nombre de grupo',
      changeGroupNameSuccess: 'Nombre del grupo cambiado con éxito.',
      groups: 'Grupos',
      inviteMembers: 'Invitar miembros',
      tabs: {
        schedule: 'Planificar',
        members: 'Miembros',
        chat: 'Chat',
        documentation: 'Documentos',
        statistic: 'Exportación y estadísticas',
        import: 'Importación',
      },
      limitExceededHeader:
        'Has alcanzado el límite de comunidades de tu plan. Para crear más, mejora tu plan en Perfil > Suscripción.',
      limitExceededMessage:
        'Contacta al propietario de tu comunidad. Solo él/ella puede administrar y actualizar la suscripción.',
      limitExceededMessageOwner:
        'Por favor, ve a Perfil > Suscripción para gestionar tu plan y actualizarlo si es necesario.',
      groupRole: 'Role de grupo',
      addGroup: 'Añadir grupo',
    },
    chat: {
      read: {
        now: '{{name}} leído justo ahora',
        hours: '{{name}} leído hace {{value}}h',
        minutes: '{{name}} leído hace {{value}} min',
        minute: '{{name}} leído hace 1 min',
        day: '{{name}} leído el {{value}}',
        dateTime: '{{name}} leído el {{value}} a las {{time}}',
      },
      noRead: 'Aún no leído',
      noActiveCommunity: 'Aún no tienes una comunidad activa.',
      lastAdmin:
        'Una sala de chat necesita al menos un administrador o un líder de grupo. Asegúrate de que al menos una persona tenga siempre este rol.',
      update: {
        success: 'La lista de miembros ha sido actualizada',
        successUpdate: 'El grupo de chat se ha actualizado correctamente',
        btn: 'GUARDAR',
      },
      modal: {
        btn: 'Gestionar',
        about: 'Info',
        editRoom: 'Editar sala de chat',
        delete: 'Eliminar sala de chat',
        editMember: 'Editar miembros',
        onlyChatAdmin: 'Solo los admins de la sala de chat pueden hacer esto.',
      },
      details: {
        title: 'Detalles de sala',
        secondTitle: 'INFORMACIÓN',
        name: 'Nombre de la sala de chat',
      },
      delete: {
        success: 'La sala de chat ha sido eliminada',
      },
      create: {
        title: 'Crear sala de chat',
        name: 'Nombre de la sala de chat',
        description: 'Descripción del grupo (opcional)',
        success: 'Sala de chat creada',
        btnNext: 'SIGUIENTE',
      },
      new: 'Nuevo',
      chat: 'chat',
      inputPlaceHolder: 'Escribe un mensaje',
      searchHover: 'Buscar o iniciar un nuevo chat',
      op1: 'Archivos & Videos',
      popover: {
        title: 'Usuario desconocido',
        message: 'Ya no forma parte de esta comunidad o grupo',
      },
      op2: 'Fotos',
      files: 'Archivos',
      plusTooltip: 'Crear un nuevo chat o un chat grupal',
      emptyStatus: {
        noChatSelected: {
          firstLine: 'Selecciona una conversación para ver el chat,',
          secondLine: 'o haz clic aquí para iniciar un',
          LinkText: 'NUEVO CHAT',
        },
        noChatUser: '¿Aún no hay chats?',
        noChatSubText: 'Inicia un chat 1:1 o espera a que tu admin te añada.',
        noUnseenUser: "Don't have any unseen chat",
        sendFirstMessage: 'Escribe tu primer mensaje a {{recipient}}.',
      },
      infoPopup: {
        title: 'Límite excedido',
        message: 'Puedes subir un máximo de 20 archivos a la vez.',
      },
    },
    statistics: {
      tableType: 'Elegir un informe',
      eventReplies: 'Respuestas y tareas',
      eventTypes: 'Tipo de evento',
      appointmentSchedule: 'Calendario de citas',
      memberFigures: 'Control de asistencia',
      charts: {
        eventTypesByMonth: 'Número de citas por tipo',
        eventReplies: 'Respuestas a las opciones de respuesta',
        memberPresence: 'Número de reacciones por respuesta',
      },
      loadingStatistics: 'Cargando...',
      memberFiguresExportSuccess: {
        title: '¡Generando informe!',
        message:
          'Estamos generando tu informe de asistencia. Por la cantidad de datos, puede tardar unos minutos. Por seguridad, recibirás el informe por correo electrónico. Revisa tu bandeja de entrada. ¡Gracias por tu paciencia!',
      },
    },
    filters: {
      clickToSelect: 'Haga clic aquí para filtrar',
      showFilters: 'Mostrar filtros',
      dateRange: 'Seleccione el intervalo de fechas',
      filterBy: 'Filtrar por',
      dateRanges: {
        yearToDate: 'Año transcurrido hasta la fecha',
        lastDays: 'Últimos {{number}} días',
        lastYear: 'Último año',
        yesterday: 'Ayer',
        today: 'Hoy',
        tomorrow: 'Mañana',
        nextDays: 'Próximos {{number}} días',
        thisWeek: 'Esta semana',
        thisMonth: 'Este mes',
        thisYear: 'Este año',
        allTime: 'Todo el tiempo',
        specificDateRange: 'Intervalo de fechas específico',
      },
      downloadXlsxOrCsv: 'Descárguelo aquí: Excel o CSV',
    },
    bulkUploadEvents: {
      toastText:
        '🆕  ¡La nueva función de importación de citas ahora está disponible para cada grupo!  🎉',
      moduleTitle: 'Importación',
      step1: 'Paso 1',
      step2: 'Paso 2',
      step3: 'Paso 3',
      step4: 'Paso 4',
      stepOne: {
        stepTitle: 'Preparar importación de datos',
        stepDescription: 'Descargar plantilla de Excel',
        componentTitle: 'Descargar plantilla de Excel',
        componentDescription:
          'Complete la plantilla con los datos de su evento o utilice su propio archivo de Excel.',
        p1: 'Complete la plantilla con los datos de su evento.',
        p2: 'Los encabezados de columna deben permanecer en inglés.',
        p3: 'Los ejemplos en cada columna le muestran el formato correcto.',
        p4: 'Los nuevos tipos de eventos se agregan automáticamente.',
        p5: '<b>Importante</b>: Si utiliza su propio archivo, los siguientes títulos de columna deben copiarse exactamente como se muestran en inglés (distingue entre mayúsculas y minúsculas):',
        p6: 'Los ejemplos en cada columna de la plantilla le muestran el formato correcto.',
        p7: 'Los nuevos tipos de eventos se agregan automáticamente.',
        eventTypes: 'IR A TIPOS DE EVENTOS',
        template: 'DESCARGAR PLANTILLA',
        nextStepButton: 'CONTINUAR',
        copy: 'Copiar todo',
      },
      stepTwo: {
        stepTitle: 'CARGAR ARCHIVO',
        stepDescription: 'CARGAR ARCHIVO CSV',
        componentTitle: 'CARGAR ARCHIVO CSV',
        componentDescription:
          'Guarda el archivo de Excel como <b><u>CSV</u></b> y súbelo aquí.',
        p1: 'Comprobaremos el formato y te mostraremos una vista previa.',
        uploadButton: 'Elegir archivo',
        maximumFileSize: 'Tamaño máximo del archivo: 1 MB',
      },
      stepThree: {
        stepTitle: 'Confirmar datos',
        stepDescription: 'Vista previa de tu primer evento.',
        componentTitle: 'Confirmar datos',
        componentDescription:
          'Revisa el ejemplo y ajusta los miembros activados.\nLos miembros seleccionados se aplican a todos los eventos.',
        nextStepButton: 'CONFIRMAR Y SUBIR',
      },
      stepFour: {
        stepTitle: '¡Carga exitosa!',
        stepDescription:
          'La carga de eventos fue exitosa. Consúltalos en el calendario.',
        componentTitle: '¡Carga exitosa!',
        componentDescription: 'Se han importado <b>{{count}}</b> eventos.',
        secondTitle: 'Bueno saber',
        secondSubTitle:
          'Puede deshacer la importación o cargar una nueva lista.',
        goToScheduler: 'IR AL CALENDARIO',
        undoImport: 'DESHACER IMPORTACIÓN',
        uploadNewList: 'SUBIR NUEVA LISTA',
      },
      errors: {
        eventNameErrorTitle: 'Error de nombre del evento',
        eventNameErrorMessage:
          'Falta el nombre del evento en la fila <b><u>{{row}}</u></b>.',
        eventTypeErrorTitle: 'Error de tipo de evento',
        eventTypeErrorMessage:
          'Falta el tipo de evento en la fila <b><u>{{row}}</u></b>.',
        timeErrorTitle: 'Error de hora',
        timeErrorMessage:
          'Falta la hora de inicio o finalización en la fila <b><u>{{row}}</u></b>.',
        dateErrorTitle: 'Error de fecha',
        dateErrorMessage: 'Falta la fecha en la fila <b><u>{{row}}</u></b>.',
        locationErrorTitle: 'Error de ubicación',
        locationErrorMessage:
          'Falta la ubicación del evento en la fila <b><u>{{row}}</u></b>.',
        invalidDateOrTimeTitle: 'Fecha u hora inválida',
        invalidDateOrTimeMessage:
          'Por favor, revise el formato de fecha y hora en la fila <b><u>{{row}}</u></b>. (ej., usa HH:MM para la hora)',
      },
      commentRequired: {
        title: 'Comentario necesario',
        message: ' Por favor, escribe un breve comentario.',
      },
      deletePopupTitle: '¿Eliminar lista de eventos?',
      deletePopupMessage:
        'Esta acción eliminará permanentemente su última lista de eventos cargada. ¿Está seguro?',
      deleteSuccessTitle: '¡Eliminación exitosa!',
      deleteSuccessMessage:
        'Su última lista de eventos cargada se eliminó correctamente.',
      successMessage:
        'Validación exitosa. Continúe al siguiente paso para ver una vista previa.',
      restartProcessTitle: 'Cargar nueva lista de eventos',
      restartProcessMessage:
        'Puedes cargar una nueva lista de eventos en cualquier momento. Ten en cuenta que los eventos cargados previamente seguirán siendo visibles en el calendario. Si deseas reemplazar la lista anterior, elimínala primero o deshaz la última importación.',
      restartProcessOkButton: 'CARGAR NUEVA LISTA',
      exportDataSample: {
        event_name: 'Zurich Street Parade',
        event_type_name: 'Actuación',
        event_location: 'Bahnhofstrasse 5, 8001 Zürich',
        event_description:
          'Festival al aire libre con bandas y DJs internacionales',
      },
    },
    event: {
      noTasks: {
        title: 'Ninguna tarea',
        description:
          'Las tareas aparecerán aquí cuando un admin las cree o las active.',
      },
      noParticipants: {
        title: 'Ningún participante todavía.',
        description: 'Cuando se añada un miembro al evento, aparecerá aquí.',
      },
      noParticipantsSearchResults: {
        title: 'Ningún resultado',
        description: 'Intenta con otro término de búsqueda.',
      },
      noDocuments: {
        title: 'Ningún archivo',
        description: 'Los archivos aparecerán aquí cuando se suban.',
      },
      noSearchResults: {
        title: 'Ningún resultado',
        description: 'Intenta con otro término de búsqueda.',
      },
      event: 'Evento',
      createdAt: 'Fecha de creación',
      editEvent: 'Editar evento',
      createEvent: 'Crear evento',
      updateEvent: 'Actualizar evento',
      eventName: 'Nombre de evento',
      eventType: 'Típo de evento',
      eventDetails: 'Detalles de evento',
      eventTypeDeleted: 'Tipos de eventos eliminados',
      eventOrganizer: 'Organizador de evento',
      eventOrganizerShort: 'Organizador',
      location: 'Ubicación',
      eventTypeEdit: 'Editar el típo de evento',
      eventTypeName: 'Nombre del tipo de evento',
      eventTypeCreate: 'Crear tipo de evento',
      responseRequired: 'Respuesta requerida',
      responseName: 'Nombre de respuesta',
      responsesEdit: 'Editar respuesta',
      responsesCreate: 'Crear respuesta',
      repeatAnEvent: 'Repetir un evento',
      repeatWithInterval: 'Repetir a un intervalo',
      allDay: 'Tdo el día',
      registrationDeadline: 'Deadline de registración',
      commentRequired: 'Commentario requerido',
      editTask: 'Editar tarea',
      createTask: 'Crear tarea',
      eventTaskName: 'Nombre de tarea',
      icon: 'Ícono',
      isMemberComing: '¿Tu respuesta?',
      recurringEvent: 'Recurring event',
      allEvents: 'All events',
      thisEventOnly: 'This event only',
      createEventSuccess: 'Event was successfully created',
      updateEventSuccess: 'Event was successfully updated',
      createEventReplySuccess: 'Respuesta guardada con éxito',
      updateEventReplySuccess: 'Respuesta actualizada con éxito',
      addGuests: '¿Invitados adicionales?',
      eventOperations: {
        eventOnly: 'Este evento',
        eventAndFollowUp: 'Este evento y los siguientes',
        all: 'Todos los eventos',
        deleteText: 'Eliminar evento periódico',
        editText: 'Editar evento periódico',
        editReplyText: 'Su respuesta se aplica a',
        confirm: 'Aceptar',
      },
      dfRes: 'Establecer Respuesta Predeterminada para Todos',
      dfResInfo:
        'Esto establece la respuesta predeterminada para todos los participantes del evento. Cualquier respuesta individual existente será sobrescrita.',
      title: 'Atención',
      responseToast:
        'Si eliminas la respuesta predeterminada sin guardar una nueva, se borrarán todas las reacciones y comentarios anteriores.',
      setPreferences: 'Establecer preferencias',
      setEventDefaults: 'Establecer valores predeterminados',
      preferencesText:
        'Define las preferencias predeterminadas para los nuevos eventos de este tipo, incluida la respuesta predeterminada para los miembros',
      responseSubTitle: 'Solicitar comentario (opcional)',
      requestComment:
        'Activa esta opción para que los miembros deban dejar un comentario al elegir esta respuesta (por ejemplo, “No, sin mí” para pedir el motivo).',
      registeredUsers: 'Respuestas',
      guests: 'Invitados',
      nomination: 'Nominación',
      nominated: 'Estás nominado(a)',
      havePenalty: 'Te han marcado un penalti',
      penalty: 'Penalización',
      invitees: 'Invitados',
      awaiting: 'A la espera de',
      minutes: 'Minutos',
      hours: 'horas',
      days: 'dias',
      weeks: 'semanas',
      weekDay: 'Entre semana',
      duration: 'Duración',
      months: 'meses',
      years: 'años',
      viewAppointment: 'Ver Evento',
      myResponse: 'Mi Respuesta',
      noEvents: {
        title: 'Ningún evento visible',
        description: 'Cuando un admin te agregue, tus eventos aparecerán aquí.',
      },
      shareEvent:
        'Compartir evento - Haz clic en el ícono para copiar el evento y pegarlo donde quieras (correo, WhatsApp, etc.).',
      shareEventOption: 'Compartir el enlace de la cita',
      exportPDFOption: 'Exportar como PDF',
      deadlineExpired:
        'Es probable que el plazo de inscripción haya terminado o que el evento ya haya pasado.',
      totalInvitees: 'Total de invitados',
      responsesReceived: 'Respuestas recibidas',
      additionalGuests: 'Invitados adicionales',
      noPermissionToGiveReply: 'Usted no tiene derecho a cambiar esto',
      responsesPercentage: 'Porcentaje de respuestas',
      acceptedTasks: 'Tareas aceptadas',
      acceptedTasksByUser: 'Tareas por usuario',
      givenComments: 'Comentarios recibidos',
      givenCommentsByUser: 'Comentarios del usuario',
      optionalMessage: 'Haga clic aquí para ver las noticias.',
    },
    task: {
      createTask: 'Crear tarea',
      taskName: 'Nombre de la tarea',
      noTasks: 'Aún no hay tareas',
    },
    groupSettings: {
      title: 'Configuraciones del grupo',
      tabs: {
        general: 'General',
        eventTypes: 'Típos de evento',
        responses: 'Respuestas',
        membersManagement: 'Administración de miembros',
        other: 'Más',
      },
      deleteGroupHeader: '¿Eliminar realmente?',
      deleteGroupMessage:
        'Todos tus datos se eliminarán de forma permanente. No es posible recuperarlos.',
    },
    documentation: {
      title: 'Documentos',
      generalDocumentation: 'Documentos generales',
      uploadedFiles: 'Archivos subidos',
      chooseFile: 'Seleccionar archivo',
      tipMessage: 'Tamaño máximo de archivo subido: 50 MB',
      overview: '{{value}} GB de {{capacity}} GB usado(s)',
      uploadSuccess: 'Archivo fué subido exitosamente',
      deleteSuccess: 'Archivo fué borrado exitosamente',
      attachFiles: 'Adjuntar archivos',
      limitExceededHeader:
        'Habéis alcanzado el límite de almacenamiento para los documentos.',
      sort: {
        label: 'Ordenar por',
        nameAsc: 'Nombre (A-Z)',
        nameDesc: 'Nombre (Z-A)',
        dateOldest: 'Fecha (Más antiguo)',
        dateNewest: 'Fecha (Más reciente)',
      },
    },
    subscriptions: {
      title: 'Suscripciones',
      subscription: 'Suscripcion',
      yearly: 'Al año',
      adBlocker: {
        header: 'Desactivar bloqueador de anuncios',
        body: 'Desactiva tu bloqueador de anuncios (icono junto a la URL) para ver los precios locales. Recarga la página.',
      },
      monthly: 'Al mes',
      freeTitle: 'Prueba gratuita de 2 meses',
      freeDescription: 'Inicia tu prueba gratuita de 2 meses ahora.',
      freeText1: 'Abrir hasta <strong>30</strong> comunidades',
      freeText2: 'Acceso completo a todas las funciones',
      freeText3:
        'No se requiere tarjeta de crédito: regístrate y comienza de inmediato',
      freeText4: 'Sin renovación automática',
      freeText5: 'Sin anuncios',
      subscribe: 'SUSCRIBA',
      seeDetails: 'VEA DETALLES',
      buildCustom: 'Custom',
      month: 'mes',
      year: 'año',
      community: 'Centro de la Comunidad',
      communities: 'Centros de Comunidad',
      scheduler: 'Planificador Central de Eventos <strong>1</strong>',
      schedulers:
        'Cada uno con <strong>1</strong> Planificador Central de Eventos',
      group: 'Planificadores de Grupo para Equipos/Departamentos',
      capacity: 'Capacidad de Miembros',
      maxStorage: 'GB almacenamiento',
      classic: 'Clásico',
      classicPlus: 'Clásico+',
      popular: 'POPULAR',
      textInnerTop:
        'Elige el plan adecuado para tu equipo. Organiza en hasta {{groups}} grupos y gestiona {{members}} miembros. Actualiza o cancela cuando quieras.',
      textInnerBottom:
        'Tu suscripción es un contrato indefinido. Ventaja: Se auto-renueva anual/mensualmente. Te enviaremos un recordatorio por email. Paga con tarjeta de crédito (MasterCard, Visa) o PayPal.',
      chatsExcluded: 'Chats excluidos',
      current: 'ACTUAL',
      pay: 'PAGAR',
      usingBlocker:
        'Desactive el bloqueador de anuncios y vuelva a cargar la página',
      failedToSubscribe:
        'Pago fallido. La verificación de seguridad falló o tu tarjeta podría expirar pronto. Por favor, usa otra o inténtalo de nuevo.',
      usedGroups: 'Grupos usados',
      usedMembers: 'Miembros usados',
      usedCommunity: 'Comunidades usados',
      usedStorage: 'Almacenamiento usado',
      orderSummary: 'Resumen de pedido',
      tax: 'IMPUESTO',
      total: 'Total',
      periodEnds: 'Período pagado se expira',
      cancelSubscription: 'CANCELAR MI SUSCRIPCIÓN',
      paypalLink: 'HISTORIA DE FACTURACIÓN',
      chatEnabled: 'Chat incluido',
      chatExcluded: 'Chat excluido',
      paymentApproved: 'Pago aprobado',
      paymentError: 'Error en el pago',
      limitExceededHeader: 'Has alcanzado el límite de miembros.',
      limitExceededMessage:
        'Contacta al propietario de tu comunidad. Solo él/ella puede administrar y actualizar la suscripción.',
      limitExceededMessageOwner: 'Elige un plan para crear una comunidad.',
      inactiveSubscriptionHeader: 'Aprobación del pago pendiente',
      inactiveSubscriptionMessage:
        'Lo siento, no puede continuar con esta acción. Es posible que primero deba completar el proceso de pago.',
      subscriptionNotPaid: 'Sin plan activo',
      contactAdmin: 'Por favor, contacte con la Administración.',
      free: 'Cuenta gratuita',
      requireSubscription:
        'Gumb es gratis para miembros de comunidades activas. Crea tu propia comunidad y comienza tu prueba gratuita ahora o cambia tu plan en "Cambiar plan".',
      requireSubscriptionMember:
        'No se ha detectado ninguna suscripción válida. Aquí no tiene que hacer nada. El propietario de la comunidad, por otro lado, puede comprobar en su perfil, en "Suscripción", si la licencia para esta comunidad está activada o ampliada.',
      cancelConfirmation: '¿Está seguro de que quiere cancelar su suscripción?',
      unsubscribe: 'Cancelar',
      cancelled:
        'Cancelación confirmada. Se acaba de enviar una confirmación de cancelación a su correo electrónico. Seguirá teniendo acceso a todas las funciones hasta la fecha de liquidación pagada.',
      renewSubscriptionText:
        'Gracias.\n\nSu suscripción anterior se renovará, si la activa ahora',
      activate: 'Activar ahora',
      activated:
        '¡Tu suscripción está activa! Bienvenido/a a Gumb: nos entusiasma que ahora organicéis y planifiquéis profesionalmente con nosotros. Te hemos enviado una confirmación por email. Todas las funciones están disponibles de inmediato para tu equipo.',
      approved:
        'Preparando tu suscripción... Por favor, espera un momento (hasta 45 segundos). No actualices ni cierres la ventana del navegador durante este proceso.',
      trialActivated:
        'Tu período de prueba ha comenzado. Tú y tus administradores ya podéis empezar a planificar, invitar miembros y gestionar los ajustes.',
      cancelledTitle: 'Cancelado',
      startTrial: 'INICIA TU PRUEBA GRATUITA',
      startTrialHeader: '¡Pruébalo largoooo!',
      startTrialText:
        'Prueba todas las funciones en funcionamiento real - ¡2 meses gratis! Sin datos de pago, sin costes ocultos. Simplemente prueba sin preocupaciones con todos los miembros.',
      subscriptionExpired:
        'Esta comunidad no tiene actualmente una suscripción activa. Para añadir nuevos usuarios, es necesario renovar la suscripción. Para preguntas: support@gumb.app',
      startTrialPopupButton: 'Probar Gratis',
      paymentMethods: 'Tarjeta de crédito o Paypal',
      checkout: {
        pageTitle: 'Checkout',
        breadcrumbCheckout: 'Checkout - {{plan}}',
        stepPlanSelected: 'Plan selected',
        stepOrderSummary: 'Order summary',
        stepConfirmation: 'Confirmation',
        completeOrder: 'Complete your order',
        planInfoSub: '{{billing}} · {{count}} {{teams}}',
        planLineAnnual: '{{plan}} (annual)',
        planLineMonthly: '{{plan}} (monthly)',
        planLineSubtextAnnual:
          '{{currency}}{{price}}/year · {{days}} days remaining',
        planLineSubtextMonthly:
          '{{currency}}{{price}}/month · {{days}} days remaining',
        daysRemainingSubtext: '{{days}} days remaining',
        annualSavingLine: 'Annual billing savings',
        totalDueToday: 'Total due today',
        renewsOn: 'Renews {{date}}',
        chargedToday: 'Charged today:',
        activationInfo:
          "After payment is approved, your plan activates and you'll get a confirmation email. You can cancel anytime from subscription settings.",
        activationInfoStripe:
          'Your plan activates immediately after payment. Renews annually on the same date - cancel anytime.',
        activationInfoStripeMonthly:
          'Your plan activates immediately after payment. Renews monthly on the same date - cancel anytime.',
        includedTitle: "What's included",
        included1: 'Shared main calendar',
        included2: 'Real-time attendance',
        included3: 'Team chat & DMs',
        included4: 'Push notifications',
        included5: 'Member roles & permissions',
        included6: 'File storage & docs',
        included7: 'iOS, Android & web',
        included8: 'Analytics & CSV export',
        trustSecure: 'Secure checkout with PayPal',
        trustSecureStripe: 'Secure checkout via Stripe',
        trustCancel: 'Cancel anytime',
        trustCancelDetailed: 'Cancel anytime, no penalty',
        trustSSL: '256-bit SSL encryption',
        stripeProcessedNote: 'Pago seguro procesado por',
        completePurchase: 'Complete purchase',
        paymentMethodLegend: 'Payment method',
        payDirectTitle: 'Pay now',
        payDirectDesc: 'Charged today.',
        payInvoiceTitle: 'Invoice',
        payInvoiceDesc: 'Invoice by email.',
        invoiceHeadline: 'Pay by invoice',
        invoiceSubline: 'Bank transfer · PDF invoice to your billing email',
        invoicePanelBody:
          'We’ll send an invoice with payment details and your reference. Your subscription is activated once payment is received (typically 1-3 business days after the transfer).',
        requestInvoice: 'Request invoice',
        toBeInvoiced: 'To be invoiced',
        invoicePageNote:
          'Vuestra suscripción empieza de inmediato, independientemente del pago',
        chf: {
          title: 'Datos de facturación',
          subtitle:
            'Recibiréis una factura QR por correo. Plazo de pago 30 días.',
          name: 'Organización o nombre',
          address: 'Dirección',
          vatNumber: 'Número de IVA',
          billingEmail: 'Correo de facturación',
          optional: 'opcional',
          recipientsHint:
            'Todos los destinatarios reciben la misma factura. Dejadlo vacío para usar {{email}}.',
          total: 'Total',
          submit: 'Solicitar factura',
          activationNote:
            'Vuestra suscripción empieza de inmediato, independientemente del pago',
          invalidEmail: 'Introduce una dirección de correo válida',
          maxRecipients: 'Máximo 5 destinatarios',
        },
        invoiceTrust1: 'Invoice sent to your billing email',
        invoiceTrust2: 'Pay by bank transfer with the reference provided',
        invoiceTrust3:
          'Tu app está activa de inmediato - paga la factura cuando te convenga',
        priceSaveVsMonthly: '2 months free vs. monthly',
        planDetails: 'Plan details',
        badgeNew: 'New subscription',
        planNotInCatalog:
          'This plan isn’t available on the checkout catalog yet, or the link is outdated. Go back to Change plan and open checkout again from there.',
        backToChangePlan: 'Back to Change plan',
        invoiceYearlyOnly:
          'Invoice billing is available for annual subscriptions only. Choose yearly billing on Change plan, then return to checkout.',
        invoicePayerEmailsLabel: 'Payer / finance emails',
        invoicePayerEmailsHint:
          'We store these contacts for your records. Stripe sends the invoice to your profile email (bill to).',
        invoiceBillToProfile: 'Bill to: {{email}}',
        invoiceEmailPlaceholder: 'finance@company.com',
        invoiceAddEmail: '+ Add another email',
        invoiceRemoveEmail: 'Remove email',
        invoiceSubmit: 'Crear factura',
        invoiceSubmitting: 'Creating invoice…',
        invoiceInvalidEmails: 'Enter at least one valid email address.',
        invoiceSubmitError:
          'Could not create the invoice. Try again or contact support.',
        stripeCheckoutError: 'No se pudo iniciar el pago. Inténtelo de nuevo.',
        invoiceSuccessTitle: 'Invoice created - complete payment when ready',
        invoiceAmount: 'Amount: {{amount}}',
        invoiceOpenHosted: 'Open Stripe invoice & pay',
        invoiceHostedPending:
          'Tu suscripción está pendiente de pago. Revisa tu correo para el enlace de la factura o abre «Suscripción» en tu perfil en breve.',
        invoiceReturnBreadcrumb: 'Confirmación',
        invoiceReturnSuccessTitle: '¡Todo listo!',
        invoiceReturnSuccessSub:
          'Tu {{plan}} ya está activo. Paga la factura de Stripe cuando quieras - no necesitas esperar el pago para usar la app.',
        invoiceReturnSuccessDetailsHeading: 'Qué se ha activado',
        invoiceReturnSuccessBulletPlan:
          '{{plan}}: se han aplicado los límites de tu suscripción y la facturación.',
        invoiceReturnSuccessBulletActive:
          'Las funciones premium están disponibles de inmediato en web y móvil.',
        invoiceReturnSuccessBulletInvoice:
          'Se ha creado una factura de Stripe - ábrela abajo o revisa tu correo de facturación.',
        invoiceReturnSeeInvoice: 'Ver factura',
        invoiceReturnSeeInvoicePending: 'Enlace de factura pendiente',
        invoiceReturnGoSubscription: 'Ir a la suscripción',
        stripeReturnBreadcrumbSuccess: 'Confirmación',
        stripeReturnBreadcrumbFailure: 'Checkout cancelled',
        stripeReturnSuccessTitle: "You're all set!",
        stripeReturnSuccessSub:
          'Your {{plan}} is now active. You can start using all features immediately - no waiting, no setup delay.',
        stripeReturnPlanFallback: 'plan',
        stripeReturnSuccessDetailsHeading: "What's been activated",
        stripeReturnSuccessBulletPlan:
          '{{plan}} - your subscription limits and billing are now applied.',
        stripeReturnSuccessBulletActive:
          'Premium features are available right away on web and mobile.',
        stripeReturnSuccessBulletEmail:
          "We'll send a receipt to your billing email when payment is confirmed.",
        stripeReturnSuccessBulletGuarantee:
          '30-day money-back guarantee applies to your subscription.',
        stripeReturnSessionRef: 'Checkout reference: {{id}}',
        stripeReturnGoHome: 'Go to home',
        stripeReturnViewSubscription: 'View subscription',
        stripeReturnFailureTitle: 'Payment not completed',
        stripeReturnFailureSub:
          "You weren't charged. You can open checkout again anytime from Change plan.",
        stripeReturnFailureDetailsHeading: 'What happened',
        stripeReturnFailureBullet1:
          'Checkout was cancelled or closed before payment finished.',
        stripeReturnFailureBullet2: 'Your subscription was not changed.',
        stripeReturnTryAgain: 'Back to plans',
        stripeReturnBackSubscription: 'View subscription',
      },
      subscriptionsPopup: {
        title: 'Sin plan activo',
        subtitle:
          '<b>{{ownerName}}</b> es el propietario y puede elegir un plan. 🙌🏻',
        firstBox: {
          title: 'Elige un plan para restaurar el acceso completo para todos.',
          btnText: 'Elegir plan',
        },
        secondBox: {
          title:
            '¿Debería hacerse cargo otra persona? Podemos transferir la propiedad.',
          btnText: 'Solicitar la propiedad',
          contactMessage:
            'Quiero solicitar la transferencia de propiedad de "{{communityName}}" ({{communityId}}). Propietario actual: {{currentOwner}}. Mi correo: {{email}}.',
        },
      },
      profile: {
        legacy: {
          heading: 'Detalles de la suscripción',
          titleMembership: 'Membresía',
          titlePayment: 'Pago',
          buttonCancel: 'Cancelar membresía',
          details: {
            linkChangePlan: 'Plan de cambio',
            infoTrial:
              'La prueba está activa. Al finalizar, no se te cobrará nada. Si quieres seguir usando Gumb, elige un plan en «Cambiar plan».',
            infoTrialNew:
              'La prueba está activa. Al finalizar el {{expireDate}}, no se te cobrará nada. Si quieres seguir usando Gumb, elige un plan en «Cambiar plan».',
            linkShowCommunities: 'Mostrar a mis comunidades',
            linkHistory:
              'Historial de facturación (Recibo por email de PayPal)',
            linkChangePayment: 'Cambiar el método de pago',
            currentPlan: 'Plan actual:',
            communitiesInUse: 'Comunidades en uso:',
            groupsInUse: 'Grupos en uso:',
            membersInUse: 'Miembros en uso:',
            storageInUse: 'Almacenamiento en uso:',
            paymentCycle: 'Ciclo de pago:',
            paymentMethod: 'Método de pago:',
          },
          billing: {
            paymentInfoNote:
              'Puedes añadir los datos de pago de forma segura al suscribirte. La facturación la gestiona Stripe con cifrado.',
            securePayments: 'Pagos seguros',
            renewalNote: 'Se renueva {{date}} · {{cycle}}',
            choosePlanTrial: 'Elige tu plan',
            cancelTrial: 'Cancelar prueba',
            cancelTrialConfirm:
              '¿Finalizar la prueba gratuita? Puedes volver a suscribirte en cualquier momento desde la página de planes.',
            trustStripeNote:
              'Pagos procesados de forma segura - gestiona la facturación para facturas y recibos',
          },
        },
        page: {
          title: 'Suscripción y facturación',
        },
        confirming: {
          onboardingTitle: 'Almost there',
          onboardingHint:
            "We're syncing your payment with your account. This usually takes just a moment.",
          subscriptionTitle: 'Almost there',
          subscriptionHint:
            "We're activating your subscription. This usually takes just a moment.",
        },
        labels: {
          paymentCycleMonth: 'Mensualmente',
          paymentCycleYear: 'Anualmente',
          validUntil: 'Sigue siendo válido hasta:',
          nextPayment: 'Próximo pago:',
          infoCancelled:
            'Tu suscripción está cancelada y no se renovará. Puedes usar la app hasta la próxima fecha de pago. Puedes renovarla cuando quieras.',
          subscriptionEndedOn: 'Suscripción finalizada:',
          trialEndedOn: 'Período de prueba finalizado:',
          accessUntil: 'Acceso hasta:',
          nextInvoice: 'Next invoice:',
          lastPlan: 'Último plan',
          invoiceBillingCyclePrimary: 'Annual · Custom pricing',
        },
        hero: {
          title: 'Empieza tu prueba gratuita de 2 meses',
          subtitle:
            'Acceso completo a todas las funciones - sin tarjeta de crédito.',
          seeIncluded: 'Ver qué está incluido',
        },
        freeAccount: {
          subtitle: 'Aún no has iniciado una prueba ni una suscripción.',
          badge: 'Cuenta gratuita',
          noActivePlan: 'Sin plan activo',
          trialUnlockBlurb:
            'Inicia tu prueba gratuita de 2 meses para desbloquear el acceso completo: varias comunidades, planificadores de grupo, gestión de miembros y más.',
          trialNoteFooter:
            'Prueba gratuita de 2 meses - sin cargos automáticos después.',
          comparePlans: 'Comparar planes',
        },
        plan: {
          title: 'Plan actual',
          subtitleTrial:
            'Prueba Gumb con tranquilidad durante tu periodo de prueba.',
          subtitleActive: 'Tu plan está activo y se renueva automáticamente.',
          subtitleNonRenewal:
            'Acceso completo hasta el {{date}}. La suscripción no se renovará automáticamente.',
          subtitleStripeEnded:
            'Suscripción de pago finalizada el {{date}}. Puedes volver a suscribirte desde Cambiar plan.',
          subtitleFullyCancelled:
            'Tu suscripción a {{plan}} finalizó el {{date}}.',
          subtitleTrialExpired: 'Tu período de prueba finalizó el {{date}}.',
          badgeTrial: 'Prueba gratuita',
          badgeTrialExpired: 'Período de prueba finalizado',
          badgeCancelled: 'Cancelado',
          badgeEnded: 'Finalizada',
          badgeActive: 'Activo',
          endsOnNote:
            'Termina el {{date}}. No se cobrará nada automáticamente después.',
          footnoteStripeEnded: 'Finalizó el {{date}}. No habrá más cargos.',
          footnoteFullyCancelled: 'Cancelada el {{date}}. No habrá más cargos.',
          footnoteTrialExpired:
            'Período de prueba finalizado el {{date}}. No se ha cobrado nada.',
          footnoteRenewalCancelled:
            'Sin renovación después del {{date}}. Mantienes el acceso completo hasta entonces · {{price}}{{period}} (último plan activo) · {{billingMethod}}',
          footnoteRenewalPayment:
            'Se renueva {{date}} · {{price}}{{period}} {{billingMethod}}',
          paymentMethodChargedGeneric: 'tu método de pago registrado',
          paymentMethodChargedTo: 'cobrado a {{chargedTo}}',
          paymentMethodBilledByInvoice: 'facturado por factura',
          featureCommunities: 'Hasta {{count}} comunidades',
          featureSchedulers: 'Hasta {{count}} planificadores de grupo',
          featureMembers: 'Hasta {{count}} miembros',
          featureStorage: '{{count}} GB de almacenamiento',
          paidProFeatureExtras: [
            'Seguimiento de asistencia en tiempo real',
            'Chat de equipo, MD y notificaciones push',
          ],
        },
        statusBanner: {
          trialTitle: 'Prueba gratuita activa',
          trialBody:
            'Tu prueba termina el {{date}}. Gumb es gratis hasta entonces - no se cobrará nada automáticamente después.',
          stripeEndedRich:
            'Esta suscripción de Stripe ha finalizado. No habrá más cargos.',
          fullyCancelledTitle: 'Cancelado',
          fullyCancelledRich:
            'Tu suscripción ha sido cancelada. El acceso finalizó el {{date}}. Puedes volver a suscribirte en cualquier momento.',
          trialExpiredTitle: 'Período de prueba finalizado',
          trialExpiredRich:
            'Tu período de prueba finalizó el {{date}}. Elige un plan para mantener el acceso completo.',
          activeLabel: '{{plan}} · Activo',
          nonRenewalRich:
            'Activa hasta el {{date}} - no se renovará. Sin cargos después de esa fecha · {{price}}{{period}}',
          renewalRich:
            'Tu suscripción se renueva el {{date}} · {{price}}{{period}}',
          frequencyAnnual: 'Anual',
          frequencyMonthly: 'Mensual',
        },
        payment: {
          title: 'Pago',
          methodLabel: 'Método de pago',
          invoiceMethodTitle: 'Invoice (annual)',
          sentToBilling: 'Factura a {{email}}',
          sentToBillingLabel: 'Factura a',
          cycleLabel: 'Ciclo de facturación',
          accountManagerLabel: 'Account manager',
          lastInvoiceLabel: 'Última factura',
          lastInvoiceUnavailable: '-',
          lastInvoiceHintInvoice: 'Factura oficial en PDF',
          lastInvoiceHint: 'Factura de este pago',
          downloadInvoice: 'Descargar PDF',
          methodOnFile: 'Tarjeta registrada',
          noPaymentYet: 'Aún no se requiere pago',
          cardExpiresShort: 'Caduca {{month}} / {{year}}',
          noActiveSubscription: 'Sin suscripción activa',
          manageBilling: 'Gestionar facturación',
          manageBillingHint: 'Abre el portal de facturación seguro de Stripe',
          viewInvoices: 'Ver facturas',
          switchToInvoice: 'Cambiar a pago por factura',
          switchToCard: 'Cambiar a pago con tarjeta',
          switchToInvoiceTitle: '¿Cambiar a pago por factura?',
          switchToInvoiceBody:
            'Las facturas se enviarán a tu correo de facturación.',
          switchToInvoiceBodyBold: 'Tu tarjeta no se cobrará automáticamente.',
          switchToInvoiceConfirm: 'Cambiar a facturas',
          switchToCardTitle: '¿Cambiar a pago con tarjeta?',
          switchToCardBody: 'Tu tarjeta guardada se cobrará automáticamente.',
          switchToCardBodyBold:
            'No se enviarán facturas por correo para los próximos pagos.',
          switchToCardConfirm: 'Cambiar a pago con tarjeta',
          switchBillingReviewSubtitle:
            'Revisa el cambio a continuación antes de confirmar.',
          switchBillingChangeSummaryLabel: 'Qué cambia',
          switchBillingTimingLabel: 'Cuándo se aplica',
          switchBillingStep1Label: 'Revisar cambio',
          switchBillingStep2Label: 'Añadir tarjeta',
          switchBillingStepIndicator:
            'Paso {{current}} de {{total}} · {{label}}',
          switchBillingProcessing: 'Actualizando método de pago…',
          switchBillingRedirecting: 'Redirigiendo…',
          switchBillingFromLabel: 'Actual',
          switchBillingToLabel: 'Nuevo',
          switchBillingInvoiceLabel: 'Factura',
          switchBillingCardLabel: 'Tarjeta',
          switchBillingNextCycleNote:
            'Entra en vigor al inicio de tu próximo ciclo de facturación.\nTu periodo de suscripción actual no cambia.',
          switchBillingAddCardTitle: 'Añadir una tarjeta de pago',
          switchBillingAddCardSubtitle:
            'Un último paso para completar el cambio a pago con tarjeta.',
          switchBillingAddCardPendingLabel: 'Tarjeta requerida',
          switchBillingAddCardPendingText:
            'Se necesita una tarjeta de pago para completar el cambio.\nTu método de facturación no cambiará hasta que añadas una.',
          switchBillingAddCardNextLabel: 'Qué sigue',
          switchBillingAddCardNextText:
            'Continúa para añadir tu tarjeta de pago en la página siguiente.',
          switchBillingAddCardSecureNote:
            'Los datos de tu tarjeta se cifran y se gestionan de forma segura.',
          switchBillingAddCardGo: 'Añadir tarjeta de pago',
          switchBillingAddCardStepDone: 'Cambio confirmado',
          switchBillingAddCardStepNext: 'Añadir tu tarjeta',
          switchBillingSuccess: 'Método de pago actualizado.',
          switchBillingErrorGeneric:
            'No pudimos actualizar tu método de pago. Inténtalo de nuevo.',
          switchBillingNoPaymentMethod:
            'Añade un método de pago antes de poder cambiar.',
          switchBillingNoPaymentMethodLink:
            '<link>Gestionar facturación</link>',
          choosePaymentTitle: 'Elige un método de pago',
          choosePaymentSubtitle: '¿Cómo te gustaría continuar?',
          choosePaymentInvoiceBody:
            'Enviaremos las facturas a tu correo de facturación. No se cobra nada automáticamente.',
          choosePaymentCardBody:
            'Paga automáticamente con una tarjeta. La añadirás en la página siguiente.',
          choosePaymentConfirm: 'Continuar',
          choosePaymentConfirmInvoice: 'Usar factura',
          choosePaymentConfirmCard: 'Añadir tarjeta',
          choosePaymentRedirecting: 'Te llevamos a añadir tu tarjeta…',
          choosePaymentCardOpened:
            'Termina de añadir tu tarjeta en la nueva pestaña.',
          choosePaymentErrorNoUrl:
            'No pudimos abrir la siguiente página. Inténtalo de nuevo.',
          editRecipients: 'Editar destinatarios',
          editRecipientsTitle: 'Destinatarios de factura',
          editRecipientsSubtitle:
            'Todos los destinatarios reciben la misma factura. Déjalo vacío para usar el correo de tu cuenta.',
          editRecipientsSave: 'Guardar',
          editRecipientsSaving: 'Guardando…',
          editRecipientsError:
            'No pudimos actualizar los destinatarios de la factura. Inténtalo de nuevo.',
        },
        invoiceHistory: {
          title: 'Historial de facturación',
          subtitle: 'Facturas y recibos anteriores de tu suscripción.',
          colInvoice: 'Factura',
          colIssued: 'Fecha de emisión',
          colDue: 'Fecha de vencimiento',
          colAmount: 'Importe',
          colStatus: 'Estado',
          colDownload: 'Descargar',
          statusOpen: 'Pendiente de pago',
          statusPaid: 'Pagada',
          statusVoid: 'Anulada',
          downloadInvoice: 'Factura',
          downloadReceipt: 'Recibo',
          invoiceFallback: 'Factura {{id}}',
          issuedOn: 'Emitida el {{date}}',
          dueOn: 'Vence el {{date}}',
          noDueDate: '—',
          empty:
            'Aún no tienes facturas. Aparecerán aquí después de tu primer ciclo de facturación.',
          loadError:
            'No hemos podido cargar tu historial de facturación. Actualiza la página o inténtalo de nuevo en unos minutos.',
          paginationLabel: 'Páginas del historial de facturación',
          showingRange: '{{from}} a {{to}} de {{total}} facturas',
          previousPage: 'Página anterior',
          nextPage: 'Página siguiente',
        },
        usage: {
          title: 'Uso actual',
          lockedHint: 'Inicia una prueba para activar los límites de tu plan',
          lockedHintResubscribe:
            'Vuelve a suscribirte para restaurar los límites de tu plan.',
          lockedHintTrialExpired: 'Elige un plan para restaurar tus límites.',
          members: 'Miembros',
          atLimitMembers: 'Límite alcanzado',
          spotsRemaining: '{{count}} plazas restantes',
          communities: 'Comunidades',
          atLimitCommunities: 'Límite alcanzado',
          communitiesRemaining: '{{count}} plazas de comunidad restantes',
          schedulers: 'Planificadores de grupo',
          atLimitSchedulers: 'Límite alcanzado',
          schedulersRemaining: '{{count}} planificadores restantes',
          storage: 'Almacenamiento',
          atLimitStorage: 'Límite alcanzado - eliminar archivos o mejorar plan',
          storageRemaining: '{{count}} GB restantes',
          upgradeNudgeTitle:
            'Has alcanzado el límite de comunidades / equipos.',
          planLimitNudgeTitle: 'Has alcanzado un límite del plan.',
          upgradeNudgeBody:
            'Pásate a Premium para más equipos, más capacidad de miembros y automatizaciones y análisis.',
          planLimitNudgeBody:
            'Mejora tu plan para aumentar límites de miembros, comunidades, planificadores de grupo y almacenamiento. Compara planes y cambia cuando quieras.',
          upgradeCta: 'Mejorar',
        },
        actions: {
          choosePlan: 'Elegir plan',
          changePlan: 'Cambiar plan',
          comparePlansMenu: 'Comparar planes',
          cancelSubscription: 'Cancelar suscripción',
          dontCancelSubscription: 'No cancelar la suscripción',
          restartMembership: 'Reiniciar la afiliación',
          subscribeAgain: 'Volver a suscribirse',
        },
        trust: {
          poweredBy: 'Pagos procesados de forma segura con Stripe',
        },
      },
    },
    terms: {
      title: 'Términos & Condiciones de Gumb',
    },
    errors: {
      cantSendMessageToYourself: 'No puedes enviarte un mensaje a ti mismo.',
      downloadFail: 'Error de descarga, inténtalo de nuevo.',
      required: 'Campo requerido',
      email: 'Por favor introducza una dirección de correo electrónico válida',
      invalidEmail:
        '¡Vaya! Por favor, introduce un correo electrónico válido. Revisa si hay errores y vuelve a intentarlo.',
      integer: 'Debe ser un número entero',
      confirmPassword: 'Las contraseñas no coinciden. Inténtelo de nuevo',
      NotAuthorizedException: 'Nombre de usuario o contraseña incorrecta',
      invalidCode: 'Ese código no es válido. Inténtalo de nuevo.',
      errorToast: 'Error: {{message}}',
      invalidRequest: 'Solicitud no válida',
      passwordChanged: 'Contraseña cambiada',
      password:
        'La contraseña debe contener al menos 8 caracteres, letras en mayúsculas y minúsculas, dígitos',
      termsError: 'Por favor acepte los términos y condiciones',
      min: '{{Value}} caracteres como mínimo',
      max: '{{Value}} caracteres como máximo',
      startDate: 'La fecha no puede ser anterior al {{Value}}',
      endDate: 'La fecha no puede ser anterior a la fecha de inicio',
      fileSize: 'El tamaño del archivo es demasiado grande',
      fileSizeCustom:
        'Archivo demasiado grande: El tamaño máximo es de {{size}} MB.',
      customFileSize:
        'Archivo demasiado grande: Max {{size}}. Elíminalo e inténtalo de nuevo.',
      unsupportedFormat: 'Formato de archivo no soportado',
      postalCode: '4 dígitos como mínimo',
      sorry: 'Lo siento',
      text404: 'Parece que la página que está buscando no está disponible :(',
      url: 'Debe ser una URL válida.',
      text500: 'Algo salió mal :(',
      onlyForGroupAndAdmin: 'Función solo para admins y líderes de grupo',
      onlyForAdmin: 'Función solo para admins',
    },
    eventTypes: {
      createSuccess: 'Tipo de evento creado',
      editSuccess: 'Cambios guardados',
      deleteSuccess: 'Tipo de evento eliminado',
    },
    eventTasks: {
      createSuccess: 'Tarea creada',
      editSuccess: 'Cambios guardados',
      deleteSuccess: 'Tarea eliminada',
    },
    eventResponses: {
      createSuccess: 'Respuesta guardada',
      editSuccess: 'Cambios guardados',
      deleteSuccess: 'Respuesta eliminada',
    },
    tips: {
      registrationDeadline:
        'La fecha límite termina a la hora de inicio establecida del evento. Los miembros pueden confirmar hasta entonces. Después, solo admins y líderes de grupo pueden cambiar.',
      eventType:
        'El admin puede agregar nuevos tipos de eventos en la configuración de la comunidad.',
    },
    frequencies: {
      doNotRepeat: 'No se repite',
      daily: 'Cada día',
      weekly: 'Cada semana',
      monthly: 'Cada mes',
      yearly: 'Anualmente',
      everyWorkingDay: 'Todos los días laborables (de lunes a viernes)',
      other: 'Personalizar…',
    },
  },
  it: {
    appWidget: 'Installa Gumb sul tuo dispositivo',
    featurePopups: {
      appointmentSchedule: {
        innerHtml:
          "<h3>New feature: Download your appointment schedule as an Excel or CSV file. </h3><p>We have completely redesigned the statistics page, and you can export your entire schedule now. The new report called 'Appointmentschedule' gives you an overview of facts and figures of your events.</p><p>We are already working on another report called 'Member figures' which will be related to user performance. </p><p>The diary report is now available in the web app for all users.</p>",
        buttonOk: 'LATER',
        buttonRedirect: 'SEE NOW',
      },
      preferecePopup: {
        title: '2 New Features',
        first: {
          title: 'Set All to "Going":',
          subtitle:
            'Set the default response for new or existing events - for all participants at once!',
          link: '',
        },
        second: {
          title: 'Default Event Settings:',
          subtitle: 'Define how new events should look.',
          link: 'Instructions',
        },
      },
      appleCalendar: {
        title: 'COLLEGA IL TUO CALENDARIO (iCal)&nbsp;🍏',
        message:
          'Abbiamo fatto centro! Dopo tanto impegno, Gumb ora consente la connessione diretta del calendario nella versione WEB per una sincronizzazione senza soluzione di continuità. Resta sintonizzato per il rilascio della versione per iOS/Smartphone, disponibile&nbsp;a&nbsp;breve!',
        extraMessage: 'Apri la guida passo dopo passo',
        redirectText: 'qui',
        okButton: 'Collega ora',
        cancelButton: 'Non ora',
      },
      calendar: {
        innerhtml:
          "<h3>Ce l'abbiamo fatta!</h3> <p> È arrivata la connessione a GOOGLE CALENDAR! </p> <br/> <p> Eventi da Gumb - Ogni comunità selezionabile individualmente può ora essere trasferita automaticamente al vostro calendario. </p> <div class='images-container'> <img src='https://gumb-cdn-prod.s3.eu-central-1.amazonaws.com/featurePopups/calendar-1.png' alt='calendar-1' /> <img src='https://gumb-cdn-prod.s3.eu-central-1.amazonaws.com/featurePopups/calendar-2.png' alt='calendar-2' /></div> <p> Tutto ciò che occorre fare è spiegato in questa guida: <br/><a target='_blank' rel='noopener noreferrer' href='https://gumb.app/en/support/connect-gumb-with-google-calender/'>→&nbsp; Leggere le istruzioni complete </a> </p> <p>Guida rapida:</p> <ol> <li>Connessione e importante: selezionare la casella!</li> <li>Selezionare la comunità</li> <li>Attendere qualche minuto e ricaricare la pagina</li> </ol> <p> Collegate il vostro calendario Google per risparmiare tempo e sfruttare al meglio ogni giorno. </p>",
        buttonOk: 'NIENTE PER ME',
        buttonRedirect: 'CONNECT NOW',
      },
      notifications: {
        title: 'Come devono essere notificati i membri??',
        firstRow:
          'Abbiamo aggiunto: Impostazioni dei messaggi e delle notifiche push per cellulari.',
        secondRow:
          "Le impostazioni di notifica che gli amministratori gestiscono possono ora essere personalizzate per l'intera comunità:",
        thirdRow: 'Tutto quello che dovete fare è:',
        listFirstRow: 'Vai a Impostazioni della comunità → Notifiche.',
        listSecondRow:
          'Attivare/disattivare le opzioni di ogni categoria → per personalizzare tutto perfettamente per te. (→ Leggi le istruzioni <0>qui</0>)',
        lastRow:
          'Dì ai tuoi membri di abilitare le impostazioni push o email nel loro profilo Gumb ora.',
        buttonLater: 'Più tardi',
        buttonSettings: 'Vai alle impostazioni ora',
      },
      pushNotifications: {
        title: '📢 Comunicazione di livello superiore: notifiche push',
        message:
          "Gli amministratori e i capigruppo possono ora creare notifiche push per inviare informazioni importanti direttamente sul tuo smartphone.\n\nCosa puoi fare con le notifiche push:\n\n• <b>Condividere informazioni importanti all'istante</b> (ad es. cambiamenti di programma, emergenze)\n• <b>Raggiungere singole persone o interi team</b> (comunicazione personalizzata)\n• <b>Salvare i messaggi come modelli per risparmiare tempo</b> (comunicazione efficiente)",
        extraMessage:
          'Rimani sempre aggiornato e non perderti più nessuna novità!',
        cancelButton: 'Vedi dopo',
        okButton: 'Prova ora',
        newMessageOne:
          'Gli amministratori e i capigruppo possono ora comunicare direttamente con singole persone o interi team per inviare informazioni importanti direttamente sul tuo smartphone.\n\n',
        redirectLink: 'Cree notificaciones push personalizadas',
        newMessageTwo:
          ', seleziona i destinatari e salva anche i tuoi messaggi come modelli per un utilizzo successivo.',
      },
      importEvent: {
        title: 'Upload/Import Events ',
        subText:
          "No more manual entry! Easily import your events with a CSV or Excel file. Whether it's 30 or 300 events - it's quick and can even be undone if there are mistakes.",
        cancelButton: 'View later',
        okButton: 'Try now',
        secondText: 'Find step-by-step instructions',
      },
      mail: {
        title: 'Nuova funzione: MAIL MODE',
        firstRow:
          'La funzione e-mail integrata semplifica e velocizza la comunicazione del team. Avete urgente bisogno di inviare un\'e-mail a tutti? Ma solo ai membri che hanno risposto "Sì" alla nomina? → Ora è possibile con pochi clic!',
        secondRow:
          'La modalità mail è ora disponibile nella web app per gli amministratori e i capigruppo. Sarà ulteriormente ampliato nel prossimo periodo.',
        thirdRow:
          'Per saperne di più: <0>https://gumb.app/support/mailmodus/</0>',
        buttonLater: 'VISUALIZZA PIÙ TARDI',
        buttonMail: 'ORA',
      },
      eventPdf: {
        title: 'Nuova funzione: Scaricare la nomina come PDF',
        firstRow:
          "Risparmia tempo ora e stampa i dettagli dell'evento con un solo clic!",
        secondRow:
          "Poco prima dei prossimi eventi, o anche per gli eventi passati, tutti i dettagli dell'evento, comprese tutte le statistiche di risposta, possono essere esportati in PDF.",
        thirdRow:
          'Prerequisito pianificatore di appuntamenti: hai i diritti di amministratore',
        fourthRow:
          'Prerequisito del pianificatore del gruppo: sei un capogruppo',
        fifthRow: 'La funzione è ora disponibile nella web app.',
      },
    },
    menu: {
      homePage: 'PAGINA INIZIALE',
      subscriptions: 'Abbonamenti',
      groupScheduler: 'CALENDARIO',
      documentation: 'DOCUMENTI',
      chats: 'CHAT',
    },
    dayOfWeek: {
      day1: 'LUN',
      day2: 'MAR',
      day3: 'MER',
      day4: 'GIO',
      day5: 'VEN',
      day6: 'SAB',
      day0: 'DOM',
    },
    status: {
      taskInactive: '= Non attivata',
      notActivated: '= Non attivato',
      awaitingReply: '= In attesa',
      taskInactiveDesc:
        'Questa attività è disattivata - i membri non la vedono.',
      notActivatedDesc:
        'Questa persona non è attivata per l’evento - non lo vede (casella bianca).',
      awaitingReplyDesc:
        'L’evento è visibile, ma non è stata ancora data risposta.',
      notActivatedAction:
        'Clicca sull’evento → Modifica → Partecipanti → spunta la casella → Salva',
      taskInactiveAction:
        'Clicca sull’evento → Modifica → Attività → spunta la casella → Salva',
      awaitingReplyAction: 'Tocca la cella → Scegli una risposta → Salva',
    },
    email: {
      sender: 'Mittente',
      recipients: 'Destinatari',
      otherRecipients: 'Altri destinatari (separare con la virgola)',
      subject: 'Oggetto',
      message: 'Messaggio',
      attachCommunityDocs: 'Allegare documenti della comunità',
      plusTooltip: 'Scrivi una nuova email',
      emailSentSuccessfuly:
        'Email inviata. Attenzione: si trattava di un’email no-reply, il destinatario non può rispondere direttamente, ma il tuo indirizzo mittente è visibile.',
      emailSent: {
        title_one: '📤 Email inviata a {{count}} destinatario',
        title_other: '📤 Email inviata a {{count}} destinatari',
        message:
          'Se qualcuno risponde, il messaggio arriva direttamente nella tua casella.',
      },
      sendCopy: 'Inviami una copia',
      maxAttachmentsSize: 'Dimensione totale allegati max 15 MB',
      changeEmail: {
        title: 'Email di conferma inviata',
        message:
          'Ti abbiamo inviato un’e-mail con un link di conferma per il tuo nuovo indirizzo. Controlla la posta in arrivo e clicca sul link per confermare la modifica. Se non la ricevi entro pochi minuti, controlla la cartella spam. Per domande siamo a tua disposizione.',
      },
    },
    pushNotification: {
      header: 'Notifiche Push',
      filterByRecipient: 'Seleziona destinatari',
      filterByResponse: 'Seleziona destinatari per risposta',
      pushMessage: 'Crea push',
      saveAsTemplate: 'Salva come modello',
      sendCopy: 'Invia copia anche a me',
      pasteUrl: '🌐 Evento o link esterno?',
      plusTooltip: 'Crea una nuova notifica push',
      toasterText:
        '🆕 Nuova funzione: Ora puoi aggiungere un link esterno, come qualsiasi sito web 🌐 (URL), alle notifiche push!\nInvia i destinatari direttamente al sito web.',
      templates: 'Modelli',
      title: 'Titolo',
      lastUsed: 'Ultimo utilizzo',
      noTemplates: 'I modelli salvati vengono visualizzati qui',
      template: 'Modello',
      sendConfirmHeader: 'Verifica prima di inviare',
      totalRecipients: 'DESTINATARI',
      redirectLink: 'AL LINK',
      successTitle: 'Notifica inviata!',
      successMessage:
        'Il tuo messaggio è stato inviato a <b>{{totalRecipients}}</b> destinatari.',
      selectEventFirst: 'Seleziona prima un evento',
      templateLimitTitle: 'Limite modelli raggiunto',
      templateLimitInfo:
        'Salva fino a 8 dei tuoi messaggi come modelli da riutilizzare in seguito. Abbiamo già aggiunto 3 modelli per ispirarti: sentiti libero di modificarli o eliminarli.',
      templateLimitMessage:
        'Hai raggiunto il numero massimo di modelli. Elimina un modello per crearne uno nuovo.',
      urlInfo:
        'Qui puoi aggiungere link a qualsiasi sito web, ad esempio una pagina prodotto, un articolo o altro che vi interessa. Inserisci l’URL completo (incluso https://).',
      urlInfoOne:
        'Qui puoi inserire qualsiasi sito web esterno (URL), così i destinatari vi accedono direttamente. Se selezioni un evento sopra, l’app aggiunge il link dell’evento e la notifica push apre direttamente l’evento in Gumb.',
      urlInfoTwo:
        'Prossimamente: aggiungi qualsiasi link esterno (tranne Gumb) alle tue notifiche push! Link a siti web, notizie e altro ancora. Resta&nbsp;sintonizzato!',
      urlTooltip:
        'Puoi creare una notifica push con o senza collegamento a un evento. Vuoi condividere il link del tuo evento? Seleziona semplicemente un evento sopra per copiarlo automaticamente qui.',
    },
    common: {
      noResultsFound: 'Nessun evento precedente disponibile',
      logoutTooltip: 'Esci',
      ctrl: 'Mostra/nascondi i totali',
      nextDay: '+1g',
      createdAt: 'Creato il',
      updatedAt: 'Aggiornato il',
      onlyAdmin: 'Solo gli admin possono utilizzare questa funzione.',
      download: 'Scarica',
      attachFile: 'Allega file',
      new: 'Nuovo',
      unseen: 'Non visti',
      more: 'Più',
      less: 'Meno',
      sunday: 'Domenica',
      monday: 'Lunedì',
      tuesday: 'Martedì',
      wednesday: 'Mercoledì',
      thursday: 'Giovedì',
      friday: 'Venerdì',
      saturday: 'Sabato',
      january: 'Gennaio',
      february: 'Febbraio',
      march: 'Marzo',
      april: 'Aprile',
      may: 'Maggio',
      june: 'Giugno',
      july: 'Luglio',
      august: 'Agosto',
      september: 'Settembre',
      october: 'Ottobre',
      november: 'Novembre',
      december: 'Dicembre',
      overallScheduler: 'Calendario',
      selectEvent: 'Seleziona evento (opzionale)',
      displayEventsFrom: 'Visualizza gli eventi da',
      modalExit: 'Sei sicuro di voler uscire senza salvare i tuoi dati?',
      all: 'Tutti',
      tooltipEdit: 'Modifica membro',
      tooltipDelete: 'Rimuovi membro',
      overview: 'Panoramica',
      cancel: 'Annulla',
      removeLogo: 'Sei sicuro di voler eliminare questo elemento?',
      noTasks: 'Nessun compito ancora',
      noUsers: 'Nessun utente ancora',
      noOptions: 'Nessuna opzione',
      role: 'Ruoli',
      admin: 'Amministratori',
      member: 'Membri',
      group_lead: 'Leader gruppi',
      email: 'Email',
      groups: 'Gruppi',
      logoutHeader: 'Disconnessione?',
      logoutMessage: 'Verrai reindirizzato alla schermata di accesso.',
      deleteHeader: "Sei sicuro di voler cancellare l'utente?",
      logout: 'Disconnetti',
      delete: 'Eliminare',
      tablePlaceholder: 'Nessun membro da mostrare al momento',
      contentPlaceholder: 'Nessun contenuto da mostrare al momento',
      create: 'Creare',
      copy: 'Copiare',
      visible: 'Visibile',
      saveChanges: 'Cambi salvati',
      newField: 'Nuovo campo',
      fieldName: 'Nome del campo',
      addField: 'Aggiungere campo',
      notifications: 'Notifiche',
      participants: 'Partecipanti',
      tasks: 'Compiti',
      documentation: 'Documenti',
      description: 'Descrizione',
      facebook: 'Facebook',
      twitter: 'X',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      youtube: 'YouTube',
      startDate: "Data d'inizio",
      startTime: "Ora d'inizio",
      startDateTime: 'Data/ora di inizio',
      endDateTime: 'Data/ora di fine',
      endDate: 'Data di fine',
      endTime: 'Ora di fine',
      icon: 'Icona',
      sendMessage: 'Invia messaggio',
      aboutMe: 'Su di me',
      selectAll: 'Selezionare tutto',
      approve: 'Approvare',
      reject: 'Rifiutare',
      backToGumb: 'Tornare a Gumb',
      edit: 'Modificare',
      addComment: 'Aggiungere commento',
      answer: 'Salva',
      ok: 'Ok',
      withoutGroup: 'Senza gruppo',
      copyLink: 'Copia link',
      copied: 'Copiato',
      sendInviteLink: 'Invia link di invito',
      apply: 'Applica',
      from: 'Da',
      to: 'A',
      enable: 'Abilita',
      search: 'Cerca',
      color: 'Colore',
      columns: 'Colonne sbiadite',
      hiddenColumns: 'Colonne nascoste',
      sorryNoResults:
        'Siamo spiacenti che non sia stato possibile trovare ciò che stavi cercando. Si prega di provare in un altro modo.',
      tutorial: 'Istruzioni',
      next: 'Avanti',
      back: 'Indietro',
      step: 'Fase',
      createSuccess: {
        title: 'Creata',
        message: 'La tua opzione è stata creata con successo.',
      },
      editSuccess: {
        title: 'Modificata',
        message: 'Le tue modifiche sono state salvate.',
      },
      deleteSuccess: {
        title: 'Cancellata',
        message: "L'opzione è stata rimossa con successo.",
      },
      toolTipText: {
        grid3x3: 'Matrice: assegnare membri alle comunità',
        faq: 'Aiuto: Guide, Contatto, Altro.',
        communityPlusIcon: 'Crea una nuova community',
        logoGumb:
          'Mistero in preparazione: Scoprite più tardi cosa nasconde questo pulsante!',
        memberPlusIcon: 'Aggiungi nuovo membro',
        memberArrowIcon: 'Vai alla panoramica membri',
        eventType: 'Crea tipo di evento',
        responses: 'Crea opzione di risposta',
        task: 'Crea attività',
        schedulerPlusIcon: 'Crea evento o gruppo',
      },
      shareEventTitle: 'Condividi il link dell’evento via:',
      copyEventLink: 'Oppure copia il link:',
    },
    auth: {
      signInWith: 'Accedi con',
      continueAs: 'Continua come',
      create: 'Crea un account gratuito',
      signUp: 'Registrati',
      signIn: 'Accedi',
      welcome: 'Benvenuto!',
      createAccount: 'Creare conto gratuito',
      forgotPassword: 'Password dimenticata?',
      resetPassword: 'Resetta la password',
      resetPasswordTooltip:
        'Se reimposti la password, il membro riceverà un’email con le istruzioni per impostarne una nuova. Per gli account creati con Facebook, Google o Apple, Gumb non può reimpostare la password. Il membro può comunque accedere tramite l’icona social corrispondente.',
      resetPasswordModalTitle: 'Reimpostazione della password avviata',
      resetPasswordModalText:
        'Il membro riceve ora un’email per cambiare la password. Per Facebook, Google o Apple, può accedere come sempre con l’icona.',
      resetPasswordErrorModalTitle:
        'Reimpostazione della password non possibile',
      resetPasswordErrorModalText:
        'Attenzione: Questo membro accede tramite Facebook, Google o Apple. Gumb non può reimpostare la password. Se il membro ha dimenticato la password, deve reimpostarla direttamente dal provider. L’accesso tramite icona social funziona comunque. Per favore, informa il membro.',
      terms: {
        '0': 'Accetto le',
        '1': 'Condizioni',
        '2': ' e la',
        '3': 'Politica sulla Privacy',
      },
      termsAcknowledgement:
        'By continuing, you acknowledge that you understand and agree to the <0>Terms & Conditions</0> and <1>Privacy Policy</1>.',
      home: 'Inizio',
      confirmed: 'Email confermata con successo',
      verifying: 'Verificando la email...',
      recovery: 'Recupera password',
      send: 'Invia',
      codeSended:
        'Il link di verifica è stato inviato alla tua email. Controlla e conferma. Guarda anche nella cartella spam.',
      signUpSuccess:
        "Iscritto con successo. Per favore controlla la tua email per confermare l'iscrizione",
      inviteSentTitle: 'Invito inviato con successo',
      inviteSentText:
        'Fatto! Membro aggiunto e invito con password temporanea inviato (controlla anche nello spam). Il membro può ora accedere e cambiare la password. Ricarica la pagina per aggiornare la lista dei membri. Tu e gli admin potete ora modificare gruppo, ruolo o profilo del membro.',
      reset: 'Ripristinare',
      yourEmail: '{{value}} è già il tuo indirizzo email',
      existEmail: '{{value}} esiste già',
      labels: {
        email: 'Email',
        currentEmail: 'Email corrente',
        newEmail: 'Nuova email',
        password: 'Password',
        oldPassword: 'Vecchia password',
        newPassword: 'Nuova password',
        confirmPassword: 'Conferma password',
      },
      accountExists:
        'Questo indirizzo e-mail è già utilizzato per un account Gumb. Se questa e-mail è vostra, fate clic su Password dimenticata e controllate la posta in arrivo e la cartella spam.',
      codeExpired:
        "Si trattava di un link scaduto. Dopo aver inserito il vostro indirizzo e-mail, vi invieremo un'e-mail con un nuovo link per completare la verifica del vostro account.",
      userNotConfirmed:
        "È comunque necessario verificare il proprio account. Vi abbiamo inviato un'e-mail con un link di conferma. Se non avete ricevuto l'e-mail, controllate la cartella spam della vostra casella di posta elettronica. ",
      invalidCredentials: 'Nome utente o password non corretti',
      userNotFound:
        'Questa email non è ancora registrata o è collegata a Google, Apple o Facebook. Non cambiare la password social in Gumb, ma accedi con l’icona corrispondente.',
      socialLoginDetected: {
        title: 'Accesso social rilevato',
        message:
          'Questa email sembra collegata a Google, Apple o Facebook. La password viene gestita lì, non su Gumb. Per accedere, clicca semplicemente sull’icona social corrispondente.',
      },
    },
    profile: {
      editSuccess: 'Modifiche salvate',
      settings: 'Impostazioni',
      editProfile: 'Modifica profilo',
      selectImage: 'Seleziona immagine',
      myProfile: 'Il mio profilo',
      profileEditBtn: 'AGGIUNGI I TUOI DATI: INDIRIZZO, SOCIAL E ALTRO',
      basicInformation: 'Info base',
      contactInformation: 'Contatto',
      addressInformation: 'Indirizzo',
      myCommunities: 'Le mie comunità',
      myChat: 'I MIEI CHATS',
      freeText1: 'Testo Libero 1',
      freeText2: 'Testo Libero 2',
      myAppointments: 'I miei appuntamenti',
      subscription: 'Abbonamento',
      userProfile: 'Profilo utente',
      tellUsAboutYourself: 'Su di me',
      firstName: 'Nome',
      lastName: 'Cognome',
      profileName: 'Nome utente',
      person: 'Persona',
      role: 'Ruolo utente',
      email: 'Email',
      dateOfBirth: 'Data di nascita',
      privatePhoneNumber: 'Tel (Privato)',
      officePhoneNumber: 'Tel (Lavoro)',
      mobilePhoneNumber: 'Tel (Cellulare)',
      street: 'Via',
      region: 'Regione',
      postalCode: 'Codice postale',
      city: 'Città',
      country: 'Paese',
      about: 'A proposito di',
      linkChangeEmail: "(Cambiare l'e-mail)",
    },
    profileCommunities: {
      empty: {
        title: 'Nessuna community visibile',
        description:
          'Quando crei le tue community o entri in altre,<brPure />le vedrai qui.',
      },
      popupLeave: {
        title: 'Sei sicuro di voler lasciare la community?',
        button: 'Lascia',
      },
      leaveCommunity: {
        title: 'Sei sicuro di voler lasciare la community?',
        message:
          'Lasci solo questa community. Il tuo account resta e puoi unirti ad altre quando vuoi.',
        okButton: 'Sì, Lascia',
        cancelButton: 'Annulla',
      },
    },
    profileSettings: {
      title: 'Impostazioni profilo',
      notification: 'Notifica',
      notificationsPlaceholder: 'Non hai ancora notifiche',
      changePassword: 'Cambia password',
      changeEmail: 'Email',
      saveNewEmail: 'Salva la nuova email',
      language: 'Lingua',
      timeFormat: 'Formato orario',
      permissions: 'Autorizzazioni',
      allowedToEdit: 'Gli amministratori possono modificare il mio profilo',
      other: 'Altro',
      pushNotification: 'Notifica push',
      receiveByEmail: 'Ricevi le notifiche via email',
      receivePush: 'Ricevere le notifiche push da mobile',
      receiveInApp: 'Ricevi notifiche in-app',
      terms: 'Termini e condizioni',
      protectionRegulation: 'Politica sulla privacy',
      deleteAccount: 'Eliminare conto',
      logout: 'Disconnettere',
      deleteProfileHeader: 'Sicuro di voler eliminare il tuo account?',
      notifications: {
        now: 'Adesso',
        hours: '{{value}} ore fa',
        minutes: '{{value}} minuti fa',
        minute: '1 minuto fa',
      },
    },
    calendarConnection: {
      outlookCalendar: 'Outlook Calendar',
      googleCalendar: 'Google Calendar',
      pageTitle: 'Connessione al calendario',
      connectTitle:
        'Collega il calendario\ne sincronizza gli eventi in automatico',
      connectDescription:
        'Gumb crea eventi per te: compaiono automaticamente nel tuo calendario.',
      appleCalendar: 'Calendario Apple',
      appleConnectionSteps: {
        headerOne:
          'Aggiungi eventi Gumb al tuo calendario (Apple o Outlook) tramite un URL iCal - in 4 passaggi.',
        demoLinks: 'Demo veloce',
        demoLinksApple: 'Apple',
        demoLinksAppleHere: 'qui',
        demoLinksDetailed: 'Guida dettagliata',
        demoLinksDetailedApple: 'Apple',
        demoLinksDetailedHere: 'qui',
        demoLinksOutlook: 'Outlook',
        demoLinksOutlookHere: 'qui',
        stepOne: 'Nella tua app calendario, aprire',
        stepOneSubscribeBold: 'Iscriviti a calendario',
        stepOneApplePrefix: 'Apple',
        stepOneAppleSuffix: 'File → Nuova iscrizione calendario',
        stepOneOutlookPrefix: 'Outlook',
        stepOneOutlookSuffix:
          'Aggiungi calendario → Da Internet / Calendario sottoscritto',
        stepTwo: 'Copiare il link iCal della community e incollarlo',
        stepThree: 'Assegnare un nome e, se vuoi, un colore',
        stepFour:
          'Impostare posizione (iCloud, Mac, Outlook) e aggiornamento, confermare',
      },
      appleConnectionPopup: {
        title: 'Come collegare?',
        stepOne: 'Copia il link della community',
        stepTwo:
          'Nel tuo Calendario Apple, seleziona "Calendario", poi "File" > "Nuovo abbonamento al calendario".',
        stepThree:
          'Inserisci il link iCal della Community copiato, poi clicca su "Iscriviti".',
        stepFour:
          'Nomina il calendario, scegli un colore, imposta preferenze come posizione (iCloud o Mac) o aggiornamento automatico e clicca "OK".',
      },
      appleDisconnectPopup: {
        title: 'Conferma Disconnessione',
        message:
          'Cliccando su "Sì, disconnetti ora" rimuoverai tutti gli eventi Gumb dal/dai tuo/i calendario/i. Si prega di cancellare manualmente il/i calendario/i in seguito, altrimenti rimarrà/rimarranno visibile/i.\n\n<b>Per disiscriverti completamente:</b>\n\n• <b>Su macOS</b>: Apri Calendario, clicca con il tasto destro sul calendario > "Annulla sottoscrizione".\n• <b>Su iOS</b>: Vai su "Calendari", tocca il pulsante "Info" accanto al calendario > "Elimina Calendario".',
        okButton: 'Sì, disconnetti ora',
      },
      appleUncheckBoxPopup: {
        title: 'Conferma Disconnessione',
        message:
          'Cliccando su "Sì, disconnetti ora" rimuoverai tutti gli eventi Gumb dal tuo calendario. Si prega di cancellare manualmente il calendario in seguito, altrimenti rimarrà visibile.\n\n<b>Per disiscriverti completamente:</b>\n\n• <b>Su macOS</b>: Apri Calendario, clicca con il tasto destro sul calendario > "Annulla sottoscrizione".\n• <b>Su iOS</b>: Vai su "Calendari", tocca il pulsante "Info" accanto al calendario > "Elimina Calendario".',
        okButton: 'Sì, disconnetti ora',
      },
      connectWithApple: 'Connetti Apple e Outlook (iCal)',
      cantSeeICal: 'Non vedi il link iCal? Basta spuntare la casella.',
      syncTip:
        'Solo gli eventi della comunità selezionata saranno sincronizzati con il vostro calendario.',
      connect: 'Collegare',
      connected: 'Associato',
      disconnect: 'Disconnettersi',
      disconnectSuccess: 'Disconnessione riuscita',
      selectCommunities: 'Selezione delle comunità',
      selectCommunitiesDescription:
        'Solo gli eventi della comunità selezionata saranno sincronizzati con il vostro calendario.',
      authSuccessTitle: 'Connessione riuscita',
      authSuccessMessage:
        'I tuoi eventi si stanno sincronizzando automaticamente. Attendi un attimo e poi ricarica Google Calendar per completare la prima sincronizzazione.',
      authSuccessTitleTwo: 'Seleziona la tua community ora',
      authSuccessMessageTwo:
        'Tocca il segno di spunta e premi "Salva modifiche" per confermare.',
      syncSuccess:
        'Aggiornato!\nSincronizzazione automatica attiva. Gestisci le tue comunità quando vuoi.',
      syncSuccessTitle: 'Quasi pronto!',
      syncSuccessMessage:
        'Stiamo collegando la tua community al tuo Google Calendar. Ci vorranno solo 2-3 minuti. Aggiorna la pagina di Google Calendar per vedere gli aggiornamenti.',
      disconnectConfirmTitle: 'Siete sicuri?',
      disconnectConfirmDescription:
        'Se ci si disconnette, tutti gli eventi verranno rimossi dal calendario.',
      disconnectConfirm: {
        title: 'Disconnettere ora?',
        message:
          'La disconnessione rimuoverà tutti gli eventi dal tuo Google Calendar. Non preoccuparti, puoi ricollegare Gumb per una nuova sincronizzazione in qualsiasi momento.',
        cancelButton: 'Annulla',
        okButton: 'Sì, Disconnetti',
      },
      noCommunities:
        'Non ci sono comunità da selezionare.\nAspettate che un amministratore vi aggiunga.',
      checkboxWarning: 'ATTENZIONE: il segno di spunta deve essere impostato!',
    },
    community: {
      noMembersEmptyState: {
        title: 'Nessun membro registrato',
        description: 'Quando i membri si iscriveranno, appariranno qui.',
      },
      plusIconSubText: 'Pianifica un evento o crea serie di eventi.',
      selectAllCommunityAdmins: 'Tutti gli amministratori',
      selectAllGroupAdmins: 'Tutti i capigruppo',
      createSuccess: 'La comunità è stata creata con successo',
      createFailure: 'Riprova tra un attimo a creare la tua comunità.',
      deleteSuccess: 'La comunità è stata eliminata con successo',
      leaveSuccess: 'Hai lasciato con successo la comunità',
      descriptionTitle: 'A proposito della comunità',
      descriptionPlaceholder: 'Qui puoi descrivere la tua comunità',
      online: 'Online',
      updateCommunity: 'Aggiorna comunità',
      members: 'Membri',
      createCommunity: 'Creare comunità',
      communityName: 'Nome della comunità',
      category: 'Categoria',
      aboutCommunity: 'A proposito della comunità',
      selectLogo: 'Seleziona logo',
      selectLogoTip: 'jpg, jpeg, png (5MB)',
      chooseCover: 'Seleziona cover',
      chooseCoverTip: 'jpg, jpeg, png (20MB)',
      website: 'Sito web',
      partnership: 'Partenariato',
      deleteCommunity: 'Elimina comunità',
      deleteHeader: 'Sei sicuro di voler rimuovere questo utente dal gruppo?',
      addMembers: 'Aggiungi membri',
      invitationLink: 'Link di invito',
      communityRole: 'Ruolo nella comunità',
      joinCommunity: 'Raggiungi comunità',
      namePlaceholder: 'La team di {{value}}',
      requestSent: 'Richiesta di adesione inviata con successo',
      requestSentButton: 'Richiesta di adesione inviata',
      limitExceededHeader:
        'Hai raggiunto il limite di comunità del tuo piano. Per crearne di più, aggiorna il tuo piano in Profilo > Abbonamento.',
      limitExceededMessage:
        "Contatta il proprietario della tua comunità. Solo lui/lei può gestire e aggiornare l'abbonamento.",
      limitExceededMessageOwner:
        'Per favore, vai a Profilo > Abbonamento per gestire il tuo piano e aggiornarlo se necessario.',
      updateFailure: "Fallimento dell'aggiornamento della comunità",
      buttonAddEvent: 'Aggiungi evento',
      userBlockedTitle: 'Bloccato',
      userBlockedText:
        'Sembra che qualcuno ti abbia bloccato su questa comunità. Gli amministratori possono bloccare o sbloccare i membri.',
      createOverLimitTitle: 'Limite comunità raggiunto',
      createOverLimitText:
        "Avvia la tua prova gratuita o scegli un abbonamento in 'Modifica piano' per organizzare la tua comunità.",
      notInvitedTitle: 'Nessun permesso',
      notInvitedText:
        "Potresti non avere il permesso di accedere a questo evento. Gli amministratori e i capigruppo possono aggiungerti all'evento.",
      noRequestsTitle: 'Ancora nessuna richiesta in sospeso.',
      noRequestsText:
        'Quando le persone inviano richieste per la tua comunità, queste saranno visualizzate qui perché tu possa esaminarle.',
      invitationCodeExpired:
        'Questo è un link di invito scaduto. Ma ora è possibile inviare una richiesta di adesione, che gli amministratori possono accettare o rifiutare.',
      communityNotFound: 'Comunità non trovata',
      communityPopup: {
        title: 'Crea Evento o Gruppo',
        subTitleOne:
          'Pianifica eventi nel PIANIFICATORE centrale. Usa i gruppi per dividere i membri in squadre.',
        createEvent: {
          infoText:
            "Programma eventi per tutti o per gruppi/membri specifici nel PIANIFICATORE. Visibile nel pianificatore, sotto 'I Miei Eventi' e nei gruppi.",
          btntitle: 'Crea Evento',
          linkText: 'Tutorial',
        },
        createGroup: {
          infoText:
            'Ogni gruppo ha il proprio pianificatore, con eventi visibili solo ai membri del gruppo. Gestisci i ruoli dei membri efficacemente',
          btntitle: 'Crea Gruppo',
          linkText: 'qui',
        },
        chatTitle: 'Opzioni chat',
        chatSubTitle: 'Avvia una chat 1:1 o crea una stanza chat per gruppi.',
        oneToOne: {
          infoText:
            "Clicca sull'icona della chat accanto al nome di un membro o sulla sua immagine del profilo per inviare un messaggio.",
          btntitle: 'Vai alla lista membri',
          linkText: 'Tutorial',
        },
        createChatGroup: {
          infoText:
            'Crea una stanza chat privata per membri selezionati, team o gruppi. Solo gli amministratori possono creare queste stanze.',
          btntitle: 'Crea una stanza chat',
          linkText: 'qui',
        },
      },
      exportStatistics: 'Esportazione delle statistiche',
      exportStatisticsTooltip: 'Esportare le statistiche in un file CSV',
    },
    communitySettings: {
      noMatrixData: {
        title: 'Nessuna community visibile',
        description:
          'Quando un proprietario crea delle community e ti rende admin, potrai assegnare qui i membri.',
      },
      noSearchResults: {
        title: 'Nessun risultato',
        description:
          'Nessun risultato per {{searchResult}}. Prova con un altro termine di ricerca.',
      },
      clearSearch: 'Cancella ricerca',
      matrixDescription:
        'Assegna/rimuovi membri alle tue comunità con un clic - salva subito.<brPure />Ideale per cambi di stagione e di squadra e per assegnazioni multiple.',
      matrix: 'Matrice',
      tooltip:
        'Vai alla vista Matrice: assegnare/rimuovere membri alle comunità.',
      admin: 'Amministratore',
      member: 'Membro',
      blocked: 'Utente bloccato',
      owner: 'Proprietario',
      group_lead: 'Amministratore del gruppo',
      group_admin: 'Leader del gruppo',
      chat_admin: 'Admin chat',
      community_admin: 'Amministratore della comunità',
      editRoleSuccess: 'Il ruolo è stato cambiato con successo',
      deleteUserSuccess:
        "L'utente è stato eliminato con successo dalla comunità",
      removeUser: {
        title: 'Sei sicuro di voler rimuovere questo utente?',
        message:
          'Quando rimuovi questo utente, verrà rimosso dalla tua community, ma conserverà il suo account utente e potrà comunque partecipare ad altre community.',
        cancelButton: 'Annulla',
        okButton: 'Sì, Rimuovi',
      },
      removeUserSuccess: {
        title: 'Utente rimosso',
        message: "L'utente è stato rimosso con successo dalla tua community.",
      },
      editSuccess: 'Le modifiche sono state aggiornate con successo',
      title: 'Impostazioni comunità',
      backToSubscriptionsDetails: "Torna ai dettagli dell'abbonamento",
      tabs: {
        general: 'Preferenze generali',
        eventTypes: 'Tipi di evento',
        subscriptions: 'Sottoscrizioni',
        responses: 'Opzioni di risposta',
        roles: 'Membri',
        requests: 'Richieste',
        other: 'Altro',
        tasks: 'Compiti',
      },
      addMember: 'Aggiungi membro',
      exportMembers: 'Esportare',
      exportMembersTooltip: "Esportare l'elenco dei membri in un file CSV",
      deleteCommunityHeader: 'Eliminare davvero?',
      deleteCommunityMessage:
        'Tutti i vostri dati verranno eliminati definitivamente. Non è possibile recuperarli.',
      defaultEventList: [
        '🤝🏻🏻 Incontro 🤝🏻🏻',
        '📅 Evento 📅',
        '📋 Riunione 📋',
        '📝 Riunione del consiglio 📝',
        '🚌 Gita 🚌',
        '🛠️ Workshop 🛠️',
        '⏰ Turno ⏰',
        '🏢 Evento aziendale 🏢',
        '🏃 Allenamento 🏃',
        '🏆 Torneo 🏆',
        '🎶 Prova 🎶',
        '🔴 ANNULLATO 🔴',
        'ℹ️ Info ℹ️',
        '📊 SONDAGGIO 📊',
      ],
      defaultResponsesTypes: [
        'Partecipo ✅',
        'Non posso venire ❌',
        'Non sono ancora sicuro 🟨',
      ],
      defaultTasks: ['Chi guida?', 'Chi porta da bere?'],
      selectUsers: {
        title: 'Seleziona Utenti',
        message:
          'Seleziona gli utenti spuntando la casella per approvare o rifiutare le richieste di adesione.',
      },
      memberExists: 'Il membro esiste già',
      mailSent:
        'Invito inviato! Vale 24 ore. Il nuovo membro clicca su “Unisciti ora” e accede con la password temporanea - e subito fa parte della tua community. Gli admin possono inviare di nuovo l’invito in qualsiasi momento.',
      userNotFound:
        'Profilo non trovato. Inserisci nome e cognome per creare un nuovo profilo e inviare l’invito.',
      disableAddMemberTooltip:
        'Limite membri raggiunto. Chiedi al proprietario della community di aggiornare l’abbonamento per aggiungere altri membri.',
      notifyByFields:
        'Invia una notifica quando questi campi vengono modificati',
      notifyByReplies: 'Vuoi inviare notifiche agli invitati?',
      remindBefore: 'Ricorda prima',
      addReminder: '+ Aggiungi promemoria (2 max.)',
      notificationsTypes: [
        'Evento creato',
        'Evento aggiornato',
        'Evento cancellato',
        "Promemoria dell'evento",
      ],
      notificationsClasses: ['In-App', 'E-mail', 'Push'],
      notificationPopupHeader: 'Inviare notifiche agli invitati?',
      notificationPopupMessageLabel: 'Aggiungi messaggio opzionale',
      notificationPopupNotify: 'Invia',
      notificationPopupDoNotNotify: 'Non inviare',
      notificationPopupBack: 'Torna a modificare',
      ownerTooltip:
        "👑 Proprietario\n\nIl proprietario ha creato questa comunità.\n\nCe n'è solo uno - con tutti i diritti: gestisce l'abbonamento e può eliminare la comunità.\n\nCambio possibile - contattare il supporto.",
      emailTooltip:
        "📧 E-mail\n\nEmail di login dell'utente.\nSolo l'utente può modificarla.\n\nSuggerimento: conosci l'e-mail di un nuovo membro? → Aggiungi utente",
      roleTooltip:
        "🛠️ Ruolo\n\nAdmin:\nAccesso completo a tutto - vede e gestisce tutto nella comunità.\n➜ Clicca sul campo per rendere admin un membro\n\nCapogruppo:\nGestisce eventi e risposte all'interno di un gruppo.\n➜ Apri il gruppo → Membri → Trascina in alto",
      groupsTooltip:
        "👥 Gruppi\n\nMostra a quali gruppi appartiene il membro.\n➜ Clicca per assegnare ai gruppi.\n\nI nuovi membri vedono tutti gli eventi del calendario.\nGli eventi di gruppo sono visibili solo dopo l'assegnazione.",
    },
    communityInvitation: {
      subjectFirst: 'Sei stato invitato a far parte della comunità',
      subjectSecond: '',
      body: 'Si prega di seguire il link qui sotto per far parte della comunità',
      invitationSuccess:
        'Approvato! Membro aggiunto alla lista. Controlla ruolo e gruppo in Impostazioni community → Membri.',
      invitationFailure:
        'Errore: probabilmente hai raggiunto il limite del tuo abbonamento.',
      membersInvitation: {
        title: 'Invita membri',
        description:
          'Hai diverse opzioni per aggiungere nuovi membri. Altre info: <0>"Aggiungere un nuovo utente"</0>.',
        showMore: 'Mostra di più',
        showLess: 'Mostra meno',
        codeInvitation: {
          title: 'Il modo più semplice e veloce',
          button: 'Copiare il link di invito',
          updateLink: 'Generare il link ora',
          generateLink: 'Generate link now',
          howItWorks: 'Come funziona',
          goodToKnow: 'Da sapere',
          howItWorksText:
            'I membri fanno clic su "Crea un account gratuito" utilizzando il link selezionato sopra. Quando Gumb invia un\'e-mail, i membri devono solo confermare il loro indirizzo e-mail per ottenere l\'accesso diretto.',
          goodToKnowText:
            "L'operazione è rapidissima, ma si noti che una volta completata la verifica dell'account, le persone in possesso di questo link potranno accedere immediatamente ai vostri eventi. Pertanto, è possibile rinnovare il link di cui sopra ogni volta che lo si desidera.",
        },
        linkInvitation: {
          title: 'Tramite link:',
          button: 'Copia il link della community',
          howItWorks: 'Come funziona:',
          adminFlow: 'Gli admin controllano le richieste:',
          howItWorksText:
            '<0>Copia e condividi il link.</0><0>I membri con account Gumb cliccano su “Unisciti”.</0><0>Chi non ha ancora un account deve prima registrarsi, poi clicca di nuovo sul link per inviarti la richiesta.</0>',
          adminFlowText:
            'Tutte le nuove richieste sono nella scheda “Richieste”. Gli admin possono accettarle o rifiutarle lì. Le richieste aperte sono contrassegnate con l’icona dell’ingranaggio.',
        },
        addMember: {
          title: 'Invita o preregistra tramite indirizzo e-mail',
          button: 'AGGIUNGI UTENTE',
          selfSignUp: 'Il membro si registra da solo:',
          preRegister: 'Preregistra persona:',
          selfSignUpText:
            'Chiunque può iscriversi gratuitamente a Gumb e inviarti il proprio indirizzo e-mail. Se lo inserisci qui, il membro viene aggiunto automaticamente e vede tutti gli eventi.',
          preRegisterText:
            'Crea un nuovo membro direttamente con il suo indirizzo e-mail. L’account viene creato subito, il membro riceve un invito con una password temporanea e può accedere immediatamente. La password può essere cambiata in seguito.',
        },
      },
    },
    group: {
      deleteEventSuccess: "L'evento è stato cancellato con successo",
      createSuccess: 'Il gruppo è stato creato con successo',
      deleteSuccess: 'Il gruppo è stato eliminato con successo',
      addMembersSuccess: 'I partecipanti sono stati aggiunti con successo',
      addMembersSuccessWithMessage: {
        title: 'Membro aggiunto!',
        message:
          'La tua lista membri è stata aggiornata con successo. Gestisci ruoli e assegnazioni ai gruppi. Puoi anche aggiungere o modificare i dettagli utente.',
      },
      deleteUserSuccess: "Eliminato con successo l'utente dal gruppo",
      addParticipants: 'Aggiungi membri',
      createGroup: 'Crea gruppo',
      deleteGroup: 'Elimina gruppo',
      groupName: 'Nome del gruppo',
      changeGroupNameSuccess: 'Nome del gruppo modificato con successo.',
      groups: 'Gruppi',
      inviteMembers: 'Invita membri',
      tabs: {
        schedule: 'Pianifica',
        members: 'Membri',
        chat: 'Chat',
        documentation: 'Documenti',
        statistic: 'Esportazione e statistiche',
        import: 'Importazione',
      },
      limitExceededHeader:
        'Hai raggiunto il limite di comunità del tuo piano. Per crearne di più, aggiorna il tuo piano in Profilo > Abbonamento.',
      limitExceededMessage:
        "Contatta il proprietario della tua comunità. Solo lui/lei può gestire e aggiornare l'abbonamento.",
      limitExceededMessageOwner:
        'Per favore, vai a Profilo > Abbonamento per gestire il tuo piano e aggiornarlo se necessario.',
      groupRole: 'Aggiungi gruppo',
      addGroup: 'Add Group',
    },
    chat: {
      read: {
        now: '{{name}} letto proprio ora',
        hours: '{{name}} letto {{value}}h fa',
        minutes: '{{name}} letto {{value}} min fa',
        minute: '{{name}} letto 1 min fa',
        day: '{{name}} letto il {{value}}',
        dateTime: '{{name}} letto il {{value}} alle {{time}}',
      },
      noRead: 'Non ancora letto',
      noActiveCommunity: 'Non hai ancora una comunità attiva.',
      lastAdmin:
        'Una chatroom deve avere almeno un amministratore o un responsabile di gruppo. Assicurati che almeno una persona abbia sempre questo ruolo.',
      update: {
        success: 'Elenco membri aggiornato',
        successUpdate: 'Chatroom aggiornata con successo',
        btn: 'SALVA',
      },
      modal: {
        btn: 'Gestisci',
        about: 'Info',
        editRoom: 'Modifica chatroom',
        delete: 'Elimina chatroom',
        editMember: 'Modifica membri',
        onlyChatAdmin: 'Solo gli admin della chatroom possono farlo.',
      },
      details: {
        title: 'Dettagli chatroom',
        secondTitle: 'INFORMAZIONI',
        name: 'Nome della chatroom',
      },
      delete: {
        success: 'La chatroom è stata eliminata',
      },
      create: {
        title: 'Crea una stanza chat',
        name: 'Nome della stanza chat',
        description: 'Descrizione del gruppo (opzionale)',
        btnNext: 'AVANTI',
        success: 'Chatroom creata',
      },
      new: 'Nuova',
      chat: 'chat',
      inputPlaceHolder: 'Digita un messaggio',
      popover: {
        title: 'Utente sconosciuto',
        message: 'Non fa più parte della community o del gruppo',
      },
      searchHover: 'Cerca o avvia una nuova chat',
      op1: 'File & Video',
      op2: 'Foto',
      files: 'File',
      plusTooltip: 'Crea una nuova chat o un gruppo chat',
      emptyStatus: {
        noChatSelected: {
          firstLine: 'Seleziona una conversazione per visualizzare la chat,',
          secondLine: 'o clicca qui per avviare un',
          LinkText: 'NUOVO CHAT',
        },
        noChatUser: 'Nessuna chat ancora?',
        noChatSubText:
          'Avvia una chat 1:1 o aspetta che il tuo admin ti aggiunga.',
        noUnseenUser: "Don't have any unseen chat",
        sendFirstMessage: 'Scrivi il tuo primo messaggio a {{recipient}}.',
      },
      infoPopup: {
        title: 'Limite superato',
        message: 'Puoi caricare al massimo 20 file alla volta.',
      },
    },
    statistics: {
      tableType: 'Scegliere un rapporto',
      eventReplies: 'Risposte e compiti',
      eventTypes: 'Tipo di evento',
      appointmentSchedule: 'Calendario degli appuntamenti',
      memberFigures: 'Controllo delle presenze',
      charts: {
        eventTypesByMonth: 'Numero di appuntamenti per tipo',
        eventReplies: 'Risposte alle opzioni di risposta',
        memberPresence: 'Numero di reazioni per risposta',
      },
      loadingStatistics: 'Caricamento...',
      memberFiguresExportSuccess: {
        title: 'Report in creazione!',
        message:
          'Stiamo creando il tuo report di presenza. Con tanti dati, potrebbero volerci alcuni minuti. Per sicurezza, riceverai il report via e-mail. Controlla la posta in arrivo. Grazie per la pazienza!',
      },
    },
    filters: {
      clickToSelect: 'Fare clic qui per filtrare',
      showFilters: 'Mostra filtri',
      dateRange: "Selezionare l'intervallo di date",
      filterBy: 'Filtrare per',
      dateRanges: {
        yearToDate: "Da un anno all'altro",
        lastDays: 'Ultimi {{number}} giorni',
        lastYear: 'Ultimo anno',
        yesterday: 'Ieri',
        today: 'Oggi',
        tomorrow: 'Domani',
        nextDays: 'I prossimi {{number}} giorni',
        thisWeek: 'Questa settimana',
        thisMonth: 'Questo mese',
        thisYear: 'Questo anno',
        allTime: 'Tutto il tempo',
        specificDateRange: 'Intervallo di date specifico',
      },
      downloadXlsxOrCsv: 'Scarica qui: Excel o CSV',
    },
    bulkUploadEvents: {
      toastText:
        '🆕  La nuova funzione di importazione degli appuntamenti è ora disponibile per ogni gruppo!  🎉',
      moduleTitle: 'Importazione',
      step1: 'Fase 1',
      step2: 'Fase 2',
      step3: 'Fase 3',
      step4: 'Fase 4',
      stepOne: {
        stepTitle: "Prepara l'importazione dei dati",
        stepDescription: 'Scarica il modello Excel',
        componentTitle: 'Scarica il modello Excel',
        componentDescription:
          'Compila il modello con i dati del tuo evento o utilizza il tuo file Excel.',
        p1: 'Compila il modello con i dati del tuo evento.',
        p2: 'Le intestazioni delle colonne devono rimanere in inglese.',
        p3: 'Gli esempi in ogni colonna ti mostrano il formato corretto.',
        p4: 'I nuovi tipi di evento vengono aggiunti automaticamente.',
        p5: '<b>Importante</b>: Se usi il tuo file, i seguenti titoli di colonna devono essere copiati esattamente come mostrato in inglese (rispettando maiuscole e minuscole):',
        p6: 'Gli esempi in ogni colonna del modello ti mostrano il formato corretto.',
        p7: 'I nuovi tipi di evento vengono aggiunti automaticamente.',
        eventTypes: 'VAI AI TIPI DI EVENTO',
        template: 'SCARICA IL MODELLO',
        nextStepButton: 'CONTINUA',
        copy: 'Copia tutte le chiavi',
      },
      stepTwo: {
        stepTitle: 'CARICA FILE',
        stepDescription: 'CARICA FILE CSV',
        componentTitle: 'CARICA FILE CSV',
        componentDescription:
          'Salva il file Excel in formato <b><u>CSV</u></b> e caricalo qui.',
        p1: "Verificheremo il formato e ti mostreremo un'anteprima.",
        uploadButton: 'Scegli file',
        maximumFileSize: 'Dimensione massima del file: 1 MB',
      },
      stepThree: {
        stepTitle: 'Conferma dati',
        stepDescription: 'Anteprima del tuo primo evento.',
        componentTitle: 'Conferma dati',
        componentDescription:
          "Controlla l'esempio e regola i membri attivati.\nI membri selezionati si applicano a tutti gli eventi.",
        nextStepButton: 'CONFERMA E CARICA',
      },
      stepFour: {
        stepTitle: 'Caricamento riuscito!',
        stepDescription:
          'Il caricamento degli eventi è avvenuto con successo. Puoi vederli nel calendario.',
        componentTitle: 'Caricamento riuscito!',
        componentDescription: 'Sono stati importati <b>{{count}}</b> eventi.',
        secondTitle: 'Buono a sapersi',
        secondSubTitle:
          "Puoi annullare l'importazione o caricare un nuovo elenco.",
        goToScheduler: 'VAI AL CALENDARIO',
        undoImport: 'ANNULLA IMPORTAZIONE',
        uploadNewList: 'CARICA NUOVO ELENCO',
      },
      errors: {
        eventNameErrorTitle: 'Errore nome evento',
        eventNameErrorMessage:
          'Nome evento mancante alla riga <b><u>{{row}}</u></b>.',
        eventTypeErrorTitle: 'Errore tipo evento',
        eventTypeErrorMessage:
          'Tipo di evento mancante alla riga <b><u>{{row}}</u></b>.',
        timeErrorTitle: 'Errore orario',
        timeErrorMessage:
          'Orario di inizio o fine mancante alla riga <b><u>{{row}}</u></b>.',
        dateErrorTitle: 'Errore data',
        dateErrorMessage: 'Data mancante alla riga <b><u>{{row}}</u></b>.',
        locationErrorTitle: 'Errore luogo',
        locationErrorMessage:
          "Luogo dell'evento mancante alla riga <b><u>{{row}}</u></b>.",
        invalidDateOrTimeTitle: 'Data o ora non valida',
        invalidDateOrTimeMessage:
          "Verificare il formato di data e ora alla riga <b><u>{{row}}</u></b> (ad es. usare HH:MM per l'ora).",
      },
      commentRequired: {
        title: 'Commento richiesto',
        message: 'Inserisci un breve commento, per favore.',
      },
      deletePopupTitle: 'Eliminare la lista degli eventi?',
      deletePopupMessage:
        'Questa azione eliminerà definitivamente la tua ultima lista di eventi caricata. Sei sicuro?',
      deleteSuccessTitle: 'Eliminazione riuscita!',
      deleteSuccessMessage:
        'La tua ultima lista di eventi caricata è stata eliminata correttamente.',
      successMessage:
        "Convalida avvenuta con successo. Procedi al passaggio successivo per visualizzare l'anteprima.",
      restartProcessTitle: 'Carica nuova lista eventi',
      restartProcessMessage:
        "Puoi caricare una nuova lista di eventi in qualsiasi momento. Tieni presente che gli eventi caricati in precedenza saranno ancora visibili nel calendario. Se vuoi sostituire la vecchia lista, eliminala prima o annulla l'ultima importazione.",
      restartProcessOkButton: 'CARICA NUOVA LISTA',
      exportDataSample: {
        event_name: 'Zurich Street Parade',
        event_type_name: 'Spettacolo',
        event_location: 'Bahnhofstrasse 5, 8001 Zurigo',
        event_description: "Festival all'aperto con gruppi e DJ internazionali",
      },
    },
    event: {
      noTasks: {
        title: 'Nessun’attività',
        description:
          'Le attività appariranno qui quando un admin le crea o le attiva.',
      },
      noSearchResults: {
        title: 'Nessun risultato',
        description: 'Prova con un altro termine di ricerca.',
      },
      noParticipants: {
        title: 'Nessun partecipante al momento.',
        description: 'Quando un membro sarà aggiunto all’evento, apparirà qui.',
      },
      noParticipantsSearchResults: {
        title: 'Nessun risultato',
        description: 'Prova con un altro termine di ricerca.',
      },
      noDocuments: {
        title: 'Nessun file',
        description: 'I file appariranno qui una volta caricati.',
      },
      event: 'Evento',
      createdAt: 'Data di creazione',
      editEvent: 'Modifica evento',
      createEvent: 'Crea evento',
      updateEvent: 'Aggiorna evento',
      eventName: "Nome dell'evento",
      eventType: 'Tipo di evento',
      eventTypeDeleted: 'Tipi di eventi eliminati',
      eventDetails: "Dettagli dell'evento",
      eventOrganizer: "Organizzatore dell'evento",
      eventOrganizerShort: 'Organizzatore',
      location: 'Luogo',
      eventTypeEdit: 'Modifica tipo di evento',
      eventTypeName: 'Nome del tipo di evento',
      responseRequired: 'Risposta necessaria',
      responseName: 'Nome della risposta',
      responsesEdit: 'Modifica risposta',
      responsesCreate: 'Creare risposta',
      repeatAnEvent: 'Ripeti un evento',
      repeatWithInterval: 'Ripeti con un intervallo',
      allDay: 'Giornata completa',
      registrationDeadline: "Scadenza per l'iscrizione",
      commentRequired: 'Commento necessario',
      editTask: 'Modifica compito',
      createTask: 'Crea compito',
      eventTypeCreate: 'Crea tipo di evento',
      eventTaskName: 'Nome del compito',
      icon: 'Icona',
      isMemberComing: 'La tua risposta?',
      recurringEvent: 'Evento ricorrente',
      allEvents: 'Tutti gli eventi',
      thisEventOnly: 'Solo questo evento',
      createEventSuccess: "L'evento è stato creato con successo",
      updateEventSuccess: "L'evento è stato aggiornato con successo",
      createEventReplySuccess: 'Risposta salvata con successo',
      updateEventReplySuccess: 'Risposta aggiornata con successo',
      addGuests: 'Ospiti aggiuntivi ?',
      eventOperations: {
        eventOnly: 'Questo evento',
        eventAndFollowUp: 'Questo evento e quelli successivi',
        all: 'Tutti gli eventi',
        deleteText: 'Elimina evento ricorrente',
        editText: 'Modifica evento ricorrente',
        editReplyText: 'La tua risposta si applica a',
        confirm: 'OK',
      },
      dfRes: 'Imposta Risposta Predefinita per Tutti',
      dfResInfo:
        "Questo imposta la risposta predefinita per tutti i partecipanti all'evento.Tutte le risposte individuali esistenti verranno sovrascritte.",
      title: 'Attenzione',
      responseToast:
        'Se elimini la risposta predefinita senza salvarne una nuova, tutte le reazioni e i commenti precedenti verranno eliminati.',
      setPreferences: 'Imposta preferenze',
      setEventDefaults: 'Imposta predefiniti evento',
      preferencesText:
        'Definisci le impostazioni predefinite per i nuovi eventi di questo tipo, inclusa la risposta predefinita per i membri',
      responseSubTitle: 'Richiedi commento (opzionale)',
      requestComment:
        'Attiva questa opzione: i membri dovranno lasciare un commento se scelgono questa risposta (ad es. “No, senza di me” per chiedere il motivo).',
      registeredUsers: 'Risposte',
      guests: 'Ospiti',
      nomination: 'Nomina',
      nominated: 'Sei nominato/a',
      havePenalty: 'Hai ricevuto una penalità',
      penalty: 'Pena',
      invitees: 'Invitati',
      awaiting: 'In attesa di',
      minutes: 'Minuti',
      hours: 'ore',
      days: 'giorni',
      weeks: 'settimane',
      weekDay: 'Giorno feriale',
      duration: 'Durata',
      months: 'mesi',
      years: 'anni',
      viewAppointment: 'Mostra Evento',
      myResponse: 'La Mia Risposta',
      noEvents: {
        title: 'Nessun evento visibile',
        description: 'Quando un admin ti aggiunge, vedrai qui i tuoi eventi.',
      },
      shareEvent:
        'Condividi evento - Clicca sull’icona per copiare l’evento e incollarlo ovunque (email, WhatsApp, ecc.).',
      shareEventOption: "Condividi il link dell'appuntamento",
      exportPDFOption: 'Esportazione come PDF',
      deadlineExpired:
        'Probabilmente il termine per iscriversi è scaduto o l’evento è già passato.',
      totalInvitees: 'Totale invitati',
      responsesReceived: 'Risposte ricevute',
      additionalGuests: 'Ospiti aggiuntivi',
      noPermissionToGiveReply: "Tu n'as pas le droit de changer cela",
      responsesPercentage: 'Percentuale di risposte',
      acceptedTasks: 'Compiti accettati',
      acceptedTasksByUser: 'Attività per utente',
      givenComments: 'Commenti dati',
      givenCommentsByUser: "Commenti dati dall'utente",
      optionalMessage: 'Clicca qui per vedere le notizie.',
    },
    task: {
      createTask: 'Creare compito',
      taskName: 'Nome del compito',
      noTasks: 'Nessun compito',
    },
    groupSettings: {
      title: 'Impostazioni gruppo',
      tabs: {
        general: 'Generale',
        eventTypes: 'Tipi di eventi',
        responses: 'Risposte',
        membersManagement: 'Amministrazione dei membri',
        other: 'Altro',
      },
      deleteGroupHeader: 'Eliminare davvero?',
      deleteGroupMessage:
        'Tutti i tuoi dati verranno eliminati in modo permanente. Nessun ripristino possibile.',
    },
    documentation: {
      title: 'Documenti',
      generalDocumentation: 'Documenti generali',
      uploadedFiles: 'File caricati',
      chooseFile: 'Scegli file',
      tipMessage: 'Massima dimensione del file da caricare: 50 MB',
      overview: '{{value}} GB usati su {{capacity}} GB',
      uploadSuccess: 'Il documento è stato caricato con successo',
      deleteSuccess: 'Il documento è stato eliminato con successo',
      attachFiles: 'Allega file',
      limitExceededHeader:
        'Avete raggiunto il limite di spazio per i documenti.',
      sort: {
        label: 'Ordina per',
        nameAsc: 'Nome (A-Z)',
        nameDesc: 'Nome (Z-A)',
        dateOldest: 'Data (Meno recente)',
        dateNewest: 'Data (Più recente)',
      },
    },
    subscriptions: {
      title: 'Abonnements',
      subscription: 'Abonnement',
      yearly: 'Annuel',
      adBlocker: {
        header: 'Disattiva ad-blocker',
        body: 'Disattiva l’ad-blocker (icona vicino alla barra degli indirizzi) per vedere i prezzi locali. Ricarica la pagina.',
      },
      monthly: 'Mensuel',
      freeTitle: 'Essai gratuit de 2 mois',
      freeDescription: 'Avvia la tua prova gratuita di 2 mesi ora.',
      freeText1: 'Aprire fino a <strong>30</strong> comunità',
      freeText2: 'Accès complet à toutes les fonctionnalités',
      freeText3:
        'Aucune carte de crédit requise - inscrivez-vous et commencez immédiatement',
      freeText4: 'Pas de renouvellement automatique',
      freeText5: 'Pas de publicité',
      subscribe: 'SOUSCRIRE',
      seeDetails: 'VOIR DETAILS',
      buildCustom: 'Custom',
      month: 'mese',
      year: 'anno',
      community: 'Comunità',
      communities: 'Comunità',
      maxStorage: 'Stoccaggio GB',
      classic: 'Classico',
      classicPlus: 'Classico+',
      popular: 'POPOLARE',
      textInnerTop:
        'Scegli il piano adatto al tuo team. Organizza in un massimo di {{groups}} gruppi e gestisci fino a {{members}} membri. Aggiorna o annulla quando vuoi.',
      textInnerBottom:
        'Il tuo abbonamento è un contratto a tempo indeterminato. Vantaggio: Si rinnova automaticamente annualmente/mensilmente. Ti invieremo un promemoria via email. Paga con carta di credito (MasterCard, Visa) o PayPal.',
      chatsExcluded: 'Chat esclusi',
      current: 'ATTUALE',
      pay: 'PAGAMENTO',
      usingBlocker: 'Disabilita il blocco degli annunci e ricarica la pagina',
      failedToSubscribe:
        "Pagamento fallito. Il controllo di sicurezza non è andato a buon fine o la tua carta potrebbe scadere presto. Per favore, usane un'altra o riprova.",
      usedGroups: 'Gruppi utilizzati',
      usedMembers: 'Membri utilizzati',
      usedCommunity: 'Comunità utilizzate',
      usedStorage: 'Stoccaggio utilizzato',
      orderSummary: "Riepilogo dell'ordine",
      tax: 'TASSA',
      total: 'Totale',
      periodEnds: 'Fine periodo di pagamento',
      cancelSubscription: 'ANNULLA IL MIO ABBONAMENTO',
      paypalLink: 'CRONOLOGIA FATTURAZIONE',
      chatEnabled: 'Chat incluse',
      chatExcluded: 'Chat escluse',
      paymentApproved: 'Pagamento accettato',
      paymentError: 'Errore pagamento',
      limitExceededHeader: 'Hai raggiunto il limite di membri.',
      limitExceededMessage:
        "Contatta il proprietario della tua comunità. Solo lui/lei può gestire e aggiornare l'abbonamento.",
      limitExceededMessageOwner: 'Scegliete un piano per creare una comunità.',
      inactiveSubscriptionHeader: 'Accettazione pagamento in attesa',
      inactiveSubscriptionMessage:
        'Siamo spiacenti, non può continuare questa azione. Prima dovrebbe completare il processo di pagamento.',
      subscriptionNotPaid: 'Nessun piano attivo',
      contactAdmin: "Si prega di contattare l'Admin.",
      free: 'Account gratuito',
      requireSubscription:
        'Gumb è gratuito per i membri delle community attive. Crea la tua community e inizia subito la tua prova gratuita o modifica il tuo abbonamento in "Modifica abbonamento".',
      requireSubscriptionMember:
        'Non è stato rilevato alcun abbonamento valido. Non devi fare nulla qui da solo. Il proprietario della comunità invece può controllare nel suo profilo sotto "Abbonamento" se la licenza per questa comunità è attivata o estesa.',
      cancelConfirmation: 'Sei sicuro di voler cancellare il tuo abbonamento?',
      unsubscribe: 'Cancellare',
      cancelled:
        'Cancellazione confermata. Una conferma di cancellazione è stata appena inviata alla tua email. Continuerai ad avere accesso a tutte le funzioni fino alla data di pagamento.',
      renewSubscriptionText:
        'Grazie!\n\nIl tuo precedente abbonamento sarà rinnovato, se lo attivi ora',
      activate: 'Attiva ora',
      activated:
        'Il tuo abbonamento è attivo! Benvenuto/a in Gumb: siamo entusiasti che da ora in poi organizziate e pianifichiate professionalmente con noi. Ti abbiamo inviato una conferma via email. Tutte le funzionalità sono subito disponibili per il tuo team.',
      approved:
        'Stiamo preparando il tuo abbonamento... Per favore, attendi un momento (fino a 45 secondi). Non aggiornare o chiudere la finestra del browser durante questo processo.',
      trialActivated:
        'Il tuo periodo di prova è iniziato. Tu e i tuoi amministratori potete ora iniziare a pianificare, invitare membri e gestire le impostazioni.',
      cancelledTitle: 'Annullato',
      startTrial: 'AVVIA LA PROVA GRATUITA',
      startTrialHeader: 'Test lungooooo!',
      startTrialText:
        'Prova tutte le funzioni in un ambiente reale - 2 mesi gratis! Nessun dato di pagamento, nessun costo nascosto. Testa semplicemente senza pensieri con tutti i membri.',
      subscriptionExpired:
        "Questa community al momento non ha un abbonamento attivo. Per aggiungere nuovi utenti, è necessario rinnovare l'abbonamento.Per domande: support@gumb.app",
      startTrialPopupButton: 'Prova Gratuitamente',
      paymentMethods: 'Carta di credito o Paypal',
      checkout: {
        pageTitle: 'Checkout',
        breadcrumbCheckout: 'Checkout - {{plan}}',
        stepPlanSelected: 'Piano selezionato',
        stepOrderSummary: 'Riepilogo ordine',
        stepConfirmation: 'Confirmation',
        completeOrder: 'Completa il tuo ordine',
        planInfoSub: '{{billing}} · {{count}} {{teams}}',
        planLineAnnual: '{{plan}} (annuale)',
        planLineMonthly: '{{plan}} (mensile)',
        planLineSubtextAnnual:
          '{{currency}}{{price}}/anno · {{days}} giorni rimanenti',
        planLineSubtextMonthly:
          '{{currency}}{{price}}/mese · {{days}} giorni rimanenti',
        daysRemainingSubtext: '{{days}} giorni rimanenti',
        annualSavingLine: 'Risparmio con fatturazione annuale',
        totalDueToday: 'Totale dovuto oggi',
        renewsOn: 'Rinnova il {{date}}',
        chargedToday: 'Addebitato oggi:',
        activationInfo:
          "Dopo l'approvazione del pagamento, il tuo piano si attiva e riceverai un'e-mail di conferma. Puoi annullare in qualsiasi momento dalle impostazioni abbonamento.",
        activationInfoStripe:
          'Il tuo piano si attiva subito dopo il pagamento. Si rinnova annualmente alla stessa data - annulla quando vuoi.',
        activationInfoStripeMonthly:
          'Il tuo piano si attiva subito dopo il pagamento. Si rinnova mensilmente alla stessa data - annulla quando vuoi.',
        includedTitle: 'Cosa include',
        included1: 'Calendario principale condiviso',
        included2: 'Presenze in tempo reale',
        included3: 'Chat di team e messaggi diretti',
        included4: 'Notifiche push',
        included5: 'Ruoli membri e permessi',
        included6: 'Archiviazione file e documenti',
        included7: 'iOS, Android e web',
        included8: 'Analisi ed esportazione CSV',
        trustSecure: 'Checkout sicuro con PayPal',
        trustSecureStripe: 'Checkout sicuro tramite Stripe',
        trustCancel: 'Annulla in qualsiasi momento',
        trustCancelDetailed: 'Annulla in qualsiasi momento, senza penali',
        trustSSL: 'Crittografia SSL a 256 bit',
        stripeProcessedNote: 'Pagamento sicuro tramite',
        completePurchase: 'Completa acquisto - {{amount}}',
        paymentMethodLegend: 'Metodo di pagamento',
        payDirectTitle: 'Paga ora',
        payDirectDesc: 'Addebitato oggi.',
        payInvoiceTitle: 'Fattura',
        payInvoiceDesc: 'Fattura via e-mail.',
        invoiceHeadline: 'Paga con fattura',
        invoiceSubline:
          'Bonifico bancario · fattura PDF alla tua e-mail di fatturazione',
        invoicePanelBody:
          'Ti invieremo una fattura con i dettagli di pagamento e il tuo riferimento. Il tuo abbonamento si attiva quando il pagamento viene ricevuto (di solito 1-3 giorni lavorativi dopo il bonifico).',
        requestInvoice: 'Richiedi fattura',
        toBeInvoiced: 'Da fatturare',
        invoicePageNote:
          'Il vostro abbonamento parte subito, indipendentemente dal pagamento',
        chf: {
          title: 'Dettagli di fatturazione',
          subtitle:
            'Riceverete una fattura QR per email. Termine di pagamento 30 giorni.',
          name: 'Organizzazione o nome',
          address: 'Indirizzo',
          vatNumber: 'Partita IVA',
          billingEmail: 'Email di fatturazione',
          optional: 'facoltativo',
          recipientsHint:
            'Tutti i destinatari ricevono la stessa fattura. Lasciate vuoto per usare {{email}}.',
          total: 'Totale',
          submit: 'Richiedi la fattura',
          activationNote:
            'Il vostro abbonamento parte subito, indipendentemente dal pagamento',
          invalidEmail: 'Inserisci un indirizzo email valido',
          maxRecipients: 'Massimo 5 destinatari',
        },
        invoiceTrust1: 'Fattura inviata alla tua e-mail di fatturazione',
        invoiceTrust2: 'Paga tramite bonifico con il riferimento indicato',
        invoiceTrust3:
          'La tua app è attiva subito - paga la fattura quando vuoi',
        priceSaveVsMonthly: '2 mesi gratis rispetto al mensile',
        planDetails: 'Dettagli piano',
        badgeNew: 'Nuovo abbonamento',
        planNotInCatalog:
          'Questo piano non è ancora disponibile nel catalogo checkout oppure il link è scaduto. Torna a «Cambia piano» e riapri il checkout da lì.',
        backToChangePlan: 'Torna ai piani',
        invoiceYearlyOnly:
          'La fatturazione tramite fattura è disponibile solo per abbonamenti annuali. Scegli la fatturazione annuale in «Cambia piano», poi torna al checkout.',
        invoicePayerEmailsLabel: 'E-mail pagatore / amministrazione',
        invoicePayerEmailsHint:
          'Conserviamo questi contatti per i tuoi archivi. Stripe invia la fattura alla tua e-mail profilo (intestatario fattura).',
        invoiceBillToProfile: 'Fatturare a: {{email}}',
        invoiceEmailPlaceholder: 'finance@company.com',
        invoiceAddEmail: "+ Aggiungi un'altra e-mail",
        invoiceRemoveEmail: 'Rimuovi e-mail',
        invoiceSubmit: 'Crea fattura',
        invoiceSubmitting: 'Creazione fattura…',
        invoiceInvalidEmails: 'Inserisci almeno un indirizzo e-mail valido.',
        invoiceSubmitError:
          "Impossibile creare la fattura. Riprova o contatta l'assistenza.",
        stripeCheckoutError:
          'Non è stato possibile avviare il checkout. Riprova.',
        invoiceSuccessTitle:
          'Fattura creata - completa il pagamento quando vuoi',
        invoiceAmount: 'Importo: {{amount}}',
        invoiceOpenHosted: 'Apri fattura Stripe e paga',
        invoiceHostedPending:
          'Il tuo abbonamento è in attesa di pagamento. Controlla la tua e-mail per il link alla fattura oppure apri presto «Abbonamento» nel tuo profilo.',
        invoiceReturnBreadcrumb: 'Conferma',
        invoiceReturnSuccessTitle: 'Tutto pronto!',
        invoiceReturnSuccessSub:
          "Il tuo {{plan}} è attivo ora. Paga la fattura Stripe quando sei pronto - non serve attendere il pagamento per usare l'app.",
        invoiceReturnSuccessDetailsHeading: 'Cosa è stato attivato',
        invoiceReturnSuccessBulletPlan:
          "{{plan}} - i limiti dell'abbonamento e la fatturazione sono applicati.",
        invoiceReturnSuccessBulletActive:
          'Le funzionalità premium sono disponibili subito su web e mobile.',
        invoiceReturnSuccessBulletInvoice:
          'È stata creata una fattura Stripe - aprila qui sotto o controlla la tua e-mail di fatturazione.',
        invoiceReturnSeeInvoice: 'Vedi fattura',
        invoiceReturnSeeInvoicePending: 'Link fattura in attesa',
        invoiceReturnGoSubscription: "Vai all'abbonamento",
        stripeReturnBreadcrumbSuccess: 'Conferma',
        stripeReturnBreadcrumbFailure: 'Checkout annullato',
        stripeReturnSuccessTitle: 'Tutto pronto!',
        stripeReturnSuccessSub:
          'Il tuo {{plan}} è ora attivo. Puoi usare subito tutte le funzionalità - senza attese né ritardi.',
        stripeReturnPlanFallback: 'piano',
        stripeReturnSuccessDetailsHeading: 'Cosa è stato attivato',
        stripeReturnSuccessBulletPlan:
          '{{plan}} - i limiti del tuo abbonamento e la fatturazione sono ora applicati.',
        stripeReturnSuccessBulletActive:
          'Le funzionalità premium sono disponibili subito su web e mobile.',
        stripeReturnSuccessBulletEmail:
          'Ti invieremo una ricevuta alla tua e-mail di fatturazione quando il pagamento sarà confermato.',
        stripeReturnSuccessBulletGuarantee:
          'La garanzia soddisfatti o rimborsati di 30 giorni si applica al tuo abbonamento.',
        stripeReturnSessionRef: 'Riferimento checkout: {{id}}',
        stripeReturnGoHome: 'Vai alla home',
        stripeReturnViewSubscription: 'Visualizza abbonamento',
        stripeReturnFailureTitle: 'Pagamento non completato',
        stripeReturnFailureSub:
          'Non ti è stato addebitato nulla. Puoi riaprire il checkout in qualsiasi momento da «Cambia piano».',
        stripeReturnFailureDetailsHeading: 'Cosa è successo',
        stripeReturnFailureBullet1:
          'Il checkout è stato annullato o chiuso prima del completamento del pagamento.',
        stripeReturnFailureBullet2:
          'Il tuo abbonamento non è stato modificato.',
        stripeReturnTryAgain: 'Torna ai piani',
        stripeReturnBackSubscription: 'Visualizza abbonamento',
      },
      subscriptionsPopup: {
        title: 'Nessun piano attivo',
        subtitle:
          '<b>{{ownerName}}</b> è il proprietario e può scegliere un piano. 🙌🏻',
        firstBox: {
          title:
            "Scegliete un piano per ripristinare l'accesso completo per tutti.",
          btnText: 'Scegli un piano',
        },
        secondBox: {
          title:
            'Volete che subentri qualcun altro? Possiamo trasferire la proprietà.',
          btnText: 'Richiedi il trasferimento',
          contactMessage:
            'Vorrei richiedere il trasferimento della proprietà di "{{communityName}}" ({{communityId}}). Proprietario attuale: {{currentOwner}}. La mia e-mail: {{email}}.',
        },
      },
      profile: {
        legacy: {
          heading: 'Dettagli abbonamento',
          titleMembership: 'Iscrizione',
          titlePayment: 'Pagamento',
          buttonCancel: "Annullare l'iscrizione",
          details: {
            linkChangePlan: 'Cambia piano',
            infoTrial:
              'La prova è attiva. Alla fine non ti verrà addebitato nulla. Se vuoi continuare con Gumb, scegli un piano sotto «Cambia piano».',
            infoTrialNew:
              'La prova è attiva. Alla fine, il {{expireDate}}, non ti verrà addebitato nulla. Se vuoi continuare con Gumb, scegli un piano in «Cambia piano».',
            linkShowCommunities: 'Mostra le mie comunità',
            linkHistory: 'Storico pagamenti (Ricevuta via email PayPal)',
            linkChangePayment: 'Modificare il metodo di pagamento',
            currentPlan: 'Piano attuale:',
            communitiesInUse: 'Comunità in uso:',
            groupsInUse: 'Gruppi in uso:',
            membersInUse: 'Membri in uso:',
            storageInUse: 'Archiviazione in uso:',
            paymentCycle: 'Ciclo di pagamento:',
            paymentMethod: 'Metodo di pagamento:',
          },
          billing: {
            paymentInfoNote:
              'Puoi aggiungere i dati di pagamento in modo sicuro quando ti abboni. La fatturazione è gestita da Stripe con crittografia.',
            securePayments: 'Pagamenti sicuri',
            renewalNote: 'Si rinnova {{date}} · {{cycle}}',
            choosePlanTrial: 'Scegli il tuo piano',
            cancelTrial: 'Annulla prova',
            cancelTrialConfirm:
              'Terminare la prova gratuita? Puoi abbonarti di nuovo in qualsiasi momento dalla pagina dei piani.',
            trustStripeNote:
              'Pagamenti elaborati in modo sicuro - gestisci la fatturazione per fatture e ricevute',
          },
        },
        page: {
          title: 'Abbonamento e fatturazione',
        },
        confirming: {
          onboardingTitle: 'Almost there',
          onboardingHint:
            "We're syncing your payment with your account. This usually takes just a moment.",
          subscriptionTitle: 'Almost there',
          subscriptionHint:
            "We're activating your subscription. This usually takes just a moment.",
        },
        labels: {
          paymentCycleMonth: 'Mensile',
          paymentCycleYear: 'Annuale',
          validUntil: 'Ancora valido fino a:',
          nextPayment: 'Pagamento successivo:',
          infoCancelled:
            'Il tuo abbonamento è stato annullato e non verrà rinnovato. Puoi usare l’app fino alla prossima data di fatturazione. Puoi riattivare l’abbonamento in qualsiasi momento.',
          subscriptionEndedOn: 'Abbonamento terminato:',
          trialEndedOn: 'Periodo di prova terminato:',
          accessUntil: 'Accesso fino al:',
          nextInvoice: 'Next invoice:',
          lastPlan: 'Ultimo piano',
          invoiceBillingCyclePrimary: 'Annual · Custom pricing',
        },
        hero: {
          title: 'Inizia la tua prova gratuita di 2 mesi',
          subtitle:
            'Accesso completo a tutte le funzioni - senza carta di credito.',
          seeIncluded: 'Vedi cosa è incluso',
        },
        freeAccount: {
          subtitle: 'Non hai ancora avviato una prova o un abbonamento.',
          badge: 'Account gratuito',
          noActivePlan: 'Nessun piano attivo',
          trialUnlockBlurb:
            'Avvia la prova gratuita di 2 mesi per l’accesso completo: più community, pianificatori di gruppo, gestione membri e altro.',
          trialNoteFooter:
            'Prova gratuita di 2 mesi - nessun addebito automatico dopo.',
          comparePlans: 'Confronta i piani',
        },
        plan: {
          title: 'Piano attuale',
          subtitleTrial: 'Prova Gumb in tranquillità durante la prova.',
          subtitleActive: 'Il tuo piano è attivo e si rinnova automaticamente.',
          subtitleNonRenewal:
            'Accesso completo fino al {{date}}. L’abbonamento non si rinnova automaticamente.',
          subtitleStripeEnded:
            'Abbonamento a pagamento terminato il {{date}}. Puoi riabbonarti da Cambia piano.',
          subtitleFullyCancelled:
            'Il tuo abbonamento {{plan}} è terminato il {{date}}.',
          subtitleTrialExpired:
            'Il vostro periodo di prova è terminato il {{date}}.',
          badgeTrial: 'Prova gratuita',
          badgeTrialExpired: 'Periodo di prova scaduto',
          badgeCancelled: 'Annullato',
          badgeEnded: 'Terminato',
          badgeActive: 'Attivo',
          endsOnNote: 'Termina il {{date}}. Nessun addebito automatico dopo.',
          footnoteStripeEnded:
            'Terminata il {{date}}. Nessun ulteriore addebito.',
          footnoteFullyCancelled:
            'Annullato il {{date}}. Nessun ulteriore addebito.',
          footnoteTrialExpired:
            'Periodo di prova terminato il {{date}}. Non è stato addebitato nulla.',
          footnoteRenewalCancelled:
            'Nessun rinnovo dopo il {{date}}. Mantieni l’accesso completo fino ad allora · {{price}}{{period}} (ultimo piano attivo) · {{billingMethod}}',
          footnoteRenewalPayment:
            'Si rinnova {{date}} · {{price}}{{period}} {{billingMethod}}',
          paymentMethodChargedGeneric: 'il tuo metodo di pagamento salvato',
          paymentMethodChargedTo: 'addebitato su {{chargedTo}}',
          paymentMethodBilledByInvoice: 'fatturato tramite fattura',
          featureCommunities: 'Fino a {{count}} community',
          featureSchedulers: 'Fino a {{count}} pianificatori di gruppo',
          featureMembers: 'Fino a {{count}} membri',
          featureStorage: '{{count}} GB di archiviazione',
          paidProFeatureExtras: [
            'Tracciamento presenze in tempo reale',
            'Chat di team, DM e notifiche push',
          ],
        },
        statusBanner: {
          trialTitle: 'Prova gratuita attiva',
          trialBody:
            'La prova termina il {{date}}. Gumb è gratuito fino ad allora - nessun addebito automatico dopo.',
          stripeEndedRich:
            'Questo abbonamento Stripe è terminato. Non ci saranno ulteriori addebiti.',
          fullyCancelledTitle: 'Annullato',
          fullyCancelledRich:
            'Il tuo abbonamento è stato annullato. L’accesso è terminato il {{date}}. Puoi riabbonarti in qualsiasi momento.',
          trialExpiredTitle: 'Periodo di prova scaduto',
          trialExpiredRich:
            "Il vostro periodo di prova è terminato il {{date}}. Scegliete un piano per mantenere l'accesso completo.",
          activeLabel: '{{plan}} · Attivo',
          nonRenewalRich:
            'Attivo fino al {{date}} - non si rinnova. Nessun addebito dopo quella data · {{price}}{{period}}',
          renewalRich:
            'Il tuo abbonamento si rinnova il {{date}} · {{price}}{{period}}',
          frequencyAnnual: 'Annuale',
          frequencyMonthly: 'Mensile',
        },
        payment: {
          title: 'Pagamento',
          methodLabel: 'Metodo di pagamento',
          invoiceMethodTitle: 'Invoice (annual)',
          sentToBilling: 'Fattura a {{email}}',
          sentToBillingLabel: 'Fattura a',
          cycleLabel: 'Ciclo di fatturazione',
          accountManagerLabel: 'Account manager',
          lastInvoiceLabel: 'Ultima fattura',
          lastInvoiceUnavailable: '-',
          lastInvoiceHintInvoice: 'Fattura ufficiale in PDF',
          lastInvoiceHint: 'Fattura per questo pagamento',
          downloadInvoice: 'Scarica PDF',
          methodOnFile: 'Carta salvata',
          noPaymentYet: 'Nessun pagamento necessario per ora',
          cardExpiresShort: 'Scade {{month}} / {{year}}',
          noActiveSubscription: 'Nessun abbonamento attivo',
          manageBilling: 'Gestisci fatturazione',
          manageBillingHint: 'Apre il portale di fatturazione sicuro Stripe',
          viewInvoices: 'Vedi fatture',
          switchToInvoice: 'Passare al pagamento tramite fattura',
          switchToCard: 'Passare al pagamento con carta',
          switchToInvoiceTitle: 'Passare al pagamento tramite fattura?',
          switchToInvoiceBody:
            'Le fatture saranno inviate alla tua email di fatturazione.',
          switchToInvoiceBodyBold:
            'La tua carta non verrà più addebitata automaticamente.',
          switchToInvoiceConfirm: 'Passa alle fatture',
          switchToCardTitle: 'Passare al pagamento con carta?',
          switchToCardBody:
            'La tua carta salvata verrà addebitata automaticamente.',
          switchToCardBodyBold:
            'Le fatture non verranno inviate via email per i prossimi pagamenti.',
          switchToCardConfirm: 'Passare al pagamento con carta',
          switchBillingReviewSubtitle:
            'Controlla la modifica qui sotto prima di confermare.',
          switchBillingChangeSummaryLabel: 'Cosa cambia',
          switchBillingTimingLabel: 'Quando si applica',
          switchBillingStep1Label: 'Rivedi modifica',
          switchBillingStep2Label: 'Aggiungi carta',
          switchBillingStepIndicator:
            'Passo {{current}} di {{total}} · {{label}}',
          switchBillingProcessing: 'Aggiornamento metodo di pagamento…',
          switchBillingRedirecting: 'Reindirizzamento…',
          switchBillingFromLabel: 'Attuale',
          switchBillingToLabel: 'Nuovo',
          switchBillingInvoiceLabel: 'Fattura',
          switchBillingCardLabel: 'Carta',
          switchBillingNextCycleNote:
            "Ha effetto dall'inizio del prossimo ciclo di fatturazione.\nIl tuo periodo di abbonamento attuale non cambia.",
          switchBillingAddCardTitle: 'Aggiungi una carta di pagamento',
          switchBillingAddCardSubtitle:
            'Un ultimo passaggio per completare il passaggio al pagamento con carta.',
          switchBillingAddCardPendingLabel: 'Carta richiesta',
          switchBillingAddCardPendingText:
            'Per completare il cambio serve una carta di pagamento.\nIl metodo di fatturazione cambierà solo dopo averne aggiunta una.',
          switchBillingAddCardNextLabel: 'Cosa succede ora',
          switchBillingAddCardNextText:
            'Continua ad aggiungere la tua carta di pagamento nella pagina successiva.',
          switchBillingAddCardSecureNote:
            'I dati della tua carta sono crittografati e gestiti in modo sicuro.',
          switchBillingAddCardGo: 'Aggiungi carta di pagamento',
          switchBillingAddCardStepDone: 'Modifica confermata',
          switchBillingAddCardStepNext: 'Aggiungi la tua carta',
          switchBillingSuccess: 'Metodo di pagamento aggiornato.',
          switchBillingErrorGeneric:
            'Impossibile aggiornare il metodo di pagamento. Riprova.',
          switchBillingNoPaymentMethod:
            'Aggiungi un metodo di pagamento prima di poter cambiare.',
          switchBillingNoPaymentMethodLink:
            '<link>Gestisci fatturazione</link>',
          choosePaymentTitle: 'Scegli un metodo di pagamento',
          choosePaymentSubtitle: 'Come vuoi continuare?',
          choosePaymentInvoiceBody:
            'Invieremo le fatture alla tua email di fatturazione. Non verrà addebitato nulla automaticamente.',
          choosePaymentCardBody:
            'Paga automaticamente con una carta. La aggiungerai nella pagina successiva.',
          choosePaymentConfirm: 'Continua',
          choosePaymentConfirmInvoice: 'Usa fattura',
          choosePaymentConfirmCard: 'Aggiungi carta',
          choosePaymentRedirecting:
            'Ti stiamo portando ad aggiungere la carta…',
          choosePaymentCardOpened:
            'Completa l’aggiunta della carta nella nuova scheda.',
          choosePaymentErrorNoUrl:
            'Impossibile aprire la pagina successiva. Riprova.',
          editRecipients: 'Modifica destinatari',
          editRecipientsTitle: 'Destinatari fattura',
          editRecipientsSubtitle:
            'Tutti i destinatari ricevono la stessa fattura. Lascia vuoto per usare l’email del tuo account.',
          editRecipientsSave: 'Salva',
          editRecipientsSaving: 'Salvataggio…',
          editRecipientsError:
            'Non è stato possibile aggiornare i destinatari della fattura. Riprova.',
        },
        invoiceHistory: {
          title: 'Cronologia fatturazione',
          subtitle: 'Fatture e ricevute passate del tuo abbonamento.',
          colInvoice: 'Fattura',
          colIssued: 'Data emissione',
          colDue: 'Scadenza',
          colAmount: 'Importo',
          colStatus: 'Stato',
          colDownload: 'Scarica',
          statusOpen: 'Non pagata',
          statusPaid: 'Pagata',
          statusVoid: 'Annullata',
          downloadInvoice: 'Fattura',
          downloadReceipt: 'Ricevuta',
          invoiceFallback: 'Fattura {{id}}',
          issuedOn: 'Emessa il {{date}}',
          dueOn: 'Scadenza {{date}}',
          noDueDate: '—',
          empty:
            'Non hai ancora fatture. Compariranno qui dopo il primo ciclo di fatturazione.',
          loadError:
            'Impossibile caricare la cronologia fatturazione. Aggiorna la pagina o riprova tra qualche minuto.',
          paginationLabel: 'Pagine cronologia fatturazione',
          showingRange: '{{from}}–{{to}} di {{total}} fatture',
          previousPage: 'Pagina precedente',
          nextPage: 'Pagina successiva',
        },
        usage: {
          title: 'Utilizzo attuale',
          lockedHint: 'Avvia una prova per attivare i limiti del piano',
          lockedHintResubscribe:
            'Riabbonati per ripristinare i limiti del tuo piano.',
          lockedHintTrialExpired:
            'Scegliete un piano per ripristinare i vostri limiti.',
          members: 'Membri',
          atLimitMembers: 'Limite raggiunto',
          spotsRemaining: '{{count}} posti rimanenti',
          communities: 'Community',
          atLimitCommunities: 'Limite raggiunto',
          communitiesRemaining: '{{count}} posti community rimanenti',
          schedulers: 'Pianificatori di gruppo',
          atLimitSchedulers: 'Limite raggiunto',
          schedulersRemaining: '{{count}} pianificatori rimanenti',
          storage: 'Archiviazione',
          atLimitStorage: 'Limite raggiunto - elimina file o aggiorna',
          storageRemaining: '{{count}} GB rimanenti',
          upgradeNudgeTitle: 'Hai raggiunto il limite di community / team.',
          planLimitNudgeTitle: 'Hai raggiunto un limite del piano.',
          upgradeNudgeBody:
            'Passa a Premium per più team, più membri e automazioni e analisi.',
          planLimitNudgeBody:
            'Aggiorna il piano per aumentare limiti di membri, community, pianificatori e archiviazione. Confronta i piani e cambia quando vuoi.',
          upgradeCta: 'Aggiorna',
        },
        actions: {
          choosePlan: 'Scegli piano',
          changePlan: 'Cambia piano',
          comparePlansMenu: 'Confronta i piani',
          cancelSubscription: 'Annulla abbonamento',
          dontCancelSubscription: 'Non annullare l’abbonamento',
          restartMembership: "Riavviare l'iscrizione",
          subscribeAgain: 'Riabbonati',
        },
        trust: {
          poweredBy: 'Pagamenti elaborati in modo sicuro tramite Stripe',
        },
      },
    },
    terms: {
      title: 'Termini e condizioni di Gumb',
    },
    errors: {
      cantSendMessageToYourself: 'Non puoi inviare un messaggio a te stesso.',
      downloadFail: 'Errore di download, riprova.',
      required: 'Campo obbligatorio',
      email: 'Per favore inserisci una email valida',
      invalidEmail:
        "Ops! Inserisci un'email valida. Controlla gli errori e riprova.",
      integer: 'Deve essere un intero',
      confirmPassword: 'Le password non sono identiche. Riprova per favore',
      NotAuthorizedException: 'Il nome utente o la password non sono validi.',
      invalidCode: 'Questo codice non è valido. Riprova per favore.',
      errorToast: 'Errore: {{message}}',
      invalidRequest: 'Richiesta non valida',
      passwordChanged: 'Password cambiata',
      password:
        'La password dovrebbe contenere al meno 8 caratteri, lettere maiuscole e minuscole, numeri',
      termsError: 'Per favore accetta i nostri termini e condizioni',
      min: 'Minimo {{value}} caratteri',
      max: 'Massimo {{value}} caratteri',
      startDate: 'La data non può essere precedente al {{value}}',
      endDate: 'La data non può essere precedente alla data di inizio',
      fileSize: 'Dimensione file troppo grande',
      fileSizeCustom:
        'File troppo grande: La dimensione massima è {{size}} MB.',
      customFileSize: 'File troppo grande: Max {{size}}. Rimuovilo e riprova.',
      unsupportedFormat: 'Formato file non supportato',
      postalCode: 'Minimo 4 numeri',
      sorry: 'Siamo spiacenti',
      text404: 'Sembrerebbe che la pagina che cerchi non è disponibile :(',
      url: 'Deve essere un URL valido.',
      text500: 'Qualche cosa è andata male :(',
      onlyForGroupAndAdmin: 'Funzione solo per admin e capigruppo',
      onlyForAdmin: 'Funzione solo per admin',
    },
    eventTypes: {
      createSuccess: 'Tipo evento creato',
      editSuccess: 'Modifiche salvate',
      deleteSuccess: 'Tipo evento eliminato',
    },
    eventTasks: {
      createSuccess: 'Attività creata',
      editSuccess: 'Modifiche salvate',
      deleteSuccess: 'Attività eliminata',
    },
    eventResponses: {
      createSuccess: 'Risposta salvata',
      editSuccess: 'Modifiche salvate',
      deleteSuccess: 'Risposta eliminata',
    },
    tips: {
      registrationDeadline:
        'Il termine scade all’orario di inizio impostato dell’evento. I membri possono confermare fino a quel momento. Dopo, solo admin e capigruppo possono modificare.',
      eventType:
        'L’admin può aggiungere nuovi tipi di evento nelle impostazioni della community.',
    },
    frequencies: {
      doNotRepeat: 'Non si ripete',
      daily: 'Ogni giorno',
      weekly: 'Ogni settimana',
      monthly: 'Ogni mese',
      yearly: 'Ogni anno',
      everyWorkingDay: 'Tutti i giorni della settimana (dal lunedì al venerdì)',
      other: 'Personalizza…',
    },
  },
  fr: {
    appWidget: 'Installe Gumb sur ton appareil',
    featurePopups: {
      appointmentSchedule: {
        innerHtml:
          "<h3>New feature: Download your appointment schedule as an Excel or CSV file. </h3><p>We have completely redesigned the statistics page, and you can export your entire schedule now. The new report called 'Appointment schedule' gives you an overview of facts and figures of your events.</p><p>We are already working on another report called 'Member figures' which will be related to user performance. </p><p>The diary report is now available in the web app for all users.</p>",
        buttonOk: 'LATER',
        buttonRedirect: 'SEE NOW',
      },
      appleCalendar: {
        title: 'CONNECTEZ VOTRE CALENDRIER (iCal)&nbsp;🍏',
        message:
          "Nous avons réussi! Après beaucoup d'efforts, Gumb permet maintenant une connexion directe du calendrier dans la version WEB pour une synchronisation sans faille. Restez à l'écoute pour la sortie de la version iOS/Smartphone&nbsp;bientôt&nbsp;disponible!",
        extraMessage: 'Ouvrez le guide étape par étape',
        redirectText: 'ici',
        okButton: 'Connecter maintenant',
        cancelButton: 'Pas maintenant',
      },
      preferecePopup: {
        title: '2 New Features',
        first: {
          title: 'Set All to "Going":',
          subtitle:
            'Set the default response for new or existing events - for all participants at once!',
          link: '',
        },
        second: {
          title: 'Default Event Settings:',
          subtitle: 'Define how new events should look.',
          link: 'Instructions',
        },
      },
      calendar: {
        innerhtml:
          "<h3>Nous l'avons fait !</h3> <p> La connexion GOOGLE CALENDRIER est là ! </p> <br/> <p> Les rendez-vous de Gumb - Chaque communauté peut être sélectionnée individuellement, peuvent maintenant être transférés automatiquement dans ton calendrier.  </p> <div class='images-container'> <img src='https://gumb-cdn-prod.s3.eu-central-1.amazonaws.com/featurePopups/calendar-1.png' alt='calendar-1' /> <img src='https://gumb-cdn-prod.s3.eu-central-1.amazonaws.com/featurePopups/calendar-2.png' alt='calendar-2' /></div> <p> Tout ce que tu dois faire t'est expliqué dans ce guide : <br/><a target='_blank' rel='noopener noreferrer' href='https://gumb.app/en/support/connect-gumb-with-google-calender/'>→&nbsp; Lire les instructions complètes </a> </p> <p>Guide de démarrage rapide :</p> <ol> <li>Schritt: Se connecter et important : cocher la case !</li> <li>Sélectionner la communauté</li> <li>Attendre quelques minutes et recharger la page.</li> </ol> <p> Connecte ton agenda Google pour gagner du temps et profiter au maximum de chaque jour. </p>",
        buttonOk: 'RIEN POUR MOI',
        buttonRedirect: 'CONNECTE-TOI MAINTENANT',
      },
      notifications: {
        title: 'Comment les membres doivent-ils être informés ?',
        firstRow:
          'Nous avons ajouté : Messages push mobiles et paramètres de notification.',
        secondRow:
          "Les paramètres de notification gérés par les administrateurs peuvent désormais être ajustés pour l'ensemble de la communauté :",
        thirdRow: 'Tout ce que vous avez à faire est :',
        listFirstRow:
          'Aller dans les paramètres de la communauté → notifications.',
        listSecondRow:
          'Activez/désactivez les options dans chaque catégorie, → pour que tout soit parfaitement adapté à vous. (→ Lire les instructions <0>ici</0>)',
        lastRow:
          "Indiquez à vos membres d'activer maintenant les paramètres de push ou d'e-mail dans leur propre profil Gumb. ",
        buttonLater: 'Plus tard',
        buttonSettings: 'Aller aux paramètres maintenant',
      },
      pushNotifications: {
        title: '📢 Communication de niveau supérieur : Notifications Push',
        message:
          "Les administrateurs et les chefs de groupe peuvent désormais créer des notifications push pour vous envoyer des informations importantes directement sur votre smartphone.\n\nCe que vous pouvez faire avec les notifications push :\n\n• <b>Partager des informations importantes instantanément</b> (ex : changements d'horaires, urgences)\n• <b>Atteindre des personnes individuelles ou des équipes entières</b> (communication personnalisée)\n• <b>Enregistrer des messages en tant que modèles pour gagner du temps</b> (communication efficace)",
        extraMessage: 'Restez informé et ne manquez plus aucune nouvelle !',
        cancelButton: 'Voir plus tard',
        okButton: 'Essayer maintenant',
        newMessageOne:
          'Les administrateurs et les chefs de groupe peuvent désormais communiquer directement avec des personnes individuelles ou des équipes entières pour vous envoyer des informations importantes directement sur votre smartphone.\n\n',
        redirectLink: 'Créez des notifications push personnalisées',
        newMessageTwo:
          ', sélectionnez les destinataires et enregistrez même vos messages en tant que modèles pour une utilisation ultérieure.',
      },
      importEvent: {
        title: 'Upload/Import Events ',
        subText:
          "No more manual entry! Easily import your events with a CSV or Excel file. Whether it's 30 or 300 events - it's quick and can even be undone if there are mistakes.",
        cancelButton: 'View later',
        okButton: 'Try now',
        secondText: 'Find step-by-step instructions',
      },
      mail: {
        title: 'Nouvelle fonction : MODE MESSAGE',
        firstRow:
          "La fonction e-mail intégrée simplifie et accélère la communication au sein de l'équipe.  Envoyer d'urgence un e-mail à tout le monde ? Mais uniquement aux membres qui ont répondu \"oui\" lors du rendez-vous ? → C'est désormais possible en quelques clics !",
        secondRow:
          "Le mode mail est dès à présent disponible dans l'application web pour les administrateurs et les responsables de groupe. Il sera encore développé dans les temps à venir.",
        thirdRow:
          'Pour en savoir plus : <0>https://gumb.app/support/mailmodus/</0>',
        buttonLater: 'PLUS TARD',
        buttonMail: 'VOIR MAINTENANT',
      },
      eventPdf: {
        title: 'Nouvelle fonction : télécharger le rendez-vous au format PDF',
        firstRow:
          "Gagnez du temps et imprimez les détails de l'événement en un seul clic !",
        secondRow:
          'Peu avant les événements à venir ou pour les événements passés, tous les détails des rendez-vous, y compris toutes les statistiques de réponse, peuvent être exportés en PDF.',
        thirdRow:
          "Condition préalable pour l'agenda : tu as des droits d'administrateur.",
        fourthRow:
          "Condition préalable pour l'agenda de groupe : tu es chef de groupe.",
        fifthRow:
          "Cette fonction est disponible dès maintenant dans l'application web.",
      },
    },
    menu: {
      homePage: 'ACCUEIL',
      subscriptions: 'Souscriptions',
      groupScheduler: 'CALENDRIER',
      documentation: 'DOCUMENTS',
      chats: 'CHAT',
    },
    dayOfWeek: {
      day1: 'LUN.',
      day2: 'MAR.',
      day3: 'MER.',
      day4: 'JEU.',
      day5: 'VEN.',
      day6: 'SAM.',
      day0: 'DIM.',
    },
    status: {
      taskInactive: '= Non activé',
      notActivated: '= Non activé',
      awaitingReply: '= En attente',
      taskInactiveDesc:
        'Cette tâche est désactivée - les membres ne la voient pas.',
      notActivatedDesc:
        'Cette personne n’est pas activée pour l’événement - elle ne le voit pas (case blanche).',
      awaitingReplyDesc:
        'L’événement est visible, mais aucune réponse n’a encore été donnée.',
      notActivatedAction:
        'Cliquer sur l’événement → Modifier → Participants → cocher la case → Enregistrer',
      taskInactiveAction:
        'Cliquer sur l’événement → Modifier → Tâches → cocher la case → Enregistrer',
      awaitingReplyAction:
        'Appuie sur la case → Choisis une réponse → Enregistrer',
    },
    email: {
      sender: 'Expéditeur',
      recipients: 'Destinataires',
      otherRecipients: 'Autres destinataires (séparer par une virgule)',
      subject: 'Sujet',
      message: 'Message',
      attachCommunityDocs: 'Joindre des documents communautaires',
      emailSentSuccessfuly:
        'E-mail envoyée. Attention : il s’agissait d’un e-mail no-reply, le destinataire ne peut pas répondre directement, mais votre adresse d’expéditeur est visible.',
      emailSent: {
        title_one: '📤 Email envoyé à {{count}} destinataire',
        title_other: '📤 Email envoyé à {{count}} destinataires',
        message:
          "Si quelqu'un répond, le message arrive directement dans votre boîte mail.",
      },
      sendCopy: 'Envoie-moi une copie',
      plusTooltip: 'Écrire un nouvel e-mail',
      maxAttachmentsSize: 'Taille totale des pièces jointes max 15 Mo',
      changeEmail: {
        title: 'E-mail de confirmation envoyée',
        message:
          'Nous t’avons envoyé un e-mail avec un lien de confirmation pour ta nouvelle adresse. Vérifie ta boîte de réception et clique sur le lien pour confirmer la modification. Si tu ne reçois rien, regarde dans le dossier spam. En cas de question, nous sommes là pour toi.',
      },
    },
    pushNotification: {
      header: 'Notifications Push',
      filterByRecipient: 'Sélectionner les destinataires',
      filterByResponse: 'Sélectionner les destinataires par réponse',
      pushMessage: 'Créer push',
      saveAsTemplate: 'Enregistrer comme modèle',
      sendCopy: "M'envoyer une copie",
      pasteUrl: '🌐 Lien vers un événement ou externe?',
      plusTooltip: 'Créer une nouvelle notification push',
      toasterText:
        "🆕 Nouvelle fonctionnalité : Tu peux maintenant ajouter un lien externe, comme n'importe quel site web 🌐 (URL), dans les notifications push!\nRedirige les destinataires directement vers le site.",
      templates: 'Modèles',
      title: 'Titre',
      lastUsed: 'Dernière utilisation',
      noTemplates: 'Les modèles enregistrés s’affichent ici',
      template: 'Modèle',
      sendConfirmHeader: "Vérifier avant d'envoyer",
      totalRecipients: 'DESTINATAIRES',
      redirectLink: 'VERS LE LIEN',
      successTitle: 'Notification envoyée !',
      successMessage:
        'Votre message a été envoyé à <b>{{totalRecipients}}</b> destinataires.',
      selectEventFirst: "Veuillez d'abord sélectionner un événement",
      templateLimitTitle: 'Limite de modèles atteinte',
      templateLimitInfo:
        "Enregistrez jusqu'à 8 de vos messages en tant que modèles pour les réutiliser ultérieurement.Nous avons déjà ajouté 3 modèles pour vous inspirer - n'hésitez pas à les modifier ou à les supprimer.",
      templateLimitMessage:
        'Vous avez atteint le nombre maximum de modèles. Veuillez en supprimer un pour en créer un nouveau.',
      urlInfo:
        'Ici, tu peux ajouter des liens vers n’importe quel site web, par exemple une page produit, un article ou tout ce qui compte pour vous. Saisis l’URL complète (y compris https://).',
      urlInfoOne:
        'Tu peux ajouter ici n’importe quel site web externe (URL) pour que tes destinataires y accèdent directement. Si tu sélectionnes un événement ci-dessus, l’app ajoute automatiquement le lien et la notification push ouvre l’événement directement dans Gumb.',
      urlInfoTwo:
        "Prochainement : Ajoutez n'importe quel lien externe (sauf Gumb) à vos notifications push ! Faites la promotion de sites Web, d'articles de presse et bien plus encore. Restez&nbsp;à&nbsp;l'écoute&nbsp;!",
      urlTooltip:
        'Vous pouvez créer une notification push avec ou sans lien vers un événement. Vous souhaitez partager le lien de votre événement ? Sélectionnez simplement un événement ci-dessus pour le copier automatiquement ici.',
    },
    common: {
      noResultsFound: 'Aucun événement plus ancien disponible',
      logoutTooltip: 'Se déconnecter',
      ctrl: 'Afficher/masquer les totaux',
      nextDay: '+1j',
      createdAt: 'Creado el',
      updatedAt: 'Actualizado el',
      onlyAdmin: 'Seuls les admins peuvent utiliser cette fonction.',
      download: 'Télécharger',
      attachFile: 'Joindre un fichier',
      new: 'Nouveau',
      unseen: 'Non vus',
      more: 'Plus',
      less: 'Moins',
      sunday: 'Dimanche',
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      january: 'Janvier',
      february: 'Février',
      march: 'Mars',
      april: 'Avril',
      may: 'Mai',
      june: 'Juin',
      july: 'Juillet',
      august: 'Août',
      september: 'Septembre',
      october: 'Octobre',
      november: 'Novembre',
      december: 'Décembre',
      overallScheduler: 'Planificateur',
      selectEvent: "Sélectionnez l'événement (facultatif)",
      displayEventsFrom: 'Afficher les événements de',
      modalExit:
        'Êtes-vous sûr de vouloir quitter sans enregistrer vos données ?',
      all: 'Tous',
      tooltipEdit: 'Modifier le membre',
      tooltipDelete: 'Supprimer un membre',
      overview: 'Aperçu',
      cancel: 'Annuler',
      removeLogo: 'Etes-vous sûr de vouloir supprimer ceci?',
      noTasks: "Aucune tâche pour l'instant",
      noUsers: "Aucun utilisateur pour l'instant",
      noOptions: 'Aucune option',
      role: 'Rôles',
      admin: 'Administrateurs',
      member: 'Membres',
      group_lead: 'Chefs de bande',
      email: 'Email',
      groups: 'Groupes',
      logoutHeader: 'Déconnexion ?',
      logoutMessage: 'Tu seras redirigé vers l’écran de connexion.',
      deleteHeader: "Êtes-vous sûr de vouloir supprimer l'utilisateur?",
      logout: 'Déconnexion',
      delete: 'Supprimer',
      tablePlaceholder: 'Aucun membre à afficher pour l’instant',
      contentPlaceholder: 'Aucun contenu à afficher pour l’instant',
      create: 'Créer',
      copy: 'Copier',
      visible: 'Visible',
      saveChanges: 'Sauvegarder les changements',
      newField: 'Nouveau champ',
      fieldName: 'Nom du champ',
      addField: 'Ajouter un champ',
      notifications: 'Notifications',
      participants: 'Participants',
      tasks: 'Tâches',
      documentation: 'Documents',
      description: 'Description',
      facebook: 'Facebook',
      twitter: 'X',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      youtube: 'YouTube',
      startDate: 'Date de début',
      startTime: 'Heure de début',
      startDateTime: 'Date/heure de début',
      endDateTime: 'Date/heure de fin',
      endDate: 'Date de fin',
      endTime: 'Heure de fin',
      icon: 'Icône',
      sendMessage: 'Envoyer message',
      aboutMe: 'A propos de moi',
      selectAll: 'Sélectionner tout',
      approve: 'Approuver',
      reject: 'Rejeter',
      backToGumb: 'Retour à Gumb',
      edit: 'Editer',
      addComment: 'Ajouter commentaire',
      answer: 'Enregistrer',
      ok: 'Ok',
      withoutGroup: 'Sans groupe',
      copyLink: 'Copier le lien',
      copied: 'Copié',
      sendInviteLink: "Envoyer un lien d'invitation",
      apply: 'Appliquer',
      from: 'De',
      to: 'À',
      enable: 'Activer',
      search: 'Recherche',
      color: 'Couleur',
      columns: 'Colonnes affichées',
      hiddenColumns: 'Colonnes masquées',
      sorryNoResults:
        "Nous sommes désolés que vous n'ayez pas trouvé ce que vous cherchiez. Veuillez essayer d'une autre manière.",
      tutorial: 'Guide',
      next: 'Suivant',
      back: 'Retour',
      step: 'Étape',
      createSuccess: {
        title: 'Créée',
        message: 'Votre option a été créée avec succès.',
      },
      editSuccess: {
        title: 'Modifiée',
        message: 'Vos modifications ont été enregistrées.',
      },
      deleteSuccess: {
        title: 'Supprimée',
        message: "L'option a été supprimée avec succès.",
      },
      toolTipText: {
        grid3x3: 'Matrice : affecter des membres aux communautés',
        faq: 'Aide: Guides, Contact, Plus.',
        communityPlusIcon: 'Créer une nouvelle communauté',
        logoGumb:
          'Mystère en préparation : Découvrez plus tard ce que cache ce bouton !',
        memberPlusIcon: 'Ajouter un nouveau membre',
        memberArrowIcon: 'Aller à l’aperçu des membres',
        eventType: "Créer un type d'événement",
        responses: 'Créer une option de réponse',
        task: 'Créer une tâche',
        schedulerPlusIcon: 'Créer un événement ou un groupe',
      },
      shareEventTitle: 'Partager le lien de l’événement via :',
      copyEventLink: 'Ou copie le lien :',
    },
    auth: {
      signInWith: 'Se connecter avec',
      continueAs: 'Continuer en tant que',
      create: 'Créer un compte gratuit',
      signUp: 'S’inscrire',
      signIn: 'Se connecter',
      welcome: 'Bienvenue !',
      createAccount: 'Créer compte gratuit',
      forgotPassword: 'Mot de passe oublié?',
      resetPassword: 'Réinitialiser le mot de passe',
      resetPasswordTooltip:
        'Si tu réinitialises le mot de passe, le membre recevra un e-mail avec des instructions pour en définir un nouveau. Pour les comptes créés via Facebook, Google ou Apple, Gumb ne peut pas réinitialiser le mot de passe. Le membre peut continuer à se connecter via l’icône du réseau social.',
      resetPasswordModalTitle: 'Réinitialisation du mot de passe lancée',
      resetPasswordModalText:
        'Le membre reçoit maintenant un e-mail pour changer son mot de passe. Pour Facebook, Google ou Apple, il peut se connecter comme d’habitude avec l’icône.',
      resetPasswordErrorModalTitle:
        'Réinitialisation du mot de passe impossible',
      resetPasswordErrorModalText:
        'Attention : Ce membre se connecte avec Facebook, Google ou Apple. Gumb ne peut pas réinitialiser le mot de passe. Si le membre a oublié son mot de passe, il doit le réinitialiser directement chez le fournisseur. La connexion via l’icône sociale fonctionne toujours. Merci d’en informer le membre.',
      terms: {
        '0': "J'accepte les",
        '1': 'Termes',
        '2': 'et la',
        '3': 'Politique de Confidentialité',
      },
      termsAcknowledgement:
        'By continuing, you acknowledge that you understand and agree to the <0>Terms & Conditions</0> and <1>Privacy Policy</1>.',
      home: 'Accueil',
      confirmed: 'Email confirmé avec succès',
      verifying: "Vérification de l'email...",
      recovery: 'Récupération du mot de passe',
      send: 'Envoyer',
      codeSended:
        'Un lien de vérification a été envoyé à ton e-mail. Merci de vérifier et de confirmer. Pense aussi au dossier spam.',
      signUpSuccess:
        "Inscription validée. Veuillez confirmer l'inscription dans l'email reçu",
      inviteSentTitle: 'Invitation envoyée avec succès',
      inviteSentText:
        'Top ! Membre ajouté et invitation avec mot de passe temporaire envoyée (vérifie le spam si besoin). Le membre peut maintenant se connecter et changer le mot de passe. Recharge la page pour mettre à jour la liste. Toi et tes admins pouvez maintenant modifier le groupe, le rôle ou le profil du membre.',
      reset: 'Réinitialiser',
      yourEmail: '{{value}} est déjà votre adresse email',
      existEmail: '{{value}} existe déjà',
      labels: {
        email: 'Email',
        currentEmail: 'Courriel actuel',
        newEmail: 'Nouveau email',
        password: 'Mot de passe',
        oldPassword: 'Ancien mot de passe',
        newPassword: 'Nouveau mot de passe',
        confirmPassword: 'Confirmer mot de passe',
      },
      accountExists:
        "Cette adresse e-mail est déjà utilisée pour un compte Gumb. Si cet e-mail t'appartient, clique sur Mot de passe oublié et vérifie ta boîte de réception et ton dossier de courrier indésirable.",
      codeExpired:
        'Ce lien a expiré. Après avoir saisi votre adresse électronique ici, nous vous enverrons un nouveau lien pour terminer la vérification de votre compte.',
      userNotConfirmed:
        "Tu dois encore vérifier ton compte. Nous t'avons envoyé un e-mail avec un lien de confirmation. Si tu n'as pas reçu d'e-mail, vérifie également le dossier spam de ta boîte de réception. ",
      invalidCredentials: "Nom d'utilisateur ou mot de passe incorrect",
      userNotFound:
        'Cet e-mail n’est pas encore enregistré ou est lié à Google, Apple ou Facebook. Ne change pas le mot de passe du réseau social dans Gumb, connecte-toi simplement avec l’icône correspondante.',
      socialLoginDetected: {
        title: 'Connexion via un réseau social détectée',
        message:
          'Cet e-mail semble lié à Google, Apple ou Facebook. Le mot de passe y est géré, pas par Gumb. Pour te connecter, clique simplement sur l’icône du réseau social.',
      },
    },
    profile: {
      editSuccess: 'Modifications enregistrées',
      settings: 'Paramètres',
      editProfile: 'Modifier profil',
      selectImage: 'Sélectionner image',
      myProfile: 'MMon profil',
      profileEditBtn: 'AJOUTE TES INFOS : ADRESSE, RÉSEAUX, ETC.',
      basicInformation: 'Infos de base',
      contactInformation: 'Contact',
      addressInformation: 'Adresse',
      myChat: 'MES CHATS',
      freeText1: 'Texte Libre 1',
      freeText2: 'Texte Libre 2',
      myCommunities: 'Mis comunidades',
      myAppointments: 'Mes rendez-vous',
      subscription: 'Abonnement',
      userProfile: 'Profil utilisateur',
      tellUsAboutYourself: 'À propos de moi',
      firstName: 'Prénom',
      lastName: 'Nom',
      profileName: 'Nom d’utilisateur',
      person: 'Personne',
      role: 'Rôle utilisateur',
      email: 'Email',
      dateOfBirth: 'Date de naissance',
      privatePhoneNumber: 'Tél (Privé)',
      officePhoneNumber: 'Tél (Travail)',
      mobilePhoneNumber: 'Tél (Mobile)',
      street: 'Rue',
      region: 'Département',
      postalCode: 'Code postal',
      city: 'Ville',
      country: 'Pays',
      about: 'A propos',
      linkChangeEmail: "(Modifier l'e-mail)",
    },
    profileCommunities: {
      empty: {
        title: 'Aucune communauté visible',
        description:
          'Dès que tu crées tes propres communautés ou que tu rejoins d’autres,<brPure />elles s’afficheront ici.',
      },
      popupLeave: {
        title: 'Tu veux vraiment quitter la communauté ?',
        button: 'Quittez',
      },
      leaveCommunity: {
        title: 'Tu veux vraiment quitter la communauté ?',
        message:
          'Tu quittes juste cette communauté. Ton compte reste et tu peux rejoindre d’autres à tout moment.',
        okButton: 'Oui, Quitter',
        cancelButton: 'Annuler',
      },
    },
    profileSettings: {
      title: 'Paramètres du profil',
      notification: 'Notification',
      notificationsPlaceholder: 'Tu n’as pas encore de notifications',
      changePassword: 'Changer mot de passe',
      changeEmail: 'Email',
      saveNewEmail: 'Sauvegarder le nouvel email',
      language: 'Langue',
      timeFormat: 'Format de l’heure',
      permissions: 'Autorisations',
      allowedToEdit: 'Les administrateurs sont autorisés à modifier mon profil',
      other: 'Autre',
      pushNotification: 'Notification push',
      receiveByEmail: 'Recevoir des notifications par e-mail',
      receivePush: 'Recevoir des notifications par push mobile',
      receiveInApp: 'Recevoir des notifications in-app',
      terms: 'Termes et conditions',
      protectionRegulation: 'Politique de confidentialité',
      deleteAccount: 'Supprimer compte',
      logout: 'Se déconnecter',
      deleteProfileHeader: 'Tu veux vraiment supprimer ton compte ?',
      notifications: {
        now: 'Maintenant',
        hours: 'Il y a {{value}} h',
        minutes: 'Il y a {{value}} min',
        minute: 'Il y a 1 min',
      },
    },
    calendarConnection: {
      outlookCalendar: 'Outlook Calendar',
      googleCalendar: 'Google Calendar',
      pageTitle: 'Connexion au calendrier',
      connectTitle: 'Connecte ton agenda\npour synchroniser tes événements',
      connectDescription:
        'Gumb crée des événements pour toi - ils s’affichent directement dans ton agenda.',
      appleCalendar: 'Calendrier Apple',
      appleConnectionSteps: {
        headerOne:
          'Ajoute les événements Gumb à ton calendrier (Apple ou Outlook) via une URL iCal - en 4 étapes.',
        demoLinks: 'Démo rapide',
        demoLinksApple: 'Apple',
        demoLinksAppleHere: 'ici',
        demoLinksDetailed: 'Guide détaillé',
        demoLinksDetailedApple: 'Apple',
        demoLinksDetailedHere: 'ici',
        demoLinksOutlook: 'Outlook',
        demoLinksOutlookHere: 'ici',
        stepOne: 'Dans ton application calendrier, ouvrir',
        stepOneSubscribeBold: "S'abonner à un calendrier",
        stepOneApplePrefix: 'Apple',
        stepOneAppleSuffix: 'Fichier → Nouvel abonnement à un calendrier',
        stepOneOutlookPrefix: 'Outlook',
        stepOneOutlookSuffix:
          "Ajouter un calendrier → À partir d'Internet / Calendrier abonné",
        stepTwo: 'Copier le lien iCal de ta communauté ci-dessous et le coller',
        stepThree: 'Donner un nom et, si besoin, choisir une couleur',
        stepFour:
          "Ajuster l'emplacement (iCloud, Mac, Outlook) & l'actualisation, confirmer",
      },
      appleConnectionPopup: {
        title: 'Comment connecter ?',
        stepOne: 'Copier le lien de la communauté',
        stepTwo:
          'Dans votre Calendrier Apple, sous "Calendrier", choisissez "Fichier" > "Nouvel abonnement au calendrier".',
        stepThree:
          'Entrez le lien iCal de la Communauté copié, puis cliquez sur "S\'abonner".',
        stepFour:
          'Nommez le calendrier, choisissez une couleur, réglez les préférences comme l\'emplacement (iCloud ou Mac) ou la mise à jour automatique et cliquez sur "OK".',
      },
      appleDisconnectPopup: {
        title: 'Confirmer la Déconnexion',
        message:
          'En cliquant sur "Oui, se déconnecter maintenant", tous les événements Gumb seront supprimés de votre/vos calendrier(s). Veuillez ensuite supprimer manuellement le(s) calendrier(s), car il(s) restera/resteront sinon visible(s).\n\n<b>Pour se désabonner complètement :</b>\n\n• <b>Sur macOS</b>: Ouvrez Calendrier, cliquez droit sur le calendrier > "Se désabonner".\n• <b>Sur iOS</b>: Allez dans "Calendriers", touchez le bouton "Info" à côté du calendrier > "Supprimer le Calendrier".',
        okButton: 'Oui, se déconnecter maintenant',
      },
      appleUncheckBoxPopup: {
        title: 'Confirmer la Déconnexion',
        message:
          'En cliquant sur "Oui, se déconnecter maintenant", tous les événements Gumb seront supprimés de votre calendrier. Veuillez ensuite supprimer manuellement le calendrier, car il restera sinon visible.\n\n<b>Pour se désabonner complètement :</b>\n\n• <b>Sur macOS</b> : Ouvrez Calendrier, cliquez droit sur le calendrier > "Se désabonner".\n• <b>Sur iOS</b> : Allez dans "Calendriers", touchez le bouton "Info" à côté du calendrier > "Supprimer le Calendrier".',
        okButton: 'Oui, se déconnecter maintenant',
      },
      connectWithApple: 'Connecter Apple et Outlook (iCal)',
      cantSeeICal:
        'Vous ne voyez pas le lien iCal ? Cochez simplement la case.',
      syncTip:
        'Seuls les événements de la communauté sélectionnée seront synchronisés avec votre calendrier.',
      connect: 'Connectez-vous à',
      connected: 'Connecté',
      disconnect: 'Déconnecter',
      disconnectSuccess: 'Déconnexion réussie',
      selectCommunities: 'Sélection des communautés',
      selectCommunitiesDescription:
        'Seuls les événements de la communauté sélectionnée seront synchronisés avec votre calendrier.',
      authSuccessTitle: 'Connexion réussie',
      authSuccessMessage:
        'Tes événements se synchronisent automatiquement. Attends un instant puis recharge Google Agenda pour terminer la première synchronisation.',
      authSuccessTitleTwo: 'Sélectionne ta communauté maintenant',
      authSuccessMessageTwo:
        'Coche la case et appuie sur "Enregistrer les modifications" pour confirmer.',
      syncSuccess:
        'Mis à jour !\nSynchronisation automatique active. Gère tes communautés à tout moment.',
      syncSuccessTitle: 'Presque fini !',
      syncSuccessMessage:
        'On relie ta communauté à ton Google Agenda. Ça prendra juste 2-3 minutes. Actualise ta page Google Agenda pour voir les mises à jour.',
      disconnectConfirmTitle: 'Vous êtes sûr ?',
      disconnectConfirmDescription:
        'Si vous vous déconnectez, tous les événements seront supprimés de votre calendrier.',
      disconnectConfirm: {
        title: 'Déconnecter maintenant ?',
        message:
          'La déconnexion supprimera tous les événements de votre Google Agenda. Ne vous inquiétez pas, vous pouvez reconnecter Gumb pour une nouvelle synchronisation à tout moment.',
        cancelButton: 'Annuler',
        okButton: 'Oui, Déconnecter',
      },
      noCommunities:
        "Il n'y a aucune communauté à sélectionner.\nAttendez qu'un administrateur vous ajoute.",
      checkboxWarning: 'ATTENTION : La case doit être cochée !',
    },
    community: {
      noMembersEmptyState: {
        title: 'Aucun membre inscrit',
        description: 'Dès que des membres s’inscriront, ils apparaîtront ici.',
      },
      plusIconSubText: "Planifie un événement ou crée des séries d'événements.",
      selectAllCommunityAdmins: 'Tous les admins',
      selectAllGroupAdmins: 'Tous les chefs de groupe',
      createSuccess: 'Communauté créée avec succès',
      createFailure: 'Réessayez dans un instant de créer votre communauté.',
      deleteSuccess: 'Communauté supprimée avec succès',
      leaveSuccess: 'Vous avez réussi à quitter la communauté',
      descriptionTitle: 'A propos de la communauté',
      descriptionPlaceholder: 'Ici vous pouvez décrire votre communauté',
      online: 'En ligne',
      updateCommunity: 'Actualiser la communauté',
      members: 'Membres',
      createCommunity: 'Créer communauté',
      communityName: 'Nom de la communauté',
      category: 'Catégorie',
      aboutCommunity: 'A propos de la communauté',
      selectLogo: 'Sélectionner logo',
      selectLogoTip: 'jpg, jpeg, png (5MB)',
      chooseCover: 'Choisir photo de couverture',
      chooseCoverTip: 'jpg, jpeg, png (20MB)',
      website: 'Site Internet',
      partnership: 'Partenariat',
      deleteCommunity: 'Supprimer communauté',
      deleteHeader:
        'Êtes-vous sûr de vouloir retirer cet utilisateur du groupe ?',
      addMembers: 'Ajouter des membres',
      invitationLink: "Lien d'invitation",
      communityRole: 'Rôle dans la communauté',
      joinCommunity: 'Rejoindre la communauté',
      namePlaceholder: 'Equipe de {{value}}',
      requestSent: "Demande d'adhésion envoyée avec succès",
      requestSentButton: "Demande d'adhésion envoyée",
      limitExceededHeader:
        'Ta limite de communautés est atteinte. Pour en créer plus, mets à niveau ton plan dans Profil > Abonnement.',
      limitExceededMessage:
        "Contacte le propriétaire de ta communauté. Seul(e) il/elle peut gérer et mettre à jour l'abonnement.",
      limitExceededMessageOwner:
        "S'il te plaît, va dans Profil > Abonnement pour gérer ton plan et le mettre à niveau si besoin.",
      updateFailure: 'Echec de mise à jour de la communauté',
      buttonAddEvent: 'Ajouter un évènement',
      userBlockedTitle: 'Bloqué',
      userBlockedText:
        "Il semble que quelqu'un vous ait bloqué sur cette communauté. Les administrateurs peuvent bloquer ou débloquer des membres.",
      createOverLimitTitle: 'Limite de communautés atteinte',
      createOverLimitText:
        "Lance ta période d'essai gratuite ou choisis un abonnement dans 'Modifier l'abonnement' pour organiser ta propre communauté.",
      notInvitedTitle: "Pas d'autorisation",
      notInvitedText:
        "Vous n'avez peut-être pas l'autorisation d'accéder à cet événement. Les administrateurs et les chefs de groupe peuvent vous ajouter à l'événement.",
      noRequestsTitle: 'Pas encore de demandes en attente.',
      noRequestsText:
        'Lorsque des personnes soumettent des demandes pour ta communauté, elles sont affichées ici pour vérification.',
      invitationCodeExpired:
        "Ce lien d'invitation a expiré. Mais tu peux maintenant envoyer une demande d'adhésion que les admins peuvent accepter ou refuser.",
      communityNotFound: 'Communauté non trouvée',
      communityPopup: {
        title: 'Créer un Événement ou un Groupe',
        subTitleOne:
          'Planifiez des événements dans le PLANIFICATEUR central. Utilisez des groupes pour diviser vos membres en équipes.',
        createEvent: {
          infoText:
            "Planifiez des événements pour tous ou pour des groupes/membres spécifiques dans le PLANIFICATEUR. Visible dans le planificateur, sous 'Mes Événements', et dans les groupes.",
          btntitle: 'Créer un Événement',
          linkText: 'Tutorial',
        },
        createGroup: {
          infoText:
            'Chaque groupe a son propre planificateur, avec des événements visibles uniquement pour les membres du groupe. Gérez efficacement les rôles des membres',
          btntitle: 'Créer un Groupe',
          linkText: 'ici',
        },
        chatTitle: 'Options de chat',
        chatSubTitle:
          'Lance un chat 1:1 ou crée une salle de chat pour des groupes.',
        oneToOne: {
          infoText:
            "Clique sur l'icône de chat à côté du nom d'un membre ou sur sa photo de profil pour lui envoyer un message.",
          btntitle: 'Voir la liste des membres',
          linkText: 'Tutorial',
        },
        createChatGroup: {
          infoText:
            'Crée une salle de chat privée pour des membres, équipes ou groupes sélectionnés. Seuls les administrateurs peuvent créer ces salles. ',
          btntitle: 'Créer une salle de chat',
          linkText: 'ici',
        },
      },
      exportStatistics: 'Exportation des statistiques',
      exportStatisticsTooltip: 'Exporter les statistiques vers un fichier CSV',
    },
    communitySettings: {
      noSearchResults: {
        title: 'Aucun résultat',
        description:
          'Aucun résultat pour {{searchResult}}. Essaie avec un autre terme de recherche.',
      },
      noMatrixData: {
        title: 'Nessuna community visibile',
        description:
          'Quando un proprietario crea delle community e ti rende admin, potrai assegnare qui i membri.',
      },
      clearSearch: 'Réinitialiser la recherche',
      matrixDescription:
        'Affecter/retirer des membres à vos communautés en un clic - enregistrement immédiat.<brPure />Idéal pour fins de saison, changements d’équipe et affectations multiples.',
      matrix: 'Matrice',
      tooltip:
        'Accéder à la vue Matrice : affecter/retirer des membres aux communautés.',
      admin: 'Administrateur',
      member: 'Membre',
      blocked: 'Utilisateur bloqué',
      owner: 'Propriétaire',
      group_lead: 'Chef de groupe',
      group_admin: 'Administrateur de groupe',
      chat_admin: 'Admin de chat',
      community_admin: 'Administrateur de la communauté',
      editRoleSuccess: 'Le rôle a été modifié avec succès',
      deleteUserSuccess:
        "L'utilisateur a été supprimé avec succès de la communauté",
      removeUser: {
        title: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
        message:
          "En supprimant cet utilisateur, il sera retiré de votre communauté tout en conservant son compte utilisateur et pourra toujours participer à d'autres communautés.",
        cancelButton: 'Annuler',
        okButton: 'Oui, Supprimer',
      },
      removeUserSuccess: {
        title: 'Utilisateur supprimé',
        message:
          "L'utilisateur a été supprimé avec succès de votre communauté.",
      },
      editSuccess: 'Les modifications ont été mises à jour avec succès',
      title: 'Paramètres de la communauté',
      backToSubscriptionsDetails: "Retour aux détails de l'abonnement",
      tabs: {
        general: 'Préférences générales',
        eventTypes: "Types d'événements",
        subscriptions: 'Abonnements',
        responses: 'Options de réponse',
        roles: 'Membres',
        requests: 'Requêtes',
        other: 'Autre',
        tasks: 'Tâches',
      },
      addMember: 'Ajouter un membre',
      exportMembers: 'Exporter',
      exportMembersTooltip: 'Exporter la liste des membres vers un fichier CSV',
      deleteCommunityHeader: 'Vraiment supprimer?',
      deleteCommunityMessage:
        'Toutes vos données seront définitivement supprimées. Cette action est irréversible.',
      defaultEventList: [
        '🤝🏻🏻 Rencontre 🤝🏻🏻',
        '📅 Événement 📅',
        '📋 Réunion 📋',
        '📝 Réunion du comité 📝',
        '🚌 Sortie 🚌',
        '🛠️ Atelier 🛠️',
        '⏰ Service / Tâche ⏰',
        '🏢 Événement d’entreprise 🏢',
        '🏃 Entraînement 🏃',
        '🏆 Tournoi 🏆',
        '🎶 Répétition 🎶',
        '🔴 ANNULÉ 🔴',
        'ℹ️ Info ℹ️',
        '📊 SONDAGE 📊',
      ],
      defaultResponsesTypes: [
        'Je participe ✅',
        'Je ne peux pas venir ❌',
        'Pas encore sûr(e) 🟨',
      ],
      defaultTasks: ['Qui conduit ?', 'Qui apporte les boissons ?'],
      selectUsers: {
        title: 'Sélectionner des Utilisateurs',
        message:
          "Veuillez cocher les utilisateurs pour approuver ou refuser les demandes d'adhésion.",
      },
      memberExists: 'Le membre existe déjà',
      mailSent:
        'Invitation envoyée ! Valable 24 h. Le nouveau membre clique sur “Rejoindre maintenant” et se connecte avec le mot de passe temporaire - et il rejoint ta communauté instantanément. Les admins peuvent renvoyer l’invitation à tout moment.',
      userNotFound:
        'Profil introuvable. Saisis prénom et nom pour créer un nouveau profil et envoyer l’invitation.',
      disableAddMemberTooltip:
        'Limite de membres atteint. Demande au propriétaire de la communauté de passer à une offre supérieure pour ajouter plus de membres.',
      notifyByFields: 'Envoyer une notification quand ces champs sont modifiés',
      notifyByReplies: 'Veux-tu envoyer des notifications aux invités ?',
      remindBefore: 'Rappeler avant',
      addReminder: '+ Ajouter un rappel (2 max.)',
      notificationsTypes: [
        'Événement créé',
        'Événement mis à jour',
        'Événement supprimé',
        "Rappel d'un événement",
      ],
      notificationsClasses: ['In-App', 'E-mail', 'Push'],
      notificationPopupHeader: 'Notifier les invités ?',
      notificationPopupMessageLabel: 'Ajouter un message optionnel',
      notificationPopupNotify: 'Envoyer',
      notificationPopupDoNotNotify: 'Ne pas envoyer',
      notificationPopupBack: "Retour à l'édition",
      ownerTooltip:
        "👑 Propriétaire\n\nLe propriétaire a créé cette communauté.\n\nIl n'y en a qu'un - avec tous les droits : il gère l'abonnement et peut supprimer la communauté.\n\nChangement possible - contactez le support.",
      emailTooltip:
        "📧 E-mail\n\nAdresse e-mail de connexion de l'utilisateur.\nSeul l'utilisateur peut la modifier.\n\nAstuce : Vous connaissez l'e-mail d'un nouveau membre ? → Ajouter un utilisateur",
      roleTooltip:
        "🛠️ Rôle\n\nAdmin:\nAccès complet à toute la communauté - voit et gère tout.\n➜ Cliquez sur le champ pour nommer un admin\n\nChef de groupe:\nGère les événements et réponses d'un groupe.\n➜ Ouvrir le groupe → Membres → Glisser vers le haut",
      groupsTooltip:
        "👥 Groupes\n\nMontre les groupes de ce membre.\n➜ Cliquez pour affecter à un groupe.\n\nLes nouveaux membres voient tous les événements du planificateur.\nLes événements de groupe ne sont visibles qu'après attribution.",
    },
    communityInvitation: {
      subjectFirst: 'Sei stato invitato a far parte della comunità',
      subjectSecond: '',
      body: 'Si prega di seguire il link qui sotto per far parte della comunità',
      invitationSuccess:
        'Approuvé ! Membre ajouté à la liste. Vérifie rôle et groupe dans Paramètres de la communauté → Membres.',
      invitationFailure:
        'Erreur : tu as probablement atteint la limite de ton abonnement.',
      membersInvitation: {
        title: 'Inviter des membres',
        description:
          'Plusieurs façons d’ajouter de nouveaux membres. Plus d’infos : <0>"Ajouter un nouvel utilisateur"</0>.',
        showMore: 'Afficher plus',
        showLess: 'Montrer moins',
        codeInvitation: {
          title: 'Le moyen le plus rapide et le plus simple',
          button: "Copier le lien d'invitation",
          updateLink: 'Générer un lien maintenant',
          generateLink: 'Generate link now',
          howItWorks: 'Comment ça marche',
          goodToKnow: 'Bon à savoir',
          howItWorksText:
            'Les membres cliquent sur "Créer un compte gratuit" en utilisant le lien sélectionné ci-dessus. Lorsque Gumb envoie un e-mail, les membres n\'ont qu\'à confirmer leur adresse e-mail pour obtenir un accès direct.',
          goodToKnowText:
            "C'est très rapide, mais veuillez noter qu'une fois la vérification du compte terminée, les personnes disposant de ce lien pourront accéder immédiatement à vos événements. Vous pouvez donc renouveler le lien ci-dessus quand vous le souhaitez.",
        },
        linkInvitation: {
          title: 'Par lien :',
          button: 'Copier le lien de la communauté',
          howItWorks: 'Comment ça marche :',
          adminFlow: 'Les admins vérifient les demandes :',
          howItWorksText:
            '<0>Copie et partage le lien.</0><0>Les membres ayant un compte Gumb cliquent sur « Rejoindre ».</0><0>Si quelqu’un n’a pas encore de compte, il doit d’abord s’inscrire, puis cliquer à nouveau sur le lien pour t’envoyer la demande.</0>',
          adminFlowText:
            'Toutes les nouvelles demandes sont dans l’onglet « Demandes ». Les admins peuvent les accepter ou refuser là. Les demandes en attente sont indiquées par l’icône d’engrenage.',
        },
        addMember: {
          title: 'Inviter ou préenregistrer par adresse e-mail',
          button: 'AJOUTER UTILISATEUR',
          selfSignUp: 'Le membre s’inscrit lui-même :',
          preRegister: 'Préenregistrer une personne :',
          selfSignUpText:
            'N’importe qui peut s’inscrire gratuitement à Gumb et t’envoyer son adresse e-mail. Si tu l’ajoutes ici, le membre est automatiquement ajouté et voit tous les événements.',
          preRegisterText:
            'Crée un nouveau membre directement avec son adresse e-mail. Le compte est créé instantanément, le membre reçoit une invitation avec un mot de passe temporaire et peut se connecter tout de suite. Le mot de passe peut être changé plus tard.',
        },
      },
    },
    group: {
      deleteEventSuccess: "L'événement a été supprimé avec succès",
      createSuccess: 'Le groupe a été créé avec succès',
      deleteSuccess: 'Le groupe a été supprimé avec succès',
      addMembersSuccess: 'Les participant ont été ajoutés avec succès',
      addMembersSuccessWithMessage: {
        title: 'Membre ajouté !',
        message:
          "Votre liste de membres a été mise à jour avec succès. Gérez les rôles et les affectations aux groupes. Vous pouvez également ajouter ou modifier les détails de l'utilisateur.",
      },
      deleteUserSuccess: "On a réussi à supprimer l'utilisateur du groupe",
      addParticipants: 'Ajouter des membres',
      createGroup: 'Créer groupe',
      deleteGroup: 'Supprimer groupe',
      groupName: 'Nom du groupe',
      changeGroupNameSuccess: 'Nom du groupe modifié avec succès.',
      groups: 'Groupes',
      inviteMembers: 'Inviter des membres',
      tabs: {
        schedule: 'Planifier',
        members: 'Membres',
        chat: 'Chat',
        documentation: 'Documents',
        statistic: 'Exportation et statistiques',
        import: 'Importation',
      },
      limitExceededHeader:
        'Ta limite de communautés est atteinte. Pour en créer plus, mets à niveau ton plan dans Profil > Abonnement.',
      limitExceededMessage:
        "Contacte le propriétaire de ta communauté. Seul(e) il/elle peut gérer et mettre à jour l'abonnement.",
      limitExceededMessageOwner:
        "S'il te plaît, va dans Profil > Abonnement pour gérer ton plan et le mettre à niveau si besoin.",
      groupRole: 'Rôle dans le groupe',
      addGroup: 'Ajouter un groupe',
    },
    chat: {
      read: {
        now: "{{name}} lu à l'instant",
        hours: '{{name}} lu il y a {{value}}h',
        minutes: '{{name}} lu il y a {{value}} min',
        minute: '{{name}} lu il y a 1 min',
        day: '{{name}} lu le {{value}}',
        dateTime: '{{name}} lu le {{value}} à {{time}}',
      },
      noRead: 'Pas encore lu',
      noActiveCommunity: "Tu n'as pas encore de communauté active.",
      lastAdmin:
        "Un salon de discussion doit avoir au moins un administrateur ou un responsable de groupe. Assurez-vous qu'au moins une personne a toujours ce rôle.",
      update: {
        successUpdate: 'Le groupe de discussion a été mis à jour avec succès',
        btn: 'ENREGISTRER',
        success: 'La liste des membres a été mise à jour',
      },
      modal: {
        btn: 'Gérer',
        about: 'Infos',
        editRoom: 'Modifier la salle de discussion',
        delete: 'Supprimer la salle de discussion',
        editMember: 'Modifier les membres',
        onlyChatAdmin:
          'Seuls les admins de la salle de discussion peuvent faire cela.',
      },
      details: {
        title: 'Détails du salon',
        secondTitle: 'INFORMATIONS',
        name: 'Nom du groupe de discussion',
      },
      delete: {
        success: 'Le salon de discussion a été supprimé',
      },
      create: {
        title: 'Créer une salle de chat',
        name: 'Nom de la salle de chat',
        description: 'Description du groupe (optionnel)',
        btnNext: 'SUIVANT',
        success: 'Salon de discussion créé',
      },
      new: 'Nouveau',
      chat: 'chat',
      popover: {
        title: 'Utilisateur inconnu',
        message: 'Ne fait plus partie de cette communauté ou groupe',
      },
      inputPlaceHolder: 'Saisir un message',
      searchHover: 'Rechercher ou démarrer un nouveau chat',
      op1: 'Fichiers & Vidéos',
      op2: 'Photos',
      files: 'Fichiers',
      plusTooltip: 'Créer un nouveau chat ou un groupe de discussion',
      emptyStatus: {
        noChatSelected: {
          firstLine: 'Sélectionne une conversation pour voir le chat,',
          secondLine: 'ou clique ici pour démarrer un',
          LinkText: 'NOUVEAU CHAT',
        },
        noChatUser:
          'Pas encore de chats ? Lance un chat 1:1 ou attends que ton admin t’ajoute.',
        noChatSubText: 'Lance un chat 1:1 ou attends que ton admin t’ajoute.',
        noUnseenUser: "Don't have any unseen chat",
        sendFirstMessage: 'Écris ton premier message à {{recipient}}.',
      },
      infoPopup: {
        title: 'Limite dépassée',
        message: "Tu peux envoyer jusqu'à 20 fichiers à la fois.",
      },
    },
    statistics: {
      tableType: 'Choisir un rapport',
      eventReplies: 'Réponses & tâches',
      eventTypes: "Type d'événement",
      appointmentSchedule: 'Calendrier des rendez-vous',
      memberFigures: 'Contrôle de présence',
      charts: {
        eventTypesByMonth: 'Nombre de rendez-vous par type',
        eventReplies: 'Réactions aux possibilités de réponse',
        memberPresence: 'Nombre de réactions par réponse',
      },
      loadingStatistics: 'Chargement...',
      memberFiguresExportSuccess: {
        title: 'Rapport en cours de création !',
        message:
          'Ton rapport de présence est en cours de création. Avec beaucoup de données, cela peut prendre quelques minutes. Par sécurité, le rapport sera envoyé à ton adresse e-mail. Vérifie ta boîte de réception. Merci pour ta patience !',
      },
    },
    filters: {
      clickToSelect: 'Cliquez ici pour filtrer',
      showFilters: 'Afficher les filtres',
      dateRange: 'Sélectionner la plage de dates',
      filterBy: 'Filtrer par',
      dateRanges: {
        yearToDate: "Depuis le début de l'année",
        lastDays: '{{number}} derniers jours',
        lastYear: 'Dernière année',
        yesterday: 'Hier',
        today: "Aujourd'hui",
        tomorrow: 'Demain',
        nextDays: '{{number}} prochains jours',
        thisWeek: 'Cette semaine',
        thisMonth: 'Ce mois-ci',
        thisYear: 'Cette année',
        allTime: "Toute l'année",
        specificDateRange: 'Période spécifique',
      },
      downloadXlsxOrCsv: 'Télécharger ici : Excel ou CSV',
    },
    bulkUploadEvents: {
      toastText:
        "🆕  La nouvelle fonction d'importation de rendez-vous est maintenant disponible pour chaque groupe!  🎉",
      moduleTitle: 'Importation',
      step1: 'Étape 1',
      step2: 'Étape 2',
      step3: 'Étape 3',
      step4: 'Étape 4',
      stepOne: {
        stepTitle: "Préparer l'importation de données",
        stepDescription: 'Télécharger le modèle Excel',
        componentTitle: 'Télécharger le modèle Excel',
        componentDescription:
          "Remplissez le modèle avec vos données d'événement ou utilisez votre propre fichier Excel.",
        p1: "Remplissez le modèle avec vos données d'événement.",
        p2: 'Les en-têtes de colonne doivent rester en anglais.',
        p3: 'Des exemples dans chaque colonne vous montrent le format correct.',
        p4: "Les nouveaux types d'événements sont ajoutés automatiquement.",
        p5: "<b>Important</b> : Si vous utilisez votre propre fichier, les titres de colonnes suivants doivent être copiés exactement tels qu'ils apparaissent en anglais (respectez la casse) :",
        p6: 'Des exemples dans chaque colonne du modèle vous montrent le format correct.',
        p7: "Les nouveaux types d'événements sont ajoutés automatiquement.",
        eventTypes: "ALLER AUX TYPES D'ÉVÉNEMENTS",
        template: 'TÉLÉCHARGER LE MODÈLE',
        nextStepButton: 'CONTINUER',
        copy: 'Copier toutes les clés',
      },
      stepTwo: {
        stepTitle: 'TÉLÉCHARGER UN FICHIER',
        stepDescription: 'TÉLÉCHARGER UN FICHIER CSV',
        componentTitle: 'TÉLÉCHARGER UN FICHIER CSV',
        componentDescription:
          'Enregistrer le fichier Excel au format <b><u>CSV</u></b> et le télécharger ici.',
        p1: 'Nous vérifierons le format et vous montrerons un aperçu.',
        uploadButton: 'Choisir un fichier',
        maximumFileSize: 'Taille maximale du fichier : 1 Mo',
      },
      stepThree: {
        stepTitle: 'Confirmer les données',
        stepDescription: 'Aperçu de votre premier événement.',
        componentTitle: 'Confirmer les données',
        componentDescription:
          "Vérifiez l'exemple et ajustez les membres activés.\nLes membres sélectionnés s'appliquent à tous les événements.",
        nextStepButton: 'CONFIRMER ET TÉLÉCHARGER',
      },
      stepFour: {
        stepTitle: 'Téléchargement réussi !',
        stepDescription:
          'Le téléchargement des événements a réussi. Vous pouvez les consulter dans le calendrier.',
        componentTitle: 'Téléchargement réussi !',
        componentDescription: '<b>{{count}}</b> événements ont été importés.',
        secondTitle: 'Bon à savoir',
        secondSubTitle:
          "Vous pouvez annuler l'importation ou télécharger une nouvelle liste.",
        goToScheduler: 'ALLER AU CALENDRIER',
        undoImport: "ANNULER L'IMPORTATION",
        uploadNewList: 'TÉLÉCHARGER UNE NOUVELLE LISTE',
      },
      errors: {
        eventNameErrorTitle: "Erreur de nom d'événement",
        eventNameErrorMessage:
          "Nom de l'événement manquant à la ligne <b><u>{{row}}</u></b>.",
        eventTypeErrorTitle: "Erreur de type d'événement",
        eventTypeErrorMessage:
          "Type d'événement manquant à la ligne <b><u>{{row}}</u></b>.",
        timeErrorTitle: "Erreur d'heure",
        timeErrorMessage:
          'Heure de début ou de fin manquante à la ligne <b><u>{{row}}</u></b>.',
        dateErrorTitle: 'Erreur de date',
        dateErrorMessage: 'Date manquante à la ligne <b><u>{{row}}</u></b>.',
        locationErrorTitle: 'Erreur de lieu',
        locationErrorMessage:
          "Lieu de l'événement manquant à la ligne <b><u>{{row}}</u></b>.",
        invalidDateOrTimeTitle: 'Date ou heure invalide',
        invalidDateOrTimeMessage:
          "Veuillez vérifier le format de la date et de l'heure à la ligne <b><u>{{row}}</u></b> (par exemple, utilisez HH:MM pour l'heure).",
      },
      commentRequired: {
        title: 'Commentaire requis',
        message: 'Merci d’ajouter un court commentaire.',
      },
      deletePopupTitle: "Supprimer la liste d'événements ?",
      deletePopupMessage:
        "Cette action supprimera définitivement votre dernière liste d'événements téléchargée. Êtes-vous sûr(e) ?",
      deleteSuccessTitle: 'Suppression réussie!',
      deleteSuccessMessage:
        "Votre dernière liste d'événements a été supprimée avec succès.",
      successMessage:
        "Validation réussie. Passez à l'étape suivante pour voir un aperçu.",
      restartProcessTitle: "Charger une nouvelle liste d'événements",
      restartProcessMessage:
        "Vous pouvez charger une nouvelle liste d'événements à tout moment. Veuillez noter que les événements précédemment chargés resteront visibles dans le calendrier. Si vous souhaitez remplacer l'ancienne liste, supprimez-la d'abord ou annulez la dernière importation.",
      restartProcessOkButton: 'CHARGER UNE NOUVELLE LISTE',
      exportDataSample: {
        event_name: 'Zurich Street Parade',
        event_type_name: 'Performance',
        event_location: 'Bahnhofstrasse 5, 8001 Zurich',
        event_description:
          'Festival en plein air avec groupes et DJs internationaux',
      },
    },
    event: {
      noTasks: {
        title: 'Aucune tâche',
        description:
          'Les tâches apparaîtront ici dès qu’un admin les crée ou les active.',
      },
      noSearchResults: {
        title: 'Aucun résultat',
        description: 'Essaie avec un autre terme de recherche.',
      },
      noParticipants: {
        title: 'Aucun participant pour l’instant.',
        description:
          'Lorsqu’un membre sera ajouté à l’événement, il apparaîtra ici.',
      },
      noParticipantsSearchResults: {
        title: 'Aucun résultat',
        description: 'Essaie avec un autre terme de recherche.',
      },
      noDocuments: {
        title: 'Aucun fichier',
        description:
          'Les fichiers apparaîtront ici dès qu’ils seront téléversés.',
      },
      event: 'Evénement',
      createdAt: 'Date de création',
      editEvent: "Modifier l'événement",
      createEvent: 'Créer événement',
      updateEvent: 'Mettre à jour événement',
      eventName: "Nom de l'événement",
      eventType: "Type d'événement",
      eventTypeDeleted: "Types d'événements supprimés",
      eventDetails: "Détails de l'événement",
      eventOrganizer: "Organisateur de l'événement",
      eventOrganizerShort: 'Organisateur',
      location: 'Emplacement',
      eventTypeEdit: "Modifier le type d'événement",
      eventTypeName: "Nom du type d'événement",
      eventTypeCreate: "Créer un type d'événement",
      responseRequired: 'Réponse requise',
      responseName: 'Nom de la réponse',
      responsesEdit: 'Modifier la réponse',
      responsesCreate: 'Créer réponse',
      repeatAnEvent: 'Répéter un événement',
      repeatWithInterval: 'Répéter avec un intervalle',
      allDay: 'Toute la journée',
      registrationDeadline: 'Date limite de souscription',
      commentRequired: 'Commentaire requis',
      editTask: 'Modifier tâche',
      createTask: 'Créer tâche',
      eventTaskName: 'Nom de la tâche',
      icon: 'Icône',
      isMemberComing: 'Ta réponse ?',
      recurringEvent: 'Evenemnt récurrent',
      allEvents: 'Tous les événements',
      thisEventOnly: 'Seulement cet événement',
      createEventSuccess: 'Evénement créé avec succès',
      updateEventSuccess: 'Evénement mis à jour avec succès',
      createEventReplySuccess: 'Réponse enregistrée avec succès',
      updateEventReplySuccess: 'Réponse mise à jour avec succès',
      addGuests: 'Invités supplémentaires ?',
      eventOperations: {
        eventOnly: 'Cet événement',
        eventAndFollowUp: 'Cet événement et les suivants',
        all: 'Tous les événements',
        deleteText: "Supprimer l'événement périodique",
        editText: "Modifier l'événement périodique",
        editReplyText: "Votre réponse s'applique à",
        confirm: 'OK',
      },
      dfRes: 'Définir Réponse par Défaut pour Tous',
      dfResInfo:
        "Ceci définit la réponse par défaut pour tous les participants à l'événement.Toutes les risposte individuali existantes seront écrasate",
      title: 'Attention',
      responseToast:
        'Si tu supprimes la réponse par défaut sans en enregistrer une nouvelle, toutes les réactions et commentaires précédents seront supprimés.',
      setPreferences: 'Définir les préférences',
      setEventDefaults: 'Définir les paramètres par défaut',
      preferencesText:
        'Définissez les paramètres par défaut pour les nouveaux événements de ce type, y compris la réponse par défaut pour les membres',
      responseSubTitle: 'Demander un commentaire (optionnel)',
      requestComment:
        'Active cette option : les membres devront laisser un commentaire s’ils choisissent cette réponse (par ex. « Non, sans moi » pour demander la raison).',
      registeredUsers: 'Réponses',
      guests: 'Invités',
      nomination: 'Nomination',
      nominated: 'Tu es nominé(e)',
      havePenalty: 'Tu as reçu une pénalité',
      penalty: 'Pénalité',
      invitees: 'Invités',
      awaiting: 'En attente de',
      minutes: 'Minutes',
      hours: 'les heures',
      days: 'jours',
      weeks: 'semaines',
      weekDay: 'Jour de la semaine',
      duration: "Durée de l'accord",
      months: 'mois',
      years: 'années',
      viewAppointment: 'Voir Événement',
      myResponse: 'Ma Réponse',
      noEvents: {
        title: 'Aucun événement visible',
        description:
          'Dès qu’un admin t’ajoute, tes événements s’afficheront ici.',
      },
      shareEvent:
        'Partager l’événement - Clique sur l’icône pour copier l’événement et le coller partout (e-mail, WhatsApp, etc.).',
      shareEventOption: 'Partager le lien du rendez-vous',
      exportPDFOption: 'Exporter en PDF',
      deadlineExpired:
        'La date limite d’inscription est probablement dépassée ou l’événement est déjà terminé.',
      totalInvitees: 'Total des invités',
      responsesReceived: 'Réponses reçues',
      additionalGuests: 'Invités supplémentaires',
      noPermissionToGiveReply: "Tu n'as pas le droit de changer cela",
      responsesPercentage: 'Pourcentage de réponses',
      acceptedTasks: 'Tâches acceptées',
      acceptedTasksByUser: 'Tâches par utilisateur',
      givenComments: 'Commentaires donnés',
      givenCommentsByUser: "Commentaires donnés par l'utilisateur",
      optionalMessage: 'Cliquez ici pour voir les nouvelles.',
    },
    task: {
      createTask: 'Créer tâche',
      taskName: 'Nom de la tâche',
      noTasks: 'Pas de tâches',
    },
    groupSettings: {
      title: 'Paramètres du groupe',
      tabs: {
        general: 'Général',
        eventTypes: "Types d'événements",
        responses: 'Réponses',
        membersManagement: 'Administration des membres',
        other: 'Plus',
      },
      deleteGroupHeader: 'Supprimer vraiment ?',
      deleteGroupMessage:
        'Toutes vos données seront supprimées de façon définitive. Restauration impossible.',
    },
    documentation: {
      title: 'Documents',
      generalDocumentation: 'Documents généraux',
      uploadedFiles: 'Fichiers téléchargés',
      chooseFile: 'Choisir fichier',
      tipMessage: 'Taille maximum du fichier téléchargé: 50 MB',
      overview: '{{value}} GB utilisés sur {{capacity}} GB',
      uploadSuccess: 'Le document a été téléchargé avec succès',
      deleteSuccess: 'Le document a été supprimé avec succès',
      attachFiles: 'Joindres des fichiers',
      limitExceededHeader:
        'Vous avez atteint la limite de stockage pour les documents.',
      sort: {
        label: 'Trier par',
        nameAsc: 'Nom (A-Z)',
        nameDesc: 'Nom (Z-A)',
        dateOldest: 'Date (Plus ancien)',
        dateNewest: 'Date (Plus récent)',
      },
    },
    subscriptions: {
      title: 'Abbonamenti',
      subscription: 'Abbonamento',
      adBlocker: {
        header: 'Désactiver le bloqueur de pub',
        body: 'Désactive ton bloqueur de pub (icône près de la barre d’adresse) pour voir les prix locaux. Recharge la page.',
      },
      yearly: 'Annuale',
      monthly: 'Mensile',
      freeTitle: 'Prova gratuita di 2 mesi',
      freeDescription:
        "Lance ta période d'essai gratuite de 2 mois maintenant.",
      freeText1: "Ouvrir jusqu'à <strong>30</strong> communautés",
      freeText2: 'Accesso completo a tutte le funzionalità',
      freeText3:
        'Nessuna carta di credito richiesta: iscriviti e inizia immediatamente',
      freeText4: 'Nessun rinnovo automatico',
      freeText5: 'Nessuna pubblicità',
      subscribe: 'ISCRIVITI',
      seeDetails: 'VEDI DETTAGLI',
      buildCustom: 'Custom',
      month: 'mois',
      year: 'année',
      community: 'Communauté',
      communities: 'Communautés',
      maxStorage: 'Capacité de rangement en GB',
      classic: 'Classique',
      classicPlus: 'Classique+',
      popular: 'POPULAIRE',
      textInnerTop:
        "Choisis l'abonnement adapté pour ton équipe. Organise en {{groups}} groupes maximum et gère jusqu'à {{members}} membres. Mets à jour ou annule à tout moment.",
      textInnerBottom:
        "Ton abonnement est un contrat à durée indéterminée. Avantage : Il se renouvelle automatiquement chaque année/mois. Nous t'enverrons un rappel par e-mail. Paye par carte de crédit (MasterCard, Visa) ou PayPal.",
      chatsExcluded: 'Chats exclus',
      current: 'COURANT',
      pay: 'PAYER',
      usingBlocker: 'Désactiver le bloqueur de publicités et recharger la page',
      failedToSubscribe:
        "Paiement échoué. Le contrôle de sécurité a échoué ou ta carte pourrait expirer bientôt. S'il te plaît, utilise une autre ou réessaie.",
      usedGroups: 'Groupes utilisés',
      usedMembers: 'Membres utilisés',
      usedCommunity: 'Communautés utilisées',
      usedStorage: 'Capacité de rangement utilisée',
      orderSummary: 'Résumé des commandes',
      tax: 'TAXE',
      total: 'Total',
      periodEnds: "La période souscrite s'achève",
      cancelSubscription: 'ANNULER MON ABONNEMENT',
      paypalLink: 'HISTORIQUE DE FACTURATION',
      chatEnabled: 'Chat inclus',
      chatExcluded: 'Chat exclus',
      paymentApproved: 'Paiement accepté',
      paymentError: 'Erreur de paiement',
      limitExceededHeader: 'Tu as atteint la limite de membres.',
      limitExceededMessage:
        "Contacte le propriétaire de ta communauté. Seul(e) il/elle peut gérer et mettre à jour l'abonnement.",
      limitExceededMessageOwner:
        'Choisissez un plan pour créer une communauté.',
      inactiveSubscriptionHeader: 'En attente de confirmation du paiement',
      inactiveSubscriptionMessage:
        "Désolé, vous ne pouvez pas poursuivre cette action. Vous devez peut-être d'abord terminer le processus de paiement.",
      subscriptionNotPaid: 'Aucun plan actif',
      contactAdmin: "Veuillez contacter l'Admin.",
      free: 'Compte gratuit',
      requireSubscription:
        'Gumb est gratuit pour les membres des communautés actives. Créez votre propre communauté et commencez votre essai gratuit dès maintenant ou modifiez votre abonnement sous "Modifier l\'abonnement".',
      requireSubscriptionMember:
        'Aucun abonnement valide n\'a été détecté. Vous n\'avez rien à faire ici. Par contre, le propriétaire de la communauté peut vérifier dans son profil sous "Abonnement" si la licence pour cette communauté est activée ou prolongée.',
      cancelConfirmation: 'Êtes-vous sûr de vouloir annuler votre abonnement?',
      unsubscribe: 'Annuler',
      cancelled:
        "Résiliation confirmée. Une confirmation de résiliation vient d'être envoyée à ton e-mail. Jusqu'à la date de facturation payée, tous continuent à avoir accès à toutes les fonctionnalités.",
      renewSubscriptionText:
        "Merci!\n\nVotre abonnement précédent sera renouvelé, si vous l'activez maintenant",
      activate: 'Activer maintenant',
      activated:
        "Ton abonnement est actif ! Bienvenue sur Gumb : nous sommes ravis que vous puissiez désormais planifier et organiser professionnellement avec Gumb. Une confirmation t'a été envoyée par e-mail. Toutes les fonctionnalités sont immédiatement disponibles pour ton équipe.",
      approved:
        "Préparation de ton abonnement en cours... Merci de patienter un instant (jusqu'à 45 secondes). Ne rafraîchis pas et ne ferme pas cette fenêtre de navigateur pendant ce temps.",
      trial: 'Test gratuit',
      trialActivated:
        "Ta période d'essai a démarré. Toi et tes administrateurs pouvez maintenant commencer à planifier, inviter des membres et gérer les paramètres.",
      cancelledTitle: 'Annulé',
      startTrial: "DÉMARREZ L'ESSAI GRATUIT",
      startTrialHeader: 'Test lonnnng !',
      startTrialText:
        'Teste toutes les fonctionnalités en conditions réelles - 2 mois gratuits ! Pas de données de paiement, pas de coûts cachés. Teste simplement sans souci avec tous les membres.',
      subscriptionExpired:
        "Cette communauté n'a pas d'abonnement actif pour le moment. Pour ajouter de nouveaux utilisateurs, l'abonnement doit être renouvelé.Pour toute question: support@gumb.app",
      startTrialPopupButton: 'Essai Gratuit',
      paymentMethods: 'Carte de crédit ou Paypal',
      checkout: {
        pageTitle: 'Checkout',
        breadcrumbCheckout: 'Checkout - {{plan}}',
        stepPlanSelected: 'Forfait sélectionné',
        stepOrderSummary: 'Récapitulatif de commande',
        stepConfirmation: 'Confirmation',
        completeOrder: 'Finaliser ta commande',
        planInfoSub: '{{billing}} · {{count}} {{teams}}',
        planLineAnnual: '{{plan}} (annuel)',
        planLineMonthly: '{{plan}} (mensuel)',
        planLineSubtextAnnual:
          '{{currency}}{{price}}/an · {{days}} jours restants',
        planLineSubtextMonthly:
          '{{currency}}{{price}}/mois · {{days}} jours restants',
        daysRemainingSubtext: '{{days}} jours restants',
        annualSavingLine: 'Économies avec la facturation annuelle',
        totalDueToday: 'Total dû aujourd’hui',
        renewsOn: 'Renouvellement le {{date}}',
        chargedToday: 'Prélevé aujourd’hui :',
        activationInfo:
          'Après validation du paiement, ton forfait est activé et tu reçois un e-mail de confirmation. Tu peux annuler à tout moment depuis les paramètres d’abonnement.',
        activationInfoStripe:
          'Ton forfait s’active immédiatement après le paiement. Renouvellement annuel à la même date - annulation à tout moment.',
        activationInfoStripeMonthly:
          'Ton forfait s’active immédiatement après le paiement. Renouvellement mensuel à la même date - annulation à tout moment.',
        includedTitle: 'Ce qui est inclus',
        included1: 'Calendrier principal partagé',
        included2: 'Présence en temps réel',
        included3: 'Chat d’équipe & messages privés',
        included4: 'Notifications push',
        included5: 'Rôles membres & permissions',
        included6: 'Stockage de fichiers & documents',
        included7: 'iOS, Android & web',
        included8: 'Analyses & export CSV',
        trustSecure: 'Paiement sécurisé avec PayPal',
        trustSecureStripe: 'Paiement sécurisé via Stripe',
        trustCancel: 'Annulation à tout moment',
        trustCancelDetailed: 'Annulation à tout moment, sans pénalité',
        trustSSL: 'Chiffrement SSL 256 bits',
        stripeProcessedNote: 'Paiement sécurisé par',
        completePurchase: 'Finaliser l’achat',
        paymentMethodLegend: 'Moyen de paiement',
        payDirectTitle: 'Payer maintenant',
        payDirectDesc: 'Prélevé aujourd’hui.',
        payInvoiceTitle: 'Facture',
        payInvoiceDesc: 'Facture par e-mail.',
        invoiceHeadline: 'Payer par facture',
        invoiceSubline:
          'Virement bancaire · facture PDF à ton e-mail de facturation',
        invoicePanelBody:
          'Nous t’enverrons une facture avec les détails de paiement et ta référence. Ton abonnement est activé dès réception du paiement (généralement 1 à 3 jours ouvrés après le virement).',
        requestInvoice: 'Demander une facture',
        toBeInvoiced: 'À facturer',
        invoicePageNote:
          'Votre abonnement démarre immédiatement, indépendamment du paiement',
        chf: {
          title: 'Détails de facturation',
          subtitle:
            'Vous recevrez une facture QR par e-mail. Délai de paiement 30 jours.',
          name: 'Organisation ou nom',
          address: 'Adresse',
          vatNumber: 'Numéro de TVA',
          billingEmail: 'E-mail de facturation',
          optional: 'facultatif',
          recipientsHint:
            'Tous les destinataires reçoivent la même facture. Laissez vide pour utiliser {{email}}.',
          total: 'Total',
          submit: 'Demander la facture',
          activationNote:
            'Votre abonnement démarre immédiatement, indépendamment du paiement',
          invalidEmail: 'Saisis une adresse e-mail valide',
          maxRecipients: '5 destinataires maximum',
        },
        invoiceTrust1: 'Facture envoyée à ton e-mail de facturation',
        invoiceTrust2: 'Paye par virement bancaire avec la référence indiquée',
        invoiceTrust3:
          'Ton application est active tout de suite - paie la facture quand cela te convient',
        priceSaveVsMonthly: '2 mois offerts vs mensuel',
        planDetails: 'Détails du forfait',
        badgeNew: 'Nouvel abonnement',
        planNotInCatalog:
          'Ce forfait n’est pas encore disponible dans le catalogue checkout, ou le lien est expiré. Retourne à « Changer de forfait » et relance le checkout depuis là.',
        backToChangePlan: 'Retour aux forfaits',
        invoiceYearlyOnly:
          'La facturation par facture est disponible uniquement pour les abonnements annuels. Choisis la facturation annuelle dans « Changer de forfait », puis reviens au checkout.',
        invoicePayerEmailsLabel: 'E-mails payeur / finance',
        invoicePayerEmailsHint:
          'Nous conservons ces contacts pour tes dossiers. Stripe envoie la facture à ton e-mail de profil (destinataire de facture).',
        invoiceBillToProfile: 'Facturer à : {{email}}',
        invoiceEmailPlaceholder: 'finance@company.com',
        invoiceAddEmail: '+ Ajouter un autre e-mail',
        invoiceRemoveEmail: 'Supprimer l’e-mail',
        invoiceSubmit: 'Créer une facture',
        invoiceSubmitting: 'Création de la facture…',
        invoiceInvalidEmails: 'Saisis au moins une adresse e-mail valide.',
        invoiceSubmitError:
          'Impossible de créer la facture. Réessaie ou contacte le support.',
        stripeCheckoutError: "Le paiement n'a pas pu démarrer. Réessaie.",
        invoiceSuccessTitle:
          'Facture créée - finalise le paiement quand tu veux',
        invoiceAmount: 'Montant : {{amount}}',
        invoiceOpenHosted: 'Ouvrir la facture Stripe & payer',
        invoiceHostedPending:
          'Ton abonnement est en attente de paiement. Vérifie ton e-mail pour le lien de facture, ou ouvre bientôt « Abonnement » dans ton profil.',
        invoiceReturnBreadcrumb: 'Confirmation',
        invoiceReturnSuccessTitle: "C'est bon !",
        invoiceReturnSuccessSub:
          "Ton {{plan}} est actif maintenant. Paie la facture Stripe quand tu veux - pas besoin d'attendre le paiement pour utiliser l'app.",
        invoiceReturnSuccessDetailsHeading: 'Ce qui a été activé',
        invoiceReturnSuccessBulletPlan:
          "{{plan}} - tes limites d'abonnement et la facturation sont appliquées.",
        invoiceReturnSuccessBulletActive:
          'Les fonctionnalités premium sont disponibles immédiatement sur web et mobile.',
        invoiceReturnSuccessBulletInvoice:
          'Une facture Stripe a été créée - ouvre-la ci-dessous ou vérifie ton e-mail de facturation.',
        invoiceReturnSeeInvoice: 'Voir la facture',
        invoiceReturnSeeInvoicePending: 'Lien de facture en attente',
        invoiceReturnGoSubscription: "Aller à l'abonnement",
        stripeReturnBreadcrumbSuccess: 'Confirmation',
        stripeReturnBreadcrumbFailure: 'Checkout annulé',
        stripeReturnSuccessTitle: 'C’est bon !',
        stripeReturnSuccessSub:
          'Ton {{plan}} est maintenant actif. Tu peux utiliser toutes les fonctionnalités immédiatement - sans attente ni délai.',
        stripeReturnPlanFallback: 'forfait',
        stripeReturnSuccessDetailsHeading: 'Ce qui a été activé',
        stripeReturnSuccessBulletPlan:
          '{{plan}} - tes limites d’abonnement et la facturation sont maintenant appliquées.',
        stripeReturnSuccessBulletActive:
          'Les fonctionnalités premium sont disponibles immédiatement sur web et mobile.',
        stripeReturnSuccessBulletEmail:
          "Nous t'enverrons un reçu à ton e-mail de facturation une fois le paiement confirmé.",
        stripeReturnSuccessBulletGuarantee:
          'La garantie satisfait ou remboursé de 30 jours s’applique à ton abonnement.',
        stripeReturnSessionRef: 'Référence checkout : {{id}}',
        stripeReturnGoHome: 'Aller à l’accueil',
        stripeReturnViewSubscription: 'Voir l’abonnement',
        stripeReturnFailureTitle: 'Paiement non finalisé',
        stripeReturnFailureSub:
          'Tu n’as pas été débité. Tu peux rouvrir le checkout à tout moment depuis « Changer de forfait ».',
        stripeReturnFailureDetailsHeading: 'Ce qui s’est passé',
        stripeReturnFailureBullet1:
          'Le checkout a été annulé ou fermé avant la fin du paiement.',
        stripeReturnFailureBullet2: 'Ton abonnement n’a pas été modifié.',
        stripeReturnTryAgain: 'Retour aux forfaits',
        stripeReturnBackSubscription: 'Voir l’abonnement',
      },
      subscriptionsPopup: {
        title: 'Aucun plan actif',
        subtitle:
          '<b>{{ownerName}}</b> est le propriétaire et peut choisir un plan. 🙌🏻',
        firstBox: {
          title: "Choisissez un plan pour rétablir l'accès complet pour tous.",
          btnText: 'Choisir un plan',
        },
        secondBox: {
          title:
            "Quelqu'un d'autre devrait reprendre ? Nous pouvons transférer la propriété.",
          btnText: 'Demander la reprise',
          contactMessage:
            'Je souhaite demander le transfert de propriété de « {{communityName}} » ({{communityId}}). Propriétaire actuel : {{currentOwner}}. Mon e-mail : {{email}}.',
        },
      },
      profile: {
        legacy: {
          heading: 'Détails de l’abonnement',
          titleMembership: 'Adhésion',
          titlePayment: 'Paiement',
          buttonCancel: 'Annuler l’adhésion',
          details: {
            linkChangePlan: 'Plan de changement',
            infoTrial:
              'La période d’essai est en cours. Aucun frais à la fin. Pour continuer avec Gumb, choisis un plan dans «Changer de forfait».',
            infoTrialNew:
              'La période d’essai est en cours. À la fin le {{expireDate}}, aucun frais. Pour continuer avec Gumb, choisis un plan dans «Changer de forfait».',
            linkShowCommunities: 'Montrer à mes communautés',
            linkHistory: 'Historique facturation (Reçu par email PayPal)',
            linkChangePayment: 'Modifier le mode de paiement',
            currentPlan: 'Forfait actuel :',
            communitiesInUse: 'Communautés en service :',
            groupsInUse: 'Groupes en cours d’utilisation :',
            membersInUse: 'Membres en service :',
            storageInUse: 'Stockage en cours d’utilisation :',
            paymentCycle: 'Cycle de paiement :',
            paymentMethod: 'Mode de paiement:',
          },
          billing: {
            paymentInfoNote:
              'Tu peux ajouter tes coordonnées de paiement en toute sécurité lors de l’abonnement. La facturation est gérée par Stripe avec chiffrement.',
            securePayments: 'Paiements sécurisés',
            renewalNote: 'Renouvellement {{date}} · {{cycle}}',
            choosePlanTrial: 'Choisis ton forfait',
            cancelTrial: 'Annuler l’essai',
            cancelTrialConfirm:
              'Mettre fin à l’essai gratuit ? Tu peux t’abonner à tout moment depuis la page des forfaits.',
            trustStripeNote:
              'Paiements sécurisés - gère la facturation pour factures et reçus',
          },
        },
        page: {
          title: 'Abonnement et facturation',
        },
        confirming: {
          onboardingTitle: 'Almost there',
          onboardingHint:
            "We're syncing your payment with your account. This usually takes just a moment.",
          subscriptionTitle: 'Almost there',
          subscriptionHint:
            "We're activating your subscription. This usually takes just a moment.",
        },
        labels: {
          paymentCycleMonth: 'Mensuel',
          paymentCycleYear: 'Annuel',
          validUntil: "Encore valable jusqu'à :",
          nextPayment: 'Prochain paiement:',
          infoCancelled:
            'Ton abonnement est annulé et ne sera pas renouvelé. Tu peux utiliser l’app jusqu’à la prochaine échéance. Tu peux le renouveler à tout moment.',
          subscriptionEndedOn: 'Abonnement terminé :',
          trialEndedOn: "Période d'essai terminée :",
          accessUntil: 'Accès jusqu’au :',
          nextInvoice: 'Next invoice:',
          lastPlan: 'Dernier forfait',
          invoiceBillingCyclePrimary: 'Annual · Custom pricing',
        },
        hero: {
          title: 'Commence ton essai gratuit de 2 mois',
          subtitle:
            'Accès complet à toutes les fonctions - sans carte bancaire.',
          seeIncluded: 'Voir ce qui est inclus',
        },
        freeAccount: {
          subtitle: 'Tu n’as pas encore commencé d’essai ni d’abonnement.',
          badge: 'Compte gratuit',
          noActivePlan: 'Aucun forfait actif',
          trialUnlockBlurb:
            'Commence ton essai gratuit de 2 mois pour un accès complet - plusieurs communautés, planificateurs de groupe, gestion des membres et plus encore.',
          trialNoteFooter:
            'Essai gratuit de 2 mois - aucun prélèvement automatique ensuite.',
          comparePlans: 'Comparer les forfaits',
        },
        plan: {
          title: 'Forfait actuel',
          subtitleTrial: 'Teste Gumb tranquillement pendant ton essai.',
          subtitleActive:
            'Ton forfait est actif et se renouvelle automatiquement.',
          subtitleNonRenewal:
            'Accès complet jusqu’au {{date}}. L’abonnement ne se renouvelle pas automatiquement.',
          subtitleStripeEnded:
            'Abonnement payant terminé le {{date}}. Tu peux t’abonner à nouveau depuis Changer de forfait.',
          subtitleFullyCancelled:
            'Ton abonnement {{plan}} a pris fin le {{date}}.',
          subtitleTrialExpired:
            "Votre période d'essai s'est terminée le {{date}}.",
          badgeTrial: 'Essai gratuit',
          badgeTrialExpired: "Période d'essai expirée",
          badgeCancelled: 'Annulé',
          badgeEnded: 'Terminé',
          badgeActive: 'Actif',
          endsOnNote:
            'Se termine le {{date}}. Aucun prélèvement automatique ensuite.',
          footnoteStripeEnded: 'Terminé le {{date}}. Aucun autre prélèvement.',
          footnoteFullyCancelled:
            'Annulé le {{date}}. Aucun autre prélèvement.',
          footnoteTrialExpired:
            "Période d'essai terminée le {{date}}. Aucun montant n'a été facturé.",
          footnoteRenewalCancelled:
            'Pas de renouvellement après le {{date}}. Accès complet jusque-là · {{price}}{{period}} (dernier forfait actif) · {{billingMethod}}',
          footnoteRenewalPayment:
            'Renouvellement {{date}} · {{price}}{{period}} {{billingMethod}}',
          paymentMethodChargedGeneric: 'ton mode de paiement enregistré',
          paymentMethodChargedTo: 'facturé sur {{chargedTo}}',
          paymentMethodBilledByInvoice: 'réglé par facture',
          featureCommunities: 'Jusqu’à {{count}} communautés',
          featureSchedulers: 'Jusqu’à {{count}} planificateurs de groupe',
          featureMembers: 'Jusqu’à {{count}} membres',
          featureStorage: '{{count}} Go de stockage',
          paidProFeatureExtras: [
            'Suivi des présences en temps réel',
            'Chat d’équipe, messages directs et notifications push',
          ],
        },
        statusBanner: {
          trialTitle: 'Essai gratuit actif',
          trialBody:
            'Ton essai va jusqu’au {{date}}. Gumb est gratuit jusque-là - rien n’est prélevé automatiquement ensuite.',
          stripeEndedRich:
            'Cet abonnement Stripe est terminé. Aucun autre prélèvement.',
          fullyCancelledTitle: 'Annulé',
          fullyCancelledRich:
            'Ton abonnement a été annulé. L’accès a pris fin le {{date}}. Tu peux t’abonner à nouveau à tout moment.',
          trialExpiredTitle: "Période d'essai expirée",
          trialExpiredRich:
            "Votre période d'essai s'est terminée le {{date}}. Choisissez un plan pour conserver l'accès complet.",
          activeLabel: '{{plan}} · Actif',
          nonRenewalRich:
            'Actif jusqu’au {{date}} - ne se renouvelle pas. Aucun prélèvement après cette date · {{price}}{{period}}',
          renewalRich:
            'Ton abonnement se renouvelle le {{date}} · {{price}}{{period}}',
          frequencyAnnual: 'Annuel',
          frequencyMonthly: 'Mensuel',
        },
        payment: {
          title: 'Paiement',
          methodLabel: 'Mode de paiement',
          invoiceMethodTitle: 'Invoice (annual)',
          sentToBilling: 'Facturé à {{email}}',
          sentToBillingLabel: 'Facturé à',
          cycleLabel: 'Cycle de facturation',
          accountManagerLabel: 'Account manager',
          lastInvoiceLabel: 'Dernière facture',
          lastInvoiceUnavailable: '-',
          lastInvoiceHintInvoice: 'Facture officielle en PDF',
          lastInvoiceHint: 'Facture pour ce paiement',
          downloadInvoice: 'Télécharger le PDF',
          methodOnFile: 'Carte enregistrée',
          noPaymentYet: 'Aucun paiement requis pour l’instant',
          cardExpiresShort: 'Expire {{month}} / {{year}}',
          noActiveSubscription: 'Aucun abonnement actif',
          manageBilling: 'Gérer la facturation',
          manageBillingHint: 'Ouvre le portail de facturation sécurisé Stripe',
          viewInvoices: 'Voir les factures',
          switchToInvoice: 'Passer au paiement par facture',
          switchToCard: 'Passer au paiement par carte',
          switchToInvoiceTitle: 'Passer au paiement par facture ?',
          switchToInvoiceBody:
            'Les factures seront envoyées à ton e-mail de facturation.',
          switchToInvoiceBodyBold:
            'Ta carte ne sera plus débitée automatiquement.',
          switchToInvoiceConfirm: 'Passer aux factures',
          switchToCardTitle: 'Passer au paiement par carte ?',
          switchToCardBody:
            'Ta carte enregistrée sera débitée automatiquement.',
          switchToCardBodyBold:
            'Les factures ne seront plus envoyées par e-mail pour les prochains paiements.',
          switchToCardConfirm: 'Passer au paiement par carte',
          switchBillingReviewSubtitle:
            'Vérifie le changement ci-dessous avant de confirmer.',
          switchBillingChangeSummaryLabel: 'Ce qui change',
          switchBillingTimingLabel: "Quand cela s'applique",
          switchBillingStep1Label: 'Vérifier le changement',
          switchBillingStep2Label: 'Ajouter une carte',
          switchBillingStepIndicator:
            'Étape {{current}} sur {{total}} · {{label}}',
          switchBillingProcessing: 'Mise à jour du mode de paiement…',
          switchBillingRedirecting: 'Redirection…',
          switchBillingFromLabel: 'Actuel',
          switchBillingToLabel: 'Nouveau',
          switchBillingInvoiceLabel: 'Facture',
          switchBillingCardLabel: 'Carte',
          switchBillingNextCycleNote:
            "Prend effet au début de ton prochain cycle de facturation.\nTa période d'abonnement actuelle reste inchangée.",
          switchBillingAddCardTitle: 'Ajouter une carte de paiement',
          switchBillingAddCardSubtitle:
            'Une dernière étape pour passer au paiement par carte.',
          switchBillingAddCardPendingLabel: 'Carte requise',
          switchBillingAddCardPendingText:
            "Une carte de paiement est nécessaire pour terminer le changement.\nTon mode de facturation ne changera qu'une fois la carte ajoutée.",
          switchBillingAddCardNextLabel: 'Et ensuite',
          switchBillingAddCardNextText:
            'Continue pour ajouter ta carte de paiement sur la page suivante.',
          switchBillingAddCardSecureNote:
            'Les données de ta carte sont chiffrées et traitées en toute sécurité.',
          switchBillingAddCardGo: 'Ajouter une carte',
          switchBillingAddCardStepDone: 'Changement confirmé',
          switchBillingAddCardStepNext: 'Ajouter ta carte',
          switchBillingSuccess: 'Mode de paiement mis à jour.',
          switchBillingErrorGeneric:
            'Impossible de mettre à jour ton mode de paiement. Réessaie.',
          switchBillingNoPaymentMethod:
            "Ajoute d'abord un mode de paiement avant de pouvoir changer.",
          switchBillingNoPaymentMethodLink: '<link>Gérer la facturation</link>',
          choosePaymentTitle: 'Choisis un mode de paiement',
          choosePaymentSubtitle: 'Comment veux-tu continuer ?',
          choosePaymentInvoiceBody:
            'Les factures seront envoyées à ton e-mail de facturation. Rien n’est débité automatiquement.',
          choosePaymentCardBody:
            'Paie automatiquement avec une carte. Tu l’ajouteras à la page suivante.',
          choosePaymentConfirm: 'Continuer',
          choosePaymentConfirmInvoice: 'Utiliser la facture',
          choosePaymentConfirmCard: 'Ajouter ta carte',
          choosePaymentRedirecting: 'Redirection pour ajouter ta carte…',
          choosePaymentCardOpened:
            'Termine d’ajouter ta carte dans le nouvel onglet.',
          choosePaymentErrorNoUrl:
            'Impossible d’ouvrir la page suivante. Réessaie.',
          editRecipients: 'Modifier les destinataires',
          editRecipientsTitle: 'Destinataires de facture',
          editRecipientsSubtitle:
            'Tous les destinataires reçoivent la même facture. Laisse vide pour utiliser l’e-mail de ton compte.',
          editRecipientsSave: 'Enregistrer',
          editRecipientsSaving: 'Enregistrement…',
          editRecipientsError:
            'Impossible de mettre à jour les destinataires de facture. Réessaie.',
        },
        invoiceHistory: {
          title: 'Historique de facturation',
          subtitle: 'Tes factures et reçus passés pour ton abonnement.',
          colInvoice: 'Facture',
          colIssued: "Date d'émission",
          colDue: "Date d'échéance",
          colAmount: 'Montant',
          colStatus: 'Statut',
          colDownload: 'Télécharger',
          statusOpen: 'Impayée',
          statusPaid: 'Payée',
          statusVoid: 'Annulée',
          downloadInvoice: 'Facture',
          downloadReceipt: 'Reçu',
          invoiceFallback: 'Facture {{id}}',
          issuedOn: 'Émise le {{date}}',
          dueOn: 'Échéance le {{date}}',
          noDueDate: '—',
          empty:
            "Tu n'as pas encore de factures. Elles apparaîtront ici après ton premier cycle de facturation.",
          loadError:
            "Impossible de charger l'historique de facturation. Actualise la page ou réessaie dans quelques minutes.",
          paginationLabel: "Pages de l'historique de facturation",
          showingRange: '{{from}} à {{to}} sur {{total}} factures',
          previousPage: 'Page précédente',
          nextPage: 'Page suivante',
        },
        usage: {
          title: 'Utilisation actuelle',
          lockedHint:
            'Commence un essai pour activer les limites de ton forfait',
          lockedHintResubscribe:
            'Abonne-toi à nouveau pour retrouver les limites de ton forfait.',
          lockedHintTrialExpired:
            'Choisissez un plan pour rétablir vos limites.',
          members: 'Membres',
          atLimitMembers: 'Limite atteinte',
          spotsRemaining: '{{count}} places restantes',
          communities: 'Communautés',
          atLimitCommunities: 'Limite atteinte',
          communitiesRemaining: '{{count}} places communauté restantes',
          schedulers: 'Planificateurs de groupe',
          atLimitSchedulers: 'Limite atteinte',
          schedulersRemaining: '{{count}} planificateurs restants',
          storage: 'Stockage',
          atLimitStorage:
            "Limite atteinte - supprimer des fichiers ou passer à l'offre supérieure",
          storageRemaining: '{{count}} Go restants',
          upgradeNudgeTitle: 'Tu as atteint la limite communautés / équipes.',
          planLimitNudgeTitle: 'Tu as atteint une limite du forfait.',
          upgradeNudgeBody:
            'Passe à Premium pour plus d’équipes, plus de membres et des automatisations & analyses.',
          planLimitNudgeBody:
            'Change de forfait pour augmenter les limites membres, communautés, planificateurs et stockage. Compare et change quand tu veux.',
          upgradeCta: 'Mettre à niveau',
        },
        actions: {
          choosePlan: 'Choisir un forfait',
          changePlan: 'Changer de forfait',
          comparePlansMenu: 'Comparer les forfaits',
          cancelSubscription: 'Annuler l’abonnement',
          dontCancelSubscription: 'Ne pas annuler l’abonnement',
          restartMembership: "Redémarrer l'adhésion",
          subscribeAgain: 'S’abonner à nouveau',
        },
        trust: {
          poweredBy: 'Paiements traités en toute sécurité par Stripe',
        },
      },
    },
    terms: {
      title: 'Les Termes et Conditions de Gumb',
    },
    errors: {
      cantSendMessageToYourself: 'Tu ne peux pas t’envoyer un message.',
      downloadFail: 'Erreur de téléchargement, réessaie.',
      required: 'Champ requis',
      email: 'Veillez pourvoir un adresse email valide',
      invalidEmail:
        'Oups! Veuillez entrer une adresse e-mail valide. Vérifiez les fautes de frappe et réessayez.',
      integer: 'Doit être un nombre entier',
      confirmPassword:
        'Les mots de passe ne sont pas identiques. Veuillez réessayer',
      NotAuthorizedException: 'Identifiant ou mot de passe érroné.',
      invalidCode: 'Ce code est invalide. Veuillez réessayer.',
      errorToast: 'Erreur: {{message}}',
      invalidRequest: 'Requête invalide',
      passwordChanged: 'Mot de passe modifié',
      password:
        'Le mot de passe devrait contenir au moins 8 caractères, des majuscules et des minuscules, des chiffres',
      termsError: 'Veuillez accepter les termes et conditions',
      min: 'Minimum {{value}} caractères',
      max: 'Maximum {{value}} caractères',
      startDate: 'La date ne peut être antérieure au {{value}}',
      endDate: 'La date ne peut être antérieure à la date de début',
      fileSize: 'La taille du fichier est trop importante',
      fileSizeCustom:
        'Fichier trop volumineux : Taille maximale de {{size}} Mo.',
      customFileSize:
        'Fichier trop volumineux: Max {{size}}. Supprime-le et réessaie.',
      unsupportedFormat: "Le format du fichier n'est pas pris en charge",
      postalCode: 'Minimum 4 chiffres',
      sorry: 'Désolé',
      text404:
        "Il semblrait que la page que vous recherchez n'est pas disponible :(",
      url: 'Doit être une URL valide.',
      text500: "Quelque chose s'est mal passé :(",
      onlyForGroupAndAdmin: 'Fonction réservée aux admins et chefs de groupe',
      onlyForAdmin: 'Fonction réservée aux admins',
    },
    eventTypes: {
      createSuccess: 'Type d’événement créé',
      editSuccess: 'Modifications enregistrées',
      deleteSuccess: 'Type d’événement supprimé',
    },
    eventTasks: {
      createSuccess: 'Tâche créée',
      editSuccess: 'Modifications enregistrées',
      deleteSuccess: 'Tâche supprimée',
    },
    eventResponses: {
      createSuccess: 'Réponse enregistrée',
      editSuccess: 'Modifications enregistrées',
      deleteSuccess: 'Réponse supprimée',
    },
    tips: {
      registrationDeadline:
        'La date limite se termine à l’heure de début définie de l’événement. Les membres peuvent répondre jusqu’à ce moment. Après, seuls les admins et chefs de groupe peuvent modifier.',
      eventType:
        'L’admin peut ajouter de nouveaux types d’événements dans les paramètres de la communauté.',
    },
    frequencies: {
      doNotRepeat: 'Une seule fois',
      daily: 'Tous les jours',
      weekly: 'Toutes les semaines',
      monthly: 'Tous les mois',
      yearly: 'Tous les ans',
      everyWorkingDay: 'Tous les jours de la semaine (du lundi au vendredi)',
      other: 'Personnaliser…',
    },
  },
  ru: {
    appWidget: 'Установи Gumb на своё устройство',
    featurePopups: {
      appointmentSchedule: {
        innerHtml:
          "<h3>New feature: Download your appointment schedule as an Excel or CSV file. </h3><p>We have completely redesigned the statistics page, and you can export your entire schedule now. The new report called 'Appointment schedule' gives you an overview of facts and figures of your events.</p><p>We are already working on another report called 'Member figures' which will be related to user performance. </p><p>The diary report is now available in the web app for all users.</p>",
        buttonOk: 'LATER',
        buttonRedirect: 'SEE NOW',
      },
      appleCalendar: {
        title: 'ПОДКЛЮЧИТЕ ВАШ КАЛЕНДАРЬ (iCal)&nbsp;🍏',
        message:
          'Мы это сделали! После большого количества работы, Gumb теперь позволяет прямое подключение календаря в WEB-версии для бесперебойной синхронизации. Скоро будет доступна версия&nbsp;для&nbsp;iOS/Смартфонов!',
        extraMessage: 'Откройте пошаговое руководство',
        redirectText: 'здесь',
        okButton: 'Подключить сейчас',
        cancelButton: 'Не сейчас',
      },
      preferecePopup: {
        title: '2 New Features',
        first: {
          title: 'Set All to "Going":',
          subtitle:
            'Set the default response for new or existing events - for all participants at once!',
          link: '',
        },
        second: {
          title: 'Default Event Settings:',
          subtitle: 'Define how new events should look.',
          link: 'Instructions',
        },
      },
      calendar: {
        innerhtml:
          "<h3>Мы сделали это!</h3> <p> Подключение GOOGLE CALENDAR уже здесь! </p> <br/> <p> События из Gumb - каждое сообщество теперь может быть автоматически перенесено в ваш календарь. </p> <div class='images-container'> <img src='https://gumb-cdn-prod.s3.eu-central-1.amazonaws.com/featurePopups/calendar-1.png' alt='calendar-1' /> <img src='https://gumb-cdn-prod.s3.eu-central-1.amazonaws.com/featurePopups/calendar-2.png' alt='calendar-2' /></div> <p> Все, что вам нужно сделать, описано в этом руководстве: <br/><a target='_blank' rel='noopener noreferrer' href='https://gumb.app/en/support/connect-gumb-with-google-calender/'>→&nbsp; Прочитайте полную инструкцию </a> </p> <p>Краткое руководство: </p> <ol> <li>Подключение и важно: установите флажок!</li> <li>Выберите сообщество</li> <li>Подождите несколько минут и перезагрузите страницу</li> </ol> <p> Подключите свой Календарь Google, чтобы сэкономить время и максимально эффективно использовать каждый день. </p>",
        buttonOk: 'Не для меня',
        buttonRedirect: 'ПОДКЛЮЧИТЬСЯ СЕЙЧАС',
      },
      notifications: {
        title: 'Как должны быть уведомлены члены клуба?',
        firstRow: 'Мы добавили настройки уведомлений.',
        secondRow:
          'Настройки уведомлений, которыми управляют администраторы, теперь могут быть кастомизированы для всего сообщества.',
        thirdRow: 'Все, что вам нужно сделать:',
        listFirstRow: 'Перейдите в настройки сообщества → уведомления.',
        listSecondRow:
          'Активируйте/деактивируйте опции в каждой категории, чтобы настроить все идеально для вас. (→ Читайте инструкции <0>здесь</0>)',
        lastRow:
          'Скажите своим пользователям, чтобы они включили настройки push или электронной почты в своем профиле Gumb.',
        buttonLater: 'Позже',
        buttonSettings: 'Перейти к настройкам сейчас',
      },
      pushNotifications: {
        title: '📢 Связь нового уровня: Push-уведомления',
        message:
          'Администраторы и руководители групп теперь могут создавать push-уведомления, чтобы отправлять вам важную информацию прямо на ваш смартфон.\n\nЧто вы можете делать с push-уведомлениями:\n\n• <b>Мгновенно делиться важной информацией</b> (например, об изменениях в расписании, чрезвычайных ситуациях)\n• <b>Связываться с отдельными людьми или целыми командами</b> (персонализированная коммуникация)\n• <b>Сохранять сообщения в качестве шаблонов, чтобы сэкономить время</b> (эффективная коммуникация)',
        extraMessage:
          'Будьте всегда в курсе событий и не пропустите ни одной новости!',
        cancelButton: 'Посмотреть позже',
        okButton: 'Попробовать сейчас',
        newMessageOne:
          'Администраторы и руководители групп теперь могут напрямую общаться с отдельными людьми или целыми командами, чтобы отправлять вам важную информацию прямо на ваш смартфон.\n\n',
        redirectLink: 'Создавайте индивидуальные push-уведомления',
        newMessageTwo:
          ', выбирайте получателей и даже сохраняйте свои сообщения в качестве шаблонов для последующего использования.',
      },
      importEvent: {
        title: 'Upload/Import Events ',
        subText:
          "No more manual entry! Easily import your events with a CSV or Excel file. Whether it's 30 or 300 events - it's quick and can even be undone if there are mistakes.",
        cancelButton: 'View later',
        okButton: 'Try now',
        secondText: 'Find step-by-step instructions',
      },
      mail: {
        title: 'Новая функция: Режим почты',
        firstRow:
          'Встроенная функция электронной почты упрощает и ускоряет общение в команде.  Вам срочно нужно отправить электронное письмо всем? Но только тем членам, которые ответили "Да" на назначение? → Теперь это возможно всего за несколько кликов!',
        secondRow:
          'Режим почты теперь доступен в веб-приложении для администраторов и руководителей групп. В предстоящий период он будет еще более расширен.',
        thirdRow: 'Подробнее: <0>https://gumb.app/support/mailmodus/</0>',
        buttonLater: 'ПОЗЖЕ',
        buttonMail: 'СЕЙЧАС',
      },
      eventPdf: {
        title: 'Новая функция: Загрузить назначение в формате PDF',
        firstRow:
          'Сэкономьте время и распечатайте информацию о мероприятии одним щелчком!',
        secondRow:
          'Незадолго до предстоящих событий или даже для прошедших событий все детали события, включая статистику ответов, можно экспортировать в PDF.',
        thirdRow:
          'Необходимый планировщик встреч: у вас есть права администратора',
        fourthRow:
          'Необходимое условие для планировщика группы: Вы являетесь руководителем группы',
        fifthRow: 'Теперь эта функция доступна в веб-приложении.',
      },
    },
    menu: {
      homePage: 'ГЛАВНАЯ',
      subscriptions: 'Подписки',
      groupScheduler: 'КАЛЕНДАРЬ',
      documentation: 'ДОКУМЕНТЫ',
      chats: 'ЧАТ',
    },
    dayOfWeek: {
      day1: 'ПН',
      day2: 'BT',
      day3: 'CP',
      day4: 'ЧТ',
      day5: 'ПТ',
      day6: 'СБ',
      day0: 'ВС',
    },
    status: {
      taskInactive: '= Не активирована',
      notActivated: '= Не активирован',
      awaitingReply: '= Ожидает',
      taskInactiveDesc: 'Это задание отключено - участники его не видят.',
      notActivatedDesc:
        'Этот пользователь не активирован для события - он его не видит (белая ячейка).',
      awaitingReplyDesc: 'Событие видно, но ответа ещё нет.',
      notActivatedAction:
        'Нажмите на событие → Редактировать → Участники → отметить галочкой → Сохранить',
      taskInactiveAction:
        'Нажмите на событие → Редактировать → Задачи → отметить галочкой → Сохранить',
      awaitingReplyAction: 'Нажмите на ячейку → Выберите ответ → Сохранить',
    },
    email: {
      sender: 'Отправитель',
      recipients: 'Получатели',
      otherRecipients: 'Дальнейшие адресаты (разделять запятой)',
      subject: 'Тема',
      message: 'Сообщение',
      attachCommunityDocs: 'Прикрепить документы сообщества',
      emailSentSuccessfuly:
        'Письмо отправлено. Внимание: это было письмо no-reply, получатель не может ответить напрямую, но твой адрес отправителя виден.',
      emailSent: {
        title_one: '📤 Письмо отправлено {{count}} получателю',
        title_few: '📤 Письмо отправлено {{count}} получателя',
        title_many: '📤 Письмо отправлено {{count}} получателей',
        title_other: '📤 Письмо отправлено {{count}} получателей',
        message:
          'Если кто-то ответит, сообщение придёт прямо в ваш почтовый ящик.',
      },
      sendCopy: 'Отправьте копию мне',
      plusTooltip: 'Написать новое письмо',
      maxAttachmentsSize: 'Общий размер вложений не более 15 МБ',
      changeEmail: {
        title: 'Письмо с подтверждением отправлено',
        message:
          'Мы отправили тебе письмо с подтверждением нового адреса. Проверь почту и перейди по ссылке, чтобы подтвердить изменения. Если письмо не пришло, проверь папку «Спам». Если есть вопросы - мы всегда поможем.',
      },
    },
    pushNotification: {
      header: 'Уведомления Push',
      filterByRecipient: 'Выбрать получателей',
      filterByResponse: 'Выбрать получателя по ответу',
      pushMessage: 'Создать push',
      saveAsTemplate: 'Сохранить как шаблон',
      sendCopy: 'Отправить копию мне',
      pasteUrl: '🌐 Событие или внешний линк?',
      plusTooltip: 'Создать новое push-уведомление',
      toasterText:
        '🆕 Новая функция: Теперь ты можешь добавить внешнюю ссылку, например любой веб-сайт 🌐 (URL), в push-уведомления!\nНаправляй получателей прямо на сайт.',
      templates: 'Шаблоны',
      title: 'Заголовок',
      lastUsed: 'Последнее использование',
      noTemplates: 'Сохраненные шаблоны отображаются здесь',
      template: 'Шаблон',
      sendConfirmHeader: 'Проверить перед отправкой',
      totalRecipients: 'ПОЛУЧАТЕЛИ',
      redirectLink: 'К ССЫЛКЕ',
      successTitle: 'Уведомление отправлено!',
      successMessage:
        'Ваше сообщение отправлено <b>{{totalRecipients}}</b> получателям.',
      selectEventFirst: 'Чтобы продолжить, выберите событие',
      templateLimitTitle: 'Достигнут лимит шаблонов',
      templateLimitInfo:
        'Сохраните до 8 своих сообщений в качестве шаблонов, чтобы использовать их позже. Мы уже добавили 3 шаблона для вдохновения - вы можете редактировать или удалять их по своему усмотрению.',
      templateLimitMessage:
        'Вы достигли максимального количества шаблонов. Пожалуйста, удалите один, чтобы создать новый.',
      urlInfo:
        'Здесь можно добавить ссылки на любые сайты, например на страницу продукта, статью или что-то важное для вас. Просто введите полный URL (включая https://).',
      urlInfoOne:
        'Здесь можно добавить любую внешнюю ссылку (URL), чтобы получатели переходили по ней напрямую. Если выберешь событие выше, приложение автоматически добавит ссылку на событие, и пуш-уведомление откроет его сразу в Gumb.',
      urlInfoTwo:
        'Скоро: добавляйте любые внешние ссылки (кроме Gumb) в ваши push-уведомления! Ссылайтесь на сайты, новости и многое другое. Следите&nbsp;за&nbsp;обновлениями!',
      urlTooltip:
        'Вы можете создать push-уведомление со ссылкой на событие или без нее. Хотите поделиться ссылкой на ваше мероприятие? Просто выберите его выше, чтобы автоматически скопировать ссылку здесь.',
    },
    common: {
      noResultsFound: 'Нет более ранних событий',
      logoutTooltip: 'Выйти',
      ctrl: 'Показать/скрыть итоги',
      nextDay: '+1д',
      createdAt: 'Создано',
      updatedAt: 'Обновлено',
      onlyAdmin: 'Только администраторы могут использовать эту функцию.',
      download: 'Скачать',
      attachFile: 'Прикрепить файл',
      new: 'Новый',
      unseen: 'Непросмотренные',
      more: 'Больше',
      less: 'Меньше',
      sunday: 'Воскресенье',
      monday: 'Понедельник',
      tuesday: 'Вторник',
      wednesday: 'Среда',
      thursday: 'Четверг',
      friday: 'Пятница',
      saturday: 'Суббота',
      january: 'Январь',
      february: 'Февраль',
      march: 'Март',
      april: 'Апрель',
      may: 'Май',
      june: 'Июнь',
      july: 'Июль',
      august: 'Август',
      september: 'Сентябрь',
      october: 'Октябрь',
      november: 'Ноябрь',
      december: 'Декабрь',
      overallScheduler: 'Планировщик',
      selectEvent: 'Выберите событие (необязательно)',
      displayEventsFrom: 'Отображение событий из',
      modalExit: 'Вы уверены, что хотите выйти без сохранения данных?',
      all: 'Все',
      tooltipEdit: 'Редактировать',
      tooltipDelete: 'Удалить',
      overview: 'Список',
      cancel: 'Отмена',
      removeLogo: 'Вы уверены, что хотите удалить логотип?',
      noTasks: 'Пока нет задач',
      noUsers: 'Пока нет пользователей',
      noOptions: 'Нет вариантов',
      role: 'Роли',
      admin: 'Администраторы',
      member: 'Участники',
      group_lead: 'Лидеры групп',
      email: 'Email',
      groups: 'Группы',
      logoutHeader: 'Выйти?',
      logoutMessage: 'Ты будешь перенаправлен на экран входа.',
      deleteHeader: 'Вы уверены, что хотите удалить пользователя?',
      logout: 'Выйти',
      delete: 'Удалить',
      tablePlaceholder: 'Пока нет участников для отображения',
      contentPlaceholder: 'Пока нет контента для отображения',
      create: 'Создать',
      copy: 'Копировать',
      visible: 'Видимый',
      saveChanges: 'Сохранить изменения',
      newField: 'Новое поле',
      fieldName: 'Имя поля',
      addField: 'Добавить поле',
      notifications: 'Оповещения',
      participants: 'Участники',
      tasks: 'Задания',
      documentation: 'Документы',
      description: 'Описание',
      facebook: 'Facebook',
      twitter: 'X',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      youtube: 'YouTube',
      startDate: 'Дата старта',
      startTime: 'Время старта',
      startDateTime: 'Дата/время начала',
      endDateTime: 'Дата/время окончания',
      endDate: 'Дата завершения',
      endTime: 'Время завершения',
      icon: 'Значок',
      sendMessage: 'Отправить сообщение',
      aboutMe: 'Обо мне',
      selectAll: 'Выбрать все',
      approve: 'Принять',
      reject: 'Отклонить',
      backToGumb: 'Вернуться к Gumb',
      edit: 'Редактировать',
      addComment: 'Добавить комментарий',
      answer: 'Сохранить',
      ok: 'Ok',
      withoutGroup: 'Без группы',
      copyLink: 'Скопировать ссылку',
      copied: 'Скопирована',
      sendInviteLink: 'Отправить ссылку-приглашение',
      apply: 'Применить',
      from: 'С',
      to: 'По',
      enable: 'Включить',
      search: 'Поиск',
      color: 'Цвет',
      columns: 'Потускневшие колонки',
      hiddenColumns: 'Скрытые колонки',
      sorryNoResults:
        'Нам жаль, что вы не смогли найти то, что искали. Пожалуйста, попробуйте другой способ.',
      tutorial: 'Инструкция',
      next: 'Далее',
      back: 'Назад',
      step: 'Шаг',
      createSuccess: {
        title: 'Создано',
        message: 'Ваш вариант был успешно создан.',
      },
      editSuccess: {
        title: 'Изменено',
        message: 'Ваши изменения были сохранены.',
      },
      deleteSuccess: {
        title: 'Удалено',
        message: 'Вариант был успешно удален.',
      },
      toolTipText: {
        grid3x3: 'Матрица: назначить участников в сообщества',
        faq: 'Помощь: Руководства, Контакт, Другое.',
        communityPlusIcon: 'Создать новое сообщество',
        logoGumb:
          'Загадка в разработке: Узнайте позже, что скрывает эта кнопка!',
        memberArrowIcon: 'Перейти к обзору участников',
        memberPlusIcon: 'Добавить нового участника',
        eventType: 'Создать тип события',
        responses: 'Создать вариант ответа',
        task: 'Создать задачу',
        schedulerPlusIcon: 'Создать событие или группу',
      },
      shareEventTitle: 'Поделиться ссылкой на событие через:',
      copyEventLink: 'Или скопируйте ссылку:',
    },
    auth: {
      signInWith: 'Войти через',
      continueAs: 'Продолжить как',
      create: 'Создать бесплатный аккаунт',
      signUp: 'Зарегистрироваться',
      signIn: 'Войти',
      welcome: 'Добро пожаловать!',
      createAccount: 'Создать бесплатный аккаунт',
      forgotPassword: 'Забыли пароль?',
      resetPassword: 'Сброс пароля',
      resetPasswordTooltip:
        'Если ты сбросишь пароль, участник получит письмо с инструкцией для нового пароля. Для аккаунтов, созданных через Facebook, Google или Apple, Gumb не может сбросить пароль. Участник может войти через нужную соцсеть.',
      resetPasswordModalTitle: 'Сброс пароля запущен',
      resetPasswordModalText:
        'Участник сейчас получает письмо для смены пароля. Для Facebook, Google или Apple пусть просто входит как обычно через иконку.',
      resetPasswordErrorModalTitle: 'Сброс пароля невозможен',
      resetPasswordErrorModalText:
        'Внимание: этот участник входит через Facebook, Google или Apple. Gumb не может сбросить пароль. Если пароль забыт, нужно сбросить его у самого провайдера. Вход через социальную иконку работает как обычно. Пожалуйста, сообщите об этом участнику.',
      terms: {
        '0': 'Я соглашаюсь с ',
        '1': 'Условиями',
        '2': ' и ',
        '3': 'Политикой конфиденциальности',
      },
      termsAcknowledgement:
        'By continuing, you acknowledge that you understand and agree to the <0>Terms & Conditions</0> and <1>Privacy Policy</1>.',
      home: 'Главная страница',
      confirmed: 'Email успешно подтвержден',
      verifying: 'Проверяем email...',
      recovery: 'Восстановление пароля',
      send: 'Отправить',
      codeSended:
        'Ссылка для подтверждения отправлена на твою почту. Пожалуйста, проверь и подтверди. Обрати внимание на папку спам.',
      signUpSuccessTitle: 'Регистрация прошла успешно',
      signUpSuccess:
        'Пожалуйста, проверьте свою электронную почту, чтобы подтвердить регистрацию.',
      inviteSentTitle: 'Приглашение успешно отправлено',
      inviteSentText:
        'Готово! Участник успешно добавлен, приглашение с временным паролем отправлено (проверь спам при необходимости). Участник может войти и сменить пароль. Обнови страницу для актуального списка. Ты и админы теперь можете редактировать группу, роль или профиль участника.',
      reset: 'Сбросить',
      yourEmail: '{{value}} уже является вашим email',
      existEmail: '{{value}} уже существует',
      labels: {
        email: 'Email',
        currentEmail: 'Текущий email',
        newEmail: 'Новый email',
        password: 'Пароль',
        oldPassword: 'Старый пароль',
        newPassword: 'Новый пароль',
        confirmPassword: 'Подтвердить пароль',
      },
      accountExists:
        'Этот адрес электронной почты уже используется для учетной записи Gumb. Если это письмо принадлежит вам, нажмите "Забыли пароль" и проверьте папку "Входящие" и "Спам".',
      codeExpired:
        'Это была ссылка с истекшим сроком действия. После того, как вы введете здесь свой e-mail, мы отправим вам письмо с новой ссылкой для завершения проверки вашей учетной записи.',
      userNotConfirmed:
        'Вам по-прежнему необходимо подтвердить свою учетную запись. Мы отправили вам электронное письмо со ссылкой для подтверждения. Если вы не получили письмо, проверьте папку "Спам" в вашем почтовом ящике.',
      invalidCredentials: 'Неверное имя пользователя или пароль',
      userNotFound:
        'Эта почта еще не зарегистрирована или связана с Google, Apple или Facebook. Не меняй пароль соцсети в Gumb - просто войди через нужную иконку.',
      socialLoginDetected: {
        title: 'Обнаружен вход через соцсеть',
        message:
          'Этот e-mail, похоже, связан с Google, Apple или Facebook. Пароль управляется там, а не в Gumb. Чтобы войти, просто нажми на нужную иконку соцсети.',
      },
    },
    profile: {
      editSuccess: 'Изменения сохранены',
      settings: 'Настройки',
      editProfile: 'Редактировать профиль',
      selectImage: 'Выбрать изображение',
      myProfile: 'Мой профиль',
      profileEditBtn: 'ДОБАВЬ СВОИ ДАННЫЕ: АДРЕС, СОЦСЕТИ И ДРУГОЕ',
      basicInformation: 'Основные данные',
      contactInformation: 'Контакты',
      addressInformation: 'Адрес',
      myCommunities: 'Мои сообщества',
      myAppointments: 'Мои события',
      myChat: 'МОИ ЧАТЫ',
      freeText1: 'Свободный текст 1',
      freeText2: 'Свободный текст 2',
      subscription: 'Подписки',
      userProfile: 'Профиль пользователя',
      tellUsAboutYourself: 'Обо мне',
      firstName: 'Имя',
      lastName: 'Фамилия',
      profileName: 'Имя пользователя',
      person: 'Человек',
      role: 'Роль пользователя',
      email: 'Email',
      dateOfBirth: 'Дата рождения',
      privatePhoneNumber: 'Тел (домашний)',
      officePhoneNumber: 'Тел (рабочий)',
      mobilePhoneNumber: 'Тел (мобильный)',
      street: 'Улица',
      region: 'Регион',
      postalCode: 'Почтовый индекс',
      city: 'Город',
      country: 'Страна',
      about: 'Сведения',
      linkChangeEmail: '(Изменить электронную почту)',
    },
    profileCommunities: {
      empty: {
        title: 'Сообщества пока не видны',
        description:
          'Когда вы создадите свои сообщества или присоединитесь к другим,<brPure />они появятся здесь.',
      },
      popupLeave: {
        title: 'Точно выйти из сообщества?',
        button: 'Оставить',
      },
      leaveCommunity: {
        title: 'Точно выйти из сообщества?',
        message:
          'Ты выходишь только из этого сообщества. Аккаунт сохранится, можно вступать в другие.',
        okButton: 'Да, Покинуть',
        cancelButton: 'Отмена',
      },
    },
    profileSettings: {
      title: 'Настройки профиля',
      notification: 'Оповещения',
      notificationsPlaceholder: 'У тебя пока нет уведомлений',
      changePassword: 'Изменить пароль',
      changeEmail: 'Email',
      saveNewEmail: 'Сохранить новый email',
      language: 'Язык',
      timeFormat: 'Формат времени',
      permissions: 'Разрешения',
      allowedToEdit: 'Администраторам разрешено редактировать мой профиль',
      other: 'Другое',
      pushNotification: 'Push-уведомления',
      receiveByEmail: 'Получать уведомления по электронной почте',
      receivePush: 'Получать мобильные push-уведомления',
      receiveInApp: 'Получать уведомления в приложении',
      terms: 'Условия и положения',
      protectionRegulation: 'Политика конфиденциальности',
      deleteAccount: 'Удалить аккаунт',
      logout: 'Выйти',
      deleteProfileHeader: 'Точно удалить свой аккаунт?',
      notifications: {
        now: 'Сейчас',
        hours: '{{value}} ч назад',
        minutes: '{{value}} мин назад',
        minute: '1 мин назад',
      },
    },
    calendarConnection: {
      outlookCalendar: 'Outlook Calendar',
      googleCalendar: 'Google Calendar',
      pageTitle: 'Синхронизация календаря',
      connectTitle:
        'Подключи календарь\nдля автоматической синхронизации событий',
      connectDescription:
        'Gumb сам добавляет события - они появляются в твоём календаре.',
      appleCalendar: 'Календарь Apple',
      appleConnectionSteps: {
        headerOne:
          'Добавь события Gumb в свой календарь (Apple или Outlook) через ссылку iCal - в 4 шага.',
        demoLinks: 'Быстрая демонстрация',
        demoLinksApple: 'Apple',
        demoLinksAppleHere: 'здесь',
        demoLinksDetailed: 'Подробная инструкция',
        demoLinksDetailedApple: 'Apple',
        demoLinksDetailedHere: 'здесь',
        demoLinksOutlook: 'Outlook',
        demoLinksOutlookHere: 'здесь',
        stepOne: 'В приложении календаря открыть',
        stepOneSubscribeBold: 'Подписка на календарь',
        stepOneApplePrefix: 'Apple',
        stepOneAppleSuffix: 'Файл → Новая подписка на календарь',
        stepOneOutlookPrefix: 'Outlook',
        stepOneOutlookSuffix:
          'Добавить календарь → Из интернета / Подписка по веб-ссылке',
        stepTwo: 'Скопировать iCal-ссылку вашей группы и вставить её',
        stepThree: 'Задать название и при желании выбрать цвет',
        stepFour:
          'Указать место хранения (iCloud, Mac, Outlook) и обновление, подтвердить',
      },
      appleConnectionPopup: {
        title: 'Как подключиться?',
        stepOne: 'Скопировать ссылку сообщества',
        stepTwo:
          'В вашем Календаре Apple, в разделе "Календарь", выберите "Файл" > "Новая подписка на календарь".',
        stepThree:
          'Введите скопированную iCal-ссылку Сообщества, затем нажмите «Подписаться».',
        stepFour:
          'Назовите календарь, выберите цвет, укажите настройки как местоположение (iCloud или Mac) или автообновление и нажмите «ОК».',
      },
      appleDisconnectPopup: {
        title: 'Подтвердить Отключение',
        message:
          'Нажав "Да, отключить сейчас", вы удалите все события Gumb из вашего/ваших календаря/календарей. Пожалуйста, вручную удалите календарь/календари после этого, иначе он/они останется/останутся видимым/видимыми.\n\n<b>Чтобы полностью отписаться:</b>\n\n• <b>На macOS</b>: Откройте Календарь, кликните правой кнопкой мыши по календарю > "Отписаться".\n• <b>На iOS</b>: Перейдите в "Календари", нажмите кнопку "Информация" рядом с календарем > "Удалить Календарь".',
        okButton: 'Oui, se déconnecter maintenant',
      },
      appleUncheckBoxPopup: {
        title: 'Подтвердить Отключение',
        message:
          'Нажав "Да, отключить сейчас", вы удалите все события Gumb из вашего календаря. Пожалуйста, вручную удалите календарь после этого, иначе он останется видимым.\n\n<b>Чтобы полностью отписаться:</b>\n\n• <b>На macOS</b>: Откройте Календарь, кликните правой кнопкой мыши по календарю > "Отписаться".\n• <b>На iOS</b>: Перейдите в "Календари", нажмите кнопку "Информация" рядом с календарем > "Удалить Календарь".',
        okButton: 'Да, отключить сейчас',
      },
      connectWithApple: 'Подключить Apple и Outlook (iCal)',
      cantSeeICal: 'Не видите ссылку iCal? Просто отметьте галочку.',
      syncTip:
        'Только события из выбранных сообществ будут синхронизированы с вашим календарем.',
      connect: 'Подключиться',
      connected: 'Подключено',
      disconnect: 'Отключить',
      disconnectSuccess: 'Успешное отключение',
      selectCommunities: 'Выбор сообществ',
      selectCommunitiesDescription:
        'Только события из выбранных сообществ будут синхронизированы с вашим календарем.',
      authSuccessTitle: 'Успешное подключение',
      authSuccessMessage:
        'Ваши события теперь синхронизируются автоматически. Подождите немного и обновите страницу Google Календаря для первой синхронизации.',
      authSuccessTitleTwo: 'Выберите сообщество прямо сейчас',
      authSuccessMessageTwo:
        'Нажмите на галочку и "Сохранить изменени", чтобы подтвердить.',
      syncSuccess:
        'Обновлено!\nАвтосинхронизация включена. Управляй сообществами в любое время.',
      syncSuccessTitle: 'Почти готово!',
      syncSuccessMessage:
        'Мы подключаем твое сообщество к твоему Google Календарю. Это займет всего 2-3 минуты. Обнови страницу Google Календаря, чтобы увидеть обновления.',
      disconnectConfirmTitle: 'Вы уверены?',
      disconnectConfirmDescription:
        'Если вы отключитесь, синхронизированные сообщества будут удалены из вашего календаря.',
      disconnectConfirm: {
        title: 'Отключиться сейчас?',
        message:
          'Отключение удалит все события из вашего календаря Google. Не волнуйтесь, вы можете повторно подключить Gumb для новой синхронизации позже в любое время.',
        cancelButton: 'Отмена',
        okButton: 'Да, Отключить',
      },
      noCommunities:
        'Нет сообществ для выбора.\nПодождите, пока вас добавит администратор.',
      checkboxWarning:
        'ВНИМАНИЕ: Необходимо дать разрешение на использование календаря',
    },
    community: {
      noMembersEmptyState: {
        title: 'Участников пока нет',
        description: 'Они появятся здесь, как только участники запишутся.',
      },
      plusIconSubText: 'Запланируй событие или создай серии событий.',
      selectAllCommunityAdmins: 'Все администраторы',
      selectAllGroupAdmins: 'Все руководители групп',
      createSuccess: 'Сообщество успешно создано',
      createFailure: 'Попробуйте создать сообщество ещё раз через минуту.',
      deleteSuccess: 'Сообщество успешно удалено',
      leaveSuccess: 'Вы успешно покинули сообщество',
      descriptionTitle: 'О сообществе',
      descriptionPlaceholder: 'Здесь вы можете добавить описание сообщества',
      online: 'Online',
      updateCommunity: 'Обновить сообщество',
      members: 'Участники',
      createCommunity: 'Создать сообщество',
      communityName: 'Название сообщества',
      category: 'Категория',
      aboutCommunity: 'О сообществе',
      selectLogo: 'Выбрать логотип',
      selectLogoTip: 'jpg, jpeg, png (5MB)',
      chooseCover: 'Выбрать обложку',
      chooseCoverTip: 'jpg, jpeg, png (20MB)',
      website: 'Веб-сайт',
      partnership: 'Сотрудничество',
      deleteCommunity: 'Удалить сообщество',
      deleteHeader:
        'Вы уверены, что хотите удалить этого пользователя из группы?',
      addMembers: 'Добавить участников',
      invitationLink: 'Ссылка-приглашение',
      communityRole: 'Роль в сообществе',
      joinCommunity: 'Присоединиться к сообществу',
      namePlaceholder: 'Команда {{value}}',
      requestSent: 'Запрос на членство успешно отправлен',
      requestSentButton: 'Отправлен запрос на членство',
      limitExceededHeader:
        'Достигнут лимит сообществ вашего тарифа. Чтобы создать больше, обновите тариф в Профиль > Подписка.',
      limitExceededMessage:
        'Свяжитесь с владельцем вашего сообщества. Только он/она может управлять и обновить подписку.',
      limitExceededMessageOwner:
        'Пожалуйста, перейди в Профиль > Подписка, чтобы управлять тарифом и обновить его при необходимости.',
      updateFailure: 'Не удалось обновить сообщество',
      buttonAddEvent: 'Добавить событие',
      userBlockedTitle: 'Заблокировано',
      userBlockedText:
        'Похоже, что кто-то заблокировал вас в этом сообществе. Администраторы могут блокировать или разблокировать пользователей.',
      createOverLimitTitle: 'Лимит сообществ достигнут',
      createOverLimitText:
        "Начни бесплатный пробный период или выбери тариф в 'Изменить подписку', чтобы организовать свое сообщество.",
      notInvitedTitle: 'Нет разрешения',
      notInvitedText:
        'Возможно, у вас нет разрешения на доступ к этому событию. Администраторы и руководители групп могут добавить вас на это мероприятие.',
      noRequestsTitle: 'Пока нет ожидающих запросов.',
      noRequestsText:
        'Заявки на вступление будут отображаться на этой странице',
      invitationCodeExpired:
        'Это ссылка на приглашение с истекшим сроком действия. Но теперь вы можете отправить запрос на присоединение, который администраторы могут принять или отклонить.',
      communityNotFound: 'Сообщество не найдено',
      communityPopup: {
        title: 'Создать Событие или Группу',
        subTitleOne:
          'Планируйте события в центральном РАСПИСАНИИ. Используйте группы для разделения участников на команды.',
        createEvent: {
          infoText:
            "Планируйте события для всех или определенных групп/участников в РАСПИСАНИИ. Видно в расписании, под 'Мои События' и в группах.",
          btntitle: 'Создать Событие',
          linkText: 'Учебник',
        },
        createGroup: {
          infoText:
            'У каждой группы свой планировщик, события в котором видны только ее участникам. Эффективно управляйте ролями участников',
          btntitle: 'Создать Группу',
          linkText: 'здесь',
        },
        chatTitle: 'Опции чата',
        chatSubTitle: 'Начните 1:1 чат или создайте комнату чата для групп.',
        oneToOne: {
          infoText:
            'Нажми на иконку чата рядом с именем участника или на его фото профиля, чтобы отправить сообщение.',
          btntitle: 'Список участников',
          linkText: 'Учебник',
        },
        createChatGroup: {
          infoText:
            'Создай приватную комнату чата для выбранных участников, команд или групп. Только администраторы могут создавать такие комнаты.',
          btntitle: 'Создать чат-комнату',
          linkText: 'здесь',
        },
      },
      exportStatistics: 'Экспорт статистики',
      exportStatisticsTooltip: 'Экспорт статистики в файл CSV',
    },
    communitySettings: {
      noMatrixData: {
        title: 'Сообщества пока не видны',
        description:
          'Когда владелец создаст сообщества и сделает вас админом, вы сможете назначать участников здесь.',
      },
      noSearchResults: {
        title: 'Результатов нет',
        description:
          'Для {{searchResult}} ничего не найдено. Попробуйте другой запрос.',
      },
      clearSearch: 'Сбросить поиск',
      matrixDescription:
        'Назначайте/удаляйте участников в ваших сообществах одним кликом - сохраняется сразу.<brPure />Идеально для смен сезона и команды, а также множественных назначений.',
      tooltip:
        'Перейти к «Матрице»: назначать/удалять участников в сообществах.',
      matrix: 'Матрица',
      admin: 'Администратор',
      member: 'Участник',
      blocked: 'Заблокированный пользователь',
      owner: 'Владелец',
      group_lead: 'Лидер группы',
      group_admin: 'Администратор группы',
      chat_admin: 'Админ чата',
      community_admin: 'Администратор сообщества',
      editRoleSuccess: 'Роль была успешно изменена',
      deleteUserSuccess: 'Пользователь был успешно удален из сообщества',
      removeUser: {
        title: 'Вы уверены, что хотите удалить этого пользователя?',
        message:
          'При удалении этого пользователя его удалят из вашего сообщества, но сохранится его учетная запись, и он сможет продолжить участие в других сообществах.',
        cancelButton: 'Отмена',
        okButton: 'Да, Удалить',
      },
      removeUserSuccess: {
        title: 'Пользователь удален',
        message: 'Пользователь успешно удален из вашего сообщества.',
      },
      editSuccess: 'Изменения были успешно обновлены',
      title: 'Настройки сообщества',
      backToSubscriptionsDetails: 'Вернуться к деталям подписки',
      tabs: {
        general: 'Общие предпочтения',
        eventTypes: 'Типы событий',
        subscriptions: 'Подписки',
        responses: 'Варианты ответов',
        roles: 'Участники',
        requests: 'Запросы',
        other: 'Другое',
        tasks: 'Задания',
      },
      addMember: 'Добавить пользователя',
      exportMembers: 'Экспорт списка участников в файл CSV',
      exportMembersTooltip: 'Экспорт списка участников в файл CSV',
      deleteCommunityHeader: 'Действительно удалить?.',
      deleteCommunityMessage:
        'Все ваши данные будут безвозвратно удалены. Восстановление невозможно.',
      defaultEventList: [
        '🤝🏻🏻 Встреча 🤝🏻🏻',
        '📅 Событие 📅',
        '📋 Совещание 📋',
        '📝 Заседание совета 📝',
        '🚌 Поездка 🚌',
        '🛠️ Воркшоп 🛠️',
        '⏰ Смена ⏰',
        '🏢 Корпоратив 🏢',
        '🏃 Тренировка 🏃',
        '🏆 Турнир 🏆',
        '🎶 Репетиция 🎶',
        '🔴 ОТМЕНЕНО 🔴',
        'ℹ️ Инфо ℹ️',
        '📊 ОПРОС 📊',
      ],
      defaultResponsesTypes: [
        'Я присоединяюсь ✅',
        'Не смогу прийти ❌',
        'Пока не уверен(а) 🟨',
      ],
      defaultTasks: ['Кто за рулем?', 'Кто приносит напитки?'],
      selectUsers: {
        title: 'Выберите Пользователей',
        message:
          'Пожалуйста, отметьте пользователей галочкой, чтобы одобрить или отклонить запросы на вступление.',
      },
      memberExists: 'Пользователь уже вступил в сообщество',
      mailSent:
        'Приглашение отправлено! Действует 24 часа. Новый участник кликает «Присоединиться» и входит с временным паролем - и сразу становится частью твоего сообщества. Админы могут отправлять приглашение в любое время.',
      userNotFound:
        'Профиль не найден. Введи имя и фамилию, чтобы создать профиль и отправить приглашение.',
      disableAddMemberTooltip:
        'Достигнут лимит участников. Попроси владельца сообщества обновить тариф, чтобы добавить больше участников.',
      notifyByFields: 'Отправлять уведомление, если эти поля изменяются',
      notifyByReplies: 'Отправить уведомления приглашённым?',
      remindBefore: 'Напомнить до',
      addReminder: '+ Добавить напоминание (2 макс.)',
      notificationsTypes: [
        'Событие создано',
        'Событие обновлено',
        'Событие удалено',
        'Напоминание о событии',
      ],
      notificationsClasses: ['In-App', 'E-mail', 'Push'],
      notificationPopupHeader: 'Уведомить приглашённых?',
      notificationPopupMessageLabel: 'Добавить опциональное сообщение',
      notificationPopupNotify: 'Отправить',
      notificationPopupDoNotNotify: 'Не отправлять',
      notificationPopupBack: 'Вернуться к редактированию',
      ownerTooltip:
        '👑 Владелец\n\nВладелец создал это сообщество.\n\nОн всегда один - с полными правами: управляет подпиской и может удалить сообщество.\n\nПередача возможна - обратитесь в поддержку.',
      emailTooltip:
        '📧 Эл. почта\n\nЛогин e-mail пользователя.\nТолько сам пользователь может его изменить.\n\nПодсказка: знаете e-mail нового участника? → Добавить пользователя',
      roleTooltip:
        '🛠️ Роль\n\nАдмин:\nИмеет полный доступ - видит и управляет всем.\n➜ Нажмите на поле, чтобы назначить участника админом\n\nРуководитель группы:\nУправляет событиями и ответами в конкретной группе.\n➜ Откройте группу → Участники → Перетащите вверх',
      groupsTooltip:
        '👥 Группы\n\nПоказывает, в каких группах состоит участник.\n➜ Нажмите, чтобы назначить группы.\n\nНовые участники видят все события в планировщике.\nГрупповые события отображаются только после назначения в группу.',
    },
    communityInvitation: {
      subjectFirst: 'Вас пригласили присоединиться к сообществу',
      subjectSecond: '',
      body: 'Пожалуйста, перейдите по ссылке ниже, чтобы вступить в сообщество',
      invitationSuccess:
        'Успешно одобрено! Участник теперь в списке. Роль и группу смотри в настройках сообщества → Участники.',
      invitationFailure: 'Ошибка - вероятно, достигнут лимит по тарифу.',
      membersInvitation: {
        title: 'Пригласить участников',
        description:
          'Есть несколько способов добавить новых участников. Подробнее: <0>"Добавление нового пользователя"</0>.',
        showMore: 'Показать больше',
        showLess: 'Показать меньше',
        codeInvitation: {
          title: 'Самый быстрый и простой способ',
          button: 'Скопируйте ссылку с приглашением',
          updateLink: 'Создать ссылку сейчас',
          generateLink: 'Generate link now',
          howItWorks: 'Как это работает',
          goodToKnow: 'Полезно знать',
          howItWorksText:
            'Пользователи нажимают на "Создать бесплатный аккаунт", используя выбранную выше ссылку. Когда Gumb отправит электронное письмо, участникам нужно будет только подтвердить свой адрес электронной почты, чтобы получить прямой доступ.',
          goodToKnowText:
            'Это быстрый способ, но, пожалуйста, обратите внимание, что после завершения проверки аккаунта люди с этой ссылкой смогут сразу же получить доступ к вашим мероприятиям. Следовательно, вы можете обновить вышеуказанную ссылку, когда захотите.',
        },
        linkInvitation: {
          title: 'По ссылке:',
          button: 'Скопировать ссылку сообщества',
          howItWorks: 'Как это работает:',
          adminFlow: 'Админы проверяют заявки:',
          howItWorksText:
            '<0>Скопируй и поделись ссылкой.</0><0>Пользователи с аккаунтом Gumb нажимают «Присоединиться».</0><0>Если у кого-то нет аккаунта, сначала нужно зарегистрироваться, затем снова перейти по ссылке и отправить вам заявку.</0>',
          adminFlowText:
            'Все новые заявки видны во вкладке «Заявки». Админы могут принять или отклонить их там. Открытые заявки отмечаются значком шестерёнки.',
        },
        addMember: {
          title: 'Пригласить или зарегистрировать по e-mail',
          button: 'ДОБАВИТЬ ПОЛЬЗОВАТЕЛЯ',
          selfSignUp: 'Пользователь регистрируется сам:',
          preRegister: 'Зарегистрировать человека заранее:',
          selfSignUpText:
            'Любой может бесплатно зарегистрироваться в Gumb и отправить тебе свой e-mail. Если ты введёшь адрес здесь, участник будет автоматически добавлен и увидит все события.',
          preRegisterText:
            'Добавь нового участника напрямую по e-mail. Аккаунт сразу создаётся, участник получает приглашение с временным паролем и может сразу войти. Пароль можно сменить позже.',
        },
      },
    },
    group: {
      deleteEventSuccess: 'Событие успешно удалено',
      createSuccess: 'Группа успешно создана',
      deleteSuccess: 'Группа успешно удалена',
      addMembersSuccess: 'Участники успешно добавлены',
      addMembersSuccessWithMessage: {
        title: 'Участник добавлен!',
        message:
          'Ваш список участников успешно обновлен. Управляйте ролями и назначениями в группах. Вы также можете добавить или изменить данные пользователя.',
      },
      deleteUserSuccess: 'Успешное удаление пользователя из группы',
      addParticipants: 'Добавить участников',
      createGroup: 'Создать группу',
      deleteGroup: 'Удалить группу',
      groupName: 'Названиe группы',
      changeGroupNameSuccess: 'Название группы успешно изменено.',
      groups: 'Группы',
      inviteMembers: 'Пригласить участников',
      tabs: {
        schedule: 'Заланировать',
        members: 'Участники',
        chat: 'Чат',
        documentation: 'Документы',
        statistic: 'Экспорт и статистика',
        import: 'Импорт',
      },
      limitExceededHeader:
        'Достигнут лимит сообществ вашего тарифа. Чтобы создать больше, обновите тариф в Профиль > Подписка.',
      limitExceededMessage:
        'Свяжитесь с владельцем вашего сообщества. Только он/она может управлять и обновить подписку.',
      limitExceededMessageOwner:
        'Пожалуйста, перейди в Профиль > Подписка, чтобы управлять тарифом и обновить его при необходимости.',
      groupRole: 'Роль группы',
      addGroup: 'Добавить группу',
    },
    chat: {
      read: {
        now: '{{name}} прочитано только что',
        hours: '{{name}} прочитано {{value}} ч назад',
        minutes: '{{name}} прочитано {{value}} мин назад',
        minute: '{{name}} прочитано 1 мин назад',
        day: '{{name}} прочитано {{value}}',
        dateTime: '{{name}} прочитано {{value}} в {{time}}',
      },
      noRead: 'Еще не прочитано',
      noActiveCommunity: 'У тебя еще нет активного сообщества.',
      lastAdmin:
        'В чате должен быть хотя бы один администратор или руководитель группы. Убедитесь, что хотя бы один человек всегда имеет эту роль.',
      update: {
        success: 'Список участников обновлён',
        successUpdate: 'Чат-группа успешно обновлена',
        btn: 'СОХРАНИТЬ',
      },
      modal: {
        btn: 'Управление',
        about: 'Инфо',
        editRoom: 'Редактировать чат',
        delete: 'Удалить чат',
        editMember: 'Редактировать участников',
        onlyChatAdmin: 'Только админы чата могут это сделать.',
      },
      details: {
        title: 'Детали чата',
        secondTitle: 'ИНФОРМАЦИЯ',
        name: 'Название чата',
      },
      delete: {
        success: 'Чат был удален',
      },
      create: {
        title: 'Создать чат-комнату',
        name: 'Название чат-комнаты',
        description: 'Описание группы (необязательно)',
        btnNext: 'ДАЛЕЕ',
        success: 'Чат создан',
      },
      new: 'Новый',
      chat: 'чат',
      popover: {
        title: 'Неизвестный пользователь',
        message: 'Больше не состоит в этом сообществе или группе',
      },
      inputPlaceHolder: 'Введите сообщение',
      searchHover: 'Найти или начать новый чат',
      op1: 'Файлы и видео',
      op2: 'Фото',
      files: 'Файлы',
      plusTooltip: 'Создать новый чат или групповой чат',
      emptyStatus: {
        noChatSelected: {
          firstLine: 'Выберите беседу, чтобы просмотреть чат,',
          secondLine: 'или нажмите здесь, чтобы начать',
          LinkText: 'НОВЫЙ ЧАТ',
        },
        noChatUser:
          'Пока нет чатов? Начни 1:1 чат или подожди, пока администратор тебя добавит.',
        noUnseenUser: "Don't have any unseen chat",
        sendFirstMessage: 'Напишите своё первое сообщение {{recipient}}.',
      },
      infoPopup: {
        title: 'Превышен лимит',
        message: 'Можно загрузить не более 20 файлов за раз.',
      },
    },
    statistics: {
      tableType: 'Выберите отчет',
      eventReplies: 'Ответы и задания',
      eventTypes: 'Тип события',
      appointmentSchedule: 'Расписание событий',
      memberFigures: 'Проверка посещаемости',
      charts: {
        eventTypesByMonth: 'Количество назначений по типу',
        eventReplies: 'Ответы на варианты ответов',
        memberPresence: 'Количество реакций на ответ',
      },
      loadingStatistics: 'Загрузка...',
      memberFiguresExportSuccess: {
        title: 'Отчёт формируется!',
        message:
          'Твой отчёт о посещаемости формируется. Из-за большого объёма данных это может занять несколько минут. В целях безопасности отчёт придёт на твой e-mail. Проверь почту. Спасибо за терпение!',
      },
    },
    filters: {
      clickToSelect: 'Нажмите здесь, чтобы отфильтровать',
      showFilters: 'Показать фильтры',
      dateRange: 'Выберите диапазон дат',
      filterBy: 'Фильтр по',
      dateRanges: {
        yearToDate: 'За год',
        lastDays: 'Последние {{number}} дней',
        lastYear: 'Последний год',
        yesterday: 'Вчера',
        today: 'Сегодня',
        tomorrow: 'Завтра',
        nextDays: 'Следующие {{number}} дней',
        thisWeek: 'На этой неделе',
        thisMonth: 'Этот месяц',
        thisYear: 'Этот год',
        allTime: 'Все время',
        specificDateRange: 'Определенный диапазон дат',
      },
      downloadXlsxOrCsv: 'Экспорт Excel или CSV',
    },
    bulkUploadEvents: {
      toastText:
        '🆕  Новая функция импорта встреч теперь доступна для каждой группы!  🎉',
      moduleTitle: 'Импорт',
      step1: 'Шаг 1',
      step2: 'Шаг 2',
      step3: 'Шаг 3',
      step4: 'Шаг 4',
      stepOne: {
        stepTitle: 'Подготовить импорт данных',
        stepDescription: 'Скачать шаблон Excel',
        componentTitle: 'Скачать шаблон Excel',
        componentDescription:
          'Заполните шаблон своими данными о событиях или используйте собственный файл Excel.',
        p1: 'Заполните шаблон данными вашего мероприятия.',
        p2: 'Заголовки столбцов должны оставаться на английском языке.',
        p3: 'Примеры в каждом столбце показывают правильный формат.',
        p4: 'Новые типы событий добавляются автоматически.',
        p5: '<b>Важно</b>: Если вы используете свой собственный файл, следующие названия столбцов должны быть скопированы точно так, как показано на английском языке (с учетом регистра):',
        p6: 'Примеры в каждом столбце шаблона показывают правильный формат.',
        p7: 'Новые типы событий добавляются автоматически.',
        eventTypes: 'ПЕРЕЙТИ К ТИПАМ СОБЫТИЙ',
        template: 'СКАЧАТЬ ШАБЛОН',
        nextStepButton: 'ПРОДОЛЖИТЬ',
        copy: 'Скопировать все',
      },
      stepTwo: {
        stepTitle: 'ЗАГРУЗИТЬ ФАЙЛ',
        stepDescription: 'ЗАГРУЗИТЬ CSV-ФАЙЛ',
        componentTitle: 'ЗАГРУЗИТЬ CSV-ФАЙЛ',
        componentDescription:
          'Сохраните файл Excel в формате <b><u>CSV</u></b> и загрузите его сюда.',
        p1: 'Мы проверим формат и покажем вам предварительный просмотр.',
        uploadButton: 'Выбрать файл',
        maximumFileSize: 'Максимальный размер файла: 1 МБ',
      },
      stepThree: {
        stepTitle: 'Подтвердить данные',
        stepDescription: 'Предварительный просмотр вашего первого события.',
        componentTitle: 'Подтвердить данные',
        componentDescription:
          'Проверьте пример и настройте активированных участников.\nВыбранные участники применяются ко всем событиям.',
        nextStepButton: 'ПОДТВЕРДИТЬ И ЗАГРУЗИТЬ',
      },
      stepFour: {
        stepTitle: 'Успешно загружено!',
        stepDescription:
          'Загрузка событий прошла успешно. Посмотрите их в планировщике.',
        componentTitle: 'Успешно загружено!',
        componentDescription: 'Было импортировано <b>{{count}}</b> событий.',
        secondTitle: 'Полезно знать',
        secondSubTitle: 'Вы можете отменить импорт или загрузить новый список.',
        goToScheduler: 'ПЕРЕЙТИ К ПЛАНИРОВЩИКУ',
        undoImport: 'ОТМЕНИТЬ ИМПОРТ',
        uploadNewList: 'ЗАГРУЗИТЬ НОВЫЙ СПИСОК',
      },
      errors: {
        eventNameErrorTitle: 'Ошибка названия события',
        eventNameErrorMessage:
          'В строке <b><u>{{row}}</u></b> отсутствует название события.',
        eventTypeErrorTitle: 'Ошибка типа события',
        eventTypeErrorMessage:
          'В строке <b><u>{{row}}</u></b> отсутствует тип события.',
        timeErrorTitle: 'Ошибка времени',
        timeErrorMessage:
          'В строке <b><u>{{row}}</u></b> отсутствует время начала или окончания.',
        dateErrorTitle: 'Ошибка даты',
        dateErrorMessage: 'В строке <b><u>{{row}}</u></b> отсутствует дата.',
        locationErrorTitle: 'Ошибка местоположения',
        locationErrorMessage:
          'В строке <b><u>{{row}}</u></b> отсутствует место проведения мероприятия.',
        invalidDateOrTimeTitle: 'Неверный формат даты или времени',
        invalidDateOrTimeMessage:
          'В строке <b><u>{{row}}</u></b> отсутствует Пожалуйста, проверьте формат даты и времени (например, используйте HH:MM для времени).',
      },
      commentRequired: {
        title: 'Требуется комментарий',
        message: 'Пожалуйста, добавь короткий комментарий.',
      },
      deletePopupTitle: 'Удалить список событий?',
      deletePopupMessage:
        'Это действие безвозвратно удалит ваш последний загруженный список событий. Вы уверены?',
      deleteSuccessTitle: 'Удаление успешно!',
      deleteSuccessMessage:
        'Ваш последний загруженный список событий был успешно удален.',
      successMessage:
        'Проверка пройдена успешно. Перейдите к следующему шагу, чтобы увидеть предварительный просмотр.',
      restartProcessTitle: 'Загрузить новый список событий',
      restartProcessMessage:
        'Вы можете загрузить новый список событий в любое время. Обратите внимание, что ранее загруженные события будут по-прежнему видны в планировщике. Если вы хотите заменить старый список, сначала удалите его или отмените последний импорт.',
      restartProcessOkButton: 'ЗАГРУЗИТЬ НОВЫЙ СПИСОК',
      exportDataSample: {
        event_name: 'Zurich Street Parade',
        event_type_name: 'Выступление',
        event_location: 'Bahnhofstrasse 5, 8001 Zurich',
        event_description:
          'Фестиваль под открытым небом с участием международных групп и диджеев',
      },
    },
    event: {
      noTasks: {
        title: 'Задач пока нет',
        description:
          'Они появятся здесь, как только админ создаст или активирует их.',
      },
      noParticipants: {
        title: 'Пока нет участников.',
        description:
          'Как только участник будет добавлен в событие, он появится здесь.',
      },
      noParticipantsSearchResults: {
        title: 'Результатов нет',
        description: 'Попробуйте другой поисковый запрос.',
      },
      noDocuments: {
        title: 'НеФайлов пока нет',
        description: 'Они появятся здесь, как только будут загружены.',
      },
      noSearchResults: {
        title: 'Результатов нет',
        description: 'Попробуйте другой поисковый запрос.',
      },
      event: 'События',
      createdAt: 'Дата создания',
      editEvent: 'Редактировать событие',
      createEvent: 'Создать событие',
      updateEvent: 'Обновить событие',
      eventName: 'Название события',
      eventType: 'Тип события',
      eventTypeDeleted: 'Удалённые типы событий',
      eventDetails: 'Детали события',
      eventOrganizer: 'Организатор события',
      eventOrganizerShort: 'Организатор',
      location: 'Местоположение',
      eventTypeEdit: 'Редактировать тип события',
      eventTypeName: 'Название типа события',
      responseRequired: 'Требуется ответ',
      responseName: 'Название ответа',
      responsesEdit: 'Редактировать ответа',
      responsesCreate: 'Создать ответ',
      repeatAnEvent: 'Повторять событие',
      eventTypeCreate: 'Создать тип события',
      repeatWithInterval: 'Повторять с интервалом',
      allDay: 'Весь день',
      registrationDeadline: 'Дедлайн регистрации',
      commentRequired: 'Требуется комментарий',
      editTask: 'Редактировать задание',
      createTask: 'Cоздать задание',
      eventTaskName: 'Название задания',
      icon: 'Значок',
      isMemberComing: 'Твой ответ?',
      recurringEvent: 'Повторяющееся событие',
      allEvents: 'Все события',
      thisEventOnly: 'Только это событие',
      createEventSuccess: 'Задание успешно создано',
      updateEventSuccess: 'Задание успешно обновлено',
      createEventReplySuccess: 'Ответ успешно сохранен',
      updateEventReplySuccess: 'Réponse mise à jour avec succès',
      addGuests: 'Дополнительные гости?',
      eventOperations: {
        eventOnly: 'Это мероприятие',
        eventAndFollowUp: 'Это и последующие мероприятия',
        all: 'Все мероприятия',
        deleteText: 'Удалить повторяющееся мероприятие',
        editText: 'Редактировать повторяющееся мероприятие',
        editReplyText: 'Ваш ответ относится к',
        confirm: 'ОК',
      },
      dfRes: 'Установить Ответ по Умолчанию для Всех',
      dfResInfo:
        'Это устанавливает ответ по умолчанию для всех участников события. Любые существующие индивидуальные ответы будут перезаписаны.',
      title: 'Внимание',
      responseToast:
        'Если вы удалите стандартный ответ, не сохранив новый, все предыдущие реакции и комментарии будут удалены.',
      setPreferences: 'Установить настройки',
      setEventDefaults: 'Установить настройки событий',
      preferencesText:
        'Определите настройки по умолчанию для новых событий этого типа, включая ответ по умолчанию для участников',
      responseSubTitle: 'Запросить комментарий (необязательно)',
      requestComment:
        'Включи эту опцию - тогда участники должны будут оставить комментарий, если выберут этот ответ (например, «Нет, без меня» - чтобы узнать причину).',
      registeredUsers: 'Ответы',
      guests: 'Гости',
      nomination: 'Требование',
      nominated: 'Вы номинированы',
      penalty: 'Штраф',
      havePenalty: 'Вам был назначен штраф',
      invitees: 'Приглашенные',
      awaiting: 'В ожидании',
      minutes: 'Минута',
      hours: 'Час',
      days: 'День',
      weeks: 'Неделя',
      weekDay: 'Будни',
      duration: 'Продолжительность',
      months: 'Месяц',
      years: 'Год',
      viewAppointment: 'Событие',
      myResponse: 'Мой Ответ',
      noEvents: {
        title: 'События пока не видны',
        description: 'Как только админ добавит вас, события появятся здесь.',
      },
      shareEvent:
        'Поделиться событием - Нажми на значок, чтобы скопировать событие и вставить его где угодно (e-mail, Telegram и др.).',
      shareEventOption: 'Поделиться ссылкой',
      exportPDFOption: 'Экспорт в формате PDF',
      deadlineExpired:
        'Вероятно, срок регистрации истёк или событие уже прошло.',
      totalInvitees: 'Всего приглашенных',
      responsesReceived: 'Полученные ответы',
      additionalGuests: 'Дополнительные гости',
      noPermissionToGiveReply: 'Недостаточно прав на редактирование ответа',
      responsesPercentage: 'Процент ответов',
      acceptedTasks: 'Принятые задания',
      acceptedTasksByUser: 'Задания по пользователям',
      givenComments: 'Комментарии',
      givenCommentsByUser: 'Комментарии пользователей',
      optionalMessage: 'Нажмите здесь, чтобы увидеть новости.',
    },
    task: {
      createTask: 'Создать задание',
      taskName: 'Название задания',
      noTasks: 'Задания не найдены',
    },
    groupSettings: {
      title: 'Настройки групп',
      tabs: {
        general: 'Общие',
        eventTypes: 'Типы событий',
        responses: 'Ответы',
        membersManagement: 'Администрация участников',
        other: 'Другое',
      },
      deleteGroupHeader: 'Точно удалить?',
      deleteGroupMessage:
        'Все ваши данные будут безвозвратно удалены. Восстановление невозможно.',
    },
    documentation: {
      title: 'Документы',
      generalDocumentation: 'Общие документы',
      uploadedFiles: 'Загруженные файлы',
      chooseFile: 'Выбрать файл',
      tipMessage: 'Максимальный размер файла: 50 МБ',
      overview: '{{value}} ГБ из {{capacity}} ГБ использовано',
      uploadSuccess: 'Документ успешно загружен',
      deleteSuccess: 'Документ успешно удален',
      attachFiles: 'Прикрепить файл',
      limitExceededHeader: 'Вы достигли лимита хранения документов.',
      sort: {
        label: 'Сортировка по',
        nameAsc: 'Имя (А-Я)',
        nameDesc: 'Имя (Я-А)',
        dateOldest: 'Дата (Сначала старые)',
        dateNewest: 'Дата (Сначала новые)',
      },
    },
    subscriptions: {
      title: 'Подписки',
      subscription: 'Подписка',
      adBlocker: {
        header: 'Отключи AdBlock',
        body: 'Отключи AdBlock (значок рядом с адресной строкой), чтобы видеть локальные цены. Перезагрузи страницу.',
      },
      yearly: 'По годам',
      monthly: 'По месяцам',
      freeTitle: 'Бесплатное испытание 2 месяца',
      freeDescription: 'Начни бесплатный 2-месячный пробный период сейчас.',
      freeText1: 'Открыть до <strong>30</strong> сообществ',
      freeText2: 'Полный доступ ко всем функциям',
      freeText3:
        'Не требуется кредитная карта - зарегистрируйтесь и начните сразу',
      freeText4: 'Без автоматического продления',
      freeText5: 'Без рекламы',
      subscribe: 'ПОДПИСАТЬСЯ',
      seeDetails: 'ПОСМОТРЕТЬ ДЕТАЛИ',
      buildCustom: 'Кастомный',
      month: 'мес.',
      year: 'г.',
      community: 'Центр сообщества',
      communities: 'Центры сообщества',
      scheduler: '<strong>1</strong> Центральный планировщик событий',
      schedulers:
        'Каждый с <strong>1</strong> Центральным планировщиком событий',
      group: 'Планировщики групп для команд/отделов',
      capacity: 'Вместимость участников',
      maxStorage: 'ГБ хранилища',
      classic: 'Классический',
      classicPlus: 'Классический+',
      popular: 'ПОПУЛЯРНЫЙ',
      textInnerTop:
        'Выбери подходящий тариф для своей команды. Дели на {{groups}} групп, управляй до {{members}} участниками. Обнови или отмени тариф в любое время.',
      textInnerBottom:
        'Ваша подписка - это бессрочный договор. Преимущество: Автоматическое продление ежегодно/ежемесячно. Мы отправим напоминание по email. Оплата кредитной картой (MasterCard, Visa) или PayPal.',
      chatsExcluded: 'Чаты исключены',
      current: 'ТЕКУЩИЙ',
      pay: 'ОПЛАТИТЬ',
      usingBlocker: 'Отключите блокировщик рекламы и перезагрузите страницу',
      failedToSubscribe:
        'Оплата не прошла. Проверка безопасности не удалась или срок действия карты скоро истекает. Пожалуйста, используй другую или попробуй еще раз.',
      usedGroups: 'Израсходовано групп',
      usedMembers: 'Израсходовано участников',
      usedCommunity: 'Израсходовано сообществ',
      usedStorage: 'Израсходовано хранилища',
      orderSummary: 'Детали заказа',
      tax: 'НАЛОГ',
      total: 'Всего',
      periodEnds: 'Оплаченный период завершается',
      cancelSubscription: 'ОТМЕНИТЬ МОЮ ПОДПИСКУ',
      paypalLink: 'ИСТОРИЯ ПЛАТЕЖЕЙ',
      chatEnabled: 'Чат включен',
      chatExcluded: 'Чат исключен',
      paymentApproved: 'Платеж одобрен',
      paymentError: 'Ошибка платежа',
      limitExceededHeader: 'Ты достиг лимита участников.',
      limitExceededMessage:
        'Свяжитесь с владельцем вашего сообщества. Только он/она может управлять и обновить подписку.',
      limitExceededMessageOwner: 'Выберите план, чтобы создать сообщество.',
      inactiveSubscriptionHeader: 'Ожидается подтверждения платежа',
      inactiveSubscriptionMessage:
        'Извините, это действие не может быть продолжено. Возможно, необходимо сначала завершить процесс оплаты.',
      subscriptionNotPaid: 'Нет активного плана',
      contactAdmin: 'Пожалуйста, свяжитесь с администратором.',
      free: 'Бесплатный аккаунт',
      requireSubscription:
        'Gumb бесплатен для участников активных сообществ. Создайте свое собственное сообщество и начните бесплатный пробный период или измените свой тарифный план в разделе «Изменить тариф».',
      requireSubscriptionMember:
        'Действующая подписка не обнаружена. Вам ничего не нужно делать самостоятельно. Владелец сообщества может проверить в своем профиле в разделе "Подписка", активирована ли лицензия для этого сообщества и продлить ее при необходимости.',
      cancelConfirmation: 'Ты уверен, что хотешь отменить свою подписку?',
      unsubscribe: 'Отменить',
      cancelled:
        'Отмена подтверждена. На вашу электронную почту только что было отправлено подтверждение об отмене бронирования. Вы будете иметь доступ ко всем функциям до даты оплаченного расчета.',
      renewSubscriptionText:
        'Спасибо!\n\nВаша предыдущая подписка будет продлена, если вы активируете ее сейчас',
      activate: 'Активировать сейчас',
      activated:
        'Ваша подписка активна! Добро пожаловать в Gumb: мы очень рады, что теперь вы профессионально планируете и организуете с Gumb. Подтверждение отправлено на твою почту. Все функции доступны вашей команде немедленно.',
      approved:
        'Подготавливаем вашу подписку... Пожалуйста, подожди немного (до 45 секунд). Не обновляй и не закрывай окно браузера в это время.',
      trial: 'Пробная версия',
      trialActivated:
        'Твой пробный период начался. Ты и твои администраторы теперь можете начинать планирование, приглашать участников и управлять настройками.',
      cancelledTitle: 'Отменено',
      startTrial: 'НАЧНИТЕ БЕСПЛАТНЫЙ ТЕСТ',
      startTrialHeader: 'Долго тестировать!',
      startTrialText:
        'Тестируй все функции в реальной работе - 2 месяца бесплатно! Без платежных данных и скрытых затрат. Просто тестируй без проблем со всеми участниками.',
      subscriptionExpired:
        'В настоящее время у этого сообщества нет активной подписки. Чтобы добавить новых пользователей, необходимо продлить подписку. По вопросам: support@gumb.app',
      startTrialPopupButton: 'Бесплатное тестирование',
      paymentMethods: 'Кредитная карта или Paypal',
      checkout: {
        pageTitle: 'Checkout',
        breadcrumbCheckout: 'Checkout - {{plan}}',
        stepPlanSelected: 'Тариф выбран',
        stepOrderSummary: 'Сводка заказа',
        stepConfirmation: 'Подтверждение',
        completeOrder: 'Завершите заказ',
        planInfoSub: '{{billing}} · {{count}} {{teams}}',
        planLineAnnual: '{{plan}} (годовой)',
        planLineMonthly: '{{plan}} (месячный)',
        planLineSubtextAnnual:
          '{{currency}}{{price}}/год · осталось {{days}} дн.',
        planLineSubtextMonthly:
          '{{currency}}{{price}}/мес. · осталось {{days}} дн.',
        daysRemainingSubtext: 'осталось {{days}} дн.',
        annualSavingLine: 'Экономия при годовой оплате',
        totalDueToday: 'Итого к оплате сегодня',
        renewsOn: 'Продление {{date}}',
        chargedToday: 'Списано сегодня:',
        activationInfo:
          'После подтверждения платежа твой тариф активируется, и ты получишь письмо с подтверждением. Отменить можно в любой момент в настройках подписки.',
        activationInfoStripe:
          'Твой тариф активируется сразу после оплаты. Продление ежегодно в ту же дату - отмена в любое время.',
        activationInfoStripeMonthly:
          'Твой тариф активируется сразу после оплаты. Продление ежемесячно в ту же дату - отмена в любое время.',
        includedTitle: 'Что включено',
        included1: 'Общий основной календарь',
        included2: 'Посещаемость в реальном времени',
        included3: 'Командный чат и личные сообщения',
        included4: 'Push-уведомления',
        included5: 'Роли участников и права доступа',
        included6: 'Хранилище файлов и документов',
        included7: 'iOS, Android и web',
        included8: 'Аналитика и экспорт CSV',
        trustSecure: 'Безопасный checkout через PayPal',
        trustSecureStripe: 'Безопасный checkout через Stripe',
        trustCancel: 'Отмена в любое время',
        trustCancelDetailed: 'Отмена в любое время, без штрафов',
        trustSSL: 'SSL-шифрование 256 бит',
        stripeProcessedNote: 'Безопасная оплата через',
        completePurchase: 'Завершить покупку - {{amount}}',
        paymentMethodLegend: 'Способ оплаты',
        payDirectTitle: 'Оплатить сейчас',
        payDirectDesc: 'Списывается сегодня.',
        payInvoiceTitle: 'Счёт',
        payInvoiceDesc: 'Счёт по электронной почте.',
        invoiceHeadline: 'Оплата по счёту',
        invoiceSubline:
          'Банковский перевод · PDF-счёт на твой e-mail для выставления счетов',
        invoicePanelBody:
          'Мы отправим счёт с реквизитами и твоей ссылкой-референсом. Подписка активируется после поступления оплаты (обычно 1-3 рабочих дня после перевода).',
        requestInvoice: 'Запросить счёт',
        toBeInvoiced: 'Будет выставлен счёт',
        invoicePageNote: 'Ваша подписка начинается сразу, независимо от оплаты',
        chf: {
          title: 'Детали счёта',
          subtitle:
            'Вы получите QR-счёт по электронной почте. Срок оплаты 30 дней.',
          name: 'Организация или имя',
          address: 'Адрес',
          vatNumber: 'Номер НДС',
          billingEmail: 'Email для счетов',
          optional: 'необязательно',
          recipientsHint:
            'Все получатели получат один и тот же счёт. Оставьте пустым, чтобы использовать {{email}}.',
          total: 'Итого',
          submit: 'Запросить счёт',
          activationNote:
            'Ваша подписка начинается сразу, независимо от оплаты',
          invalidEmail: 'Введи корректный адрес электронной почты',
          maxRecipients: 'Максимум 5 получателей',
        },
        invoiceTrust1: 'Счёт отправлен на твой e-mail для выставления счетов',
        invoiceTrust2:
          'Оплати банковским переводом с указанной ссылкой-референсом',
        invoiceTrust3:
          'Твоё приложение активно сразу - оплати счёт, когда удобно',
        priceSaveVsMonthly: '2 месяца бесплатно по сравнению с месячным',
        planDetails: 'Детали тарифа',
        badgeNew: 'Новая подписка',
        planNotInCatalog:
          'Этот тариф пока недоступен в каталоге checkout либо ссылка устарела. Вернись в «Сменить тариф» и открой checkout заново оттуда.',
        backToChangePlan: 'Назад к тарифам',
        invoiceYearlyOnly:
          'Оплата по счёту доступна только для годовых подписок. Выбери годовую оплату в «Сменить тариф», затем вернись в checkout.',
        invoicePayerEmailsLabel: 'E-mail плательщика / бухгалтерии',
        invoicePayerEmailsHint:
          'Мы сохраняем эти контакты для ваших записей. Stripe отправляет счёт на e-mail профиля (кому выставить счёт).',
        invoiceBillToProfile: 'Выставить счёт на: {{email}}',
        invoiceEmailPlaceholder: 'finance@company.com',
        invoiceAddEmail: '+ Добавить ещё e-mail',
        invoiceRemoveEmail: 'Удалить e-mail',
        invoiceSubmit: 'Создать счёт',
        invoiceSubmitting: 'Создаём счёт…',
        invoiceInvalidEmails: 'Укажи хотя бы один корректный e-mail.',
        invoiceSubmitError:
          'Не удалось создать счёт. Попробуй снова или обратись в поддержку.',
        stripeCheckoutError: 'Не удалось начать оформление. Попробуй ещё раз.',
        invoiceSuccessTitle:
          'Счёт создан - завершите оплату, когда будете готовы',
        invoiceAmount: 'Сумма: {{amount}}',
        invoiceOpenHosted: 'Открыть счёт Stripe и оплатить',
        invoiceHostedPending:
          'Твоя подписка ожидает оплаты. Проверь e-mail со ссылкой на счёт или открой «Подписка» в профиле чуть позже.',
        invoiceReturnBreadcrumb: 'Подтверждение',
        invoiceReturnSuccessTitle: 'Готово!',
        invoiceReturnSuccessSub:
          'Твой {{plan}} уже активен. Оплати счёт Stripe, когда будешь готов - не нужно ждать оплаты, чтобы пользоваться приложением.',
        invoiceReturnSuccessDetailsHeading: 'Что было активировано',
        invoiceReturnSuccessBulletPlan:
          '{{plan}} - лимиты подписки и биллинг применены.',
        invoiceReturnSuccessBulletActive:
          'Премиум-функции доступны сразу на web и mobile.',
        invoiceReturnSuccessBulletInvoice:
          'Создан счёт Stripe - открой его ниже или проверь e-mail для выставления счетов.',
        invoiceReturnSeeInvoice: 'Открыть счёт',
        invoiceReturnSeeInvoicePending: 'Ссылка на счёт ожидается',
        invoiceReturnGoSubscription: 'Перейти к подписке',
        stripeReturnBreadcrumbSuccess: 'Подтверждение',
        stripeReturnBreadcrumbFailure: 'Checkout отменён',
        stripeReturnSuccessTitle: 'Готово!',
        stripeReturnSuccessSub:
          'Твой {{plan}} теперь активен. Можно сразу пользоваться всеми функциями - без ожидания и задержек.',
        stripeReturnPlanFallback: 'тариф',
        stripeReturnSuccessDetailsHeading: 'Что было активировано',
        stripeReturnSuccessBulletPlan:
          '{{plan}} - лимиты подписки и биллинг уже применены.',
        stripeReturnSuccessBulletActive:
          'Премиум-функции доступны сразу на web и mobile.',
        stripeReturnSuccessBulletEmail:
          'Мы отправим квитанцию на твой e-mail для выставления счетов после подтверждения платежа.',
        stripeReturnSuccessBulletGuarantee:
          'На твою подписку распространяется 30-дневная гарантия возврата денег.',
        stripeReturnSessionRef: 'Ссылка checkout: {{id}}',
        stripeReturnGoHome: 'На главную',
        stripeReturnViewSubscription: 'Открыть подписку',
        stripeReturnFailureTitle: 'Платёж не завершён',
        stripeReturnFailureSub:
          'С тебя ничего не списали. Ты можешь снова открыть checkout в любое время из «Сменить тариф».',
        stripeReturnFailureDetailsHeading: 'Что произошло',
        stripeReturnFailureBullet1:
          'Checkout был отменён или закрыт до завершения оплаты.',
        stripeReturnFailureBullet2: 'Твоя подписка не была изменена.',
        stripeReturnTryAgain: 'Назад к тарифам',
        stripeReturnBackSubscription: 'Открыть подписку',
      },
      subscriptionsPopup: {
        title: 'Нет активного плана',
        subtitle: '<b>{{ownerName}}</b> — владелец и может выбрать план. 🙌🏻',
        firstBox: {
          title: 'Выберите план, чтобы вернуть всем полный доступ.',
          btnText: 'Выбрать план',
        },
        secondBox: {
          title: 'Передать сообщество другому? Мы переоформим право владения.',
          btnText: 'Запросить передачу',
          contactMessage:
            'Хочу запросить передачу права владения сообществом «{{communityName}}» ({{communityId}}). Текущий владелец: {{currentOwner}}. Мой email: {{email}}.',
        },
      },
      profile: {
        legacy: {
          heading: 'Подробная информация о подписке',
          titleMembership: 'Членство',
          titlePayment: 'Оплаты',
          buttonCancel: 'Возобновить членство',
          details: {
            linkChangePlan: 'Изменить план',
            infoTrial:
              'Тестовый период активен. После окончания ничего не будет списано. Если хочешь продолжить пользоваться Gumb, выбери тариф в разделе «Сменить тариф».',
            infoTrialNew:
              'Тестовый период активен. После окончания {{expireDate}} ничего не будет списано. Если хочешь продолжить пользоваться Gumb, выбери тариф в разделе «Сменить тариф».',
            linkShowCommunities: 'Покажите мои сообщества',
            linkHistory: 'История оплат (Квитанция по e-mail PayPal)',
            linkChangePayment: 'Изменение способа оплаты',
            currentPlan: 'Текущий тариф:',
            communitiesInUse: 'Сообщества в использовании:',
            groupsInUse: 'Группы в использовании:',
            membersInUse: 'Участники в использовании:',
            storageInUse: 'Хранение в использовании:',
            paymentCycle: 'Цикл оплаты:',
            paymentMethod: 'Способ оплаты:',
          },
          billing: {
            paymentInfoNote:
              'Платёжные данные можно безопасно добавить при оформлении подписки. Оплата обрабатывается через Stripe с шифрованием.',
            securePayments: 'Безопасные платежи',
            renewalNote: 'Продление {{date}} · {{cycle}}',
            choosePlanTrial: 'Выберите тариф',
            cancelTrial: 'Отменить пробный период',
            cancelTrialConfirm:
              'Завершить бесплатный пробный период? Подписаться снова можно в любой момент на странице тарифов.',
            trustStripeNote:
              'Платежи обрабатываются безопасно - управляй оплатой, счетами и квитанциями',
          },
        },
        page: {
          title: 'Подписка и оплата',
        },
        confirming: {
          onboardingTitle: 'Almost there',
          onboardingHint:
            "We're syncing your payment with your account. This usually takes just a moment.",
          subscriptionTitle: 'Almost there',
          subscriptionHint:
            "We're activating your subscription. This usually takes just a moment.",
        },
        labels: {
          paymentCycleMonth: 'Ежемесячно',
          paymentCycleYear: 'Ежегодно',
          validUntil: 'Действительно до:',
          nextPayment: 'Следующий платеж:',
          infoCancelled:
            'Твоя подписка отменена и не будет продлена. Приложением можно пользоваться до следующей даты оплаты. Можно продлить в любое время.',
          subscriptionEndedOn: 'Подписка завершена:',
          trialEndedOn: 'Пробный период завершён:',
          accessUntil: 'Доступ до:',
          nextInvoice: 'Next invoice:',
          lastPlan: 'Последний план',
          invoiceBillingCyclePrimary: 'Annual · Custom pricing',
        },
        hero: {
          title: 'Начни бесплатный 2-месячный пробный период',
          subtitle: 'Полный доступ ко всем функциям - без банковской карты.',
          seeIncluded: 'Что входит',
        },
        freeAccount: {
          subtitle: 'Ты ещё не начинал пробный период или подписку.',
          badge: 'Бесплатный аккаунт',
          noActivePlan: 'Нет активного плана',
          trialUnlockBlurb:
            'Запусти бесплатный 2-месячный пробный период с полным доступом - несколько сообществ, планировщики групп, управление участниками и другое.',
          trialNoteFooter:
            '2 месяца бесплатно - после этого списаний не будет.',
          comparePlans: 'Сравнить тарифы',
        },
        plan: {
          title: 'Текущий план',
          subtitleTrial: 'Спокойно тестируй Gumb в течение пробного периода.',
          subtitleActive: 'План активен и продлевается автоматически.',
          subtitleNonRenewal:
            'Полный доступ до {{date}}. Подписка не продлится автоматически.',
          subtitleStripeEnded:
            'Платная подписка завершена {{date}}. Оформить снова можно в разделе смены плана.',
          subtitleFullyCancelled: 'Подписка {{plan}} завершена {{date}}.',
          subtitleTrialExpired: 'Ваш пробный период завершился {{date}}.',
          badgeTrial: 'Пробный период',
          badgeTrialExpired: 'Пробный период истёк',
          badgeCancelled: 'Отменено',
          badgeEnded: 'Завершена',
          badgeActive: 'Активно',
          endsOnNote:
            'Заканчивается {{date}}. Автоматических списаний не будет.',
          footnoteStripeEnded:
            'Завершена {{date}}. Дальнейших списаний не будет.',
          footnoteFullyCancelled:
            'Отменено {{date}}. Дальнейших списаний не будет.',
          footnoteTrialExpired:
            'Пробный период завершился {{date}}. Списаний не было.',
          footnoteRenewalCancelled:
            'Без продления после {{date}}. Полный доступ до этого момента · {{price}}{{period}} (последний активный план) · {{billingMethod}}',
          footnoteRenewalPayment:
            'Продление {{date}} · {{price}}{{period}} {{billingMethod}}',
          paymentMethodChargedGeneric: 'сохранённый способ оплаты',
          paymentMethodChargedTo: 'списано с {{chargedTo}}',
          paymentMethodBilledByInvoice: 'оплата по счёту',
          featureCommunities: 'До {{count}} сообществ',
          featureSchedulers: 'До {{count}} групповых планировщиков',
          featureMembers: 'До {{count}} участников',
          featureStorage: '{{count}} ГБ хранилища',
          paidProFeatureExtras: [
            'Учёт посещаемости в реальном времени',
            'Командный чат, личные сообщения и push-уведомления',
          ],
        },
        statusBanner: {
          trialTitle: 'Пробный период активен',
          trialBody:
            'Пробный период до {{date}}. До этой даты Gumb бесплатен - автоматических списаний не будет.',
          stripeEndedRich:
            'Эта подписка в Stripe завершена. Дальнейших списаний не будет.',
          fullyCancelledTitle: 'Отменено',
          fullyCancelledRich:
            'Подписка отменена. Доступ закончился {{date}}. Вы можете оформить подписку снова в любое время.',
          trialExpiredTitle: 'Пробный период истёк',
          trialExpiredRich:
            'Ваш пробный период завершился {{date}}. Выберите план, чтобы сохранить полный доступ.',
          activeLabel: '{{plan}} · Активно',
          nonRenewalRich:
            'Активна до {{date}} - не продлится. После этой даты списаний не будет · {{price}}{{period}}',
          renewalRich: 'Подписка продлевается {{date}} · {{price}}{{period}}',
          frequencyAnnual: 'Ежегодно',
          frequencyMonthly: 'Ежемесячно',
        },
        payment: {
          title: 'Оплата',
          methodLabel: 'Способ оплаты',
          invoiceMethodTitle: 'Invoice (annual)',
          sentToBilling: 'Счёт для {{email}}',
          sentToBillingLabel: 'Счёт для',
          cycleLabel: 'Цикл оплаты',
          accountManagerLabel: 'Account manager',
          lastInvoiceLabel: 'Последний счёт',
          lastInvoiceUnavailable: '-',
          lastInvoiceHintInvoice: 'Официальный счёт в формате PDF',
          lastInvoiceHint: 'Счёт за этот платёж',
          downloadInvoice: 'Скачать PDF',
          methodOnFile: 'Карта сохранена',
          noPaymentYet: 'Пока оплата не требуется',
          cardExpiresShort: 'Действует до {{month}} / {{year}}',
          noActiveSubscription: 'Нет активной подписки',
          manageBilling: 'Управление оплатой',
          manageBillingHint: 'Открывает защищённый платёжный портал Stripe',
          viewInvoices: 'Посмотреть счета',
          switchToInvoice: 'Перейти на оплату по счёту',
          switchToCard: 'Перейти на оплату картой',
          switchToInvoiceTitle: 'Перейти на оплату по счёту?',
          switchToInvoiceBody:
            'Счета будут отправляться на ваш платёжный email.',
          switchToInvoiceBodyBold:
            'С вашей карты больше не будут списывать средства автоматически.',
          switchToInvoiceConfirm: 'Перейти на счета',
          switchToCardTitle: 'Перейти на оплату картой?',
          switchToCardBody:
            'С вашей сохранённой карты будут списывать средства автоматически.',
          switchToCardBodyBold:
            'Счета по email для будущих платежей отправляться не будут.',
          switchToCardConfirm: 'Перейти на оплату картой',
          switchBillingReviewSubtitle:
            'Проверьте изменение ниже перед подтверждением.',
          switchBillingChangeSummaryLabel: 'Что изменится',
          switchBillingTimingLabel: 'Когда вступает в силу',
          switchBillingStep1Label: 'Проверить изменение',
          switchBillingStep2Label: 'Добавить карту',
          switchBillingStepIndicator:
            'Шаг {{current}} из {{total}} · {{label}}',
          switchBillingProcessing: 'Обновление способа оплаты…',
          switchBillingRedirecting: 'Перенаправление…',
          switchBillingFromLabel: 'Текущий',
          switchBillingToLabel: 'Новый',
          switchBillingInvoiceLabel: 'Счёт',
          switchBillingCardLabel: 'Карта',
          switchBillingNextCycleNote:
            'Вступает в силу с начала следующего расчётного периода.\nТекущий период подписки не изменится.',
          switchBillingAddCardTitle: 'Добавить платёжную карту',
          switchBillingAddCardSubtitle:
            'Последний шаг для перехода на оплату картой.',
          switchBillingAddCardPendingLabel: 'Требуется карта',
          switchBillingAddCardPendingText:
            'Для завершения перехода нужна платёжная карта.\nСпособ оплаты изменится только после её добавления.',
          switchBillingAddCardNextLabel: 'Что дальше',
          switchBillingAddCardNextText:
            'Перейдите на следующую страницу, чтобы добавить платёжную карту.',
          switchBillingAddCardSecureNote:
            'Данные карты шифруются и обрабатываются безопасно.',
          switchBillingAddCardGo: 'Добавить карту',
          switchBillingAddCardStepDone: 'Изменение подтверждено',
          switchBillingAddCardStepNext: 'Добавьте карту',
          switchBillingSuccess: 'Способ оплаты обновлён.',
          switchBillingErrorGeneric:
            'Не удалось обновить способ оплаты. Повторите попытку.',
          switchBillingNoPaymentMethod:
            'Сначала добавьте способ оплаты, чтобы переключиться.',
          switchBillingNoPaymentMethodLink: '<link>Управление оплатой</link>',
          choosePaymentTitle: 'Выберите способ оплаты',
          choosePaymentSubtitle: 'Как вы хотите продолжить?',
          choosePaymentInvoiceBody:
            'Счета будут отправляться на ваш платёжный email. Автоматическое списание не используется.',
          choosePaymentCardBody:
            'Оплачивайте автоматически картой. Вы добавите её на следующей странице.',
          choosePaymentConfirm: 'Продолжить',
          choosePaymentConfirmInvoice: 'Оплата по счёту',
          choosePaymentConfirmCard: 'Добавить карту',
          choosePaymentRedirecting: 'Переходим к добавлению карты…',
          choosePaymentCardOpened:
            'Завершите добавление карты в новой вкладке.',
          choosePaymentErrorNoUrl:
            'Не удалось открыть следующую страницу. Повторите попытку.',
          editRecipients: 'Изменить получателей',
          editRecipientsTitle: 'Получатели счетов',
          editRecipientsSubtitle:
            'Все получатели получают один и тот же счёт. Оставьте пустым, чтобы использовать email аккаунта.',
          editRecipientsSave: 'Сохранить',
          editRecipientsSaving: 'Сохранение…',
          editRecipientsError:
            'Не удалось обновить получателей счетов. Повторите попытку.',
        },
        invoiceHistory: {
          title: 'История платежей',
          subtitle: 'Прошлые счета и квитанции по вашей подписке.',
          colInvoice: 'Счёт',
          colIssued: 'Дата выставления',
          colDue: 'Срок оплаты',
          colAmount: 'Сумма',
          colStatus: 'Статус',
          colDownload: 'Скачать',
          statusOpen: 'Не оплачен',
          statusPaid: 'Оплачен',
          statusVoid: 'Аннулирован',
          downloadInvoice: 'Счёт',
          downloadReceipt: 'Квитанция',
          invoiceFallback: 'Счёт {{id}}',
          issuedOn: 'Выставлен {{date}}',
          dueOn: 'Оплатить до {{date}}',
          noDueDate: '—',
          empty:
            'Счетов пока нет. Они появятся здесь после первого платёжного периода.',
          loadError:
            'Не удалось загрузить историю платежей. Обновите страницу или повторите попытку через несколько минут.',
          paginationLabel: 'Страницы истории платежей',
          showingRange: '{{from}}–{{to}} из {{total}} счетов',
          previousPage: 'Предыдущая страница',
          nextPage: 'Следующая страница',
        },
        usage: {
          title: 'Текущее использование',
          lockedHint: 'Начни пробный период, чтобы активировать лимиты плана',
          lockedHintResubscribe:
            'Оформите подписку снова, чтобы восстановить лимиты плана.',
          lockedHintTrialExpired: 'Выберите план, чтобы восстановить лимиты.',
          members: 'Участники',
          atLimitMembers: 'Лимит достигнут',
          spotsRemaining: 'Осталось мест: {{count}}',
          communities: 'Сообщества',
          atLimitCommunities: 'Лимит достигнут',
          communitiesRemaining: 'Осталось мест сообществ: {{count}}',
          schedulers: 'Групповые планировщики',
          atLimitSchedulers: 'Лимит достигнут',
          schedulersRemaining: 'Осталось планировщиков: {{count}}',
          storage: 'Хранилище',
          atLimitStorage: 'Лимит достигнут - удалите файлы или обновите план',
          storageRemaining: 'Осталось ГБ: {{count}}',
          upgradeNudgeTitle: 'Достигнут лимит сообществ / команд.',
          planLimitNudgeTitle: 'Достигнут лимит тарифа.',
          upgradeNudgeBody:
            'Перейди на Premium - больше команд, участников, автоматизаций и аналитики.',
          planLimitNudgeBody:
            'Обнови план, чтобы увеличить лимиты участников, сообществ, планировщиков и хранилища. Сравни тарифы и меняй в любое время.',
          upgradeCta: 'Улучшить',
        },
        actions: {
          choosePlan: 'Выбрать план',
          changePlan: 'Сменить тариф',
          comparePlansMenu: 'Сравнить тарифы',
          cancelSubscription: 'Отменить подписку',
          dontCancelSubscription: 'Не отменять подписку',
          restartMembership: 'Возобновить подписку',
          subscribeAgain: 'Оформить подписку снова',
        },
        trust: {
          poweredBy: 'Платежи безопасно обрабатываются через Stripe',
        },
      },
    },
    terms: {
      title: 'Правила и Условия Gumb',
    },
    errors: {
      cantSendMessageToYourself: 'Нельзя отправить сообщение самому себе.',
      downloadFail: 'Ошибка загрузки, попробуйте снова.',
      required: 'Требуется поле',
      email: 'Пожалуйста, введите верный email',
      invalidEmail:
        'Ой! Пожалуйста, введите действительный адрес электронной почты. Проверьте на опечатки и попробуйте снова.',
      integer: 'Должно быть целым числом',
      confirmPassword: 'Пароли не совпадают. Пожалуйста, повторите попытку.',
      NotAuthorizedException: 'Неверное имя пользователя или пароль',
      invalidCode: 'Неверный код. Пожалуйста, повторите попытку.',
      errorToast: 'Ошибка: {{message}}',
      invalidRequest: 'Неверный запрос',
      passwordChanged: 'Пароль изменен',
      password:
        'Пароль должен содержать не менее 8 символов, буквы в верхнем и нижнем регистре и цифры .',
      termsError: 'Подтвердите согласие с Условиями и положениями',
      min: 'Минимум {{value}} символов',
      max: 'Максимум {{value}} символов',
      startDate: 'Дата не может быть раньше {{value}}',
      endDate: 'Дата не может быть раньше даты начала',
      fileSize: 'Превышен допустимый размер файла',
      fileSizeCustom:
        'Файл слишком большой: Максимальный размер - {{size}} МБ.',
      customFileSize:
        'Файл слишком большой: Макс {{size}}. Удалите и попробуйте снова.',
      unsupportedFormat: 'Неподдерживаемый формат файла',
      postalCode: 'Минимум 4 символа',
      sorry: 'Извините',
      text404: 'Похоже, искомая страница недоступна :(',
      url: 'Должен быть действительным URL.',
      text500: 'Что-то пошло не так :(',
      onlyForGroupAndAdmin: 'Функция только для админов и лидеров групп',
      onlyForAdmin: 'Функция только для админов',
    },
    eventTypes: {
      createSuccess: 'Тип события создан',
      editSuccess: 'Изменения сохранены',
      deleteSuccess: 'Тип события удалён',
    },
    eventTasks: {
      createSuccess: 'Задача создана',
      editSuccess: 'Изменения сохранены',
      deleteSuccess: 'Задача удалена',
    },
    eventResponses: {
      createSuccess: 'Ответ сохранён',
      editSuccess: 'Изменения сохранены',
      deleteSuccess: 'Ответ удалён',
    },
    tips: {
      registrationDeadline:
        'Срок заканчивается в установленное время начала события. Участники могут ответить до этого момента. После - только админы и руководители групп могут вносить изменения.',
      eventType:
        'Админ может добавить новые типы событий в настройках сообщества.',
    },
    frequencies: {
      doNotRepeat: 'Не повторять',
      daily: 'Ежедневно',
      weekly: 'Еженедельно',
      monthly: 'Ежемесячно',
      yearly: 'Каждый год',
      everyWorkingDay: 'Каждый будний день (с понедельника по пятницу)',
      other: 'Другое…',
    },
  },
};
